/*!
* @cc_on
* 
* Version: IENP-2.9.8
* Built: 2021-04-01 14:42:11
* Revision: 93486
* 
* @cc_on
*/

"use strict";
angular.module("videotron.illico.debug",[]);
angular.module("videotron.illico.common", []);


angular.module("videotron.illico.common.loadingOverlay", []);


angular.module("videotron.illico.native-bridge-send", []);

angular.module("videotron.illico.native-bridge", ["videotron.illico.common","videotron.illico.native-bridge-send"]);
angular.module("videotron.illico.common.web", []);


angular.module("videotron.illico.translate-config", [
    "pascalprecht.translate"
]);




//WARNING : this module depends on http://qtip2.com/
angular.module("videotron.illico.tooltip", []);
angular.module("videotron.illico.grid-scroll", ["videotron.illico.common"]);
angular.module("videotron.illico.grid-click", ["videotron.illico.common"]);
angular.module("videotron.illico.grid-long-press", ["videotron.illico.common"]);
angular.module("videotron.illico.content-details", [
    "videotron.illico.delete-recording",
    "videotron.illico.recording-conflict"
]);
angular.module("videotron.illico.recording-conflict", [

]);
angular.module("videotron.illico.grid",
    [ "videotron.illico.common"]);

angular.module("videotron.illico.modal",[]);

angular.module("videotron.illico.delete-recording", []);

angular.module("videotron.illico.epg-grid",
    [ "videotron.illico.grid", "videotron.illico.grid-scroll", "videotron.illico.grid-click"]);
angular.module("videotron.illico.pvr-grid",
    [ "videotron.illico.grid", "videotron.illico.grid-scroll", "videotron.illico.grid-click", "videotron.illico.grid-long-press"]);

angular.module("app.epg.web", [
    "ngRoute",
    "videotron.illico.debug",
    "videotron.illico.tooltip",
    "videotron.illico.translate-config",
    "videotron.illico.native-bridge",
    "videotron.illico.common",
    "videotron.illico.common.loadingOverlay",
    "videotron.illico.common.web",
    "videotron.illico.epg-grid",
    "videotron.illico.content-details"
]);




angular.module("app.pvr.web", [
    "ngRoute",
    "videotron.illico.translate-config",
    "videotron.illico.debug",
    "videotron.illico.native-bridge",
    "videotron.illico.pvr-grid",
    "videotron.illico.modal",
    "videotron.illico.delete-recording",
    "videotron.illico.common.loadingOverlay",
    "videotron.illico.common.web",
    "videotron.illico.tooltip",
    "videotron.illico.content-details"
]);




angular.module("videotron.illico.debug").directive("console", ["$parse",function ($parse) {

    return {
        restrict: "A",
        template: "<div class='console' ng-show='display' ng-click='visible = !visible' ng-class='{visible:visible}'>" +
            "<div class='content'><div class='log' ng-repeat='log in logs'>{{log.message}}</div></div>" +
            "</div>",
        replace: true,
        scope: true,
        link: function (scope, element, parameters) {
            var windowConsole = window.console;
            var counter = 1;
            var showConsoleParam = new RegExp(/console=true/);
            scope.display = true;
            if (!$parse(parameters.console)(scope) || !showConsoleParam.test(window.location.href)) {
                scope.display = false;
                return;
            }

            scope.visible = false;
            scope.logs = [];

            function customLogger(prefix) {
                windowConsole.log(arguments);
                var log = [counter + " => "];
                var argumentsLength = arguments.length;
                for (var i = 0; i < argumentsLength; i++) {
                    log.push(arguments[i]);
                }
                log = log.join(" ");
                //check if angular is in a digest cycle
                if (scope.$$phase) {
                    scope.logs.unshift({message: log});
                } else {
                    scope.$apply(function () {
                        scope.logs.unshift({message: log});
                    });
                }
                counter++;
            }

            window.console = {
                log: customLogger,
                dir: angular.noop,
                error: customLogger,
                warn: customLogger,
                info: customLogger,
                time: angular.noop,
                timeEnd: angular.noop
            };
        }

    };

}]);
angular.module("videotron.illico.debug").service("Lorem", function () {

    var words = ["lorem", "ipsum", "dolor", "sit", "amet", "vix", "an", "tritani", "deleniti", "ne", "graeco", "commodo", "vel", "ne", "veniam", "facilisi", "vim", "ea", "graeco", "elaboraret", "sed", "mel", "ei", "legendos", "repudiare", "consequuntur", "an", "erroribus", "maiestatis", "vel", "id", "his", "alia", "illum", "vocibus", "ei", "modus", "indoctum", "sed", "ex", "elitr", "intellegebat", "est", "an", "ius", "justo", "exerci", "dolorem", "regione", "insolens", "salutatus", "nam", "ne", "summo", "scaevola", "no", "nam", "liber", "debet", "eum", "ad", "solum", "corpora", "vivendum", "ea", "eam", "solet", "omnesque", "menandri", "ex", "nec", "sea", "an", "nemore", "insolens", "has", "te", "vidisse", "dolorum", "vel", "et", "adhuc", "clita", "ut", "cum", "dolorum", "postulant", "torquatos", "te", "iusto", "propriae", "nam", "quo", "diam", "discere", "conclusionemque", "ut", "at", "mea", "dicat", "repudiandae", "ullamcorper", "homero", "tamquam", "pertinax", "eam", "ad", "id", "soluta", "mucius", "per", "eu", "delenit", "consulatu", "mel", "vix", "ex", "tacimates", "euripidis", "aeque", "sanctus", "senserit", "vim", "no", "saepe", "tempor", "docendi", "sed", "ut", "ex", "eum", "eros", "putent", "deserunt", "pri", "an", "graeco", "tibique", "eu", "eripuit", "perpetua", "definiebas", "eam", "vis", "modo", "incorrupte", "instructior", "ei", "ei", "usu", "minimum", "delicatissimi", "an", "idque", "equidem", "minimum", "ius", "persius", "pertinax", "te", "eum", "eu", "harum", "virtute", "eum", "an", "ius", "nisl", "saperet", "pertinax", "tale", "labores", "qui", "at", "ius", "cu", "civibus", "invidunt", "moderatius", "pro", "ad", "facer", "possim", "moderatius", "choro", "doctus", "dissentias", "vel", "in", "mea", "et", "dicant", "corrumpit", "eu", "simul", "invenire", "sed", "pro", "ei", "affert", "sadipscing", "te", "est", "assentior", "reprimique", "his", "idque", "instructior", "cu", "detracto", "sapientem", "an", "vis", "vis", "id", "mazim", "deleniti", "appellantur", "sumo", "ferri", "virtute", "vis", "at", "mea", "nusquam", "quaestio", "eu", "cu", "vis", "decore", "everti", "periculis", "mea", "ad", "enim", "dissentias", "vim", "nibh", "reque", "ad", "idque", "molestiae", "ei", "vix", "epicuri", "luptatum", "iudicabit", "eam", "ut", "eam", "ex", "suas", "omnesque", "voluptaria", "id", "tollit", "aliquid", "scripserit", "quo", "usu", "mazim", "maluisset", "accommodare", "eu", "eum", "ut", "salutandi", "interpretaris", "ex", "amet", "mazim", "fabellas", "his", "at", "pri", "saperet", "ceteros", "quaerendum", "vim", "laoreet", "postulant", "argumentum", "at", "ut", "minimum", "praesent", "pro", "at", "eam", "enim", "dicunt", "ad", "sea", "eirmod", "qualisque", "labitur", "numquam", "delicata", "an", "nec", "quaeque", "dolores", "concludaturque", "usu", "in", "in", "quo", "menandri", "referrentur", "an", "cum", "dicat", "fastidii", "ocurreret", "eum", "ex", "quas", "timeam", "qualisque", "cum", "tation", "suavitate", "no", "duo", "legere", "probatus", "efficiantur", "ad", "mei", "altera", "lobortis", "ei", "quas", "honestatis", "no", "vix", "ubique", "albucius", "interpretaris", "usu", "an", "eam", "magna", "referrentur", "te", "altera", "pericula", "at", "eam", "purto", "discere", "contentiones", "ei", "vis", "qui", "cu", "placerat", "mediocrem", "vix", "in", "mazim", "omnes", "congue", "at", "vim", "possim", "integre", "tincidunt", "ad", "ius", "feugiat", "expetendis", "ut", "probo", "novum", "nobis", "pri", "viris", "ornatus", "mea", "et", "vix", "eu", "unum", "blandit", "accusamus", "quando", "dicant", "at", "sit", "nam", "novum", "error", "detracto", "id", "pro", "intellegat", "neglegentur", "in", "cum", "in", "everti", "causae", "molestiae", "aliquip", "petentium", "argumentum", "his", "ad", "debitis", "aliquando", "eu", "pro", "nisl", "minim", "civibus", "pri", "ne", "ad", "soleat", "splendide", "est", "id", "his", "viris", "insolens", "sensibus", "voluptua", "lobortis", "id", "vim", "dicit", "delicata", "tractatos", "ad", "eam", "vel", "quaeque", "deserunt", "an", "vero", "elaboraret", "persequeris", "est", "an", "mei", "ea", "viris", "decore", "sensibus", "eu", "audire", "referrentur", "eam", "dicta", "ponderum", "facilisi", "eam", "ea", "pri", "nobis", "recusabo", "pericula", "ut", "evertitur", "contentiones", "ad", "eos", "ius", "vivendum", "similique", "in", "scripta", "definitiones", "per", "cu", "senserit", "accusamus", "mea", "ex", "justo", "mediocrem", "et", "vix", "nam", "an", "integre", "dissentiunt", "nobis", "tritani", "evertitur", "est", "in", "sit", "munere", "delectus", "assentior", "eu", "viris", "tollit", "mei", "id", "aliquid", "vivendum", "ius", "at", "veri", "ridens", "usu", "ad", "natum", "regione", "ad", "usu", "luptatum", "menandri", "tractatos", "an", "ius", "dico", "persequeris", "usu", "no", "eu", "usu", "ferri", "noluisse", "patrioque", "tale", "mollis", "eu", "pro", "eu", "quot", "facer", "dolore", "qui", "no", "cibo", "nemore", "eos", "pro", "ea", "mediocrem", "consequat", "et", "qui", "suscipit", "apeirian", "affert", "primis", "ut", "vis", "pro", "ut", "iudicabit", "contentiones", "mea", "ne", "autem", "vivendo", "quaeque", "saperet", "pro", "in", "tota", "nominavi", "theophrastus", "mei", "an", "eam", "sale", "efficiendi", "cu", "repudiare", "reprimique", "has", "an", "alia", "vitae", "aliquid", "mei", "te", "te", "vim", "fugit", "epicuri", "intellegebat", "aliquando", "efficiantur", "ullamcorper", "nam", "ex", "labore", "volumus", "vix", "ei", "cu", "quot", "persequeris", "mel", "equidem", "albucius", "antiopam", "per", "ut", "eam", "et", "elit", "omnis", "dicta", "malorum", "iracundia", "eam", "no", "vel", "eu", "nibh", "ceteros", "brute", "quando", "ne", "eos", "pri", "ex", "harum", "cotidieque", "accumsan", "pertinacia", "at", "eam", "at", "rebum", "ceteros", "constituto", "has", "suavitate", "consulatu", "eam", "eu", "te", "atqui", "dissentias", "nec", "cu", "his", "sumo", "epicurei", "posse", "alienum", "propriae", "ea", "est", "mei", "ut", "deleniti", "probatus", "ex", "mazim", "omnes", "ius", "cu", "eos", "impetus", "pericula", "aliquid", "praesent", "democritum", "vis", "et", "ei", "nec", "ubique", "nemore", "ne", "vel", "nulla", "percipitur", "ponderum", "gubergren", "interesset", "vim", "in", "te", "veniam", "ignota", "molestie", "pro", "dicit", "bonorum", "at", "eum", "esse", "iusto", "dolorem", "vix", "ei", "quot", "recusabo", "est", "ex", "prima", "prodesset", "te", "cum", "ferri", "velit", "luptatum", "pro", "eu", "an", "eum", "alii", "phaedrum", "hendrerit", "temporibus", "sed", "cu", "sit", "id", "velit", "option", "integre", "virtute", "noluisse", "his", "an", "nam", "ei", "congue", "aperiri", "nam", "in", "probo", "praesent", "dignissim", "has", "senserit", "accommodare", "concludaturque", "cu", "et", "ridens", "ponderum", "partiendo", "eam", "vim", "ea", "dolor", "integre", "disputationi", "et", "mei", "cetero", "laboramus", "pri", "impetus", "aliquam", "adipisci", "an", "nec", "cu", "velit", "erant", "magna", "eruditi", "splendide", "no", "quo", "dico", "tantas", "postea", "mei", "no", "ex", "summo", "partem", "saperet", "mel", "mel", "tale", "fuisset", "oportere", "et", "dicat", "semper", "id", "duo", "id", "ubique", "deserunt", "eum", "at", "sed", "equidem", "veritus", "neglegentur", "atqui", "debitis", "no", "est", "at", "molestie", "platonem", "vix", "nec", "ne", "integre", "vivendum", "fuisset", "dolores", "mei", "eu", "no", "minimum", "definiebas", "mel", "pri", "quod", "rebum", "ancillae", "ad", "id", "eos", "habemus", "argumentum", "eu", "sed", "nusquam", "probatus", "gloriatur", "quo", "an", "dicta", "periculis", "temporibus", "pro", "ne", "mutat", "audire", "justo", "facilis", "docendi", "sea", "no", "est", "novum", "commodo", "cu", "at", "sea", "consul", "repudiare", "has", "at", "ridens", "semper", "disputando", "an", "nulla", "laoreet", "nec", "id", "porro", "omnium", "vituperata", "vel", "ne", "tibique", "evertitur", "neglegentur", "mea", "homero", "vocibus", "facilisi", "te", "sit", "in", "mutat", "facete", "laboramus", "quo", "at", "dolores", "invidunt", "laboramus", "his", "impetus", "eripuit", "reformidans", "eam", "ei", "sonet", "debitis", "praesent", "eu", "mea", "et", "vis", "brute", "luptatum", "inani", "nostro", "quaerendum", "te", "sea", "quot", "minim", "perfecto", "nec", "cu", "eam", "laoreet", "democritum", "eloquentiam", "an", "vidit", "errem", "pri", "at", "ne", "tritani", "signiferumque", "vis", "cum", "eu", "putent", "singulis", "assueverit", "duo", "ei", "nulla", "menandri", "abhorreant", "dicat", "blandit", "iudicabit", "duo", "ne", "vim", "at", "oporteat", "maiestatis", "cum", "eius", "eleifend", "an", "est", "eu", "persequeris", "suscipiantur", "duo", "ad", "vide", "atomorum", "convenire", "ad", "nec", "illum", "iriure", "persecuti", "no", "has", "errem", "lucilius", "intellegam", "id", "salutandi", "urbanitas", "pri", "sea", "ea", "labore", "probatus", "doming", "deserunt", "definitionem", "in", "pro", "vix", "at", "tamquam", "tractatos", "iracundia", "mea", "altera", "consectetuer", "et", "no", "sit", "tibique", "placerat", "postulant", "sea", "te", "civibus", "maluisset", "amet", "eros", "delenit"];

    function randWord() {
        return words[Math.floor(Math.random() * words.length)];
    }

    this.sentence = function (sentenceWordCount) {
        sentenceWordCount = sentenceWordCount || 10;
        var sentence = [];
        while (sentenceWordCount--) {
            sentence.push(randWord());
        }
        sentence = sentence.join(" ");
        sentence = sentence.charAt(0).toUpperCase() + sentence.slice(1);
        sentence += ".";
        return sentence;
    };

    this.paragraph = function () {

    };

    this.words = function (wordCount) {
        var words = [];
        while (wordCount--) {
            words.push(randWord());
        }
        words = words.join(" ");
        return words;
    };


});






angular.module("videotron.illico.common").constant("SERVICES_BASE_PATH", (function () {

    // modify to return mock server here
    return "/illicoservice";

})());
angular.module("videotron.illico.common").controller("CtrlAuthenticationError", ["$scope", "$routeParams", "$location", "$translate", "LoadingOverlay",
    function ($scope, $routeParams, $location, $translate, LoadingOverlay) {

        $scope.ErrorMessage = $routeParams.error || $translate.instant("Unknown error");

        LoadingOverlay.hide();

    }]);
angular.module("videotron.illico.common").controller("CtrlError", ["$scope", "$routeParams", "$window", "$location", "$translate", "LoadingOverlay", "$sce","NativeActions",
    function ($scope, $routeParams, $window, $location, $translate, LoadingOverlay, $sce, NativeActions) {

        // remove everything after the # (mobile) and then remove the /error (web)
        var backLinkHref = $location.absUrl().replace(/\#.+/, "").replace(/\/error.+/, "");
        var errorText = $routeParams.error || $translate.instant("Unknown error");
        var containsDebugParam = new RegExp(/debug/);

        NativeActions.trackEvent('Erreurs ENP', errorText, '');

        $scope.detailsVisible = false;
        $scope.ErrorMessage = $sce.trustAsHtml(errorText);
        $scope.ErrorButtonText = $translate.instant("Try again");

        $scope.reloadPage = function(){
            $window.location.href = backLinkHref;
        };


        if(containsDebugParam.test($location.absUrl())){
            $scope.detailsVisible = true;
        }

        LoadingOverlay.hide();

    }]);
angular.module("videotron.illico.common").controller("CtrlPerceptionError", ["$scope", "$routeParams", "$location", "$translate", "LoadingOverlay",
    function ($scope, $routeParams, $location, $translate, LoadingOverlay) {

        $scope.ErrorMessage = $routeParams.error || $translate.instant("Unknown error");

        LoadingOverlay.hide();

    }]);
// simple directive to load an alternate image in case an error occurs while loading original image
angular.module("videotron.illico.common").directive('fallbackSrc', function () {
    var fallbackSrc = {
        link: function postLink(scope, iElement, iAttrs) {
            iElement.bind('error', function() {
                // first make sure we haven't already switched the src
                // this avoids endless calls if fallback image returns a 404
                if(angular.element(this).attr("src") !== iAttrs.fallbackSrc){
//                console.error("use fallback image");
                    angular.element(this).attr("src", iAttrs.fallbackSrc);
                }
            });
        }
    }
    return fallbackSrc;
});

angular.module("videotron.illico.common").factory("BooleanObj", function () {

    function BooleanObj() {

        var state = false;

        this.isTrue = function () {
            return state;
        };

        this.isFalse = function () {
            return !state;
        };

        this.reset = function () {
            state = false;
        };

        this.set = function (value) {
            state = !!value;
        };

    }

    return function () {
        return new BooleanObj();
    };


});
angular.module("videotron.illico.common").factory("BoundedRange", function () {
    var min = Math.min;
    var max = Math.max;

    function BoundedRange() {
    }

    BoundedRange.prototype = {
        value: 0,
        max: 0,
        min: 0,
        extent: 0,
        newValue: 0,
        newMax: 0,
        newMin: 0,
        newExtent: 0,
        update: function () {
            this.newMin = parseInt(min(this.newMin, this.newMax));
            this.newMax = parseInt(max(this.newMax, this.newMin));
            this.newExtent = parseInt(max(0, min(this.newMax - this.newMin, this.newExtent)));
            this.newValue = parseInt(max(this.newValue, this.newMin));
            if (this.newValue + this.newExtent > this.newMax) {
                this.newValue = this.newMax - this.newExtent;
            }
            var hasChanged = this.newValue !== this.value || this.newMax !== this.max || this.newMin !== this.min || this.newExtent !== this.extent;
            if (hasChanged) {
                this.value = this.newValue;
                this.max = this.newMax;
                this.min = this.newMin;
                this.extent = this.newExtent;

                //console.log("hasChanged", this.value, this.max, this.min, this.extent)
            }
            return hasChanged;
        },
        getValue: function () {
            return this.value;
        },
        getMax: function () {
            return this.max;
        },
        getMin: function () {
            return this.min;
        },
        getExtent: function () {
            return this.extent;
        },
        setValue: function (value) {
            this.newValue = value;
        },
        increaseValue: function (value) {
            this.newValue = this.newValue + value;
        },
        setMax: function (max) {
            this.newMax = max;
        },
        setMin: function (min) {
            this.newMin = min;
        },
        setExtent: function (extent) {
            this.newExtent = extent;
        },
        getSize: function () {
            return this.max - this.min;
        }

    };


    return function () {
        return new BoundedRange();
    };


});
angular.module("videotron.illico.common").factory("Clock",
    ["Time", "EventDispatcher", "$timeout", function (Time, EventDispatcher, $timeout) {
        var DEFAULT_ACCURACY = Time.seconds(0.5);
        var FORCE_TIME_UPDATE = -1;

        var SECOND_CHANGE = "second_change";
        var TIME_ERROR = "time_error";
        var TIC_TAC_TIME_DIFF_THRESHOLD = 10;
        var TIC_TAC_TIME_DIFF_ERROR_THRESHOLD = Time.seconds(60);

        function webPageIsHidden(){
            var prefixes = ['webkit','moz','ms','o'];

            // if 'hidden' is natively supported just return it
            if ('hidden' in document) return document.hidden;

            // otherwise loop over all the known prefixes until we find one
            for (var i = 0; i < prefixes.length; i++){
                if ((prefixes[i] + 'Hidden') in document)
                    return document[prefixes[i] + 'Hidden'];
            }

            // otherwise it's not supported
            return null;
        }

        function Clock(Time, accuracy) {
            //accuracy === $timeout delay


            var isRunning = false;
            var timeoutPromise = null;
            var previousHostTime;
            var elapsedTimeSinceClockStart = 0;
            var referenceTime = 0;
            var eventDispatcher = new EventDispatcher();
            var time = 0;

            var timeSeconds = 0;


            function getHostTime() {
                return new Date().getTime();
            }


            function updateTime() {
                time = referenceTime + elapsedTimeSinceClockStart;
            }


            function tictac() {

                var currentHostTime = getHostTime();
                var timeDiff = currentHostTime - previousHostTime;

                // if more then 1 minute has passed, something is wrong (ie app minimized or tablet sleeping), reload the app
                if (Math.abs(timeDiff - accuracy) > TIC_TAC_TIME_DIFF_ERROR_THRESHOLD) {
                    // only trigger error if page is currently visible
                    if(!webPageIsHidden()){
                        eventDispatcher.dispatch(TIME_ERROR);
                    }else{
                        console.info("Time error not fired because page not visible");
                    }
                }

                // round time difference to accuracy (10 seconds) since $timeout not 100% accurate
                if (Math.abs(timeDiff - accuracy) > TIC_TAC_TIME_DIFF_THRESHOLD) {
                    timeDiff = accuracy;
                }


                previousHostTime = currentHostTime;
                elapsedTimeSinceClockStart += timeDiff;

                updateTime();

                var newTimeSeconds = Time.millisecondsToSeconds(time);

                if (timeSeconds !== newTimeSeconds) {
                    timeSeconds = newTimeSeconds;
                    eventDispatcher.dispatch(SECOND_CHANGE, timeSeconds);
                }
                $timeout.cancel(timeoutPromise);
                timeoutPromise = $timeout(tictac, accuracy);
            }

            this.getTime = function () {
                return time;
            };

            this.setReferenceTime = function (value) {
                if (isNaN(value) || value < 0) {
                    throw new Error("Invalid reference time : " + value + " thrown at " + new Date().toLocaleString());
                }
                referenceTime = value;
                updateTime();
            };

            this.start = function () {
                if (!isRunning) {
                    isRunning = true;
                    elapsedTimeSinceClockStart = 0;
                    timeSeconds = FORCE_TIME_UPDATE;
                    previousHostTime = getHostTime();
                    timeoutPromise = $timeout(tictac, accuracy);
                    tictac();
                }
            };

            this.stop = function () {
                if (isRunning) {
                    isRunning = false;
                    $timeout.cancel(timeoutPromise);
                }
            };

            this.isRunning = function () {
                return isRunning;
            };

            this.addExceptionHandler = function (listener) {
                return eventDispatcher.addListener(TIME_ERROR, listener);
            };


            //cycleSize === I want to be notified every X seconds
            function addTimeCycleListener(eventName, listener, cycleSize) {
                cycleSize = Math.max(1, cycleSize);
                var previousCycleTime = Time.millisecondsToSeconds(time);
                var balance = 0;
                var removeListener = eventDispatcher.addListener(eventName, function (event, cycleTime) {
                    var diff = cycleTime - previousCycleTime + balance;
                    if (diff >= cycleSize) {
                        balance = diff - cycleSize;
                        previousCycleTime = cycleTime;
                        listener.call(null, event, time);
                    }
                });
                return function () {
                    removeListener();
                };
            }

            this.addSecondCycleListener = function (listener, cycleSize) {
                return addTimeCycleListener(SECOND_CHANGE, listener, cycleSize);
            };


        }

        return function (accuracy) {
            accuracy = accuracy || DEFAULT_ACCURACY;
            return new Clock(Time, accuracy);
        };


    }]);
angular.module("videotron.illico.common").factory("Day", [function () {

    function Day(timeStamp) {
        this.time = timeStamp;
    }

    return function (timeStamp) {
        return new Day(timeStamp);
    };

}]);
angular.module("videotron.illico.common").factory("EventDispatcher", ["$rootScope", function ($rootScope) {


    function EventDispatcher(scope) {
        this.scope = scope;
    }

    EventDispatcher.prototype = {
        scope: null,
        addListener: function (event, listener) {
            return this.scope.$on(event, listener);
        },
        dispatch: function (event, data) {
			//TODO track events in order to remove useless events	
            this.scope.$emit(event, data);
            if (!$rootScope.$$phase) {
                $rootScope.$digest();
            }
        },
        destroy: function () {
            this.scope.$destroy();
            this.scope = null;
        }
    };

    return function () {
        return new EventDispatcher($rootScope.$new(true));
    };


}]);
angular.module("videotron.illico.common").factory("MouseDrag", [function () {

    // TODO this should be used on web to allow dragging of grid but currently not used do to lack of time to implement it

//    var DRAG_MOVE = "mousemove";
//    var DRAG_START = "mousedown";
//    var DRAG_END = "mouseup";

    function MouseDrag(element) {
//        var dragging = false;
//        var touchX = 0;
//        var startTouchX = 0;
//        var touchDX = 0;
//        var touchY = 0;
//        var startTouchY = 0;
//        var touchDY = 0;
//        var dragListener = angular.noop;
//        var dragStartListener = angular.noop;
//        var dragEndListener = angular.noop;
//
//        function touchMove(event) {
//            event = event.originalEvent;
//            event.preventDefault();
//            touchDX = touchX - event.clientX;
//            touchDY = touchY - event.clientY;
//            touchX = event.clientX;
//            touchY = event.clientY;
//            dragListener(null, {x: touchX, y: touchY, dx: touchDX, dy: touchDY, originalEvent: event});
//        }
//
//
//        function touchEnd(event) {
//            event = event.originalEvent;
//            if (touchDX !== 0 || touchDY !== 0) {
//                event.preventDefault();
//            }
//            dragEndListener(null, {x: touchX, y: touchY, dx: touchDX, dy: touchDY, originalEvent: event});
//
//            element.off(DRAG_MOVE, touchMove);
//            dragging = false;
//        }
//
//        function touchStart(event) {
//            event = event.originalEvent;
//            dragging = true;
//            startTouchX = touchX = event.clientX;
//            touchDX = 0;
//            startTouchY = touchY = event.clientY;
//            touchDY = 0;
//            dragStartListener(null, {x: touchX, y: touchY, dx: touchDX, dy: touchDY, originalEvent: event});
//            element.on(DRAG_MOVE, touchMove);
//        }
//
//        this.addDragListener = function (listener) {
//            dragListener = listener;
//        };
//
//        this.addDragStartListener = function (listener) {
//            dragStartListener = listener;
//        };
//
//        this.addDragEndListener = function (listener) {
//            dragEndListener = listener;
//        };
//
//        this.enable = function () {
//            element.on(DRAG_END, touchEnd);
//            element.on(DRAG_START, touchStart);
//        };
//
//        this.disable = function () {
//            element.off(DRAG_START, touchStart);
//            element.off(DRAG_END, touchEnd);
//            if (dragging) {
//                element.off(DRAG_MOVE, touchMove);
//                dragging = false;
//            }
//        };

    }


    return function (element) {
        return new MouseDrag(element);
    };


}]);
angular.module("videotron.illico.common").factory("TouchDrag", [function () {

    var DRAG = "drag";
    var DRAG_START = "drag_start";
    var DRAG_END = "drag_end";
    var TOUCH_START = "touchstart";
    var TOUCH_END = "touchend";
    var TOUCH_MOVE = "touchmove";

    function TouchDrag(element) {
        var dragging = false;
        var touchX = 0;
        var startTouchX = 0;
        var touchDX = 0;
        var touchY = 0;
        var startTouchY = 0;
        var touchDY = 0;
        var dragListener = angular.noop;
        var dragStartListener = angular.noop;
        var dragEndListener = angular.noop;

        function extractTouchXY(event) {
            var touches = event.touches;
            var result = {};
            if (touches.length === 1) {
                var touch = touches[0];
                result.x = touch.pageX;
                result.y = touch.pageY;
            } else {
                result.x = touchX;
                result.y = touchY;
            }
            return result;
        }

        function touchMove(event) {
            event = event.originalEvent;
            event.preventDefault();
            var touch = extractTouchXY(event);
            touchDX = touchX - touch.x;
            touchDY = touchY - touch.y;
            touchX = touch.x;
            touchY = touch.y;
            dragListener(null, {x: touchX, y: touchY, dx: touchDX, dy: touchDY, originalEvent: event});
        }


        function touchEnd(event) {
            event = event.originalEvent;
            if (touchDX !== 0 || touchDY !== 0) {
                event.preventDefault();
            }
            dragEndListener(null, {x: touchX, y: touchY, dx: touchDX, dy: touchDY, originalEvent: event});

            element.off(TOUCH_MOVE, touchMove);
            dragging = false;
        }

        function touchStart(event) {
            event = event.originalEvent;
            dragging = true;
            var touch = extractTouchXY(event);
            startTouchX = touchX = touch.x;
            touchDX = 0;
            startTouchY = touchY = touch.y;
            touchDY = 0;
            dragStartListener(null, {x: touchX, y: touchY, dx: touchDX, dy: touchDY, originalEvent: event});
            element.on(TOUCH_MOVE, touchMove);
        }

        this.addDragListener = function (listener) {
            dragListener = listener;
        };

        this.addDragStartListener = function (listener) {
            dragStartListener = listener;
        };

        this.addDragEndListener = function (listener) {
            dragEndListener = listener;
        };

        this.enable = function () {
            element.on(TOUCH_END, touchEnd);
            element.on(TOUCH_START, touchStart);
        };

        this.disable = function () {
            element.off(TOUCH_START, touchStart);
            element.off(TOUCH_END, touchEnd);
            if (dragging) {
                element.off(TOUCH_MOVE, touchMove);
                dragging = false;
            }
        };

    }


    return function (element) {
        return new TouchDrag(element);
    };


}]);
angular.module("videotron.illico.common").factory("Value", function () {
    //primitive value wrapper : used when you don't want to pass values around by copy
    function Value(initialValue) {
        var value = initialValue;
        this.toString = function () {
            return value;
        };
        this.setValue = function (newValue) {
            value = newValue;
        };
        this.getValue = function () {
            return value;
        };
    }

    return function (initialValue) {
        return new Value(initialValue);
    };
});
angular.module("videotron.illico.common").provider("AppConfig",
    function () {

        var serviceBasePath;
        var thumbsImagePathName = "thumbsImagePath";
        var largeThumbsImagePathName = "largeThumbsImagePath";
        var defaultImageFileNames = ["default_1.jpg", "default_2.jpg"];
        var hasBeenInitialized = false;

        this.setServiceBasePath = function (value) {
            serviceBasePath = value;
        };

        // optionally modify attribute used to find thumbs image path
        this.setThumbsImagePathName = function (value) {
            thumbsImagePathName = value;
        };
        this.setLargeThumbsImagePathName = function (value) {
            largeThumbsImagePathName = value;
        };
        this.setDefaultImageFileNames = function (arrayOrString) {
            defaultImageFileNames = arrayOrString;
        };

        function AppConfig($http, $q, HttpConfigs, APP_CONSTANTS, InitParams, SERVICES_BASE_PATH) {
            //TODO should be moved in another module ? YES should be moved into APP-IOS-COMMON (app config is not 'common')
            var data;
            // customProviderLogoPath added as a temporary hack for iPhone EPG
            var customProviderLogoPath = APP_CONSTANTS.customProviderLogoPath || false;
            var appName = APP_CONSTANTS.appName || "legacyWebview";
            var initPath = SERVICES_BASE_PATH + '/init?appName=' + appName;
            // local mock
            // var initPath = "/appEnp/dev_tools/init.json";

            var httpConfig = {
                method: 'GET',
                url: initPath,
                cache: false
            };

            this.isInitialized = function(){
                return hasBeenInitialized;
            };

            this.initialize = function () {
                var localHttpConfigs = HttpConfigs.getConfigs();
                //console.log("AppConfig", localHttpConfigs)
                angular.extend(httpConfig, localHttpConfigs);
                //console.log('httpConfig: ', httpConfig);
                // can be used to test version received from app in mock console
                // console.log(localHttpConfigs.headers.Accept)

                //always get new config data to have the actual time (see getNow() for detail)
                return $http(httpConfig).then(function (response) {
                    //console.log('AppConfig::response: ', response);
                    hasBeenInitialized = true;
                    data = response.data.body.main;
                    return data;
                }, function () {
                    return $q.reject("Loading config error.");
                });
            };

            this.setFromParentConfig = function (importedConfig) {
                data = importedConfig;
                hasBeenInitialized = true;
            };

            this.get = function () {
                return data;
            };

            this.getNow = function () {
                // test Daylight savings
                // spring - 02:00, mar 9, 2014
                // return 1394344774398;
                // fall - 02:00, nov 2, 2014
                // return 1414990711373;

                // return date in milliseconds
                return ENP.tsFromCustomDate(data.now);
            };

            this.getAppName = function () {
                return appName;
            };

            this.getEPGAppConstants = function () {
                var EPGAppConstants;
                if(!InitParams.isLargeScreen() && APP_CONSTANTS.ctrlEPGGrid && APP_CONSTANTS.ctrlEPGGrid.default && APP_CONSTANTS.ctrlEPGGrid.mobile){
                    EPGAppConstants = $.extend({}, APP_CONSTANTS.ctrlEPGGrid.default, APP_CONSTANTS.ctrlEPGGrid.mobile);
                }else if(APP_CONSTANTS.ctrlEPGGrid && APP_CONSTANTS.ctrlEPGGrid.default){
                    EPGAppConstants = APP_CONSTANTS.ctrlEPGGrid.default;
                }else{
                    EPGAppConstants = APP_CONSTANTS.ctrlEPGGrid;
                }
                return EPGAppConstants;
            };

            this.getPVRAppConstants = function () {
                var PVRAppConstants;
                if(!InitParams.isLargeScreen() && APP_CONSTANTS.ctrlPVRGrid && APP_CONSTANTS.ctrlPVRGrid.default && APP_CONSTANTS.ctrlPVRGrid.mobile){
                    PVRAppConstants = $.extend({}, APP_CONSTANTS.ctrlPVRGrid.default, APP_CONSTANTS.ctrlPVRGrid.mobile);
                }else if(APP_CONSTANTS.ctrlPVRGrid && APP_CONSTANTS.ctrlPVRGrid.default){
                    PVRAppConstants = APP_CONSTANTS.ctrlPVRGrid.default;
                }else{
                    PVRAppConstants = APP_CONSTANTS.ctrlPVRGrid;
                }
                return PVRAppConstants;
            };

            this.isTabletVersion = function(){
                return InitParams.isLargeScreen();
            };

            this.getExtraLinks = function(){
                return InitParams.getExtraLinks();
            };

            this.getLogoBasePath = function () {
                var providerLogo;
                if(customProviderLogoPath){
                    providerLogo = customProviderLogoPath;
                }else{
                    providerLogo = data.providersLogoPath || "";
                }
                return data.baseImagePath + providerLogo;
            };

            this.getThumbsBasePath = function () {
                return data.baseImagePath + data[thumbsImagePathName];
            };

            this.getLargeThumbsBasePath = function () {
                return data.baseImagePath + data[largeThumbsImagePathName];
            };

            this.getDefaultImageName = function () {
                var randomInt;
                if(angular.isArray(defaultImageFileNames)){
                    // return random image from array of images
                    randomInt = Math.floor(Math.random()*defaultImageFileNames.length);
                    return defaultImageFileNames[randomInt];
                }
                // return image if only 1 possibility
                return defaultImageFileNames;
            };

            this.getHelpPath = function () {
                return data.helpPath;
            };

        }

        this.$get = ["$http", "$q", "HttpConfigs", "APP_CONSTANTS", "InitParams", "SERVICES_BASE_PATH", function ($http, $q, HttpConfigs, APP_CONSTANTS, InitParams, SERVICES_BASE_PATH) {
            if (!angular.isDefined(serviceBasePath)){
                throw new Error("Service base path must be defined (AppConfigProvider.setServiceBasePath(xxx) in module config function)");
            }
            return new AppConfig($http, $q, HttpConfigs, APP_CONSTANTS, InitParams, SERVICES_BASE_PATH);
        }];

    });
angular.module("videotron.illico.common").service("AppServicesInitializer",
    ["InitParams", "$injector", "$q", "LoadingOverlay", function (InitParams, $injector, $q, LoadingOverlay) {

        function handleError(error){
            LoadingOverlay.hide();
            //initialization failure, the global error handler will redirect the user to the error page
            throw new Error(error);
        }

        this.initialize = function (services) {
            // generic promise object to be returned
            var defer = $q.defer();

            // we need to call the InitParams before anything else to set the clientModelVersion in HttpConfigs
            InitParams.initialize().then(function () {

                // Once InitParams are resolved, we can call the rest of the init services to bootstrap app
                // build array of promises
                for (var i = 0, count = services.length; i < count; i++) {
                    try {
                        //TODO check if a promise is returned by the service
                        services[i] = $injector.get(services[i]).initialize();
                    } catch (e) {
                        services[i] = $q.reject(services[i] + " initialization error : " + e.message);
                    }
                }

                // resolve once all promises complete
                $q.all(services).then(function (result) {
                    defer.resolve(result);
                }, function (error) {
                    handleError(error);
                });
            }, function(error){
                handleError(error);
            });

            return defer.promise;
        };


    }]);
//Illico Service http configs
// didn't use the standard $httpProvider to set defaults because timeout can not currently be set globally

angular.module("videotron.illico.common").service("HttpConfigs", ["InitParams", function (InitParams) {

    // TODO - this service and InitParams.getClientModelVersion() should return a promise
    // or even better moved to $httpProvider if setting timeout feature now available
    // to avoid returning the default version on calls before the native bridge init call is completed

    // quick fix was to transform vars into functions so InitParams.getClientModelVersion() was called every time
    // and not just when module is instantiated

    // private functions
    function defaultConfigs() {
        return {
            // specify timeout (in milliseconds) for a request, returns an error after time specified
            timeout: 60000,
            // specify client Model Version globally for API - equivalent to passing clientModelVersion=5 in URI
            headers: {
                "Accept": "application/json, text/plain, */*;version=" + InitParams.getClientModelVersion(),
                "Content-Type": "application/json;charset=UTF-8"
            }
        }
    }

    function putAndPostContentType() {
        return {
            // specific Content-Type for put/post requests
            headers: {
                "Content-Type": "application/json, text/plain, */*;version=" + InitParams.getClientModelVersion()
            }
        }
    }

    function recordingFormContentType() {
        return {
            // for some unknown reason, the recording service only passes with this config
            headers: {
                "Content-Type": "application/json;charset=UTF-8;version=" + InitParams.getClientModelVersion()
            }
        }
    }


    //public methods
    var getConfigs = function () {
        return defaultConfigs();
    };

    var deleteConfigs = function () {
        return defaultConfigs();
    };

    var postConfigs = function () {
        var postCombined = {};
        // using jQuery extend in order to deep extend objects (not shallow like angular.extend)
        jQuery.extend(true, postCombined, defaultConfigs(), putAndPostContentType());
        return postCombined;
    };

    var putConfigs = function () {
        var putCombined = {};
        // using jQuery extend in order to deep extend objects (not shallow like angular.extend)
        jQuery.extend(true, putCombined, defaultConfigs(), putAndPostContentType());
        return putCombined;
    };

    var recordingFormConfigs = function () {
        var combined = {};
        // using jQuery extend in order to deep extend objects (not shallow like angular.extend)
        jQuery.extend(true, combined, defaultConfigs(), recordingFormContentType());
        return combined;
    };

    // expose functions publicly
    return {
        getConfigs: getConfigs,
        putConfigs: putConfigs,
        postConfigs: postConfigs,
        recordingFormConfigs: recordingFormConfigs,
        deleteConfigs: deleteConfigs
    };
}]);
angular.module("videotron.illico.common").provider("HttpInterceptor",
    function () {



        var maintenanceUrl;
        var embeddedInWebsite = false;
        var urlsToBeTreated;

        function createInterceptor($q, $window, maintenanceUrl, $translate) {

            // when bundled into illico.tv website, there are 2 httpInterceptors in play that do very different things
            // this little function checks to see if we should be treating response or passing it on to the web interceptor
            // TODO there must be a cleaner way of doing this
            function shouldBeTreatedByThisModule(url){

                // if we're not in website, then all responses should be treated
                if(!embeddedInWebsite){
                    return true;
                }
                // if we are in website, only these service urls should be treated
                if(urlsToBeTreated.test(url)){
//                    console.info("treat error for url : ", url);
                    return true;
                }

                // let the web interceptor handle it
                return false;
            }

            function handleSuccess(response) {
                if(!shouldBeTreatedByThisModule(response.config.url)){
                    return response
                }

                //console.log("epg success", response.config.url)
                if (response.data.maintenance === true) {
                    $window.location.href = maintenanceUrl;
                }
                return response;
            }

            function handleError(error) {
                //console.log("handleError", error.isCustomError || !shouldBeTreatedByThisModule(error.config.url), error)

                if(error.isCustomError || !shouldBeTreatedByThisModule(error.config.url)){
                    return $q.reject(error)
                }

                //console.log("epg error", error.config.url)
                // special exceptions based on service called
                //*********************************************************
                var containsMetaData = new RegExp(/\/guide\/metadata/);
                if(containsMetaData.test(error.config.url)){
                    // this error should not break the page
                    var metaErrorMessage = (error.data && error.data.head && error.data.head.error && error.data.head.error.message) ? error.data.head.error.message : "Unknown error";
                    return $q.reject("Non fatal error : " + error.config.url + " : " + metaErrorMessage);
                }

                // special exceptions based on service called
                var containsGuidePrograms = new RegExp(/\/guide\/programs/);
                if(containsGuidePrograms.test(error.config.url)){
                    // this error should not break the page
                    var programsErrorMessage = (error.data && error.data.head && error.data.head.error && error.data.head.error.message) ? error.data.head.error.message : "Unknown error";
                    return $q.reject("Non fatal error : " + error.config.url + " : " + programsErrorMessage);
                }

                // normal error handling
                var status = error.status;
                var errorText = "";
                try{
                    errorText = error.data.head.error.message;
                }catch (e){
                    // no error message found
                    errorText = $translate.instant("Unknown error");
                }

                // make sure the customError names match those that are set in RedirectToErrorPageExceptionHandler.js
                var customError = new Error(errorText);
                customError.number = status;
                customError.name = "HttpInterceptor";
                customError.isCustomError = true;
                // include original data for handled errors, like recording conflicts
                customError.data = error.data || {};

                // special exception for failed recording
                var isRecordingUrl = new RegExp(/recordings/);
                if(isRecordingUrl.test(error.config.url) && error.config.method === "POST"){
                    // this error should not break the page
                    return $q.reject(customError);
                }

                // handle "normal" errors based on http status code
                switch (status) {
                    case 401:
                        // Unauthorized - Fatal error
                        // caused when user not logged in
                        customError.name = "authError";
                        throw customError;
                    case 403:
                        // Forbidden - Fatal error
                        // caused when user's account is flagged as being in perception (hasn't paid his bill)
                        customError.name = "perceptionError";
                        throw customError;
                    case 405:
                        // Conflict - Recoverable error
                        // caused when currently playing recording is deleted
                        // or when conflict resolution screen is open on tv and you try to delete something
                        return $q.reject(error);
                    case 409:
                        // Conflict - Recoverable error
                        // caused when current recording request has caused a conflict
                        return $q.reject(error);
                    default :
                        // Everything else - Generic fatal error
                        // number used to redirect to specific error pages, so remove it here
                        delete customError.number;
                        throw customError;

                        // alternate error - can be useful for debugging
                        //throw new Error("Network error " + "(" + error.status + ") : " + error.config.method + ":" + error.config.url + " : " + errorText);
                }

            }

            return {
                response: handleSuccess,
                responseError: handleError
            };
        }

        this.setMaintenanceUrl = function (value) {
            maintenanceUrl = value;
        };

        this.setEmbeddedInWebsite = function (regExp) {
            embeddedInWebsite = true;
            urlsToBeTreated = regExp;
        };


        this.$get = ["$q", "$window", "$translate", function ($q, $window, $translate) {
            if (!angular.isDefined(maintenanceUrl)){
                throw new Error("'errorUrl must be defined'");
            }
            return createInterceptor($q, $window, maintenanceUrl, $translate);
        }];

    });
angular.module("videotron.illico.common").service("InitParams", ["NativeActions", "$q", "$translate", function (NativeActions, $q, $translate) {

    var initParams;
    var DEFAULT_CURRENT_PLATFORM_ONLY = false;
    var DEFAULT_CLIENT_MODEL_VERSION = 777;
    var LARGE_DEVICE_TYPE = "TABLET";
    var DEFAULT_EPG_LINK = [{
        "link": {
            "analyticPageValue": "Chaines favorites",
            "parameters": {
                "requiresLogin": true
            },
            "template": "PROVIDER_SELECTIONS",
            "title": $translate.instant("Modify my favorites - Favorite channels link"),
            "uri": "/page/PG_PROVIDER_SELECTIONS"
        }
    }];
    var DEFAULT_PVR_LINK = [{
        link: {
            analyticPageValue: "Guide Horaire - Accueil",
            parameters: {
                requiresLogin: true
            },
            template: "TAB_EPG_RESULT",
            title: $translate.instant("How to program recording - Program guide link"),
            uri: "/page/PG_LANDING_PROGRAM_GUIDE"
        }
    }];
    // example of what iOS send us via the initParams
    var DEFAULT_COOKIES = [{
        "Name": "iPlanetDirectoryPro",
        "Secure": "TRUE",
        "Domain": ".videotron.com",
        "HttpOnly": "TRUE",
        "Path": "\/",
        "Created": 484692509,
        "Value": "ceGlSJ4DaVa36n6NusFDNlYk1OWwkbwiIvnFQwuUTmCCW0850wTJeXRV70RmL9aMLxnzUgAMEfZOppgXVMWDf56GsUjU\/QD3d\/zeHZK5FTR+mkeialHBPOS8IKMm9XNpOioBabyqqtPVt9MOF7yl2fTv3STEFbCRhl91IiV\/ISjilgF57gl6Lh2S+EGJvBmnyy+ncwXY2Z3b8scob+XzacZtbUzrJ6ZCPtOvJ7\/KwPUYKvXGVTpurgqsct1EV2fxumiz2owH7sfllSq7L8CelFTqBu5H+rrrqfzw8Qw\/2rJk6WNHglu9HG221qRgYO4+gIKfvURCk3PHEkJXKVj7yH0w208\/E0apgPZRJm8hlJzsfrBZafP03z4MeSNLKR5zFPIPEuhicGEHrd8dUZO\/MrATJ1I++ztcEl9SIsNQJBM=",
        "Expires": "2016-05-12 20:48:29 +0000"
    }, {
        "Name": "ssoTokenTypeCookie",
        "Secure": "TRUE",
        "Domain": ".videotron.com",
        "Path": "\/",
        "Created": 484692509,
        "Value": "1",
        "Expires": "2016-05-12 20:48:29 +0000"
    }, {
        "Name": "JSESSIONID",
        "Domain": window.location.hostname,
        "HttpOnly": "TRUE",
        "Path": "\/",
        "Created": 484752499,
        "Value": "0000X15Ra5HXd1pgWjvQgXjjhqK:16gs4dv37",
        "Discard": "TRUE"
    }, {
        "Domain": window.location.hostname,
        "Path": "\/",
        "Created": 484682518,
        "Value": "715971",
        "Name": "session-illico-profile",
        "Expires": "2017-05-12 18:01:57 +0000"
    }, {
        "Domain": window.location.hostname,
        "Path": "\/",
        "Created": 484682514,
        "Value": "supportillico",
        "Name": "session-username",
        "Expires": "2017-05-12 18:01:53 +0000"
    }];

    var debugParam = new RegExp(/debug/);
    var url = window.location.href;

    // provide default links for EPG and PVR by checking page url to know which app we're currently using
    var isEpgAppMatcher = (/epg-/i).test(url);
    var DEFAULT_EXTRA_LABELS = (isEpgAppMatcher) ? DEFAULT_EPG_LINK : DEFAULT_PVR_LINK;

    function setAuthCookies(cookies) {
        var COOKIES_TO_USE = ["session-username", "JSESSIONID", "session-illico-profile"];
        var KEYS_TO_USE = ["Name", "Value", "Domain", "Path", "Expires"];
        for (var i = 0, iLen = cookies.length; i < iLen; i++) {
            var cookie = cookies[i];
            var cookieString = "";
            var isValid = true;
            if (COOKIES_TO_USE.indexOf(cookie[KEYS_TO_USE[0]]) !== -1) {
                for (var j = 0, jLen = KEYS_TO_USE.length; j < jLen; j++) {
                    var key = KEYS_TO_USE[j];
                    if (cookie[key] === "undefined") {
                        isValid = false;
                    }
                }
                if (isValid) {
                    cookieString = cookie[KEYS_TO_USE[0]] + "=" + cookie[KEYS_TO_USE[1]] + ";";
                    cookieString += " " + KEYS_TO_USE[2] + "=" + cookie[KEYS_TO_USE[2]] + ";";
                    cookieString += " " + KEYS_TO_USE[3] + "=" + cookie[KEYS_TO_USE[3]].replace("\\", "") + ";";
                    if (cookie[KEYS_TO_USE[4]] && cookie[KEYS_TO_USE[4]] !== null) {
                        cookieString += " expires=" + new Date(cookie[KEYS_TO_USE[4]]).toUTCString() + ";";
                    }
                    console.log("set cookie -> ", cookieString);
                    document.cookie = cookieString;
                }
            }
        }
    }

    function logInitValues(initParams, mode){
        console.log("received clientModelVersion: ", initParams.clientModelVersion);
        console.log("received deviceType: ", initParams.deviceType);
        if(mode){
            console.log("received extraLabels: ", initParams.extraLabels);
            console.log("received cookies: ", initParams.cookies);
            console.log("DEBUG MODE, SETTING initParams TO : ", initParams);
        }else{
            console.log("received extraLabels: ", JSON.stringify(initParams.extraLabels));
            console.log("received cookies: ", JSON.stringify(initParams.cookies));
            console.log("full init payload : ", JSON.stringify(initParams));
        }

    }

    this.initialize = function () {
        var deferred = $q.defer();
        // if initParams have already been set, return as promise data
        // this happens while navigation on the illico.tv site when we leave page the return to it for example
        if (initParams) {
            deferred.resolve(initParams);
            return deferred.promise;
        }

        return NativeActions.init().then(function (data) {
            initParams = data;

            // TODO validate use of JSON.parse here
            // not needed on iOS8/Webkit, validate android and remove if possible
            if (typeof(initParams) === "string") {
                console.warn("initParams is a string");
                initParams = JSON.parse(initParams);
            }

            logInitValues(initParams);

            // Only needed by iOS, so make sure we receive them here
            if (initParams.cookies) {
                setAuthCookies(initParams.cookies);
            }

            return initParams;

        }, function () {

            /*************************************************************************************/
            // ON ERROR
            // for debugging outside of webview, force fake return data by adding debug to url
            /*************************************************************************************/


            if (debugParam.test(url)) {
                // check params for currentPlatformOnly or provide default
                var platformMatcher = url.match(/currentPlatformOnly=([^&#]*)/);

                // check params for clientModelVersion or provide default
                var modelMatcher = url.match(/clientModelVersion=(\d*\.?\d*)/);

                // check params for deviceType or provide default
                var deviceTypeMatcher = url.match(/deviceType=(\w*)/i);


                var forcedCurrentPlatformOnly = (platformMatcher && platformMatcher[1]) ? platformMatcher[1] : DEFAULT_CURRENT_PLATFORM_ONLY;
                var forcedClientModelVersion = (modelMatcher && modelMatcher[1]) ? modelMatcher[1] : DEFAULT_CLIENT_MODEL_VERSION;
                var forcedDeviceType = (deviceTypeMatcher && deviceTypeMatcher[1]) ? deviceTypeMatcher[1].toUpperCase() : LARGE_DEVICE_TYPE;


                initParams = {
                    currentPlatformOnly: forcedCurrentPlatformOnly,      // used in ios for state of ipad/tv switch
                    clientModelVersion: forcedClientModelVersion,        // used to add version to http headers for illicoCore
                    deviceType: forcedDeviceType,                        // used to adapt AppConfigs depending on deviceType
                    extraLabels: DEFAULT_EXTRA_LABELS,                   // link towards another part of the app received from the back-end
                    cookies: DEFAULT_COOKIES                             // array of cookies that need to be set to fix suthentication problems with WkWebView
                };


                logInitValues(initParams, "debugMode");

                setAuthCookies(initParams.cookies);

                return initParams;
            } else {
                return $q.reject("InitParams error (unable to contact the device).");
            }
        });
    };


    this.getCurrentPlatformOnly = function () {
        var result = DEFAULT_CURRENT_PLATFORM_ONLY;
        if (initParams) {
            result = initParams.currentPlatformOnly || result;
        }
        return result;
    };


    this.getClientModelVersion = function () {
        var result = DEFAULT_CLIENT_MODEL_VERSION;
        if (initParams) {
            result = initParams.clientModelVersion || result;
        }
        return result;
    };


    this.isLargeScreen = function () {
        var result = false;
        if (initParams) {
            if (initParams.deviceType) {
                // different possile return values
                // TABLET
                // MOBILE
                result = (initParams.deviceType === LARGE_DEVICE_TYPE);
            }
        }
        return result;
    };


    this.getExtraLinks = function () {
        var result = DEFAULT_EXTRA_LABELS[0].link;
        if (initParams && initParams.extraLabels) {
            // extraLabels is array but only contains 1 item for now to simplify native code
            // if ever more then one is needed, native will need t be modified
            result = initParams.extraLabels[0].link;
        }
        return result;
    };


}]);

angular.module("videotron.illico.common").service("LocalStorage", function () {

    var UNDEFINED = "undefined";
    // Careful - Android webview returns true even if not explicitly enabled, causing a js error
    // to enable in Android webview --> settings.setDomStorageEnabled(true)
    var LOCAL_STORAGE_AVAILABLE = typeof(Storage)!== UNDEFINED;

    function setValue(k,v){
        if(LOCAL_STORAGE_AVAILABLE){
            // convert to JSON if value is an object
            if(typeof(v) === "object"){
                v = JSON.stringify(v);
            }
            localStorage[k] = v;
            return true;
        }else{
            return false;
        }
    }

    this.set = function(key, val){
        return setValue(key, val);
    };

    this.get = function(key){
        var data;
        if(LOCAL_STORAGE_AVAILABLE){
            data = localStorage[key];
            try{
                return JSON.parse(data);
            }catch(e){
                return data;
            }
        }else{
            return UNDEFINED;
        }
    };

    this.remove = function(key){
        return setValue(key, UNDEFINED);
    };

});
angular.module("videotron.illico.common").service("NormalizeAccentedCharacters", function () {

    // remplace tous les charactere speciaux par des équivalents
    // transforme aussi tous les charactere en minuscule
    var normalizeAccentedChars = (function() {
        //var translate_re = /[àâçéèêëîïôûùüÿæœ\d]|radio/ig;
        var translate_re = /^\d|[àâçéèêëîïôûùüÿæœ]/ig; // replace first digit with zzz so they are after all alpha
        //var translate_re = /[àâçéèêëîïôûùüÿæœ]/ig;
        var translate = {
            "à": "a",
            "â" : "a",
            "ç" : "c",
            "é" : "e",
            "è" : "e",
            "ê" : "e",
            "ë" : "e",
            "î" : "i",
            "ï" : "i",
            "ô" : "o",
            "û" : "u",
            "ù" : "u",
            "ü" : "u",
            "ÿ" : "y",
            "æ" : "ae",
            "œ" : "oe",
            "0" : "zzz",
            "1" : "zzz",
            "2" : "zzz",
            "3" : "zzz",
            "4" : "zzz",
            "5" : "zzz",
            "6" : "zzz",
            "7" : "zzz",
            "8" : "zzz",
            "9" : "zzz"
            //,
            //"radio" : "zzz"
        };
        return function(s) {
            // handle recording without a title to avoid crash
            if(!s){
                return "undefined";
            }
            return ( s.toLowerCase().replace(translate_re, function(match) {
                return translate[match];
            }) );
        };
    })();

    this.get = function (str) {
        //console.log("normalizeAccentedChars", str, normalizeAccentedChars(str));
        return normalizeAccentedChars(str);
    };

});
angular.module("videotron.illico.common").provider("$exceptionHandler", function () {

    var errorPageUrl;
    var authenticationErrorPageUrl;
    var perceptionErrorPageUrl;
    var inDebugMode;

    var alreadyReceivedError = false;
    var embeddedInWebsite = false;
    var urlsOfPagesToHandleRegExp;

    this.setErrorPageUrl = function (value) {
        errorPageUrl = value;
    };

    this.setAuthenticationErrorPageUrl = function (value) {
        authenticationErrorPageUrl = value;
    };

    this.setPerceptionErrorPageUrl = function (value) {
        perceptionErrorPageUrl = value;
    };

    this.setEmbeddedInWebsite = function (regExp) {
        embeddedInWebsite = true;
        urlsOfPagesToHandleRegExp = regExp;
    };

    this.$get = ["$injector", function ($injector) {
        if (!errorPageUrl || !authenticationErrorPageUrl || !perceptionErrorPageUrl) {
            throw new Error("'$exceptionHandler' not completely configured");
        }

        return function (exception, cause) {
            //$location can not be injected here because it create a circular dependency error...
            var $location = $injector.get("$location");
            var $translate = $injector.get("$translate");

            // TODO - create global debug state instead of constantly testing params
            inDebugMode = $location.search().debug || false;
            //console.info("inDebugMode", $location.search(), inDebugMode)
            // add ?debug to url to set debug mode
            // or
            // inDebugMode = true; // force to true here, but don't commit!

            //console.log("$exceptionHandler", alreadyReceivedError, exception, cause);

            // make sure the first error that occurs is the one reported to the user
            if (!alreadyReceivedError) {

                if (!embeddedInWebsite || (embeddedInWebsite && urlsOfPagesToHandleRegExp.test($location.absUrl()))) {

                    // while on website, it's possible to change page and then come back,
                    // so we'll need to display error again
                    if (!embeddedInWebsite) {
                        alreadyReceivedError = true;
                    }

                    // if not in debug mode and this is not a http error, it must be a javascript error, so show sanitized error to the user
                    // make sure the conditions' names match those that are set in HttpInterceptor.js
                    if (!inDebugMode && exception.name !== "HttpInterceptor" && exception.name !== "authError" && exception.name !== "perceptionError") {
                        exception.message = $translate.instant("Sanitized JavaScript error");
                    }

                    var page = errorPageUrl;
                    if (exception.name === "authError") {
                        page = authenticationErrorPageUrl;
                    } else if (exception.name === "perceptionError") {
                        page = perceptionErrorPageUrl;
                    }
                    $location.path(page);
                    $location.search("error", exception.message);
                }
                //else{
                //     console.error("ignore this error, not on EPG page", exception.message)
                //}
            }
            // but it could be useful to see all errors in the console
            if (inDebugMode) {
                console.error(exception.stack);
            }
        };
    }];

});
angular.module("videotron.illico.common").service("SrvTerminals",
    ["$http", "HttpConfigs", "$q", "SERVICES_BASE_PATH", "AppConfig", function ($http, HttpConfigs, $q, SERVICES_BASE_PATH, AppConfig) {

        var terminals;
        var hasLegacyTerminals = false;

        this.get = function () {
            return terminals;
        };

        // self initializing get promise
        this.getTerminalsPromise = function () {
            var defered = $q.defer();
            if(terminals){
                //console.info("SrvTerminals - loaded", terminals);
                defered.resolve(terminals);
            }else{
                // if not already defined, initialize now and return promise
                this.initialize().then(function(response){
                    //console.info("SrvTerminals - get initialize", response);
                    defered.resolve(response);
                });

            }
            return defered.promise;
        };

        this.hasTerminals = function () {
            return terminals && terminals.length > 0;
        };

        this.hasLegacyTerminals = function () {
            return hasLegacyTerminals;
        };

        this.getTerminalById = function (value) {
            var result = null;
            var i = terminals.length;
            while (i--) {
                var terminal = terminals[i];
                if (terminal.macAddress === value) {
                    result = terminal;
                    break;
                }
            }

            return result;
        };

        this.initialize = function () {
            var recordersPath = SERVICES_BASE_PATH + "/terminals/recorders";
            // local mock
            // var recordersPath = "/appEnp/dev_tools/recorders.json";
            return $http.get(recordersPath, HttpConfigs.getConfigs()).then(function (response) {
                var result = response.data.body.main;
                var APP_CONST = AppConfig.getPVRAppConstants();
                terminals = result.terminals;
                // some apps support legacy terminals
                hasLegacyTerminals = result.incomplete && APP_CONST.SHOW_LEGACY_TERMINAL_WARNINGS;
                return terminals;
            }, function (error) {
                // app can't run without terminals so die on error
                return $q.reject(error);
            });
        };

    }]);

angular.module("videotron.illico.common").service("Time", function () {

    var round = Math.round;
    var MILLISECOND = 1;
    var SECOND = MILLISECOND * 1000;
    var MINUTE = SECOND * 60;
    var HOUR = MINUTE * 60;
    var DAY = HOUR * 24;

    this.millisecondsToHours = function (milliseconds) {
        return round(milliseconds / HOUR);
    };

    this.millisecondsToMinutes = function (milliseconds) {
        return round(milliseconds / MINUTE);
    };

    this.millisecondsToSeconds = function (milliseconds) {
        return round(milliseconds / SECOND);
    };

    this.millisecondsToNumberOfDays = function (milliseconds) {
        return round(milliseconds / DAY);
    };

    this.extractMidnightDate = function(milliseconds){
        var date = new Date(milliseconds);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
    };

    this.tomorrow = function(milliseconds){
        var date = new Date(milliseconds);
        date.setDate(date.getDate()+1);
        return date.getTime();
    };

    this.minutesToHoursAndMinutes = function(minutes){
        var mins = parseInt(minutes);
        if (isNaN(mins)) {
            mins = 0;
        }
        var hours = Math.floor(mins / 60);
        mins = mins - (hours * 60);
        return {
            hours: hours,
            minutes: mins
        };
    };


    this.millisecond = function () {
        return MILLISECOND;
    };

    this.milliseconds = function (f) {
        return MILLISECOND * f;
    };

    this.second = function () {
        return SECOND;
    };

    this.seconds = function (f) {
        return SECOND * f;
    };

    this.minute = function () {
        return MINUTE;
    };

    this.minutes = function (f) {
        return MINUTE * f;
    };

    this.hour = function () {
        return HOUR;
    };

    this.hours = function (f) {
        return HOUR * f;
    };


    this.hoursToMinutes = function (hours) {
        return round(hours * 60);
    };

    this.hoursToMilliseconds = function (hours) {
        return round(hours * 60);
    };

    this.day = function () {
        return DAY;
    };

    this.days = function (f) {
        return DAY * f;
    };

    // returns next day and does not break for daylight savings
    this.nextDay = function (ts) {
        var date = new Date(ts);
        var nextDay = date.setDate(date.getDate() + 1);
        return nextDay;
    };


});
angular.module("videotron.illico.common").service("Timestamp", function () {

    this.get = function () {
        return new Date().getTime();
    };


});
angular.module("videotron.illico.common").service("UID", function () {
    //naive uid service : )
    var UID = 0;
    this.get = function (prefix) {
        prefix = prefix || "uid-";
        return (prefix + UID++).toString();
    };
});
angular.module("videotron.illico.common.loadingOverlay").provider("LoadingOverlay", function () {

    // HTML loading overlay used

    // default path, over written by setTemplatePath
    var templatePath = "/appEnp/templates/common-web/loadingOverlay.template.html";
    var appendNode;

    function LoadingOverlay($timeout, $templateCache, templatePromise, translatedText) {

        var counter = 0;
        var template;
        var that = this;

        templatePromise.then(
            function (result) {

                $templateCache.put("templateCodeId", result.data);
                var templateCode = $templateCache.get("templateCodeId");

                if (!angular.isDefined(templateCode)) {
                    throw new Error("template is missing (not found in $templateCache)");
                }

                template = angular.element(templateCode.replace(/^\s*/, ""));

                $(".spinnerText", template).text(translatedText)

            }
        ).catch(
            function (error) {
                throw new Error("LoadingOverlay : template not found here >>> " + templatePath);
            }
        );

        this.show = function () {
            //console.log("show", counter)
            if (template) {
                if (counter === 0) {
                    appendNode.append(template);
                }
                counter++;
            } else {

                // overlay not ready yet,  try later
                $timeout(that.show, 10);
            }
        };

        this.hide = function () {
            //console.log("hide", counter)
            if (template) {
                counter--;
                if (counter === 0) {
                    template.remove();
                }else if(counter < 0){
                    counter = 0;
                }
            }
        };

    }

    this.setTemplatePath = function (value) {
        templatePath = value;
    };

    this.setAppendNode = function (selector) {
        appendNode = angular.element(selector);
    };

    this.$get = ["$templateCache", "$document", "$http", "$timeout", "$translate", function ($templateCache, $document, $http, $timeout, $translate) {

        appendNode = appendNode || angular.element($document[0].body);
        var templatePromise = $http.get(templatePath);
        var translatedText = $translate.instant("Loading");

        return new LoadingOverlay($timeout, $templateCache, templatePromise, translatedText);

    }];


});
angular.module("videotron.illico.native-bridge-send").factory("NativeBridgeSend", ["$document", function ($document) {

    function NativeBridgeSend(bridgeOutExpression, contextRoot, bridgeIn) {
        //console.log(bridgeOutExpression, contextRoot, bridgeIn)

        var ACTION_KEY = "type";

        this.send = function (action, data, callbackId) {
            data = data || {};
            if (data[ACTION_KEY]) {
                throw new Error(ACTION_KEY + " is already defined");
            } else {
                data[ACTION_KEY] = action;
            }

            // removed before production
//            console.log("bridgeOut-web", action, data, callbackId);

            if(contextRoot[bridgeOutExpression] && typeof contextRoot[bridgeOutExpression][action] === "function"){
                contextRoot[bridgeOutExpression][action](data, callbackId);
            }else{
                console.error(bridgeOutExpression + "." + action + " not defined, so it was not called");
            }
        };

    }

    return function (bridgeOutExpression, contextRoot) {
        return new NativeBridgeSend(bridgeOutExpression, contextRoot);
    };

}]);

angular.module("videotron.illico.native-bridge").provider("NativeBridge", function NativeBridgeProvider() {
    var DEFAULT_BRIDGE_IN_EXPRESSION = "bridgeIn";
    var DEFAULT_BRIDGE_OUT_EXPRESSION = "bridgeOut";
    var ALL_EVENTS = "*";
    var TIMEOUT;
    var bridgeInExpression = DEFAULT_BRIDGE_IN_EXPRESSION;
    var bridgeOutExpression = DEFAULT_BRIDGE_OUT_EXPRESSION;

    function NativeBridge(bridgeInExpression, eventDispatcher, $q, window, NativeBridgeSend, $timeout) {
        var sendService;
        var callbacks = {};
        var callbacksCount = 0;

        function registerBridgeInFunction(bridgeInExpression, bridgeInFunction, contextRoot) {
            var expressionParts = bridgeInExpression.split(".");
            var functionName = expressionParts.pop();
            for (var i = 0, namespacePartCount = expressionParts.length; i < namespacePartCount; i++) {
                var namespace = expressionParts[i];
                contextRoot = contextRoot[namespace] = contextRoot[namespace] || {};
            }
            contextRoot[functionName] = bridgeInFunction;
        }

        function bridgeIn(action, data, callbackId) {

            // removed before production
//            if(data){
//                console.log("bridgeIn called with data", data.type, action, data, callbackId);
//            }else{
//                console.log("bridgeIn called", action, data, callbackId);
//            }

            if (angular.isDefined(callbackId)) {
                var deferred = callbacks[callbackId];
                if (deferred) {
                    delete callbacks[callbackId];
                    deferred.resolve(data);
                }
            } else {
                eventDispatcher.dispatch(action, data);
                data = {action: action, data: data};
                eventDispatcher.dispatch(ALL_EVENTS, data);
            }
        }

        this.send = function (action, data, timeout) {
            var callbackId = callbacksCount++;
            var deferred = $q.defer();
            callbacks[callbackId] = deferred;
            sendService.send(action, data, callbackId);
            timeout += 0;
            if (!isNaN(timeout)) {
                $timeout(function () {
                    if (callbacks[callbackId]) {
                        delete callbacks[callbackId];
                        deferred.reject(TIMEOUT);
                    }
                }, timeout);
            }
            return deferred.promise;
        };

        // allows shortcut for illico.tv integration
        this.receive = bridgeIn;

        this.on = function (action, callback) {
//            console.log('NativeBridge::$on');
//            console.log('action: ',action);
//            console.log('callback: ',callback);
            return eventDispatcher.addListener(action, callback);
        };

        this.onAll = function (callback) {
            return eventDispatcher.addListener(ALL_EVENTS, callback);
        };

        registerBridgeInFunction(bridgeInExpression, bridgeIn, window);

        sendService = new NativeBridgeSend(bridgeOutExpression, window, bridgeIn);

    }

    this.$get = ["$window", "$q", "EventDispatcher", "NativeBridgeSend", "$timeout", function ($window, $q,
                                                                                               EventDispatcher,
                                                                                               NativeBridgeSend,
                                                                                               $timeout) {
        var eventDispatcher = new EventDispatcher();
        return new NativeBridge(bridgeInExpression, eventDispatcher, $q, $window, NativeBridgeSend, $timeout);
    }];

    this.setBridgeINExpression = function (value) {
        bridgeInExpression = value || DEFAULT_BRIDGE_IN_EXPRESSION;
    };

    this.setBridgeOUTExpression = function (value) {
        bridgeOutExpression = value || DEFAULT_BRIDGE_OUT_EXPRESSION;
    };


});
angular.module("videotron.illico.common.web").constant("APP_CONSTANTS", (function () {
    return {
        appName: "webEpgPvr",
        ctrlEPGGrid : {
            CHANNELS_COLUMN_WIDTH : 147,
            PROGRAMS_STICK_LEFT_EDGE : false,
            TIMELINE_ROW_HEIGHT : 40,
            PIXELS_PER_MINUTE : 6,
            MINIMUM_MINUTES_IN_PROGRAM : 12, // 44px minimum on iPad, so no lower then 8 - > PIXELS_PER_MINUTE * MINIMUM_MINUTES_IN_PROGRAM = 48
            HOURS_OF_PROGRAMS_TO_LOAD : 8,
            PRELOAD_PREVIOUS_CHANNELS_MULTIPLIER : 1,
            PRELOAD_NEXT_CHANNELS_MULTIPLIER : 2,
            MIN_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME : 10,
            MAX_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME : 30,
            CHANNEL_ROW_HEIGHT : 80,
            CHANNEL_GROUP_ROW_HEIGHT : 80,
            FIRST_GROUP_DELIMITER_ROW_HEIGHT : 50,
            GROUP_DELIMITER_ROW_HEIGHT : 80,
            NOW_BUTTON_WIDTH : 100,
            NOW_BUTTON_HEIGHT : 60,
            FREE_PREVIEW_TOOL_TIP_HIDE_DELAY : 5000,
            FREE_PREVIEW_TOOL_TIP_SHOW_DELAY : 500,
            CHANNEL_CLICK_ONLY_TOGGLES_FAVORITES : true,
            MODALS_TRIGGERED_BY_ROUTE_CHANGE : false,
            USE_NATIVE_VERTICAL_SCROLL : true,
            TIMELINE_IS_POSITION_ABSOLUTE : false
        },
        ctrlPVRGrid : {
            SHOW_LEGACY_TERMINAL_WARNINGS : false,
            RECORDING_ROW_HEIGHT : 110,
            SERIES_GROUP_ROW_HEIGHT : 110,
            GROUP_DELIMITER_ROW_HEIGHT : 38,
            FIRST_GROUP_DELIMITER_ROW_HEIGHT : 38,
            RECORDING_ROW_STYLE : "web",
            RECORDING_DATE_FORMAT : "long",
            ALLOW_SWIPE_DELETE : true,
            ALLOW_LONG_PRESS : false,
            MODALS_TRIGGERED_BY_ROUTE_CHANGE : false,
            USE_NATIVE_VERTICAL_SCROLL : true
        }
    };
})());
angular.module("videotron.illico.common.web").service("NativeActions", ["NativeBridge", "$translate", "SimpleModal", "EPGExtraFilters", "LoadingOverlay", function NativeActions(NativeBridge, $translate, SimpleModal, EPGExtraFilters,LoadingOverlay) {

    // BRIDGE IN

    // Global event listener to close all modals
    NativeBridge.on("hideContentDetails", function(){
        var simpleModal = new SimpleModal();
        simpleModal.closeAll();
    });

    // Global event listener to reset filters
    NativeBridge.on("resetFilters", function(){
        EPGExtraFilters.resetFilters();
    });

    // Global event listener to show/hide EPG loader
    NativeBridge.on("EPGLoaderShow", function(){
        LoadingOverlay.show();
    });
    NativeBridge.on("EPGLoaderHide", function(){
        LoadingOverlay.hide();
    });


    // EPG in
    this.onFilterChange = function (listener) {
        return NativeBridge.on("setFilter", listener);
    };

    this.onPlatformChange = function (listener) {
        return NativeBridge.on("setPlatform", listener);
    };

    this.onMetaDataUpdateRequest = function (listener) {
        return NativeBridge.on("updateData", listener);
    };

    this.onProfileDataUpdateRequest = function (listener) {
        return NativeBridge.on("updateProfile", listener);
    };

    // PVR in
    this.onUpdateData = function (listener) {
        return NativeBridge.on("updateData", listener);
    };

    this.onAppWakeUp = function (listener) {
        return NativeBridge.on("appWakeUp", listener);
    };

    // Content Details in
    this.onShowContentDetails = function (listener) {
//        console.log('onShowContentDetails()');
        return NativeBridge.on("showContentDetails", listener);
    };

    // BRIDGE OUT


    // epg out

//    this.addToFavorites = function(channelIsFavorite){
//        if(!channelIsFavorite){
//            NativeBridge.send("addToFavorites", {});
//        }
//    };

    // pvr out

    this.manualRecording = function () {
        NativeBridge.send("sendManualRecording", {
            "analyticPageValue": {
                "action": "enregistrer_man",
                "category": "Terminal",
                "label": "Enregistrement manuel"
            },
            "uri": "/recordings",
            "uri_type": "POST"
        });
    };

    this.openEpg = function () {
        var epg_link = {
            "link": {
                "analyticPageValue": "Guide Horaire",
                "id": "-1792300803380116938",
                "parameters": {
                    "requiresLogin": true
                },
                "template": "TAB_EPG_RESULT",
                "title": $translate.instant("EPG PAGE TITLE"),
                "uri": $translate.instant("EPG PAGE URL - WEB")
            }
        };

        NativeBridge.send("link", epg_link);
    };

    this.helpMissingTerminal = function (helpPath) {
        var help_link = {
            "link": {
                "analyticPageValue": "appEnp/help-ios.html?lang=fr",
                "displayInNewTab": false,
                "id": "2182656831942407129",
                "type": "NORMAL",  // NORMAL is the modal with the cancel button
                "template": "WEBVIEW",
                "title": $translate.instant("HELP PAGE TITLE"),
                "uri": helpPath + "?key=accesContenu&scrollTo=otherTerminals"
            }
        };
        NativeBridge.send("link", help_link);
    };

    this.editTerminalName = function () {

        var edit_terminal_link = {
            "link": {
                "analyticPageValue": "Modifier nom du terminal",
                "template": "SETTINGS",
                "type": "PAGE",
                "parameters": {
                    "goto": "terminals"
                },
                "title": $translate.instant("PREFERENCES PAGE TITLE"),
                "uri": "/preferences/123456"
            }
        };
        NativeBridge.send("link", edit_terminal_link);
    };


    // common

    this.init = function () {
        // response comes from enpWebBridgeOut.init in IllicoWebClient
        return NativeBridge.send("init", null, 2000);
    };


    this.link = function (data) {
        //if there is no link data : DO NOTHING (recording or channel with no LINK is possible)
        if (angular.isDefined(data) && angular.isDefined(data.link)) {

            if(data.link && data.link.template === "CONTENT"){
                NativeBridge.receive("showContentDetails", data.link);
            }else if(data.link.uri === "chaines/null" || data.link.uri === "channels/null"){
                // channels that do not exist on web platform get this broken uri
                // do nothing instead of sending to 404 page - IWEB-405
                console.log(data.title + " does not have a channel page defined, so do nothing");
            }else{
                NativeBridge.send("link", {link: data.link});
            }


        }
    };


    this.trackPageView = function (url, title) {
        NativeBridge.send("trackPageView", {
            url: url,
            title: title
        });
    };

    this.trackEvent = function (category, action, label) {
        NativeBridge.send("trackEvent", {
            category: category,
            action: action,
            label: label
        });
    };

    // use this when you want to simulate a call coming from native
    // callbackId not included because I can't think of a time when it would be used
    this.fakeNativeBridgeIn = function(functionName, data){
        NativeBridge.receive(functionName, data);
    };

    this.updateData = function(){
        NativeBridge.receive("updateData");
    };

    this.dismissSpinner = function () {
        NativeBridge.send("dismissSpinner", {});
    };

    this.showSpinner = function () {
        NativeBridge.send("showSpinner", {});
    };


}]);

angular.module("videotron.illico.translate-config").config(["$translateProvider", function ($translateProvider) {

    // all translations found here, except for Date, Time and number formats, which are found in AngularDateTimeFormatsLocalization.js

    // register french translation table
    $translateProvider.translations('fr', {
        "lang": "fr",
        "Loading": "Chargement...",
        "Delete": "Supprimer",
        "Duration": "Durée",
        "Cancel": "Annuler",
        "Close": "Fermer",
        "Back": "Retour",
        "Yes": "Oui",
        "No": "Non",
        "Add": "Ajouter",
        "and": "et",
        "At" : "à",
        "TO_FAVORITE": "aux favoris",
        "Recorded programs tab": "Enregistrés",
        "Scheduled recordings tab": "À venir",
        "Recorded programs": "Émissions enregistrées",
        "Scheduled recordings": "Enregistrements à venir",
        "Recorded program": "Émission enregistrée",
        "Scheduled recording": "Enregistrement à venir",
        "No programs recorded": "Aucune émission enregistrée",
        "No programs scheduled": "Aucun enregistrement à venir",
        "Where are my other terminals": "Où sont mes autres terminaux?",
        "Only illico TV new generation terminals": "Seuls les terminaux illico nouvelle génération sont compatibles avec l'application.",
        "Learn more": "En savoir plus",
        "edit terminal name": "Modifier le nom du terminal",
        "How to program recording - intro": "Vous pouvez enregistrer des émissions à partir du",
        "How to program recording - Program guide link": "Guide horaire",
        "How to program recording - or": "ou",
        "How to program recording - manual record link": "programmer un enregistrement manuel",
        "See list of episodes": "Voir les épisodes",
        "Hide list of episodes": "Cacher les épisodes",
        "Episodes recorded": "épisodes enregistrés",
        "No PVR": "Cette fonctionnalité est uniquement offerte avec un Enregistreur illico télé.",
        "CHANGE DAY": "Changer de jour",
        "CHANGE HOUR": "Changer d'heure",
        "Filter channels": "Filtrer les chaînes",
        "Filter channels type": "Types de chaînes",
        "Modify": "Modifier",
        "Program a recording": "Programmer un enregistrement",
        "By PVR": "Par enregistreur",
        "Filter": "Filtrer",
        "Filter and sort": "Filtres et tris",
        "Channels available on mobile": "Chaînes offertes sur l'appareil",
        "Sort by": "Tri",
        "By date": "Par date",
        "Alphabetically": "Par ordre alphabétique",
        "Channel types": "Genre",
        "close": "Fermer",
        "All channels": "Toutes les chaînes",
        "Favorite channels": "Mes chaînes favorites",
        "In package channels": "Les chaînes de mon forfait",
        "All channels_short": "Toutes",
        "Favorite channels_short": "Favorites",
        "In package channels_short": "Mon forfait",
        "Today": "Aujourd'hui",
        "Tomorrow": "Demain",
        "delete episode or series": "Voulez-vous vraiment annuler tous les enregistrements à venir de \"",
        "delete selected recording": "Voulez-vous vraiment supprimer l'enregistrement sélectionné",
        "delete multiple recordings": "Voulez-vous vraiment supprimer les enregistrements sélectionnés?",
        "delete multiple recordings - pre": "Voulez-vous vraiment supprimer les ",
        "delete multiple recordings - post": "enregistrements sélectionnés?",
        "Only this recording": "Uniquement cet épisode",
        "All recordings": "Tous les épisodes",
        "Stop": "Arrêter",
        "Delete recording in progress": "Arrêter l'enregistrement en cours",
        "Stop and save": "Arrêter et sauvegarder",
        "Stop and delete": "Arrêter et effacer",
        "now": "Maintenant",
        "to": "à",
        "free preview": "Débrouillée",
        "Deletion error": "Problème de suppression",
        "Deletion error details": "Les enregistrements ci-dessous n'ont pas pu être supprimés",
        "recording_date_time_splitter": " – ",
        "At least one recording failed": "Une émission n'a pas été enregistrée au complet.",
        "filter no results": "La combinaison suivante ne donne aucun résultat :",
        "favorites heading": "Chaînes favorites",
        "favorites list empty": "Votre liste de chaînes favorites est vide.",
        "favorites list tutorial": "Vous pouvez ajouter une chaîne dans votre liste de chaînes favorites en touchant son étoile.",
        "favorites list button": "Modifier mes chaines favorites",
        "See all channels - pre": "Voir toutes les chaînes",
        "See all channels - post": "",
        // for next ***Only values, search for CURRENT_PLATFORM because key is concatenated
        "iOSOnly": "Chaînes sur iOS",
        "webOnly": "Chaînes sur le Web",
        "androidOnly": "Chaînes sur Android",
        "pvr_recording_day_and_month_splitter": "<span class='splitter'> | </span>",
        "pvr_recording_hour_suffix": " h ",
        "pvr_recording_hour_splitter": "",
        "pvr_recording_times_splitter": " - ",
        "pvr_recording_recorder_splitter": "<span class='splitter'> | </span>",
        "PVR PAGE TITLE": "Mes enregistrements",
        "PVR A11y version title": "Version accéssible de mes enregistrements",
        "PVR A11y version url": "/accessible/mes-enregistrements",
        "Try again": "Veuillez réessayer",
        "Unknown error": "Désolé, le service est temporairement indisponible. Veuillez réessayer plus tard. [WEBV-001]",
        "Sanitized JavaScript error": "Désolé, le service est temporairement indisponible. Veuillez réessayer plus tard. [WEBV-002]",
        "Help error": "Désolé, le service est temporairement indisponible. Veuillez réessayer plus tard. [WEBV-003]",
        "Help setClientType title": "Quel type de client êtes-vous?",
        "Help setClientType videotron": "Je suis un client Vidéotron",
        "Help setClientType videotron description": "J'ai un forfait Télé, Internet ou Mobile avec Vidéotron",
        "Help setClientType club": "Je suis un client Club illico",
        "Help setClientType club description": "Je suis abonné au Club illico par carte de crédit",
        "Help setClientType mobile": "Je suis un client télé et Club illico mobile",
        "Help setClientType mobile description": "J'ai un forfait Télé et un forfait mobile éligible et j'ai accès à Club illico sur mon mobile ou tablette",
        "Help setClientType mobile only": "Je suis un client Club illico mobile",
        "Help setClientType mobile only description": "J'ai un forfait mobile éligible et j'ai accès à Club illico sur mon mobile ou tablette",
        "epg grid cell loading": "chargement",
        "epg grid cell no data": "aucune donnée",
        "epg grid cell pending": "en attente",
        "EPG PAGE TITLE": "Guide horaire",
        "EPG PAGE TITLE - MOBDROID": "Enregistreur à distance",
        "EPG PAGE URL - WEB": "/tele-horaire",
        "HELP PAGE TITLE": "Aide",
        "Modify my favorites - Favorite channels link": "Modifier mes chaînes favorites",
        "PREFERENCES PAGE TITLE": "Mes préférences",
        "WIZARD PAGE TITLE": "Thématiques préférées",
        "AppConfig not initialized": "Désolé, le service est temporairement indisponible. Veuillez réessayer plus tard. [WEBV-004]",
        // EPG CHANNEL FILTERS
        "CHANNEL FILTER LABEL": "Filtrer les chaines",
        "CHANNEL_NUM": "Chaîne numéro",
        "ALL CHANNELS": "Tous",
        "Chaines HD" : "HD",
        "Chaines UHD" : "UHD",
        "Chaines francophones" : "Francophones",
        "Chaines anglophones" : "Anglophones",
        "Chaines internationales" : "Internationales",
        "Chaines de nouvelles" : "Nouvelles",
        "Chaines de films" : "Films",
        "Chaines famille et enfants" : "Familles et enfants",
        "Chaines de sports" : "Sports",
        "Chaines de musique" : "Musique",
        "Chaines débrouillées" : "Débrouillées",
        "Only Web Channels" : "Les chaînes web seulement",
        "Channel type : NORMAL" : "Chaînes courantes",
        "Channel type : PAY_PER_VIEW" : "Chaînes Indigo",
        "Channel type : GALAXIE" : "Chaînes Stingray",
        "Channel type : RADIO" : "Stations radio",
        "Sort by position" : "Par n° de chaîne",
        "Sort by alphabetically" : "Par ordre alphabétique",
        "Apply" : "Appliquer",
        "Filters button" : "Filtrer",
        "Filter banner" : "Filtre : ",
        "Filters banner" : "Filtres : ",
        "RecordedOn" : "Enregistré le",
        "scrollToTop" : "retour en haut",
        // mini-fiche
        "TERMINAL": "enregistreur",
        "OnTerminal": "Sur l'enregistreur",
        "QUALITY": "qualité",
        "EXTENSION": "prolongement",
        "REPEAT": "répéter",
        "SAVE": "sauvegarder",
        "PROGRAM_RECORDING": "programmer l'enregistrement",
        "SEND_RECORDING": "Enregistrer",
        "PLAY_CHANNEL_PLATFORM": "Regarder en direct",
        "SEND_TO_TV_CHANNEL": "Regarder sur ma télé",
        "LINK_VOD": "Voir sur demande",
        "MODIFY_RECORDING": "Modifier enregistrement",
        "DELETE_RECORDING": "Supprimer",
        "CANCEL_RECORDING": "Annuler l'enregistrement",
        "PLAY_RECORDING": "Regarder l'enregistrement sur ma télé",
        "STOP_RECORDING": "Arrêter l'enregistrement en cours",
        "CONTENT_IS_LOCKED": "Ce contenu est réservé aux abonnés de la chaîne",
        "CONFLICT": "Conflit d'enregistrement",
        "CONFLICT_ZONE": "Conflit",
        "CONFLICT_NOT_RECORDED": "Le titre suivant ne sera pas enregistré :",
        "CONFLICTS_NOT_RECORDED": "Les titres suivant ne seront pas enregistré :",
        "RESOLVE": "Sauvegarder",
        "RESOLVE_CONFLICT": "resoudre le conflit",
        "UNRESOLVE_CONFLICT": "Ajouter aux enregistrements",
        "NEXT_HOURS":"Heures suivantes",
        "PREVIOUS_HOURS":"Heures précédentes",
        "timeExtension.hour" : "heure",
        "timeExtension.hours" : "heures",
        "timeExtension.minute" : "minute",
        "timeExtension.minutes" : "minutes",
        "timeExtension.aucun" : "Aucun",
        "recordingRepeat.NO" : "Non",
        "recordingRepeat.YES" : "Oui",
        "saveModeNormal.KEEP" : "Jusqu'à ce que je le supprime",
        "saveModeNormal.ONE_DAY" : "1 jour",
        "saveModeNormal.TWO_DAYS" : "2 jours",
        "saveModeNormal.ONE_WEEK" : "7 jours",
        "saveModeNormal.TWO_WEEKS" : "14 jours",
        "saveModeRepeat.KEEP" : "Tous les enregistrements",
        "saveModeRepeat.LAST_ONE" : "Le dernier enregistrement",
        "saveModeRepeat.LAST_TWO" : "Deux derniers enregistrements",
        "saveModeRepeat.LAST_THREE" : "Trois derniers enregistrements",
        "saveModeRepeat.LAST_FOUR" : "Quatre derniers enregistrements",
        "saveModeRepeat.LAST_FIVE" : "Cinq derniers enregistrements",
        "recording_conflict_time_span_splitter": " - ",
        "recording is repeated": "l'enregistrement est répété"
    });

    // register english translation table
    $translateProvider.translations('en', {
        "lang": "en",
        "Loading": "Loading...",
        "Delete": "Delete",
        "Duration": "Duration",
        "Cancel": "Cancel",
        "Close": "Close",
        "Back": "Back",
        "Yes": "Yes",
        "No": "No",
        "Add": "Add",
        "and": "and",
        "At" : "At",
        "TO_FAVORITE": "to favorites",
        "Recorded programs tab": "Recorded",
        "Scheduled recordings tab": "Scheduled",
        "Recorded programs": "Recorded programs",
        "Scheduled recordings": "Scheduled recordings",
        "Recorded program": "Recorded program",
        "Scheduled recording": "Scheduled recording",
        "No programs recorded": "No programs have been recorded.",
        "No programs scheduled": "There are no recordings scheduled.",
        "Where are my other terminals": "Where are my other terminals?",
        "Only illico TV new generation terminals": "Only illico TV new generation terminals are compatible with this app.",
        "Learn more": "Learn more",
        "edit terminal name": "Edit the terminal's name",
        "How to program recording - intro": "You can record programs using the",
        "How to program recording - Program guide link": "Program Guide",
        "How to program recording - or": "or you can",
        "How to program recording - manual record link": "record a program manually",
        "See list of episodes": "See list of episodes",
        "Hide list of episodes": "Hide list of episodes",
        "Episodes recorded": "episodes recorded",
        "No PVR": "This feature only works with an illico TV PVR.",
        "CHANGE DAY": "Select a different day",
        "CHANGE HOUR": "Select a different hour",
        "Filter channels": "Filter channels",
        "Filter channels type": "Types of channels",
        "Modify": "Modify",
        "Program a recording": "Program a recording",
        "By PVR": "By PVR",
        "Filter": "Filter",
        "Filter and sort": "Filter and sort",
        "Channels available on mobile": "Channels available on device",
        "Sort by": "Sort",
        "By date": "By date",
        "Alphabetically": "By alphabetical order",
        "Channel types": "Themes",
        "close": "Close",
        "All channels": "All channels",
        "Favorite channels": "My favourite channels",
        "In package channels": "Channels in my package",
        "All channels_short": "All",
        "Favorite channels_short": "Favourites",
        "In package channels_short": "My package",
        "Today": "Today",
        "Tomorrow": "Tomorrow",
        "delete episode or series": "Are you sure you want to cancel all upcoming recordings of \"",
        "delete selected recording": "Do you really want to delete the selected program",
        "delete multiple recordings": "Do you really want to delete the selected programs?",
        "delete multiple recordings - pre": "Do you really want to delete the ",
        "delete multiple recordings - post": "selected programs?",
        "Only this recording": "Only this episode",
        "All recordings": "All episodes",
        "Stop": "Stop",
        "Delete recording in progress": "Stop current recording",
        "Stop and save": "Stop and save this recording",
        "Stop and delete": "Stop and delete this recording",
        "now": "Now",
        "to": "to",
        "free preview": "Free preview",
        "Deletion error": "Deletion issue",
        "Deletion error details": "The following recordings could not be deleted",
        "recording_date_time_splitter": " at ",
        "At least one recording failed": "At least one program was not recorded in full.",
        "filter no results": "The following combination yields no results:",
        "favorites heading": "Favourite channels",
        "favorites list empty": "Your list of favourite channels is empty.",
        "favorites list tutorial": "You can add a channel to your list of favourites by tapping the star icon next to it.",
        "favorites list button": "Choose my favourite channels",
        "See all channels - pre": "View all",
        "See all channels - post": "channels",
        // for next ***Only values, search for CURRENT_PLATFORM because key is concatenated
        "iOSOnly": "Channels on iOS",
        "webOnly": "Channels on the Web",
        "androidOnly": "Channels on Android",
        "pvr_recording_day_and_month_splitter": "<span class='splitter'> | </span>",
        "pvr_recording_hour_suffix": "",
        "pvr_recording_hour_splitter": ":",
        "pvr_recording_times_splitter": " – ",
        "pvr_recording_recorder_splitter": "<span class='splitter'> | </span>",
        "PVR PAGE TITLE": "My Recordings",
        "PVR A11y version title": "Accessible version of my recordings",
        "PVR A11y version url": "/accessible/my-recordings",
        "Try again": "Please try again",
        "Unknown error": "Sorry, the service is temporarily unavailable. Please try again later. [WEBV-001]",
        "Sanitized JavaScript error": "Sorry, the service is temporarily unavailable. Please try again later. [WEBV-002]",
        "Help error": "Sorry, the service is temporarily unavailable. Please try again later. [WEBV-003]",
        "Help setClientType title": "What type of customer are you?",
        "Help setClientType videotron": "I am a Videotron customer",
        "Help setClientType videotron description": "I have a Television, Internet or Mobile subscription with Videotron",
        "Help setClientType club": "I am a Club illico customer",
        "Help setClientType club description": "I am subscribed to Club illico with my credit card",
        "Help setClientType mobile": "I am a TV and Club illico mobile customer",
        "Help setClientType mobile description": "I have a Television subscription and an eligible mobile plan and I have access to Club illico on my mobile and tablet",
        "Help setClientType mobile only": "I am a Club illico mobile customer",
        "Help setClientType mobile only description": "I have an eligible mobile plan and I have access to Club illico on my mobile and tablet",
        "epg grid cell loading": "loading...",
        "epg grid cell no data": "no data...",
        "epg grid cell pending": "pending...",
        "EPG PAGE TITLE": "Program Guide",
        "EPG PAGE TITLE - MOBDROID": "Remote Recording",
        "EPG PAGE URL - WEB": "/tv-guide",
        "HELP PAGE TITLE": "Help",
        "Modify my favorites - Favorite channels link": "Modify my favourite channels",
        "PREFERENCES PAGE TITLE": "My preferences",
        "WIZARD PAGE TITLE": "Favourite themes",
        "AppConfig not initialized": "Sorry, the service is temporarily unavailable. Please try again later. [WEBV-004]",
        // EPG CHANNEL FILTERS
        "CHANNEL FILTER LABEL": "Filter channels",
        "CHANNEL_NUM": "Channel number",
        "ALL CHANNELS": "All",
        "Chaines HD" : "HD",
        "Chaines UHD" : "UHD",
        "Chaines francophones" : "French",
        "Chaines anglophones" : "English",
        "Chaines internationales" : "International",
        "Chaines de nouvelles" : "News",
        "Chaines de films" : "Movies",
        "Chaines famille et enfants" : "Family and kids",
        "Chaines de sports" : "Sports",
        "Chaines de musique" : "Music",
        "Chaines débrouillées" : "Free view",
        "Only Web Channels" : "Web only channels",
        "Channel type : NORMAL" : "Regular channels",
        "Channel type : PAY_PER_VIEW" : "Indigo channels",
        "Channel type : GALAXIE" : "Stingray channels",
        "Channel type : RADIO" : "Radio stations",
        "Sort by position" : "By channel number",
        "Sort by alphabetically" : "In alphabetical order",
        "Apply" : "Apply",
        "Filters button" : "Filter",
        "Filter banner" : "Filter : ",
        "Filters banner" : "Filters : ",
        "RecordedOn" : "Recorded on",
        "scrollToTop" : "back to top",
        // mini-fiche
        "TERMINAL": "terminal",
        "OnTerminal": "On terminal",
        "QUALITY": "quality",
        "EXTENSION": "extend",
        "REPEAT": "repeat",
        "SAVE": "save",
        "PROGRAM_RECORDING": "Schedule the recording",
        "SEND_RECORDING": "Record",
        "PLAY_CHANNEL_PLATFORM": "Watch live",
        "SEND_TO_TV_CHANNEL": "Watch on TV",
        "LINK_VOD": "Watch on demand",
        "MODIFY_RECORDING": "Modify recording",
        "DELETE_RECORDING": "Delete",
        "CANCEL_RECORDING": "Cancel recording",
        "PLAY_RECORDING": "Watch on TV",
        "STOP_RECORDING": "Stop current recording",
        "CONTENT_IS_LOCKED": "This content is available for channel subscribers.",
        "CONFLICT": "Recording conflicts",
        "CONFLICT_ZONE": "conflict",
        "CONFLICT_NOT_RECORDED": "The following program will not be recorded:",
        "CONFLICTS_NOT_RECORDED": "The following programs will not be recorded:",
        "RESOLVE": "Save",
        "RESOLVE_CONFLICT": "resolve conflict",
        "UNRESOLVE_CONFLICT": "Add to recordings",
        "NEXT_HOURS":"Next hours",
        "PREVIOUS_HOURS":"Previous hours",
        "timeExtension.hour" : "hour",
        "timeExtension.hours" : "hours",
        "timeExtension.minute" : "minute",
        "timeExtension.minutes" : "minutes",
        "timeExtension.aucun" : "None",
        "recordingRepeat.NO" : "No",
        "recordingRepeat.YES" : "Yes",
        "saveModeNormal.KEEP" : "Always",
        "saveModeNormal.ONE_DAY" : "1 day",
        "saveModeNormal.TWO_DAYS" : "2 days",
        "saveModeNormal.ONE_WEEK" : "7 days",
        "saveModeNormal.TWO_WEEKS" : "14 days",
        "saveModeRepeat.KEEP" : "All recordings",
        "saveModeRepeat.LAST_ONE" : "Last recording",
        "saveModeRepeat.LAST_TWO" : "Last two recordings",
        "saveModeRepeat.LAST_THREE" : "Last three recordings",
        "saveModeRepeat.LAST_FOUR" : "Last four recordings",
        "saveModeRepeat.LAST_FIVE" : "Last five recordings",
        "recording_conflict_time_span_splitter": " - ",
        "recording is repeated": "recording is repeated"
});

    // register handler for missing translations
    $translateProvider.useMissingTranslationHandler("MissingTranslationHandler");

    // which language to use by default?
    $translateProvider.preferredLanguage('fr');

    $translateProvider.useSanitizeValueStrategy('escapeParameters');


}]);

angular.module("videotron.illico.translate-config").run(["$rootScope", "$translate", "$location", "AngularDateTimeFormatsLocalization",
    function ($rootScope, $translate, $location, AngularDateTimeFormatsLocalization) {
        //don't remove AngularDateTimeFormatsLocalization only here in order to be created...

        var lang;
        var DEFAULT_LANG = "fr";
        var url = $location.$$absUrl;
        var paramLanguage = /lang=(fr|en)/g.exec(url);
        var navLangValue = navigator.language || navigator.browserLanguage;
        var navigatorLanguage = /(\w\w)(-\w\w)?/.exec(navLangValue);

        function standardizeLang(str){
            return str === "en" ? "en" : "fr";
        }

        if(paramLanguage){
            lang = standardizeLang(paramLanguage[1]);
        }else if(navigatorLanguage) {
            lang = standardizeLang(navigatorLanguage[1]);
        }else{
            lang = DEFAULT_LANG;
        }

        $translate.use(lang);


        // added for integration with illico.tv, language set on $rootScope
        // TODO see if there would be a cleaner way of integrating this
        $rootScope.$watch("headerLanguage", function(siteLang){
            if(siteLang){
                $translate.use(standardizeLang(siteLang));
            }
        });

    }]);

angular.module("videotron.illico.translate-config").service("AngularDateTimeFormatsLocalization",
    ["$translate", "$locale", "$rootScope", function ($translate, $locale, $rootScope) {

        // hack to allow standard i18n in current locale without packaging 2 versions of app code or loading async
        // locales based on ngLocale : https://github.com/angular/angular.js/tree/master/src/ngLocale

        // for simplicity, also extended DATETIME_FORMATS to include Videotron specific date and time formats
        // look for vl_ prefix, like vl_date_format

        var i18n_locales = {};

        // French values
        i18n_locales.fr = {
            "DATETIME_FORMATS": {
                "AMPMS": [
                    "a.m.",
                    "p.m."
                ],
                "DAY": [
                    "dimanche",
                    "lundi",
                    "mardi",
                    "mercredi",
                    "jeudi",
                    "vendredi",
                    "samedi"
                ],
                "MONTH": [
                    "janvier",
                    "f\u00e9vrier",
                    "mars",
                    "avril",
                    "mai",
                    "juin",
                    "juillet",
                    "ao\u00fbt",
                    "septembre",
                    "octobre",
                    "novembre",
                    "d\u00e9cembre"
                ],
                "SHORTDAY": [
                    "dim.",
                    "lun.",
                    "mar.",
                    "mer.",
                    "jeu.",
                    "ven.",
                    "sam."
                ],
                "SHORTMONTH": [
                    "janv.",
                    "f\u00e9vr.",
                    "mars",
                    "avr.",
                    "mai",
                    "juin",
                    "juil.",
                    "ao\u00fbt",
                    "sept.",
                    "oct.",
                    "nov.",
                    "d\u00e9c."
                ],
                "fullDate": "EEEE d MMMM y",
                "longDate": "d MMMM y",
                "medium": "yyyy-MM-dd HH:mm:ss",
                "mediumDate": "yyyy-MM-dd",
                "mediumTime": "HH:mm:ss",
                "short": "yy-MM-dd HH:mm",
                "shortDate": "yy-MM-dd",
                "shortTime": "HH:mm",
                // custom formats
                "vl_date_format": "EEEE dd MMMM",
                "vl_date_format_with_comma": "EEEE, d MMMM",
                "vl_short_date_format": "EEEE dd MMM",
                "vl_day_and_month_format": "d MMMM",
                "vl_day_and_month_short_format": "d MMM",
                "vl_recording_date_format": "EEEE d MMM",
                "vl_recording_start_end_time_format": "HH 'h' mm",
                "vl_recording_start_end_time_no_minutes_format": "HH 'h'",
                "vl_recording_hour_format": "H"
            },
            "NUMBER_FORMATS": {
                "CURRENCY_SYM": "$",
                "DECIMAL_SEP": ",",
                "GROUP_SEP": "\u00a0",
                "PATTERNS": [
                    {
                        "gSize": 3,
                        "lgSize": 3,
                        "macFrac": 0,
                        "maxFrac": 3,
                        "minFrac": 0,
                        "minInt": 1,
                        "negPre": "-",
                        "negSuf": "",
                        "posPre": "",
                        "posSuf": ""
                    },
                    {
                        "gSize": 3,
                        "lgSize": 3,
                        "macFrac": 0,
                        "maxFrac": 2,
                        "minFrac": 2,
                        "minInt": 1,
                        "negPre": "(",
                        "negSuf": "\u00a0\u00a4)",
                        "posPre": "",
                        "posSuf": "\u00a0\u00a4"
                    }
                ]
            },
            "id": "fr"
        };

        // English values
        i18n_locales.en = {
            "DATETIME_FORMATS": {
                "AMPMS": [
                    "a.m.",
                    "p.m."
                ],
                "DAY": [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ],
                "MONTH": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                "SHORTDAY": [
                    "Sun",
                    "Mon",
                    "Tue",
                    "Wed",
                    "Thu",
                    "Fri",
                    "Sat"
                ],
                "SHORTMONTH": [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                "fullDate": "EEEE, d MMMM, y",
                "longDate": "d MMMM, y",
                "medium": "yyyy-MM-dd h:mm:ss a",
                "mediumDate": "yyyy-MM-dd",
                "mediumTime": "h:mm:ss a",
                "short": "yy-MM-dd h:mm a",
                "shortDate": "yy-MM-dd",
                "shortTime": "h:mm a",
                // custom formats
                "vl_date_format": "EEEE MMMM dd",
                "vl_date_format_with_comma": "EEEE, MMMM d",
                "vl_short_date_format": "EEEE MMM dd",
                "vl_day_and_month_format": "MMMM d",
                "vl_day_and_month_short_format": "MMM d",
                "vl_recording_date_format": "EEEE, MMM d",
                "vl_recording_start_end_time_format": "h:mm a",
                "vl_recording_start_end_time_no_minutes_format": "h a",
                "vl_recording_hour_format": "h"
            },
            "NUMBER_FORMATS": {
                "CURRENCY_SYM": "$",
                "DECIMAL_SEP": ".",
                "GROUP_SEP": ",",
                "PATTERNS": [
                    {
                        "gSize": 3,
                        "lgSize": 3,
                        "macFrac": 0,
                        "maxFrac": 3,
                        "minFrac": 0,
                        "minInt": 1,
                        "negPre": "-",
                        "negSuf": "",
                        "posPre": "",
                        "posSuf": ""
                    },
                    {
                        "gSize": 3,
                        "lgSize": 3,
                        "macFrac": 0,
                        "maxFrac": 2,
                        "minFrac": 2,
                        "minInt": 1,
                        "negPre": "(\u00a4",
                        "negSuf": ")",
                        "posPre": "\u00a4",
                        "posSuf": ""
                    }
                ]
            },
            "id": "en"

        };


        function updateAngularLocaleData(lang) {
            if (i18n_locales[lang]) {
                // deep object copy of i18n_locales into $locales
                $.extend(true, $locale, i18n_locales[lang]);
            } else {
                throw new Error("AngularDateTimeFormatsLocalization : " + lang + " is not defined in var i18n_locales");
            }
        }


        $rootScope.$on("$translateChangeSuccess", function () {

            // overwrite existing locales with current version
            updateAngularLocaleData($translate.use());
        });

    }]);
angular.module("videotron.illico.translate-config").factory("MissingTranslationHandler", function () {

    var missingKeys = {};

    return function (missingKey) {
        missingKeys[missingKey] = missingKey;
        if (angular.isUndefined(missingKey)){
            throw new Error();
        }

        // playtime is over, throw error if missing key
        throw new Error("missing translation for key : " + missingKey);

        //print json with all the missing keys... very useful ; )
//        console.log("missing key :", missingKey);
//        console.log(JSON.stringify(missingKeys));
    };


});
angular.module("videotron.illico.tooltip").directive("tooltip",
    ["$templateCache", "$compile", function ($templateCache, $compile) {

        /*

         WARNINGS

         this directive depends on http://qtip2.com/
         this directive use only inline template
         this directive do not watch attributes changes

         ATTRIBUTES :

         tooltip : represent the template ID, value is used in order to publish the controller in the scope
         tooltip-event : event that trigger the tooltip opening

         */


        var DEFAULT_POSITION_MY = "top left";
        var DEFAULT_POSITION_AT = "bottom right";
        var DEFAULT_EVENT = "click";
        var DEFAULT_WIDTH = "250px";

        var TOOLTIP_EVENT = "tooltipEvent";
        var TOOLTIP = "tooltip";
        var TOOLTIP_TEMPLATE = "tooltipTemplate";
        var TOOLTIP_POSITION_MY = "tooltipPositionMy";
        var TOOLTIP_POSITION_AT = "tooltipPositionAT";
        var TOOLTIP_WIDTH = "tooltipWidth";


        return {

            restrict: "A",
            controller: ["$scope", "$element", "$attrs", "$rootScope", function ($scope, $element, $attrs, $rootScope) {
                if($attrs[TOOLTIP]){
                    $scope[$attrs[TOOLTIP]] = this;
                }else{
                    $scope.tooltip = this;
                }

                //TODO this directive should use the tooltip service... (service was written after the directive...)

                var templateId = $attrs[TOOLTIP_TEMPLATE];

                var ttEvent = $attrs[TOOLTIP_EVENT] || DEFAULT_EVENT;
                var positionMy = $attrs[TOOLTIP_POSITION_MY] || DEFAULT_POSITION_MY;
                var positionAt = $attrs[TOOLTIP_POSITION_AT] || DEFAULT_POSITION_AT;
                var tooltipWidth = $attrs[TOOLTIP_WIDTH] || DEFAULT_WIDTH;
                var contentTemplate = $templateCache.get(templateId);
                //trim spaces, see : http://stackoverflow.com/questions/16122139/angular-js-jquery-html-string-parsing-in-1-9-1-vs-1-8-3
                contentTemplate = contentTemplate.replace(/^\s*/, "");
                var tooltipContentElement = angular.element(contentTemplate);
                $compile(tooltipContentElement)($scope);


                var modalLayer = angular.element("<div class=\"qtip-modal-layer\"><div>");


                //to close the tvguide tooltip (select-day), if opened, preventing the overlapping
                $rootScope.$on('lightboxOpened', function(evt) {
//                    console.log('$on::',evt);
                    if(toolTipIsVisible) hideTooltip();
                });


                var options = {
                    overwrite: false,
                    content: tooltipContentElement,
                    position: {
                        viewport: $(window),
                        my: positionMy,
                        at: positionAt
                    },
                    hide: "",
                    style: {
                        def: false,
                        classes: "qtip-epg",
                        width: tooltipWidth,
                        tip: {
                            corner: true,
                            height: 8,
                            width: 16
                        }
                    },
                    show: {
                        solo: true,
                        event: null,
                        ready: false
                    },
                    events: {
                        hide: function () {
                            toolTipIsVisible = false;
                            modalLayer.remove();
                        },
                        show: function (event) {
                            var target = angular.element(event.target);
                            target.after(modalLayer);
                            toolTipIsVisible = true;
                            modalLayer.bind(ttEvent ,function(event){
                                event.preventDefault();
                                event.stopImmediatePropagation();
                                hideTooltip();
                            });
                        },
                        render: function (event) {

                        }
                    }
                };

                $element.qtip(options);

                function showTooltip() {
                    $element.qtip("show");

                    //the tooltip is mispositioned when page scrolled; just close the tooltip if scroll evt is detected
                    //ie.: the tooltip for changing the day of tv guide (<div class="select-day...>)
                    $(document).bind('scroll',
                        function(evt) {
                            hideTooltip();

                            //unregister listener
                            $(document).unbind('scroll');
                        }
                    );
                }

                function hideTooltip() {
//                    console.log('hideTooltip()');
                    $element.qtip("hide");
                }


                function onEvent() {
                    if (toolTipIsVisible) {
                        hideTooltip();
                    } else {
                        showTooltip();
                    }
                }

                var toolTipIsVisible = false;
                $element.on(ttEvent, onEvent);

                this.show = function () {
                    //INFO removed if(!toolTipIsVisible) in order to prevent a call to show if the tooltip is already visible... (it was buggy...)
                    showTooltip();
                };

                this.hide = function () {
                    //INFO removed if(toolTipIsVisible) in order to prevent a call to show if the tooltip is already visible... (it was buggy...)
                    hideTooltip();
                };


                $element.on("$destroy", function () {
                    $element.off(ttEvent, onEvent);
                    modalLayer.remove();
                    //TODO complete clean up... (destroy qtip)
                });
            }]

        };


    }]);
angular.module("videotron.illico.tooltip").service("Tooltip", function () {

    //WARNING : this service depends on http://qtip2.com/

    var targetElement;

    var modalLayer = angular.element("<div class=\"qtip-modal-layer\"><div>");

    var self = this;


    this.hide = function () {
        if (targetElement) {
            targetElement.qtip("hide");

            //to prevent error when mouse move over the target (Uncaught TypeError: Cannot set property 'onTarget' of null)
            //unregister listener
            targetElement.unbind('mousemove');
        }
    };

    this.show = function (target, content, boundEvent, destroyCallback) {


        targetElement = angular.element(target);
        var options = {
            overwrite: false,
            content: content,
            position: {
                viewport: $(window),
                my: "top center",
                at: "bottom center"
            },
            hide: "",
            style: {
                def: false,
                classes: "qtip-epg",
                width: "350px",
                tip: {
                    corner: true,
                    height: 8,
                    width: 16
                }
            },
            show: {
                solo: true,
                event: null,
                ready: false
            },
            events: {
                show: function (event) {
                    var target = angular.element(event.target);
                    target.after(modalLayer);

                    modalLayer.bind(boundEvent, function (event) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        self.hide();
                    });
                },
                hide: function () {
                    modalLayer.remove();
                    targetElement.qtip("destroy");
                    if (angular.isFunction(destroyCallback)) {
                        destroyCallback.call(null);
                    }
                }

            }


        };

        targetElement.qtip(options);
        targetElement.qtip("show");


    };

})
;
// TODO make common?
angular.module("videotron.illico.grid-scroll").controller("CtrlGridScroll",
    ["$element", "Scroll", function ($element, Scroll) {

        var SCROLL_FRICTION = 0.92;

        var scroll = new Scroll($element, SCROLL_FRICTION);

        this.addScrollListener = function (scrollListener) {
            return scroll.addScrollListener(scrollListener);
        };

        this.resetScrollVelocity = function(){
            scroll.resetScrollVelocity();
        };

        this.update = function () {
            scroll.update();
        };

        this.wasScrolling = function () {
            return scroll.wasScrolling();
        };


    }]);

// TODO - make common?
angular.module("videotron.illico.grid-scroll").directive("gridScroll", function () {

    return {
        restrict: "A",
        priority: 1000,
        controller: "CtrlGridScroll"
    };


});

// TODO - shell factory, does nothing for now but cannot be removed because of dependancies in ctrlgridEpg/pvr
// all thats needed to implement this is :
// * lock y axis
// * handle click cancelation to avoid opening contentModal on dragEnd
angular.module("videotron.illico.grid-scroll").factory("Scroll",
    ["MouseDrag", function (MouseDrag) {

//        var abs = Math.abs;

        function Scroll(mouseDrag, friction, channelZone) {
//            // the higher this number is, the faster the grid will stop
//            var MIN_VELOCITY_THRESHOLD = 0.1;
//            // the higher this number is, the further you need to drag to start inertia
//            var DRAG_END_VELOCITY_THRESHOLD = 5;
//            var totalVx = 0;
//            var totalVy = 0;
//            var vx = 0;
//            var vy = 0;
//            var userIsDragging = false;
//            var scrollListener = angular.noop;
//            var eventKeeper = null;
//            //flag that is true if the grid was scrolling due to inertia before the DragStart event
//            var wasScrolling = false;

//            function handleDragChange(vxIncrease, vyIncrease) {
//                totalVx += vxIncrease;
//                totalVy += vyIncrease;
//
//                // block diagonal scrolling
//                if (abs(totalVx) > abs(totalVy)) {
//                    vyIncrease = 0;
//                    totalVx *= 2;
//                } else {
//                    vxIncrease = 0;
//                    totalVy *= 2;
//                }
//                vx += vxIncrease;
//                vy += vyIncrease;
//            }
//
//            function drag(event, data) {
//                if(data.x > channelZone){
//                    handleDragChange(data.dx, data.dy);
//                }
//            }
//
//            function dragStart(event, data) {
//                eventKeeper = data.originalEvent;
//                wasScrolling = abs(vx) > 0 || abs(vy) > 0;
//                totalVx = 0;
//                totalVy = 0;
//                vx = 0;
//                vy = 0;
//                userIsDragging = true;
//            }
//
//            function dragEnd(event, data) {
//                userIsDragging = false;
//                if(data.x > channelZone){
//                    handleDragChange(data.dx, data.dy);
//                }
//                if (abs(vx) < DRAG_END_VELOCITY_THRESHOLD) {
//                    vx = 0;
//                }
//                if (abs(vy) < DRAG_END_VELOCITY_THRESHOLD) {
//                    vy = 0;
//                }
//            }

            this.wasScrolling = function () {
//                return wasScrolling;
                return false;
            };

            this.update = function () {

//                if (userIsDragging) {
//                    scrollListener(eventKeeper, {scrollX: vx, scrollY: vy});
//                    vx = 0;
//                    vy = 0;
//                } else if (abs(vx) > MIN_VELOCITY_THRESHOLD || abs(vy) > MIN_VELOCITY_THRESHOLD) {
//                    // this causes the inertia scroll
//                    vx *= friction;
//                    vy *= friction;
//                    scrollListener(eventKeeper, {scrollX: vx, scrollY: vy});
//                } else {
//                    vx = 0;
//                    vy = 0;
//                }
            };

            this.resetScrollVelocity = function () {
                // setting velocity to 0 effectively stops the scroll in process
//                vx = 0;
//                vy = 0;
            };

            this.addScrollListener = function (listener) {
//                scrollListener = listener;
            };

//            mouseDrag.addDragListener(drag);
//            mouseDrag.addDragStartListener(dragStart);
//            mouseDrag.addDragEndListener(dragEnd);


        }

        return function (element, friction, channelZone) {
            var mouseDrag = new MouseDrag(element, true);
            //mouseDrag.enable();
            return new Scroll(mouseDrag, friction, channelZone);
        };


    }]);
angular.module("videotron.illico.grid-click").controller("CtrlGridClick",
    ["$element", "$attrs", "EventDispatcher", function ($element, $attrs, EventDispatcher) {

        var DEFAULT_EVENT = "click";
        var GRID_CLICK_EVENT = "gridClick";
        var eventName = $attrs.gridClick || DEFAULT_EVENT;

        var eventDispatcher = new EventDispatcher();

        this.addClickListener = function (listener) {
            return eventDispatcher.addListener(GRID_CLICK_EVENT, listener);
        };

        function onEvent(event) {
            var originalEvent = event.originalEvent;
            if (!originalEvent.defaultPrevented){
                var data = null;
                switch (originalEvent.toString()) {
                    case "[object TouchEvent]" :
                        data = {};
                        data.x = originalEvent.changedTouches[0].pageX;
                        data.y = originalEvent.changedTouches[0].pageY;
                        break;
                    case "[object MouseEvent]":
                    case "[object PointerEvent]":
                        data = {};
                        data.x = originalEvent.pageX;
                        data.y = originalEvent.pageY;
                        break;
                    default :
                        break;
                }
                data.target = angular.element(originalEvent.target);
                eventDispatcher.dispatch(GRID_CLICK_EVENT, data);
            }
        }

        function destroy() {
            $element.unbind(eventName, onEvent);
            $element.unbind("$destroy", destroy);
        }

        $element.bind(eventName, onEvent);
        $element.bind("$destroy", destroy);


    }]);
angular.module("videotron.illico.grid-click").directive("gridClick", function () {

    return {
        restrict: "A",
        controller: "CtrlGridClick"

    };


});
angular.module("videotron.illico.grid-long-press").controller("CtrlGridLongPress",
    ["$element", "$attrs", "$scope", "EventDispatcher", function ($element, $attrs, $scope, EventDispatcher) {

        var DEFAULT_TRIGGER_EVENT = "touchstart";
        var DEFAULT_CANCEL_EVENTS = "touchend touchmove touchcancel contextmenu";
        var LONG_PRESS_THRESH_HOLD = 500;
        var GRID_LONG_PRESS_EVENT = "gridLongPress";
        var triggerEventName = $attrs.gridLongPressTrigger || DEFAULT_TRIGGER_EVENT;
        var cancelEventNames = $attrs.gridLongPressCancel || DEFAULT_CANCEL_EVENTS;
        var longPressFired = false;
        var timer = null;
        var eventDispatcher = new EventDispatcher();

        this.addClickListener = function (listener) {
            return eventDispatcher.addListener(GRID_LONG_PRESS_EVENT, listener);
        };

        // once a long press is fired, we need to cancel the subsequent events being fired
        // since other bound click events might need this info, we provide this method to share the info
        this.hasLongPressFired = function () {
            return longPressFired;
        };

        function onTriggerEvent(event) {
            var originalEvent = event.originalEvent;
            longPressFired = false;

            timer = setTimeout(function(){
                longPressFired = true;
                if (!originalEvent.defaultPrevented){
                    var data = null;
                    switch (originalEvent.toString()) {
                        case "[object TouchEvent]" :
                            data = {};
                            data.x = originalEvent.changedTouches[0].pageX;
                            data.y = originalEvent.changedTouches[0].pageY;
                            break;
                        // hard to imagine longPress not being a touchEvent, but just in case
                        case "[object MouseEvent]":
                            data = {};
                            data.x = originalEvent.pageX;
                            data.y = originalEvent.pageY;
                            break;
                        default :
                            break;
                    }
                    data.target = angular.element(originalEvent.target);
                    eventDispatcher.dispatch(GRID_LONG_PRESS_EVENT, data);
                }
            }, LONG_PRESS_THRESH_HOLD);
        }

        function onCancelEvent(event) {
//            console.log("cancelEvent", longPressFired, event.type);
            clearTimeout(timer);
            if (longPressFired){
                return event.stopImmediatePropagation() || false;
            }
        }

        function destroy() {
            $element.unbind(triggerEventName, onTriggerEvent);
            $element.unbind(cancelEventNames, onCancelEvent);
            $element.unbind("$destroy", destroy);
        }

        $element.bind(triggerEventName, onTriggerEvent);
        $element.bind(cancelEventNames, onCancelEvent);
        $element.bind("$destroy", destroy);


    }]);
angular.module("videotron.illico.grid-long-press").directive("gridLongPress", function () {

    return {
        restrict: "A",
        controller: "CtrlGridLongPress"

    };


});
angular.module("videotron.illico.content-details").config(["DeleteRecordingModalProvider", "DeleteRecordingsModalProvider", "RecordingsDeletionErrorProvider",
    function (DeleteRecordingModalProvider, DeleteRecordingsModalProvider, RecordingsDeletionErrorProvider) {

        DeleteRecordingModalProvider.setModalConfirmDeleteTemplate("/appEnp/templates/content-details/modal-confirm-record-deletion.template.html");
        DeleteRecordingModalProvider.setModalConfirmDeleteRecordingInProgressTemplate("/appEnp/templates/content-details/modal-confirm-recording-in-progress-deletion.template.html");
        DeleteRecordingsModalProvider.setModalConfirmDeleteMultipleTemplate("/appEnp/templates/content-details/modal-confirm-multiple-record-deletion.template.html");
        RecordingsDeletionErrorProvider.setModalRecordingsDeletionErrorTemplate("/appEnp/templates/content-details/modal-recordings-deleteion-error.template.html");

    }]);


angular.module("videotron.illico.content-details").constant("CHANNEL_DEFINITIONS", {
    SD: "SD",
    HD: "HD",
    UHD: "UHD"
});

angular.module("videotron.illico.content-details").factory("ContentDetailsDataLoader",
            ["$http", "HttpConfigs", "$filter", "AppConfig", "SERVICES_BASE_PATH", "$q", "$translate", "$log",
    function ($http,   HttpConfigs,   $filter,   AppConfig,   SERVICES_BASE_PATH,   $q,   $translate,   $log) {

        var dateFilter = $filter("date");
        var basePath = SERVICES_BASE_PATH;
        var logoBasePath;
        var largeThumbsBasePath;
        var defaultImageName;
        var HANDLED_ACTIONS = ["SEND_RECORDING", "MODIFY_RECORDING", "LINK_VOD", "PLAY_CHANNEL_PLATFORM", "DELETE_RECORDING", "STOP_RECORDING"];

        function setLogoPath(str) {
            // TODO - web platform image format is different from companion format
            // until platform is modified and all new images are created, we tweak the image names here
            // see JIRA for details : IAPPDEV-5231
            var image = str || "";
            var cleanedString = image.replace("_TF.png", ".png").replace("_TP.png", ".png");
            return logoBasePath + cleanedString;
        }

        function setImagePath(str) {
            return largeThumbsBasePath + str;
        }


        function addExtraKey(obj, name, value){
            //first test if the key is available
            if (obj.hasOwnProperty(name)) {
                throw new Error(name + " is already defined");
            } else {
                obj[name] = value;
            }
        }

        function removeUnusedKeys(data, unusedKeys){
            for(var i = unusedKeys.length; i>=0; i--){
                var key = unusedKeys[i];
                if(data[key]){
                    data[key] = null;
                    delete data[key];
                }
            }
        }

        function removeUnhandledActions(actions, handledActions){
            for(var i = 0; i < actions.length; i++){
                var action = actions[i];
                if(handledActions.indexOf(action.type) === -1){
                    $log.debug("(IENP-308) Removing unhandled action type : " + action.type);
                    actions.splice(i, 1);
                    i--; // since we removed an item, back up 1 in loop
                }
            }
        }

        function extendContentDetailsData(data){

            // avoid app crash in case the provider block is missing
            if (!data.provider) {
                data.provider = {};
            }

            var currentStartTime = false;

            // if currentStartTime not defined, use the first episode in program list if possible
            if(data.currentStartTime){
                currentStartTime = ENP.tsFromCustomDate(data.currentStartTime);
            }else if(data.programs && data.programs.length){
                currentStartTime = ENP.tsFromCustomDate(data.programs[0].startTime);
            }

            var unusedKeys = [
                "actors", "code", "currentProgramId",
                "currentStartTime", "directors", "epgId", "episodeNo",
                "facebook", "genre", "id", "image", "lang", "lengthInMinutes",
                "link", "objectType", "programs", "searchHighlight", "seasonNo", "twitter"
            ];

            // Voir IWEB-805, nouvelle attribut gridLogo n'existe pas dans tous les plate-formes
            var logoImageSrc = data.provider.gridLogo || data.provider.image;
            //add extra properties to the record
            addExtraKey(data, "isContentLocked", data.accessInfo.access === "LOCKED");
            addExtraKey(data, "formattedImage", setImagePath(data.image));
            addExtraKey(data, "fallbackImage", setImagePath(defaultImageName));
            addExtraKey(data, "formattedLogo", setLogoPath(logoImageSrc));
            if(currentStartTime){
                addExtraKey(data, "formattedDate", dateFilter(new Date(currentStartTime), "vl_day_and_month_short_format"));
                addExtraKey(data, "formattedStartTime", dateFilter(new Date(currentStartTime), "shortTime"));
            }

            // remove actions that can't be treated on this platform, like modifying a manuel recording and in case others are added
            removeUnhandledActions(data.actions, HANDLED_ACTIONS);

            // remove what isn't used to avoid polluting the scope
            removeUnusedKeys(data, unusedKeys);

            return data;

        }

        function ContentDetailsDataLoader() {

            this.load = function (contentUrl) {
                var url = basePath + contentUrl;

                if(!AppConfig.isInitialized()){

                    var defer = $q.defer();
                    var error = {
                        message : $translate.instant("AppConfig not initialized")
                    };
                    defer.reject(error);
                    return defer.promise;
                }

                // by setting these here, we can be assurred that the Appconfigs are set
                logoBasePath = logoBasePath || AppConfig.getLogoBasePath();
                largeThumbsBasePath = largeThumbsBasePath || AppConfig.getLargeThumbsBasePath();
                defaultImageName = AppConfig.getDefaultImageName(); // don't cache response like the others so random image selection takes place

                return $http.get(url, HttpConfigs.getConfigs()).then(function (response) {
                    var contentDetails = response.data.body.main;
                    return extendContentDetailsData(contentDetails);
                });

            };

        }

        return function () {
            return new ContentDetailsDataLoader();
        };

    }]);

angular.module("videotron.illico.content-details").factory("ModalContentDetails",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader) {

         function ModalContentDetails(template) {
             var templateString;
             var simpleModal = new SimpleModal();

             SrvModalTemplateLoader.load(template).then(function(result){
                 templateString = result;
             });


            this.show = function (scope, modalOptions) {

                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (template) {
            return new ModalContentDetails(template);
        };


    }]);
//TODO: this is obsolete and should be removed???
angular.module("videotron.illico.content-details").run(["AppServicesInitializer", function (AppServicesInitializer) {
    // required for image paths and clientModelVersion
    //console.info('content-details - init')
    //Note: init is now being called only where required (CtrlPgMyIllico/CtrlPgSearchSolr)
    //AppServicesInitializer.initialize(["AppConfig"]);
}]);

angular.module("videotron.illico.content-details").service("SrvLinearContentDetails",
    ["$rootScope", "$location", "ModalContentDetails", "NativeActions", "$q", "$http", "$templateCache", "ContentDetailsDataLoader", "SrvRecordingForm", "DeleteRecordingModal", "SrvModalHeight", "$translate",
        function ($rootScope, $location, ModalContentDetails, NativeActions, $q, $http, $templateCache, ContentDetailsDataLoader, SrvRecordingForm, DeleteRecordingModal, SrvModalHeight, $translate) {

            var MAX_MODAL_HEIGHT = 600; // modal should never be higher than 700px;
            var MODAL_HEIGHT_BUFFER = 60; // height of modal if it had no content in it;
            var modalContentDetails = new ModalContentDetails("/appEnp/templates/content-details/content-details.template.html");
            var contentDetailsDataLoader = new ContentDetailsDataLoader();
            var scopeRef;
            var formIsReady = false;
            var modalState = {
                current: null,
                possibleStates: [
                    "loading",
                    "fatalError",
                    "viewing",
                    "editing",
                    "pending",
                    "noFurtherActionsPossible"
                ]
            };
            var modalOptions = {
                autoResize: false,
                opacity: 50,
                minWidth: 506,
                overlayClose: true,
                minHeight: 550, // will be over written at render time in showContentDetailsModal();
                closeClass: 'simplemodal-close',
//                closeClass: 'content-modal-close',
                zIndex: 77777 // make sure this is below the confirmation modals
            };

            function getModalHeights(){
                return SrvModalHeight.getHeights({
                    modalHeightBuffer: MODAL_HEIGHT_BUFFER,
                    maxModalHeight: MAX_MODAL_HEIGHT
                });
            }


            function sendRecordingForm(form){
                SrvRecordingForm.sendRecordingForm(scopeRef, form, modalState, loadContent);
            }

            function setUpForm(action){
                SrvRecordingForm.setUpRecordingForm(action, scopeRef.content).then(function(formObject){
                    scopeRef.recordingForm = formObject;

                    // expose function so it can be bound to checkbox
                    scopeRef.modifySaveModeOption = SrvRecordingForm.modifySaveModeOption;
                    scopeRef.sendRecordingForm = sendRecordingForm;

                    // show form
                    scopeRef.formIsReady = true;
                });
            }

            function actionButtonClick(action, title) {
//                console.log('actionButtonClick()');
//                console.log('action: ',action);
                // TODO define missing types
                // TODO google analytics tracking?
                switch (action.type) {
                    case "SEND_RECORDING":
                    case "MODIFY_RECORDING":
                        modalState.current = "editing";
                        formIsReady = true;
                        setUpForm(action);
                        break;
                    case "LINK_VOD":
                        modalContentDetails.hide();
                        //Google Analytics tracking through Native Bridge
                        NativeActions.trackEvent('Terminal', 'vsd', title);
                        $location.path(action.link.uri);
                        break;
                    case "PLAY_CHANNEL_PLATFORM":
                        modalContentDetails.hide();
                        //Google Analytics tracking through Native Bridge
                        NativeActions.trackEvent('Terminal', 'chaine', title);
                        $location.path(action.link.uri);
                        break;
                    case "DELETE_RECORDING":
                    case "STOP_RECORDING":
                        DeleteRecordingModal.confirmDeleteRecording(scopeRef.content, function(){
                            modalContentDetails.hide();
                            NativeActions.updateData();
                        }, function(){
                            NativeActions.updateData();
                        }).catch(function(){
                            NativeActions.updateData();
                        });
                        //Google Analytics tracking through Native Bridge
                        NativeActions.trackEvent('Terminal', 'Arrêter un enregistrement', '');
                        break;
                    default :
                        console.info("actionButtonClick - undefined action.type", action.type, action);
                        break;
                }
            }

            function loadContent(scope){
                contentDetailsDataLoader.load(scope.contentUrl).then(function (value) {
                    scope.content = value;
                    modalState.current = "viewing";
                    // TODO trigger analytics page view?
                },function(error){
                    modalState.current = "fatalError";
                    scope.error = (error.message) ? error.message : error.data.head.error.message;
                });
            }

            function showContentDetailsModal(link) {
                var scope = $rootScope.$new(true);
                var modalHeights = getModalHeights();

                scopeRef = scope;
                modalState.current = "loading";
                scope.contentUrl = link.uri ? link.uri + '?localeLang=' + $translate.instant('lang') : "";
                scope.title = link.title || "";
                scope.modalState = modalState;
                scope.actionButton = actionButtonClick;
                scope.content = {};
                scope.contentMaxHeight = {'max-height': modalHeights.innerHeight + 'px'};
                scope.formIsReady = formIsReady;

                // load content data
                loadContent(scopeRef);

                // although this causes the modal to be higher than vertical center,
                // the bottom is never cut off at least.
                // It`s the lesser of 2 evils, see IWEB-380
                modalOptions.minHeight = modalHeights.outerHeight;

                // open modal
                modalContentDetails.show(scope, modalOptions);
            }

            this.init = function () {

            };


            // set up listeners
            NativeActions.onShowContentDetails(function (event, link) {
                // console.log("NativeActions.onShowContentDetails", link)
                showContentDetailsModal(link);
            });

        }]);
angular.module("videotron.illico.epg-grid").service("SrvRecordingForm",
    ["$http", "$rootScope", "HttpConfigs", "$timeout", "$translate", "SERVICES_BASE_PATH", "SrvTerminals", "NativeActions", "SrvRecordingConflict", "ChannelsDataConverter", "CHANNEL_DEFINITIONS",
        function ($http, $rootScope, HttpConfigs, $timeout, $translate, SERVICES_BASE_PATH, SrvTerminals, NativeActions, SrvRecordingConflict, ChannelsDataConverter, CHANNEL_DEFINITIONS) {
            var CONFIRMATION_MESSAGE_DURATION = 5000;
            var ERROR_MESSAGE_DURATION = 15000;
            var UPDATE_DATA_DELAY = 1000;
            var recordingFormConfigs = HttpConfigs.recordingFormConfigs();
            var convertChannelData = new ChannelsDataConverter();
            var SD = CHANNEL_DEFINITIONS.SD;
            var HD = CHANNEL_DEFINITIONS.HD;
            var UHD = CHANNEL_DEFINITIONS.UHD;
            var that = this;

            function createRecordingFormDefaults() {
                // create defaults in current language
                return {
                    timeExtension: [0, 5, 10, 30, 45, 60, 120],
                    repeatOptions: [
                        {label: $translate.instant("recordingRepeat.NO"), value: false},
                        {label: $translate.instant("recordingRepeat.YES"), value: true}
                    ],
                    saveModeNormal: [
                        {label: $translate.instant("saveModeNormal.KEEP"), value: "KEEP"},
                        {label: $translate.instant("saveModeNormal.ONE_DAY"), value: "ONE_DAY"},
                        {label: $translate.instant("saveModeNormal.TWO_DAYS"), value: "TWO_DAYS"},
                        {label: $translate.instant("saveModeNormal.ONE_WEEK"), value: "ONE_WEEK"},
                        {label: $translate.instant("saveModeNormal.TWO_WEEKS"), value: "TWO_WEEKS"}
                    ],
                    saveModeRepeat: [
                        {label: $translate.instant("saveModeRepeat.KEEP"), value: "KEEP"},
                        //{label: $translate.instant("saveModeRepeat.LAST_ONE"), value:"LAST_ONE"}, // possible value but not used
                        {label: $translate.instant("saveModeRepeat.LAST_TWO"), value: "LAST_TWO"},
                        {label: $translate.instant("saveModeRepeat.LAST_THREE"), value: "LAST_THREE"},
                        {label: $translate.instant("saveModeRepeat.LAST_FOUR"), value: "LAST_FOUR"},
                        {label: $translate.instant("saveModeRepeat.LAST_FIVE"), value: "LAST_FIVE"}
                    ]
                };
            }

            function createTimeExtensionList(options, paramValue) {
                var selectOptionList = [];
                var generateOption = function (value) {
                    var timeFormat = "";
                    var formattedValue = (value >= 60 && value % 60 === 0) ? value / 60 : value;
                    // hour or hours
                    if (value >= 60 && value % 60 === 0) {
                        timeFormat = value / 60 === 1 ? "timeExtension.hour" : "timeExtension.hours";
                    }
                    // minute or minutes
                    else {
                        timeFormat = value === 1 ? "timeExtension.minute" : "timeExtension.minutes";
                    }
                    var template = {
                        label: formattedValue + " " + $translate.instant(timeFormat),
                        value: value
                    };
                    if (value === 0) {
                        template.label = $translate.instant("timeExtension.aucun");
                    }
                    return template;
                };
                var numericSort = function (a, b) {
                    return a - b;
                };

                // if no param provided, select the first option
                var selectValue = (typeof paramValue === "undefined") ? 0 : paramValue;

                // if param provided but not part of default list, we must add it to the list and select it
                // this happens if custom timeExtension was added via the terminal
                if (options.indexOf(selectValue) === -1) {
                    options.push(selectValue);
                    options.sort(numericSort);
                }

                for (var i = 0, iLen = options.length; i < iLen; i++) {
                    selectOptionList.push(generateOption(options[i]));
                }

                return selectOptionList;
            }

            function getOptionByValue(selectOptionList, paramValue) {
                // if no param provided, provide a fake one
                var selectValue = (typeof paramValue === "undefined") ? "fake value" : paramValue;

                // by default, return first option
                var selectedOption = selectOptionList[0];

                for (var i = 0, iLen = selectOptionList.length; i < iLen; i++) {
                    var option = selectOptionList[i];
                    if (option.value === selectValue) {
                        selectedOption = option;
                    }
                }

                return selectedOption;
            }

            function modifySaveModeOption(formScope, saveMode) {
//                console.log('modifySaveModeOption()');
//                console.log('formScope: ',formScope);
//                console.log('saveMode: ',saveMode);
                formScope.saveMode = (formScope.repeat === true) ? formScope.saveModeRepeat : formScope.saveModeNormal;
                formScope.selectedSaveMode = getOptionByValue(formScope.saveMode, saveMode);
            }

            function showMessage(scope, type, text, duration) {
                scope.messageType = type;
                scope.message = text;
                scope.messageVisible = true;
                $timeout(function () {
                    scope.messageVisible = false;
                }, duration)
            }


            // public methods
            //*************************************

            this.modifySaveModeOption = modifySaveModeOption;

            this.setUpRecordingForm = function (action, content) {
                return SrvTerminals.getTerminalsPromise().then(function (response) {
                    var params = action.parameters;
                    var channelInfo = (content) ? content.provider : {};
                    var isUhd = convertChannelData.isDefinitionAvailable(channelInfo.definitionGroup, UHD);
                    var isHd = convertChannelData.isDefinitionAvailable(channelInfo.definitionGroup, HD);
                    var isSd = convertChannelData.isDefinitionAvailable(channelInfo.definitionGroup, SD);
                    // setup up a new form from defaults
                    var thisRecordingForm = $.extend(true, {}, createRecordingFormDefaults());
                    // add custom values
                    thisRecordingForm.isModificationForm = action.type === "MODIFY_RECORDING"; // used to make fields read only
                    thisRecordingForm.action = action; // keep original action on scope to be used in sendRecordingForm

                    // TERMINALS
//                    params.terminalId = undefined; // test undefined option
//                    params.terminalId = "fake mack address"; // test incorrect option
                    thisRecordingForm.terminals = response;
                    thisRecordingForm.selectedTerminal = SrvTerminals.getTerminalById(params.terminalId) || thisRecordingForm.terminals[0];

                    // QUALITY
//                    params.definition = SD; // test SD option
//                    params.definition = HD; // test HD option
//                    params.definition = UHD; // test UHD option

                    // if channel has uHd feed, the UI will show a uHD option only, so expose boolean for simplicity
                    thisRecordingForm.showUhdBottonOnly = isUhd;
                    if(thisRecordingForm.isModificationForm){
                        // if this is a modification, use recording definition
                        thisRecordingForm.definition = params.definition;
                    }else{
                        // select best quality feed possible by default
                        thisRecordingForm.definition = isUhd ? UHD : isHd ? HD : SD;
                    }

                    // if either SD or HD is not defined, we'll disable the switch
                    thisRecordingForm.isSingleFeedChannel = !isHd || !isSd;
                    //console.info("thisRecordingForm.isSingleFeedChannel", thisRecordingForm.isSingleFeedChannel, channelInfo.sdPosition, channelInfo.hdPosition)

                    // TIME EXTENSION
//                    params.timeExtension = Math.round(Math.random()*100); // test custom option
//                    params.timeExtension = 600; // test custom option
//                    params.timeExtension = undefined; // test undefined option
                    thisRecordingForm.timeExtension = createTimeExtensionList(thisRecordingForm.timeExtension, params.timeExtension);
                    thisRecordingForm.selectedTimeExtension = getOptionByValue(thisRecordingForm.timeExtension, params.timeExtension);

                    // REPEAT
//                    params.repeat = true; // test true option
                    thisRecordingForm.repeat = (params.repeat === true);

                    // SAVE MODE
//                    params.saveMode = "ONE_WEEK"; // test no repeat option
//                    params.saveMode = "LAST_FIVE"; // test repeat option
                    modifySaveModeOption(thisRecordingForm, params.saveMode);

                    return thisRecordingForm;
                });
            };



            function forceDigest(scope) {
                // this code force http loading if not in a digest cycle
                //check if angular is in a digest cycle
                console.log(!$rootScope.$$phase, !scope.$$phase, !$rootScope.$$phase && !scope.$$phase);
                if (!$rootScope.$$phase && !scope.$$phase) {
                    $rootScope.$digest();
                }
            }

            this.sendRecordingForm = function (scope, form, modalState, loadContent) {
//                console.log("sendRecordingForm", form);
//                console.log("sendRecordingForm", form.definition);
//                modalState.current = "pending";
//                modalState.current = "loading";
                var formPayload;
                var action;
                var payload = {};
                if(form.conflictResolutions){
                    // this is a return from the conflict resolutions screen, data can be passed as is
                    action = form.resolveAction;
                    formPayload = $.extend({}, action.parameters);
                    payload.conflictResolutions = form.conflictResolutions;
                }else{
                    action = form.action;
                    formPayload = $.extend({}, action.parameters);
                    // over write default values with form values
                    formPayload.terminalId = form.selectedTerminal.macAddress;
                    formPayload.definition = form.definition;
                    formPayload.timeExtension = form.selectedTimeExtension.value;
                    formPayload.repeat = form.repeat;
                    formPayload.saveMode = form.selectedSaveMode.value;
                }

                payload.options = formPayload;

                var configs = {};
                var actionConfigs = {
                    data: payload,
                    url: SERVICES_BASE_PATH + action.uri + '?localeLang=' + $translate.instant('lang'),//add localeLang to get response msg in right language
                    method: action.method
                };

                $.extend(true, configs, recordingFormConfigs, actionConfigs);

                modalState.current = "pending";

                $http(configs).then(function (response) {
                    // set confirmation message
                    showMessage(scope, "success", response.data.body.main.message, CONFIRMATION_MESSAGE_DURATION);
                    // for now created a custom state, to be determined if this is a good work around or if modal should be closed
                    if (form.isModificationForm) {
                        modalState.current = "noFurtherActionsPossible";

                        //Google Analytics tracking through Native Bridge
                        NativeActions.trackEvent('Terminal', 'modifier', scope.content.title);
                    } else {
                        loadContent(scope);

                        //Google Analytics tracking through Native Bridge
                        NativeActions.trackEvent('Terminal', 'enregistrer', scope.content.title);
                    }


                    // updateData via bridge after delay to give terminal time to update cleanly
                    $timeout(function () {
                        NativeActions.updateData();
                    }, UPDATE_DATA_DELAY)
                }, function (error) {
                    //console.info("sendRecordingForm - error", error)
                    if (error.number === 409 || error.status === 409) {

                        SrvRecordingConflict.showConflictModal(error).then(function(conflictResolution){
                            //console.log("conflictResolution", conflictResolution)
                            // when a conflict is resolved, we try again
                            that.sendRecordingForm(scope, conflictResolution, modalState, loadContent);
                        }, function(){
                            // conflict resolution canceled or modal closed
                            // TODO use forceDigest function instead of timeout here
                            $timeout(function(){
                                modalState.current = "editing";
                            }, 0)

                        });
                    } else {
                        // got an error while trying to record or modify recording
                        // show message and return to viewing state
                        var errorMessage = (error.message) ? error.message : error.data.head.error.message;
                        showMessage(scope, "error", errorMessage, ERROR_MESSAGE_DURATION);
                        modalState.current = "viewing";
                    }
                });
            };

        }]);
angular.module("videotron.illico.delete-recording").factory("ModalConfirmConflictDeleteType",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader) {

        function ModalConfirmConflictDeleteType(template) {
            var templateString;
            var simpleModal = new SimpleModal();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            this.getTemplateId = function(){
                return template
            };

            this.show = function (modalOptions, yesCallback, noCallback) {
                var scope = $rootScope.$new(true);

                scope.skipOnly = function () {
                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null, true);
                    }
                    simpleModal.close();
                };

                scope.deleteAll = function () {
                    if (angular.isFunction(noCallback)) {
                        noCallback.call(null, false);
                    }
                    simpleModal.close();
                };


                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (templateId) {
            return new ModalConfirmConflictDeleteType(templateId);
        };


    }]);
angular.module("videotron.illico.recording-conflict").factory("ModalRecordingConflict",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader) {

         function ModalRecordingConflict(template) {
             var templateString;
             var simpleModal = new SimpleModal();

             SrvModalTemplateLoader.load(template).then(function(result){
                 templateString = result;
             });



            this.show = function (scope, modalOptions, yesCallback, noCallback) {
                var skipNoCallBack = false;
                scope.resolve = function(){
                    console.log("YES")
                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null);
                    }
                    skipNoCallBack = true;
                    simpleModal.close();
                };
                scope.cancel = function(){
                    simpleModal.close();
                };
                var element = SrvModalTemplateLoader.compile(templateString, scope);

                // since there's a close button on the modal, we need the noCallBack to be called here
                simpleModal.show(element, modalOptions, function close() {
                    // but since the resolve action also closes the window, we avoid calling both callBacks with the skipNoCallBack flag
                    if (!skipNoCallBack && angular.isFunction(noCallback)) {
                        noCallback.call(null, undefined);
                    }
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (template) {
            return new ModalRecordingConflict(template);
        };


    }]);
angular.module("videotron.illico.recording-conflict").service("SrvRecordingConflict",
    ["$rootScope", "$location", "$filter", "$translate", "ModalRecordingConflict", "ModalConfirmConflictDeleteType", "NativeActions", "$q", "SrvModalHeight",
        function ($rootScope, $location, $filter, $translate, ModalRecordingConflict, ModalConfirmConflictDeleteType, NativeActions, $q, SrvModalHeight) {

            var CONFLICT_ROW_HEIGHT = 100; // approximate height of each conflict;
            var MODAL_HEIGHT_BUFFER = 160; // approximate height of modal if it had no conflicts in it;

            var modalRecordingConflict = new ModalRecordingConflict("/appEnp/templates/recording-conflict/recording-conflict.template.html");
            var modalConfirmConflictDeleteType = new ModalConfirmConflictDeleteType("/appEnp/templates/recording-conflict/recording-conflict-confirm-delete-type.template.html");
            var dateFilter = $filter("date");
            var modalRecordingConflictOptions = {
                autoResize: false,
                opacity: 90,
                minWidth: 400,
                minHeight: 400, // will be over written at render time in showConflictModal();
                closeClass: 'simplemodal-close',
//                closeClass: 'conflict-modal-close',
                zIndex: 88888 // make sure this is below the confirmation modals but above the content-details modal
            };
            var modalConfirmConflictDeleteTypeOptions = {
                opacity: 90,
                zIndex: 99999 // make sure this is above conflict modal
            };


            function getModalHeights(numberOfConflicts){
                return SrvModalHeight.getHeights({
                        numberOfConflicts : numberOfConflicts,
                        modalHeightBuffer: MODAL_HEIGHT_BUFFER,
                        conflictRowHeight: CONFLICT_ROW_HEIGHT
                    });
            }


            function getTimeBoundaries(conflicts){
                var earliestStartTime = Number.POSITIVE_INFINITY;
                var latestEndTime = 0;
                for(var i = 0, iLen = conflicts.length; i < iLen; i++){
                    var conflict = conflicts[i];
                    var conflictStartTime = new Date(conflict.startTime).getTime();
                    var conflictEndTime = new Date(conflict.endTime).getTime();
                    if(conflictStartTime < earliestStartTime){
                        earliestStartTime = conflictStartTime;
                    }
                    if(conflictEndTime > latestEndTime){
                        latestEndTime = conflictEndTime;
                    }
                }
                return {
                    startTime : earliestStartTime,
                    endTime : latestEndTime
                };
            }
            function formatConflict (conflict, timeBoundaries){
                return {
                    channelPosition : conflict.channelPosition,
                    canBeSkipped : conflict.skippable,
                    conflictingTimeSlots : convertTimeSlotsToPositions(timeBoundaries, conflict.conflictingTimeSlots),
                    isNew : conflict.recordingId.indexOf("NULL") !== -1,
                    programTimeSlot : formattedTimeSlot(conflict.startTime, conflict.endTime, timeBoundaries),
                    recordingId : conflict.recordingId,
                    skipOnly : false,
                    timeSpan : formatTimeSpan(conflict.startTime, conflict.endTime),
                    title : conflict.title
                }
            }

            function formatTimeSpan (startTime, endTime){
                return dateFilter(new Date(startTime), "shortTime") + $translate.instant("recording_conflict_time_span_splitter") + dateFilter(new Date(endTime), "shortTime");
            }


            function getTimeInRangeAsPercentageOfRange(time, min, max){
                return Math.round((time - min)/(max - min)*100);
            }

            function formattedTimeSlot(startTime, endTime, timeBoundaries){
                var timeMin = timeBoundaries.startTime;
                var timeMax = timeBoundaries.endTime;
                var startTimeStamp = new Date(startTime).getTime();
                var endTimeStamp = new Date(endTime).getTime();
                var leftPercentage = getTimeInRangeAsPercentageOfRange(startTimeStamp, timeMin, timeMax) + "%";
                var rightPercentage = 100 - getTimeInRangeAsPercentageOfRange(endTimeStamp, timeMin, timeMax) + "%";

                return {
                    startTime: startTimeStamp,
                    endTime: endTimeStamp,
                    cssStyle: {
                        "left" : leftPercentage,
                        "right" : rightPercentage
                    }
                };
            }

            function convertTimeSlotsToPositions (timeBoundaries, timeSlots){
                // return timeslots expressed as positions relative to boundaries
                var convertedTimeSlots = [];
                for(var i = 0, iLen = timeSlots.length; i < iLen; i++){
                    convertedTimeSlots.push(formattedTimeSlot(timeSlots[i].startTime, timeSlots[i].endTime, timeBoundaries))
                }

                return convertedTimeSlots;
            }

            function parseConflicts(conflicts){
                var unresolvedConflicts = [];
                var timeBoundaries = getTimeBoundaries(conflicts);
                for(var i = 0, iLen = conflicts.length; i < iLen; i++){
                    unresolvedConflicts.push(formatConflict(conflicts[i], timeBoundaries))
                }
                return unresolvedConflicts;
            }

            function moveConflict(source, destination, conflict){
                // remove from source array
                for(var i = 0, iLen = source.length; i < iLen; i++){
                    if(conflict.recordingId === source[i].recordingId){
                        source.splice(i, 1);
                        break;
                    }
                }
                // add to destination array
                destination.push(conflict);
            }

            function resolvePromiseAndMoveConflict(promise, skipOnly, scope, conflict){
                conflict.skipOnly = skipOnly;
                moveConflict(scope.unResolvedConflicts, scope.resolvedConflicts, conflict);
                promise.resolve();
            }

            function simplifiedResolvedConflicts(resolvedConflicts){
                var cleanedResolvedConflicts = [];
                for(var i = 0, iLen = resolvedConflicts.length; i < iLen; i++){
                    cleanedResolvedConflicts.push({
                        recordingId: resolvedConflicts[i].recordingId,
                        skipOnly: resolvedConflicts[i].skipOnly
                    });
                }
                return cleanedResolvedConflicts;
            }


            this.showConflictModal = function(conflictResponse) {
                var deferred = $q.defer();
                var conflicts = conflictResponse.data.body.main;
                var scope = $rootScope.$new(true);
                var modalHeights = getModalHeights(conflicts.conflictElements.length);

                scope.title = $translate.instant("CONFLICT");
                scope.conflictMaxHeight = {'max-height': modalHeights.innerHeight + 'px'};
                scope.unResolvedConflicts = parseConflicts(conflicts.conflictElements);
                scope.resolvedConflicts = [];
                scope.resolveAction = conflicts.resolveAction;
                scope.maxSimultaneousRecordings = conflicts.maxSimultaneousRecordings;

                scope.moveToResolved = function(conflict){
                    var deleteTypeDeferred = $q.defer();
                    if(conflict.canBeSkipped){
                        modalConfirmConflictDeleteType.show(modalConfirmConflictDeleteTypeOptions, function(){
                            resolvePromiseAndMoveConflict(deleteTypeDeferred, true, scope, conflict);
                        }, function(){
                            resolvePromiseAndMoveConflict(deleteTypeDeferred, false, scope, conflict);
                        });
                    }else{
                        resolvePromiseAndMoveConflict(deleteTypeDeferred, false, scope, conflict);
                    }
                    return deleteTypeDeferred.promise;
                };
                scope.moveToUnResolved = function(conflict){
                    // set skipOnly back to default false value
                    conflict.skipOnly = false;
                    moveConflict(scope.resolvedConflicts, scope.unResolvedConflicts, conflict)
                };


                // open modal with correct height
                modalRecordingConflictOptions.minHeight = modalHeights.outerHeight;
                modalRecordingConflict.show(scope, modalRecordingConflictOptions, function(){
                    deferred.resolve({
                        resolveAction : scope.resolveAction,
                        conflictResolutions : simplifiedResolvedConflicts(scope.resolvedConflicts)
                    });
                }, function(error){
                    deferred.reject(error);
                });

                return deferred.promise;
            }

        }]);
angular.module("videotron.illico.grid").factory("GridContainer", ["EventDispatcher", "Sprite", "$window",function (EventDispatcher, Sprite, $window) {
    var SIZE_CHANGE = "sizeChange";
    var OFFSET_CHANGE = "offsetChange";

    function GridContainer(container, gridContainerParentId, eventDispatcher) {
        var width = null;
        var height = null;
        var offsetTop = null;
        var offsetTopFromWindow = null;
        var offsetBottomFromWindow = null;
        var scrollTop = 0;
        var scrollDiff = 0;
        var $containerParent = $(container).parent();
        var sprite = new Sprite(container[0]);

        function getOffsetTop(){
            return $containerParent.offset().top;
        }
        function getOffsetTopFromWindow(){
            return Math.max(scrollTop*-1 + offsetTop, 0);
        }
        function getOffsetBottomFromWindow(){
            // this should never return a negative number
            var vpHeight = Math.max(getOffsetTopFromWindow() + height - scrollTop, 0);
            return Math.min(vpHeight, $($window).height());
        }



        this.update = function () {
            var newWidth = container.width();
            var newHeight = container.height();
            var newOffset = getOffsetTop();
            var newScrollTop = $window.pageYOffset;
            if (width !== newWidth || height !== newHeight) {
                width = newWidth;
                height = newHeight;
                offsetTopFromWindow = getOffsetTopFromWindow();
                offsetBottomFromWindow = getOffsetBottomFromWindow();
                eventDispatcher.dispatch(SIZE_CHANGE);
            }
            if (offsetTop !== newOffset || scrollTop !== newScrollTop){
                offsetTop = newOffset;
                scrollDiff = newScrollTop - scrollTop;
                scrollTop = newScrollTop;
                offsetTopFromWindow = getOffsetTopFromWindow();
                offsetBottomFromWindow = getOffsetBottomFromWindow();
                eventDispatcher.dispatch(OFFSET_CHANGE);
            }else{
                // reset scrollDiff once we've stopped scrolling
                scrollDiff = 0;
            }

        };

        this.addSizeChangeListener = function (listener) {
            return eventDispatcher.addListener(SIZE_CHANGE, listener);
        };

        this.getWidth = function () {
//            console.log("width", width)
            return width;
        };

        this.getHeight = function () {
//            console.log("height", height)
            return height;
        };

        this.getSprite = function () {
            return sprite;
        };

        this.setHeight = function (value) {
//            console.info("setHeight", value, $containerParent, $(container))
            height = value;
            $containerParent.height(value);
            eventDispatcher.dispatch(SIZE_CHANGE);
        };

        this.addOffsetChangeListener = function (listener) {
            return eventDispatcher.addListener(OFFSET_CHANGE, listener);
        };

        this.getOffsetTop = function () {
//            console.log("offsetTopFromWindow", offsetTopFromWindow)
            return offsetTopFromWindow;
        };

        this.getOffsetBottom = function () {
//            console.log("offsetBottomFromWindow", offsetBottomFromWindow)
            return offsetBottomFromWindow;
        };

        this.getCalculatedHeight = function (bufferHeight) {
            var bH = bufferHeight || 0;
            var thisHeight = getOffsetBottomFromWindow() - getOffsetTopFromWindow() - bH;
            return Math.max(thisHeight, bH);
        };

        this.getScrollDiff = function () {
//            console.log("offsetTop", offsetTop)
            return scrollDiff;
        };
    }


    return function (container, gridContainerParentId) {
        return new GridContainer(container, gridContainerParentId, new EventDispatcher());
    };


}]);
angular.module("videotron.illico.grid").factory("GridItem", function () {

    function GridItem(type, x, y, width, height, data, renderer) {
        this.type = type;
        //viewport context based position and size
        this.viewportX = x;
        this.viewportY = y;
        this.positionAbsolute = true;
        this.x = x;
        this.maxX = x + width;
        this.y = y;
        this.width = width;
        this.height = height;
        this.zIndex = 0;
        this.data = data;
        this.sprite = null;
        this.renderId = 0;
        this.renderer = renderer;
        this.onRelease = null;
        this.isClickable = true;
        this.endIndex = null;
        this.spritePool = null;

    }

    return function (type, x, y, width, height, data, renderer) {
        return new GridItem(type, x, y, width, height, data, renderer);
    };

});
angular.module("videotron.illico.grid").factory("GridOverview",
    ["Sprite", "EventDispatcher", function (Sprite, EventDispatcher) {

        var MOVE_TO = "move_to";

        function GridOverview(viewport, scale, eventDispatcher) {
            var containerSprite = new Sprite();
            containerSprite.setZIndex(10000);
            containerSprite.setClass("grid-overview");

            angular.element(containerSprite.getElement()).on("click", function (event) {
                event = event.originalEvent;
                var x = event.offsetX * (1 / scale);
                var y = event.offsetY * (1 / scale);
                eventDispatcher.dispatch(MOVE_TO, {x: x, y: y});
            });

            var viewportSprite = new Sprite();
            viewportSprite.setClass("viewport");

            containerSprite.append(viewportSprite);

            this.render = function () {

                containerSprite.setWidth(viewport.getSceneWidth() * scale);
                containerSprite.setHeight(viewport.getSceneHeight() * scale);
                viewportSprite.setWidth(viewport.getWidth() * scale);
                viewportSprite.setHeight(viewport.getHeight() * scale);
                viewportSprite.setX(viewport.getX() * scale);
                viewportSprite.setY(viewport.getY() * scale);
            };

            this.getSprite = function () {
                return containerSprite;
            };

            this.addMoveToListener = function (listener) {
                return eventDispatcher.addListener(MOVE_TO, listener);
            };

        }

        return function (viewport, scale) {
            return new GridOverview(viewport, scale, new EventDispatcher());
        };


    }]);
angular.module("videotron.illico.grid").factory("GridRenderer",
    ["$window", function ($window) {


        function GridRenderer(w_buffer, stickyProgs) {
            var renderCount = 0;
            var activeSprites = [];


            this.find = function (x, y) {
                var i = activeSprites.length;
                var lastResultIndex = -1;
                var result = null;
                while (i--) {
                    var sprite = activeSprites[i];
                    if (sprite) {
                        var gridItem = sprite.gridItem;

                        // elements that are not position:absolute are fixed, like the timeline and now button
                        // therefore we need to remove the window offset
                        // so that it can be found using the viewportX and viewportY
                        var relativeY = (gridItem.positionAbsolute) ? y : y - $window.pageYOffset;
                        var relativeX = (gridItem.positionAbsolute) ? x : x - $window.pageXOffset;
                        if (gridItem.isClickable && relativeX >= gridItem.viewportX && relativeX <= (gridItem.viewportX + gridItem.width) && relativeY >= gridItem.viewportY && relativeY <= (gridItem.viewportY + gridItem.height)) {
                            if (lastResultIndex < gridItem.zIndex) {
                                result = gridItem;
                                lastResultIndex = gridItem.zIndex;
                            }
                        }
                    }
                }
                return result;
            };


            this.render = function (gridItems) {
                renderCount++;

                var gridItemCount = gridItems.length;
                var gridItem;
                var sprite;
                for (var i = 0; i < gridItemCount; i++) {
                    gridItem = gridItems[i];
                    gridItem.renderId = renderCount;
                    sprite = gridItem.sprite;
                    if (!sprite) {

                        sprite = gridItem.spritePool.getSprite();
                        gridItem.sprite = sprite;
                        if (sprite.activeSpriteId) {
                            activeSprites[sprite.activeSpriteId] = sprite;
                        } else {
                            sprite.activeSpriteId = activeSprites.length;
                            activeSprites.push(sprite);
                        }
                        sprite.setZIndex(gridItem.zIndex);
                        sprite.gridItem = gridItem;
                        gridItem.renderer.render(sprite, gridItem.data, gridItem);
                    }

                    if(!gridItem.positionAbsolute){
                        sprite.setCssPositionFixed(true);
                    }

                    // used by EPG grid to make title stick to left edge of the screen
                    if(stickyProgs && gridItem.data && gridItem.data.objectType && gridItem.data.objectType === "LINEAR_PROGRAM" && gridItem.viewportX < w_buffer){
                        gridItem.paddingLeft = (gridItem.viewportX - w_buffer) *-1;
                    }else{
                        gridItem.paddingLeft = 0;
                    }
//                    console.log(" --------- gridItem.height", gridItem.height, $.extend({}, gridItem))
                    sprite.setPositionAndSize(gridItem.viewportX, gridItem.viewportY, gridItem.width, gridItem.height, gridItem.paddingLeft);

                }

                var activeSpriteCount = activeSprites.length;

                for (var j = 0; j < activeSpriteCount; j++) {
                    sprite = activeSprites[j];
                    if (sprite) {
                        gridItem = sprite.gridItem;
                        if (gridItem.renderId !== renderCount) {
                            if (angular.isFunction(gridItem.onRelease)) {
                                gridItem.onRelease.call(null);
                            }
                            gridItem.sprite = null;
                            sprite.gridItem = null;
                            activeSprites[j] = null;
                            gridItem.spritePool.releaseSprite(sprite);

                        }
                    }
                }


            };

        }


        return function (w_buffer,stickyProgs) {
            return new GridRenderer(w_buffer, stickyProgs);
        };


}]);
angular.module("videotron.illico.grid").factory("Row", function () {

    function Row(id, height, visible) {
        this.id = id;
        this.height = height;
        this.visible = visible;
    }


    return function (id, height, visible) {
        return new Row(id, height, visible);
    };


});
angular.module("videotron.illico.grid").factory("RowContainer",
    ["EventDispatcher", function (EventDispatcher) {


        var HEIGHT_CHANGE = "height_change";

        function Row(id, y, height, index) {
            this.startY = y;
            this.viewportStartY = 0;
            this.initialHeight = height;
            this.height = height;
            this.endY = y + height;
            this.id = id;
            this.visible = true;
            this.index = index;
            this.hideCallback = null;
            this.showCallback = null;
            this.updateAction = null;
        }


        function RowContainer(eventDispatcher, offsetY) {

            var rowsById = {};
            var rows = [];
            var height = 0;
            var rowsToUpdate = [];
            var rowToUpdateCount = 0;


            this.getVisibleProgramRowsLength = function () {
                var fillteredRows = [];
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    // filter out hidden and title heading rows
                    if (row.visible && !isNaN(row.id)) {
                        fillteredRows.push(row);
                    }
                }
                return fillteredRows.length;
            };

            this.setRows = function (data) {
                //TODO check currently animated rows...
                var previousHeight = height;

                rows.length = 0;
                rowsById = {};
                height = 0;
                for (var i = 0, count = data.length; i < count; i++) {
                    var item = data[i];
                    // TODO needed ?
                    if (!item.id) {
                        console.error("no ID", item, i)
                    }
                    var row = new Row(item.id, height, item.height, rows.length);
                    row.visible = item.visible;

                    // if duplicate ids, just ignore them
                    // this includes channel groups that are non-sequential, like for example :
                    // Viewers Choice, position 351 - 358 and 751
                    // 2 groups will be created with the same id, so the channel at position 751 will never show up inn the grid
                    if (!rowsById[item.id]) {
                        rowsById[item.id] = row;
                        rows.push(row);
                        if (row.visible) {
                            height += item.height;
                        } else {
                            row.height = 0;
                        }
                    }
                }
                lastRowRequest = new RowsRequest([], Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);

                if (previousHeight !== height) {
                    eventDispatcher.dispatch(HEIGHT_CHANGE);
                }
            };

            this.getRowPosition = function (rowId) {
                var result = null;
                rowId = parseInt(rowId);
                main:
                    for (var i = 0, count = rows.length; i < count; i++) {
                        var row = rows[i];
                        if (row.id === rowId) {
                            if (row.height === 0) {
                                while (--i) {
                                    row = rows[i];
                                    if (row.height > 0) {
                                        result = row.startY;
                                        break main;
                                    }
                                }
                            } else {
                                result = row.startY;
                            }
                            break;
                        }
                    }
                return result;
            };

            this.getRowVisibilityById = function (rowId) {
                for (var i = 0, count = rows.length; i < count; i++) {
                    var row = rows[i];
                    if (row.id === rowId) {
                        return row.visible;
                    }
                }
                return false;
            };

            this.getHeight = function () {
                return Math.ceil(height);
            };

            function updateRowsYPosition(startIndex, delta) {
                var rowCount = rows.length;
                for (var i = startIndex; i < rowCount; i++) {
                    var row = rows[i];
                    row.startY += delta;
                    row.endY += delta;
                }
            }


            this.showRow = function (rowId) {
                var row = rowsById[rowId];
                if (row && !row.visible) {
                    row.visible = true;
                    row.updateAction = showRow;
                    rowToUpdateCount++;
                    rowsToUpdate.push(row);
                }
            };


            this.toggleChildrenVisibility = function (parentRowId, childrenRowIds, callback) {
                var row = rowsById[parentRowId];
                var numberOfRowsToAnimate = 1;
                var firstChildRow = rowsById[childrenRowIds[0].recordingId];
                var childrenVisible = (firstChildRow && firstChildRow.visible) ? true : false;

                for (var i = childrenRowIds.length-1, count = 0; i >= count; i--) {
                    var childRow = rowsById[childrenRowIds[i].recordingId];
                    if (childRow) {
                        if (!childrenVisible) {
                            childRow.visible = true;
                            childRow.updateAction = (i < numberOfRowsToAnimate) ? showRow : showRowNow;
                            childRow.showCallback = callback;
                            rowToUpdateCount++;
                            rowsToUpdate.push(childRow);
                        }else{
                            childRow.visible = false;
                            childRow.updateAction = (i < numberOfRowsToAnimate) ? hideRow : hideRowNow;
                            childRow.hideCallback = callback;
                            rowToUpdateCount++;
                            rowsToUpdate.push(childRow);
                        }
                    }
                }
            };


            function hideRowNow(row, i) {
                var diff = row.height;
                row.height = 0;
                row.visible = false;
                rowsToUpdate[i] = null;
                rowToUpdateCount--;
                if (row.hideCallback) {
                    row.hideCallback.call(null);
                }
                updateRowsYPosition(row.index + 1, -diff);
                height -= diff;
                eventDispatcher.dispatch(HEIGHT_CHANGE);
            }


            function hideRow(row, i) {
                var diff = row.height * 0.25;
                if (diff < 0.15) {
                    diff = row.height;
                    row.height = 0;
                    row.visible = false;
                    rowsToUpdate[i] = null;
                    rowToUpdateCount--;
                    if (row.hideCallback) {
                        row.hideCallback.call(null);
                    }
                } else {
                    row.height -= diff;
                }

                updateRowsYPosition(row.index + 1, -diff);
                height -= diff;
            }

            function showRow(row, i) {
                var increase = (row.initialHeight - row.height) * 0.25;
                row.height += increase;
                if (Math.abs(increase) < 0.15) {
                    increase = row.initialHeight - row.height;
                    row.height = row.initialHeight;
                    rowsToUpdate[i] = null;
                    rowToUpdateCount--;
                    if (row.showCallback) {
                        row.showCallback.call(null);
                    }
                }

                updateRowsYPosition(row.index + 1, increase);
                height += increase;
            }

            function showRowNow(row, i) {
                var rowH = row.initialHeight;
                row.height = rowH;
                rowsToUpdate[i] = null;
                rowToUpdateCount--;
                if (row.showCallback) {
                    row.showCallback.call(null);
                }
                updateRowsYPosition(row.index + 1, rowH);
                height += rowH;
            }

            this.hideRow = function (rowId, withoutAnimation, callback) {
                var row = rowsById[rowId];
                if (row && row.visible) {
                    row.updateAction = withoutAnimation ? hideRowNow : hideRow;
                    row.hideCallback = callback;
                    rowToUpdateCount++;
                    rowsToUpdate.push(row);
                }
            };

            function RowsRequest(rows, min, max, startY, endY) {

                this.match = function (startY, endY) {
                    return min <= startY && max >= endY;
                };

                this.yPositionHasChanged = function (newStartY, newEndY) {
                    return newStartY - startY + newEndY - endY !== 0;
                };

                this.updatePosition = function (newStartY, newEndY) {
                    startY = newStartY;
                    endY = newEndY;
                };

                this.getRows = function () {
                    return rows;
                };

            }

            function setRowViewportStartY(rowStartY, offsetY, startY, useNativeVerticalScroll){
                // when using native scroll, row position if calculated from the top of the window, not the viewport
                if(useNativeVerticalScroll){
                    return rowStartY + offsetY;
                }else{
                    return rowStartY - startY + offsetY;
                }
            }

            var lastRowRequest = new RowsRequest([], Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY);

            // return list of on screen rows
            this.findRows = function (startY, endY, useNativeVerticalScroll) {
                var result;
                var i;
                var row;
                useNativeVerticalScroll = useNativeVerticalScroll || false;

                if (lastRowRequest.match(startY, endY) && !rowToUpdateCount) {
                    result = lastRowRequest.getRows();
                    if (lastRowRequest.yPositionHasChanged(startY, endY)) {
                        i = result.length;
                        while (i--) {
                            row = result[i];
                            row.viewportStartY = setRowViewportStartY(row.startY, offsetY, startY, useNativeVerticalScroll);
                        }
                        lastRowRequest.updatePosition(startY, endY);
                    }
                } else {
                    result = [];
                    i = rows.length;
                    while (i--) {
                        row = rows[i];
                        if (row.startY <= endY && row.endY >= startY && row.visible) {
                            row.viewportStartY = setRowViewportStartY(row.startY, offsetY, startY, useNativeVerticalScroll);
                            result.push(row);
                        }
                    }
                    var lastIndex = result.length - 1;
                    if (lastIndex >= 0) {
                        var first = result[lastIndex];
                        var last = result[0];
                        var min = first.startY;
                        var max = last.endY;
                        lastRowRequest = new RowsRequest(result, min, max, startY, endY);
                    }
                }
                return result;
            };

            // return list of on screen rows + rows above and below
            this.findPreloadRowsIds = function (preloadStartY, preloadEndY) {
                // TODO see if caching strategy like findRows would help here
                var result;
                var i;
                var row;

                result = [];
                i = rows.length;
                while (i--) {
                    row = rows[i];
                    if (row.startY <= preloadEndY && row.endY >= preloadStartY && row.visible) {
                        result.push(row.id);
                    }
                }
                // return result reversed to avoid having unloaded content on screen
                // since we're using a while-- above
                return result.reverse();
            };

            this.update = function () {
                var count = rowsToUpdate.length;
                if (count > 0) {
                    for (var i = 0; i < count; i++) {
                        var row = rowsToUpdate[i];
                        if (row) {
                            row.updateAction(row, i);
                        }
                    }
                    if (rowToUpdateCount === 0) {
                        rowsToUpdate.length = 0;
                    }
                    eventDispatcher.dispatch(HEIGHT_CHANGE);
                }
            };

            this.addHeightChangeListener = function (listener) {
                return eventDispatcher.addListener(HEIGHT_CHANGE, listener);
            };


        }

        return function (offset) {
            var offsetY = offset || 0;
            return new RowContainer(new EventDispatcher(), offsetY);
        };


    }]);
angular.module("videotron.illico.grid").factory("Sprite", ["$document", function ($document) {


    function Sprite(element) {
        this.element = element;
        this.style = element.style;
        this.style.position = "absolute";
        this.x = 0;
        this.y = 0;
        this.gridItem = null;
        this.activeSpriteId = null;
    }

    Sprite.prototype.setClass = function (value) {
        this.element.className = value;
    };

    Sprite.prototype.getElement = function () {
        return this.element;
    };

    Sprite.prototype.setZIndex = function (value) {
        this.style.zIndex = value;
    };

    Sprite.prototype.setCssPositionFixed = function (boolean) {
        if(boolean === true){
            this.style.position = "fixed";
        }else{
            this.style.position = "absolute";
        }

    };

    Sprite.prototype.setBorder = function (value) {
        this.style.border = value;
    };

    Sprite.prototype.setOpacity = function (value) {
        this.style.opacity = value;
    };

    Sprite.prototype.setBackground = function (value) {
        this.style.background = value;
    };

    Sprite.prototype.setWidth = function (value) {
        //The renderer reuse sprites so if the new width is invalid, the previously set width will be used
		this.style.width = value + "px";
    };

    Sprite.prototype.setHeight = function (value) {
        this.style.height = value + "px";
    };

    Sprite.prototype.setX = function (value) {
        this.setPosition(value, this.y);
    };

    Sprite.prototype.setY = function (value) {
        this.setPosition(this.x, value);
    };

    //utility function used by the GridRenderer, remove need for multiple function calls.
    Sprite.prototype.setPositionAndSize = function (newX, newY, width, height, paddingLeft, visible) {
//        this.style.display = (visible) ? "block" : "none";
        this.x = newX;
        this.y = newY;
        this.style.width = width + "px";
        this.style.height = height + "px";

        var translateStyle = "translate(" + this.x + "px," + this.y + "px)";
        // for multi browser compatibility
        this.style.webkitTransform = translateStyle; // webkit/opera
        this.style.msTransform  = translateStyle; //IE
        this.style.transform = translateStyle; // firefox/w3c

        var pl = paddingLeft || 0;
        // for when titles stick to left edge
        if($(this.element).hasClass("program")){
            $(this.element).find(".title").css({"padding-left":pl + "px"});
        }
    };

    Sprite.prototype.setPosition = function (newX, newY) {
        this.x = newX;
        this.y = newY;
        var translateStyle = "translate(" + this.x + "px," + this.y + "px)";
        // for multi browser compatibility
        this.style.webkitTransform = translateStyle; // webkit/opera
        this.style.msTransform  = translateStyle; //IE
        this.style.transform = translateStyle; // firefox/w3c
    };

    Sprite.prototype.append = function (sprite) {
        this.element.appendChild(sprite.getElement());
    };

    Sprite.prototype.meta = null;

    var rawDocument = $document[0];
    return function (element) {
        var elem = element || rawDocument.createElement("div");
        return new Sprite(elem);
    };

}]);
angular.module("videotron.illico.grid").factory("SpritePool", ["Sprite", function (Sprite) {


    var DEFAULT_POOL_START_SIZE = 50;

    function SpritePool(container, spritePoolStartSize, spriteFactory) {
        spritePoolStartSize = spritePoolStartSize || DEFAULT_POOL_START_SIZE;

        var spritePool = [];
        var createdSprites = 0;

        function createSprite() {
            var sprite = spriteFactory ? spriteFactory.create() : new Sprite();
            container.append(sprite);
            return sprite;
        }

        this.getSprite = function () {
            var sprite;
            if (spritePool.length > 0) {
                sprite = spritePool.pop();
                sprite.style.display = "block";
            } else {
                createdSprites++;
                sprite = createSprite();
            }
            return sprite;
        };

        this.releaseSprite = function (sprite) {
            sprite.style.display = "none";
            spritePool.push(sprite);
        };

        function initializeSpritePool(size, spritePool) {
            while (size--) {
                var sprite = createSprite();
                sprite.style.display = "none";
                spritePool.push(sprite);
            }
        }

        initializeSpritePool(spritePoolStartSize, spritePool);

    }


    return function (container, spritePoolStartSize, spriteFactory) {
        return new SpritePool(container, spritePoolStartSize, spriteFactory);
    };


}]);
angular.module("videotron.illico.grid").factory("Viewport", ["BoundedRange", function (BoundedRange) {

    function Viewport(testHelper) {
        var xAxisBoundedRange = new BoundedRange();
        var yAxisBoundedRange = new BoundedRange();

        this.setWidth = function (value) {
            testHelper.viewPortWidth = value;
            xAxisBoundedRange.setExtent(value);
        };

        this.getWidth = function () {

            return xAxisBoundedRange.getExtent();
        };

        this.setHeight = function (value) {
            testHelper.viewPortHeight = value;
            yAxisBoundedRange.setExtent(value);
        };

        this.getHeight = function () {
            return yAxisBoundedRange.getExtent();
        };

        this.setSceneWidth = function (value) {
            testHelper.totalGridWidth = value;
            xAxisBoundedRange.setMax(value);
        };

        this.getSceneWidth = function () {
            return xAxisBoundedRange.getMax();
        };

        this.setSceneHeight = function (value) {
            testHelper.totalGridHeight = value;
            yAxisBoundedRange.setMax(value);
        };

        this.getSceneHeight = function () {
            return yAxisBoundedRange.getMax();
        };

        this.setX = function (value) {
            xAxisBoundedRange.setValue(value);
        };

        this.setY = function (value) {
            yAxisBoundedRange.setValue(value);
        };

        this.getX = function () {
            return xAxisBoundedRange.getValue();
        };

        this.getY = function () {
            return yAxisBoundedRange.getValue();
        };

        this.move = function (dx, dy) {

            xAxisBoundedRange.increaseValue(dx);
            yAxisBoundedRange.increaseValue(dy);
        };

        this.update = function () {
            var hasChanged = false;
            hasChanged = xAxisBoundedRange.update() || hasChanged;
            hasChanged = yAxisBoundedRange.update() || hasChanged;
            return hasChanged;
        };

    }

    return function (testHelper) {
        testHelper = testHelper || {};
        return new Viewport(testHelper);
    };

}]);
angular.module("videotron.illico.grid").factory("ViewportXAnimator", function () {


    function ViewportXAnimator(viewport) {

        // percentage of viewport width to move per update while continuously scrolling (~16ms) - higher is faster
        var VELOCITY_VIEWPORT_PERCENTAGE = 0.02;
        // percentage of viewport width to move for a click - higher scrolls further
        var DEFAULT_CLICK_VIEWPORT_PERCENTAGE = 0.5;
        // distance in pixels used for inertia slow down after continuously scrolling
        var DEFAULT_SCROLL_SLOW_DOWN_DISTANCE = 50;
        // time in ms that determines if user clicked or held button
        var CLICK_TIME_THRESHOLD = 250;

        var vx;
        var destination;
        var velocity;
        var inertia;
        var startTime;
        var clickScrollDistancePercentage;
        var scrollDirectionMultiplier;

        function goTo(value) {
            destination = value;
            inertia = true;
            var currentPosition = viewport.getX();
            vx = currentPosition - destination;
        }

        this.goTo = goTo;

        this.startContinuousScroll = function (data) {
            // if scrollFromLeftToRight, we need to move the grid left, so negative
            scrollDirectionMultiplier = (data.scrollFromLeftToRight) ? -1 : 1;
            clickScrollDistancePercentage = data.scrollDistance || DEFAULT_CLICK_VIEWPORT_PERCENTAGE;
            velocity = viewport.getWidth() * VELOCITY_VIEWPORT_PERCENTAGE * scrollDirectionMultiplier;
            inertia = false;
            vx = Number.POSITIVE_INFINITY;
            startTime = (!startTime) ? new Date() : startTime;
        };

        this.stopContinuousScroll = function () {
            if (startTime) {
                scrollDirectionMultiplier = (velocity > 0) ? -1 : 1;
                var stopTime = new Date();
                var isClickTimeThresholdReached = stopTime - startTime >= CLICK_TIME_THRESHOLD;
                var shortDistance = scrollDirectionMultiplier * DEFAULT_SCROLL_SLOW_DOWN_DISTANCE;
                var longDistance = scrollDirectionMultiplier * viewport.getWidth()* clickScrollDistancePercentage;

                // if user holds button longer then this, stop moving quickly
                if (isClickTimeThresholdReached) {
                    goTo(viewport.getX() + shortDistance);
                } else {
                    goTo(viewport.getX() + longDistance);
                }
                startTime = null;
            }
        };

        this.update = function () {
            if (vx) {
                var k = (inertia) ? Math.round(vx * 0.2) : velocity;
                vx -= k;
                if (inertia && Math.abs(viewport.getX() - destination) <= 2) {
                    viewport.setX(destination);
                    vx = 0;
                } else {
                    viewport.setX(viewport.getX() - k);
                    // we've reached the end of k or an edge, stop scrolling
                    if (k === 0 || viewport.getX() === 0 || viewport.getX() + viewport.getWidth() === viewport.getSceneWidth()) {
                        vx = 0;
                    }
                }
            }
        };


    }


    return function (viewport) {
        return new ViewportXAnimator(viewport);
    };

});
angular.module("videotron.illico.modal").factory("SimpleModal", ["$translate", function ($translate) {
    var openModals = [];
    function SimpleModal(){
        var modalRef;
        this.show = function (content, options, closeCallback) {
            var defaults = {
                autoResize: true,
                zIndex: 999999,
                overlayClose: false,
                escClose: true,
                closeHTML: '<button class="modalCloseImg" title="'+ $translate.instant("close") +'"></button>',
                closeClass: 'simplemodal-close',
                minWidth: 300,
                minHeight: 140,
                focus: true,
                onClose: function () {
                    if (angular.isFunction(closeCallback)) {
                        closeCallback.call(null);
                    }
                    modalRef.close();
                }
            };

            // extend defaults with options param
            if(options !== null && typeof options === "object"){
                $.extend(defaults, options);
            }

            modalRef = $.modal(content, defaults);
            openModals.push(modalRef);
        };

        this.close = function () {
            modalRef.close();
        };

        this.closeAll = function() {
            for(var i = 0, iLen = openModals.length; i<iLen; i++){
                var modal = openModals[i];
                //console.log("closing modal", $(modal.d.data).find(".title").text());
                modal.close();
            }
        }
    }


    return function () {
        return new SimpleModal();
    };
}]);
angular.module("videotron.illico.modal").service("SrvModalHeight",
    ["$window",
        function ($window) {

            var MAX_MODAL_TO_WINDOW_RATIO = 0.95; // modal should not be more than 95% of window height

            this.getHeights = function (options) {
                var innerHeight = 0;
                var outerHeight = 0;
                var conflictBasedHeight = (options.numberOfConflicts) ? options.numberOfConflicts * options.conflictRowHeight + options.modalHeightBuffer : 0;
                var windowBasedHeight = Math.round($($window).height() * MAX_MODAL_TO_WINDOW_RATIO);
                // if options.maxModalHeight not provided, use conflictBasedHeight
                var contentBasedHeight = options.maxModalHeight || conflictBasedHeight;

                if(contentBasedHeight > windowBasedHeight){
                    innerHeight = windowBasedHeight - options.modalHeightBuffer;
                    outerHeight = windowBasedHeight;
                }else{
                    innerHeight = contentBasedHeight;
                    outerHeight = contentBasedHeight;
                }

                //console.info("getHeights", innerHeight, outerHeight, windowBasedHeight, options.maxModalHeight)

                return {
                    outerHeight : outerHeight,
                    innerHeight : innerHeight
                };
            };

        }]);
angular.module("videotron.illico.modal").service("SrvModalTemplateLoader",
    ["$rootScope", "$compile", "$q", "$http", "$templateCache",
        function ($rootScope, $compile, $q, $http, $templateCache) {
             function trimTemplate(templateString){
                 //trim spaces, see : http://stackoverflow.com/questions/16122139/angular-js-jquery-html-string-parsing-in-1-9-1-vs-1-8-3
                 return templateString.trim();
             }

            this.load = function (template) {
                var deferred = $q.defer();
                var templateString;
                var isUrl = (/\/|\.html/).test(template);
                if (isUrl) {
                    //console.info("template is URL", template);
                    // download template
                    $http.get(template, {cache: $templateCache}).then(function (result) {
                        templateString = result.data;
                        deferred.resolve(trimTemplate(templateString));
                    }, function (error) {
                        throw new Error("template : " + template + "is missing (error while downloading via $http)");
                    });
                }else{
                    //console.info("template is INLINE", template);
                    // look for inline template with id
                    templateString = $templateCache.get(template);
                    if (!angular.isDefined(templateString)){
                        throw new Error("template : " + template + "is missing (not found in $templateCache)");
                    }
                    deferred.resolve(trimTemplate(templateString));
                }
                return deferred.promise;
            };

            this.compile = function (template, scope) {
                var element = angular.element(template);
                //if no digest is in progress compilation will fail...
                if (!$rootScope.$$phase) {
                    $rootScope.$apply(function () {
                        $compile(element)(scope);
                    });
                } else {
                    $compile(element)(scope);
                }
                return element;
            }

        }]);
angular.module("videotron.illico.delete-recording").factory("ModalConfirmDelete",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, AppConfig, $window) {

        function ModalConfirmDelete(template) {
            var templateString;
            var APP_CONST = AppConfig.getPVRAppConstants();
            var simpleModal = new SimpleModal();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.getTemplateId = function(){
                return template
            };

            this.show = function (record, modalOptions, yesCallback, noCallback) {
                var scope = $rootScope.$new(true);

                scope.record = record;

                scope.deleteRecord = function (skipOnly) {
//                    console.log('single - deleteRecord('+skipOnly+')');
//                    console.log('record: ',record);
                    simpleModal.close();
                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null, skipOnly);
                    }
                };

                scope.cancel = function () {
                    simpleModal.close();
                    if (angular.isFunction(noCallback)) {
                        noCallback.call(null);
                    }
                };


                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (templateId) {
            return new ModalConfirmDelete(templateId);
        };


    }]);
angular.module("videotron.illico.delete-recording").factory("ModalConfirmDeleteMultiple",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, AppConfig, $window) {

            function ModalConfirmDeleteMultiple(template) {
                var templateString;
                var APP_CONST = AppConfig.getPVRAppConstants();
                var simpleModal = new SimpleModal();
                SrvModalTemplateLoader.load(template).then(function(result){
                    templateString = result;
                });

                function triggerClose(){
                    if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                        $window.history.back();
                    }else{
                        simpleModal.close();
                    }
                }

                this.getTemplateId = function(){
                    return template
                };

                this.show = function (record, modalOptions, yesCallback, noCallback) {
                    var scope = $rootScope.$new(true);

                    scope.record = record;

                    scope.deleteRecord = function () {
//                        console.log('multiple - deleteRecord()');
//                        console.log('record: ',record);
                        simpleModal.close();
                        if (angular.isFunction(yesCallback)){
                            yesCallback.call(null);
                        }
                    };

                    scope.cancel = function () {
                        simpleModal.close();
                        if (angular.isFunction(noCallback)){
                            noCallback.call(null);
                        }
                    };

                    var element = SrvModalTemplateLoader.compile(templateString, scope);
                    simpleModal.show(element, modalOptions, function close() {
                        triggerClose();
                        scope.$destroy();
                    });

                };

                this.hide = function(){
                    simpleModal.close();
                };

            }


            return function (templateId) {
                return new ModalConfirmDeleteMultiple(templateId);
            };


        }]);
angular.module("videotron.illico.delete-recording").factory("ModalConfirmDeleteRecordingInProgress",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, AppConfig, $window) {

        function ModalConfirmDeleteRecordingInProgress(template) {
            var templateString;
            var APP_CONST = AppConfig.getPVRAppConstants();
            var simpleModal = new SimpleModal();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.getTemplateId = function(){
                return template
            };

            this.show = function (record, modalOptions, callback, cancelCallback) {
                var scope = $rootScope.$new(true);
                scope.record = record;
                scope.stopRecordingAndSave = function () {
                    simpleModal.close();
                    if (angular.isFunction(callback)){
                        callback.call(null, true);
                    }
                };
                scope.stopRecordingAndDelete = function () {
                    simpleModal.close();
                    if (angular.isFunction(callback)){
                        callback.call(null, false);
                    }
                };
                scope.cancel = function () {
                    simpleModal.close();
                    if (angular.isFunction(cancelCallback)){
                        cancelCallback.call(null);
                    }
                };

                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });
            };


            this.hide = function(){
                simpleModal.close();
            };


        }

        return function (templateId) {
            return new ModalConfirmDeleteRecordingInProgress(templateId);
        };


    }]);

angular.module("videotron.illico.delete-recording").factory("ModalRecordingsDeletionError",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "$filter", "$translate", "$sce", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, $filter, $translate, $sce, AppConfig, $window) {

        function ModalRecordingsDeletionError(template) {
            var templateString;
            var simpleModal = new SimpleModal();
            var dateFilter = $filter("date");
            var timeFilter = $filter("formatStartOrEndTime");
            var APP_CONST = AppConfig.getPVRAppConstants();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function extractDate(record) {
                var startTime = record.startTime;
                var date = dateFilter(new Date(startTime), "vl_recording_date_format");
                var time = timeFilter(startTime);
                return $sce.trustAsHtml(date + $translate.instant("recording_date_time_splitter") + time);
            }

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.getTemplateId = function(){
                return template
            };


            this.show = function (records) {

                var scope = $rootScope.$new(true);
                var modalOptions = {minHeight: 400};

                for (var i = 0, count = records.length; i < count; i++) {
                    var record = records[i];

                    //console.log(record);

                    records[i] = {
                        title: record.title,
                        date: extractDate(record)
                    };

                }

                scope.records = records;
                scope.close = function () {
                    simpleModal.close();
                };

                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });


            };

            this.hide = function(){
                simpleModal.close();
            };

        }

        return function (templateId) {
            return new ModalRecordingsDeletionError(templateId);
        };

    }]);
angular.module("videotron.illico.delete-recording").provider("DeleteRecordingModal",
    function () {
        var confirmSingleTemplate;
        var confirmRecordingInProgressTemplate;
        var DELETE_ACTIONS = {
            stop: "STOP_RECORDING",
            delete: "DELETE_RECORDING"
        };

        this.setModalConfirmDeleteTemplate = function (template) {
            confirmSingleTemplate = template;
        };

        this.setModalConfirmDeleteRecordingInProgressTemplate = function (template) {
            confirmRecordingInProgressTemplate = template;
        };

        function DeleteRecordingModal($q, $location, SrvDeleteRecordings, LoadingOverlay, AppConfig, RecordingsDeletionError, ModalConfirmDelete, ModalConfirmDeleteRecordingInProgress, confirmSingleTemplate, confirmRecordingInProgressTemplate) {

            var confirmSingle = new ModalConfirmDelete(confirmSingleTemplate);
            var confirmRecordingInProgress = new ModalConfirmDeleteRecordingInProgress(confirmRecordingInProgressTemplate);
            var APP_CONST = AppConfig.getPVRAppConstants();

            function setLocation(location){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $location.search("modal", location);
                }
            }

            function deleteRecord(deleteAction, skipOnly, stopOnly, successCallback, failureCallback) {
                LoadingOverlay.show();
                SrvDeleteRecordings.deleteRecording(deleteAction, skipOnly, stopOnly).then(function () {
                    LoadingOverlay.hide();
                    if(angular.isFunction(successCallback)){
                        successCallback();
                    }
                }, function (error) {
                    LoadingOverlay.hide();
                    RecordingsDeletionError.confirmError(error.data.body.main);
                    if(angular.isFunction(failureCallback)){
                        failureCallback();
                    }
                });
            }

            function getDeleteAction(actionsList) {
                var type = null;
                for (var i = 0, iLen = actionsList.length; i < iLen; i++) {
                    var action = actionsList[i];
                    if (action.allowed === true && (action.type === DELETE_ACTIONS.stop || action.type === DELETE_ACTIONS.delete)) {
                        type = action;
                        break;
                    }
                }
                return type;
            }

            this.confirmDeleteRecording = function (recording, successCallback, failureCallback) {

                var deferred = $q.defer();
                var modalOptions = {
                    opacity: 90
                };
                var deleteAction = getDeleteAction(recording.actions);

                // although not likely, it is possible for seriesTitle to be undefined
                // so we make sure we have something to show in the modal
                recording.seriesTitle = recording.seriesTitle || recording.title;

                switch (deleteAction.type) {
                    case DELETE_ACTIONS.stop:

                        // IN PROGRESS MODAL
                        $.extend(modalOptions, {minHeight: 250});

                        // add stop and save button on modal
                        if (deleteAction.parameters && angular.isDefined(deleteAction.parameters.stopOnly)) {
                            recording.canSaveWhenStopped = true;
                        }

                        setLocation(confirmRecordingInProgress.getTemplateId());
                        confirmRecordingInProgress.show(recording, modalOptions, function yes(stopOnly) {
                            deferred.resolve();
                            deleteRecord(deleteAction, false, stopOnly, successCallback, failureCallback);
                        }, function no() {
                            deferred.reject();
                        });
                        break;
                    case DELETE_ACTIONS.delete:

                        // CONFIRMATION MODAL STANDARD


                        // SERIES MODAL
                        // add property repeated to recording to set state in template
                        if (deleteAction.parameters && angular.isDefined(deleteAction.parameters.skipOnly)) {
                            recording.repeated = "canSkip";
                            $.extend(modalOptions, {minHeight: 260});
                        }
//                        console.log('recording: ',recording);
                        setLocation(confirmSingle.getTemplateId());
                        confirmSingle.show(recording, modalOptions, function yes(skipOnly) {
                            deferred.resolve();
                            deleteRecord(deleteAction, skipOnly, false, successCallback, failureCallback);
                        }, function no() {
                            deferred.reject();
                        });

                        break;
                    default:
                        throw Error("UNKNOWN DELETE TYPE DECLARED");
                }
                return deferred.promise;
            };
        }

        this.$get = ["$q", "$location", "SrvDeleteRecordings", "LoadingOverlay", "AppConfig", "RecordingsDeletionError", "ModalConfirmDelete", "ModalConfirmDeleteRecordingInProgress",
            function ($q, $location, SrvDeleteRecordings, LoadingOverlay, AppConfig, RecordingsDeletionError, ModalConfirmDelete, ModalConfirmDeleteRecordingInProgress) {
                if (!angular.isDefined(confirmSingleTemplate) || !angular.isDefined(confirmRecordingInProgressTemplate)){
                    throw new Error("one of delete recording modals not configured (DeleteRecordingModalProvider.setModalxxxxx(temaplate) in module config function)");
                }
                return new DeleteRecordingModal($q, $location, SrvDeleteRecordings, LoadingOverlay, AppConfig, RecordingsDeletionError, ModalConfirmDelete, ModalConfirmDeleteRecordingInProgress, confirmSingleTemplate, confirmRecordingInProgressTemplate);
            }];
    });

angular.module("videotron.illico.delete-recording").provider("DeleteRecordingsModal",
    function () {
        var confirmMultipleTemplate;

        this.setModalConfirmDeleteMultipleTemplate = function (template) {
            confirmMultipleTemplate = template;
        };

        function DeleteRecordingsModal($q, $location, SrvDeleteRecordings, LoadingOverlay, AppConfig, RecordingsDeletionError, ModalConfirmDeleteMultiple, confirmMultipleTemplate) {

            var confirmMultiple = new ModalConfirmDeleteMultiple(confirmMultipleTemplate);
            var APP_CONST = AppConfig.getPVRAppConstants();

            function setLocation(location){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $location.search("modal", location);
                }
            }

            function deleteRecords(recordIds, successCallback, failureCallback) {
                LoadingOverlay.show();
                SrvDeleteRecordings.deleteMultipleRecordings(recordIds).then(function () {
                    LoadingOverlay.hide();
                    if(angular.isFunction(successCallback)){
                        successCallback();
                    }
                }, function (error) {
                    LoadingOverlay.hide();
                    RecordingsDeletionError.confirmError(error.data.body.main);
                    if(angular.isFunction(failureCallback)){
                        failureCallback();
                    }
                });
            }

            this.confirmDeleteRecordings = function (recordIds, modalOptions, successCallback, failureCallback) {
                var deferred = $q.defer();
                var options = modalOptions || null;
                if (angular.isArray(recordIds) && recordIds.length > 0) {
                    setLocation(confirmMultiple.getTemplateId());
                    confirmMultiple.show(recordIds, options, function yes() {
                        deferred.resolve();
                        deleteRecords(recordIds, successCallback, failureCallback);
                    }, function no() {
                        deferred.reject();
                    });
                }
                return deferred.promise;
            };
        }

        this.$get = ["$q", "$location", "SrvDeleteRecordings", "LoadingOverlay", "AppConfig", "RecordingsDeletionError", "ModalConfirmDeleteMultiple",
            function ($q, $location, SrvDeleteRecordings, LoadingOverlay, AppConfig, RecordingsDeletionError, ModalConfirmDeleteMultiple) {
                if (!angular.isDefined(confirmMultipleTemplate)){
                    throw new Error("one of delete recording modals not configured (DeleteRecordingsModalProvider.setModalxxxxx(temaplate) in module config function)");
                }
                return new DeleteRecordingsModal($q, $location, SrvDeleteRecordings, LoadingOverlay, AppConfig, RecordingsDeletionError, ModalConfirmDeleteMultiple, confirmMultipleTemplate);
            }];
    });

angular.module("videotron.illico.delete-recording").provider("RecordingsDeletionError",
    function () {
        var recordingsDeletionErrorTemplate;

        this.setModalRecordingsDeletionErrorTemplate = function (template) {
            recordingsDeletionErrorTemplate = template;
        };

        function RecordingsDeletionError($location, AppConfig, ModalRecordingsDeletionError, recordingsDeletionErrorTemplate) {

            var recordingsDeletionError = new ModalRecordingsDeletionError(recordingsDeletionErrorTemplate);
            var APP_CONST = AppConfig.getPVRAppConstants();

            function setLocation(location){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $location.search("modal", location);
                }
            }

            this.confirmError = function (errorMessage) {
                setLocation(recordingsDeletionError.getTemplateId());
                recordingsDeletionError.show(errorMessage);
            };
        }

        this.$get = ["$location", "AppConfig", "ModalRecordingsDeletionError",
            function ($location, AppConfig, ModalRecordingsDeletionError) {
                if (!angular.isDefined(recordingsDeletionErrorTemplate)){
                    throw new Error("one of delete recording modals not configured (RecordingsDeletionErrorProvider.setModalxxxxx(temaplate) in module config function)");
                }
                return new RecordingsDeletionError($location, AppConfig, ModalRecordingsDeletionError, recordingsDeletionErrorTemplate);
            }];
    });

angular.module("videotron.illico.delete-recording").service("SrvDeleteRecordings",
    ["$http", "HttpConfigs", "SERVICES_BASE_PATH", "NativeActions", function ($http, HttpConfigs, SERVICES_BASE_PATH,  NativeActions) {

        var deleteConfigs = HttpConfigs.deleteConfigs();

        this.deleteRecording = function (deleteAction, skipOnly, stopOnly) {
            var configs = {};
            var actionConfigs = {
                url: SERVICES_BASE_PATH + deleteAction.uri,
                method: deleteAction.method || "DELETE"
            };

            if (skipOnly) {
                actionConfigs.url += "?skipOnly=true";
            } else if (stopOnly) {
                actionConfigs.url += "?stopOnly=true";
            }

            $.extend(true, configs, deleteConfigs, actionConfigs);


            //Google Analytics tracking through Native Bridge
            NativeActions.trackEvent('Terminal', 'Supprimer un enregistrement', 'x1');

            return $http(configs);
        };

        this.deleteMultipleRecordings = function (recordIds) {
            var url = SERVICES_BASE_PATH + "/recordings";
            if (recordIds.length > 0) {
                url += "?";
                for (var i = 0, count = recordIds.length; i < count; i++) {
                    url += "id=" + recordIds[i] + "&";
                }
                url = url.slice(0, -1);
            }

            //Google Analytics tracking through Native Bridge
            NativeActions.trackEvent('Terminal', 'Supprimer un enregistrement', 'x' + recordIds.length);

            return $http.delete(url, deleteConfigs);
        };


    }]);

angular.module("videotron.illico.epg-grid").constant("CHANNEL_MAIN_FILTERS", {
    ALL: {id: "ALL", label: "All channels"},
    FAVORITES: {id: "FAVORITES", label: "Favorite channels"},
    IN_PACKAGE: {id: "IN_PACKAGE", label: "In package channels"}
});

angular.module("videotron.illico.epg-grid").constant("CHANNEL_MAIN_FILTER_GROUPS", {
    ALL: {},
    FAVORITES: {},
    IN_PACKAGE: {}
});

angular.module("videotron.illico.epg-grid").constant("CHANNEL_SORTS", {
    POSITION: {type: "POSITION", label: "Sort by position"},
    ALPHA: {type: "ALPHA", label: "Sort by alphabetically"}
});

angular.module("videotron.illico.epg-grid").constant("CHANNEL_TYPES", {
    NORMAL: {id: "NORMAL", label: "Channel type : NORMAL"},
    PAY_PER_VIEW: {id: "PAY_PER_VIEW", label: "Channel type : PAY_PER_VIEW"},
    GALAXIE: {id: "GALAXIE", label: "Channel type : GALAXIE"},
    RADIO: {id: "RADIO", label: "Channel type : RADIO"}
});

angular.module("videotron.illico.epg-grid").controller("CtrlEPGGrid",
    ["$scope", "$element", "$attrs", "$parse", "$window", "AppConfig", "Viewport", "GridOverview", "Sprite", "GridContainer", "TimeSpan", "$timeout",
        "Time", "GridRenderer", "ChannelsDataLoader", "ProgramsLoader", "RowContainer",
        "ChannelGridItemProvider", "ProgramGridItemProvider", "ChannelGroupItemProvider",
        "TimeLineGridItemProvider", "TimeLineCornerPatchProvider", "NowIndicatorGridItemProvider", "GridUnitConverter",
        "GridCurrentDay", "BooleanObj", "$rootScope", "ViewportXAnimator", "MetadataLoader",
        "ManualRecordingsGridItemProvider", "ChannelsFilter", "GridRowsFactory", "ChannelGroupDelimiterGridItemProvider",
        "Channels", "FreePreviewToolTipGridItemProvider", "Metadata", "CHANNEL_MAIN_FILTER_GROUPS", "LoadingOverlay", "NativeActions",
        function ($scope, $element, $attrs, $parse, $window, AppConfig, Viewport, GridOverview, Sprite, GridContainer, TimeSpan, $timeout,
                  Time, GridRenderer, ChannelsDataLoader, ProgramsLoader, RowContainer,
                  ChannelGridItemProvider, ProgramGridItemProvider, ChannelGroupItemProvider,
                  TimeLineGridItemProvider, TimeLineCornerPatchProvider, NowIndicatorGridItemProvider, GridUnitConverter, GridCurrentDay,
                  BooleanObj, $rootScope, ViewportXAnimator, MetadataLoader, ManualRecordingsGridItemProvider,
                  ChannelsFilter, GridRowsFactory, ChannelGroupDelimiterGridItemProvider, Channels,
                  FreePreviewToolTipGridItemProvider, Metadata, CHANNEL_MAIN_FILTER_GROUPS, LoadingOverlay, NativeActions) {
            //console.info('CtrlEPGGrid');
            var GROUP_CLICK = "group_click";
            var Z_INDEX_CORNER_PATCH = 600;
            var Z_INDEX_NOW_LABEL = 550;
            var Z_INDEX_TIMELINE = 500;
            var Z_INDEX_CHANNEL_GROUP_DELIMITER = 400;
            var Z_INDEX_NOW_BAR = 250;
            var Z_INDEX_NOW_BUTTON = 610;
            var Z_INDEX_CHANNEL = 300;
            var Z_INDEX_CHANNEL_GROUP = 199;
            var Z_INDEX_MANUAL_RECORDINGS = 150;
            var Z_INDEX_FREE_PREVIEW_TOOL_TIP = 275;
            var Z_INDEX_PROGRAMS = 100;

            var gConst = AppConfig.getEPGAppConstants();

            // app specific configs here
            var CHANNELS_COLUMN_WIDTH = gConst.CHANNELS_COLUMN_WIDTH;
            var PROGRAMS_STICK_LEFT_EDGE = gConst.PROGRAMS_STICK_LEFT_EDGE;
            var TIMELINE_ROW_HEIGHT = gConst.TIMELINE_ROW_HEIGHT;
            var PIXELS_PER_MINUTE = gConst.PIXELS_PER_MINUTE;
            var MINIMUM_MINUTES_IN_PROGRAM = gConst.MINIMUM_MINUTES_IN_PROGRAM;
            var HOURS_OF_PROGRAMS_TO_LOAD = gConst.HOURS_OF_PROGRAMS_TO_LOAD;
            var PRELOAD_PREVIOUS_CHANNELS_MULTIPLIER = gConst.PRELOAD_PREVIOUS_CHANNELS_MULTIPLIER;
            var PRELOAD_NEXT_CHANNELS_MULTIPLIER = gConst.PRELOAD_NEXT_CHANNELS_MULTIPLIER;
            var MIN_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME = gConst.MIN_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME;
            var MAX_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME = gConst.MAX_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME;
            var CHANNEL_ROW_HEIGHT = gConst.CHANNEL_ROW_HEIGHT;
            var CHANNEL_GROUP_ROW_HEIGHT = gConst.CHANNEL_GROUP_ROW_HEIGHT;
            var FIRST_GROUP_DELIMITER_ROW_HEIGHT = gConst.FIRST_GROUP_DELIMITER_ROW_HEIGHT;
            var GROUP_DELIMITER_ROW_HEIGHT = gConst.GROUP_DELIMITER_ROW_HEIGHT;
            var NOW_BUTTON_WIDTH = gConst.NOW_BUTTON_WIDTH;
            var NOW_BUTTON_HEIGHT = gConst.NOW_BUTTON_HEIGHT;
            var FREE_PREVIEW_TOOL_TIP_HIDE_DELAY = gConst.FREE_PREVIEW_TOOL_TIP_HIDE_DELAY;
            var FREE_PREVIEW_TOOL_TIP_SHOW_DELAY = gConst.FREE_PREVIEW_TOOL_TIP_SHOW_DELAY;
            var CHANNEL_CLICK_ONLY_TOGGLES_FAVORITES = gConst.CHANNEL_CLICK_ONLY_TOGGLES_FAVORITES;
            var USE_NATIVE_VERTICAL_SCROLL = gConst.USE_NATIVE_VERTICAL_SCROLL;
            var TIMELINE_IS_POSITION_ABSOLUTE = gConst.TIMELINE_IS_POSITION_ABSOLUTE;

            var CHANNEL_GRID_ITEM_TYPE = {name: "channel"};
            var CHANNEL_GROUP_GRID_ITEM_TYPE = {name: "channel_group"};
            var PROGRAM_GRID_ITEM_TYPE = {name: "program"};
            var PROGRAM_GROUP_GRID_ITEM_TYPE = {name: "program_group"};
            var NOW_BUTTON_GRID_ITEM_TYPE = {name: "now_button"};
            var FREE_PREVIEW_TOOL_TIP_GRID_ITEM_TYPE = {name: "free_preview_tooltip"};

            var channels = new Channels();
            var metadata = new Metadata();
            var currentDateInternalChange = false;
            var startDateExpression = $attrs.startDate;
            var endDateExpression = $attrs.endDate;
            var forceRendering = new BooleanObj();
            var lastRenderedAt;

            // IENP-370 - add data to help automated tests
            var testHelper = {};
            $scope.testHelper = testHelper;

            var epgDataShare = $parse($attrs.epgDataShare)($scope);
            $scope.epgDataShare = epgDataShare;

            //debugger;
            var gridContainerParentId = epgDataShare.gridContainerParentId || $($element).parent();
            var metadataLoader = new MetadataLoader(epgDataShare.servicesBasePath);
            var channelsDataLoader = new ChannelsDataLoader(epgDataShare.servicesBasePath, epgDataShare.logoBasePath);

            var viewport = new Viewport(testHelper);
            //gridScroll directive is required by epgGrid directive
            var scrollController = $element.controller("gridScroll");
            //gridClick directive is required by epgGrid directive
            var clickController = $element.controller("gridClick");
            var gridContainer = new GridContainer($element, gridContainerParentId);
            var container = gridContainer.getSprite();
            var timeSpan = new TimeSpan($scope, startDateExpression, endDateExpression);
            var rowContainer = new RowContainer(TIMELINE_ROW_HEIGHT);
            var gridUnitConverter = new GridUnitConverter(PIXELS_PER_MINUTE, viewport, timeSpan);
            var channelGridItemProvider = new ChannelGridItemProvider(CHANNEL_GRID_ITEM_TYPE,
                Z_INDEX_CHANNEL, CHANNELS_COLUMN_WIDTH, container);
            var programGridItemProvider = new ProgramGridItemProvider(PROGRAM_GRID_ITEM_TYPE,
                PROGRAM_GROUP_GRID_ITEM_TYPE,
                Z_INDEX_PROGRAMS, CHANNELS_COLUMN_WIDTH, gridUnitConverter, container, MINIMUM_MINUTES_IN_PROGRAM, PIXELS_PER_MINUTE);
            var channelGroupGridItemProvider = new ChannelGroupItemProvider(CHANNEL_GROUP_GRID_ITEM_TYPE,
                Z_INDEX_CHANNEL_GROUP, CHANNELS_COLUMN_WIDTH, container);
            var timeLineGridItemProvider = new TimeLineGridItemProvider(Z_INDEX_TIMELINE, CHANNELS_COLUMN_WIDTH,
                TIMELINE_ROW_HEIGHT, gridUnitConverter, container, TIMELINE_IS_POSITION_ABSOLUTE);
            var timeLineCornerPatchProvider = new TimeLineCornerPatchProvider(Z_INDEX_CORNER_PATCH, CHANNELS_COLUMN_WIDTH,
                TIMELINE_ROW_HEIGHT, container, TIMELINE_IS_POSITION_ABSOLUTE);
            var nowIndicatorGridItemProvider = new NowIndicatorGridItemProvider(NOW_BUTTON_GRID_ITEM_TYPE,
                NOW_BUTTON_WIDTH, NOW_BUTTON_HEIGHT, Z_INDEX_NOW_BUTTON, CHANNELS_COLUMN_WIDTH, TIMELINE_ROW_HEIGHT, Z_INDEX_NOW_BAR,
                Z_INDEX_NOW_LABEL, gridUnitConverter, viewport, container, TIMELINE_IS_POSITION_ABSOLUTE);
            var manualRecordingsGridItemProvider = new ManualRecordingsGridItemProvider(Z_INDEX_MANUAL_RECORDINGS, CHANNELS_COLUMN_WIDTH,
                gridUnitConverter, container);
            var channelGroupDelimiterGridItemProvider = new ChannelGroupDelimiterGridItemProvider(CHANNELS_COLUMN_WIDTH,
                Z_INDEX_CHANNEL_GROUP_DELIMITER, container);
            var freePreviewToolTipGridItemProvider = new FreePreviewToolTipGridItemProvider(FREE_PREVIEW_TOOL_TIP_GRID_ITEM_TYPE,
                Z_INDEX_FREE_PREVIEW_TOOL_TIP, CHANNELS_COLUMN_WIDTH, FREE_PREVIEW_TOOL_TIP_HIDE_DELAY, FREE_PREVIEW_TOOL_TIP_SHOW_DELAY,
                container);
            var gridRenderer = new GridRenderer(CHANNELS_COLUMN_WIDTH, PROGRAMS_STICK_LEFT_EDGE);
            var gridCurrentDay = new GridCurrentDay(gridUnitConverter, viewport);
            var viewportXAnimator = new ViewportXAnimator(viewport);
            var channelsFilter = new ChannelsFilter();
            var programsLoader = new ProgramsLoader(epgDataShare.servicesBasePath, viewport, gridUnitConverter);
            var gridRowsFactory = new GridRowsFactory(CHANNEL_ROW_HEIGHT, CHANNEL_GROUP_ROW_HEIGHT,
                GROUP_DELIMITER_ROW_HEIGHT, FIRST_GROUP_DELIMITER_ROW_HEIGHT);


            function setTimeSpan() {
                var startTime = timeSpan.getStart();
                var endTime = timeSpan.getEnd();
                viewport.setSceneWidth(gridUnitConverter.millisecondsToPixels(timeSpan.getDuration()));
                //always re-apply the viewport width when changing the scene width (it may be changed by the bounded range)
                viewport.setWidth(gridContainer.getWidth() - CHANNELS_COLUMN_WIDTH);
                programsLoader.initialize(startTime, endTime, Time.hours(HOURS_OF_PROGRAMS_TO_LOAD));
                programGridItemProvider.reset();
                manualRecordingsGridItemProvider.reset();
                timeLineGridItemProvider.setTimeSpan(startTime, endTime);
                gridCurrentDay.setTimeSpan(startTime, endTime);
                forceRendering.set(true);
            }

            function gridContainerSizeChange() {
                viewport.setWidth(gridContainer.getWidth() - CHANNELS_COLUMN_WIDTH);
                viewport.setHeight(gridContainer.getCalculatedHeight(TIMELINE_ROW_HEIGHT));
                viewport.move(0, gridContainer.getScrollDiff());
            }

            function gridContainerOffsetChange() {
                viewport.setHeight(gridContainer.getCalculatedHeight(TIMELINE_ROW_HEIGHT));
                viewport.move(0, gridContainer.getScrollDiff());
                if (USE_NATIVE_VERTICAL_SCROLL) {
                    epgDataShare.scrollPosition = gridContainer.getOffsetTop();
                }
            }

            function scrollListener(event, data) {
                viewport.move(data.scrollX, data.scrollY);
            }

            function rowContainerHeightChange() {
                viewport.setSceneHeight(rowContainer.getHeight());
                if (USE_NATIVE_VERTICAL_SCROLL) {
                    gridContainer.setHeight(rowContainer.getHeight() + TIMELINE_ROW_HEIGHT);
                } else {
                    viewport.setHeight(gridContainer.getHeight() - TIMELINE_ROW_HEIGHT);
                }
            }

            function gridDayChange() {
                //prevent a grid update see : currentDayChange(day)
                currentDateInternalChange = true;
                epgDataShare.currentDay = gridCurrentDay.getDay();
            }

            function updateViewportPosition(milliseconds) {
                var x = gridUnitConverter.millisecondsToSceneXPosition(milliseconds);
                viewport.setX(x);
                forceRendering.set(true);
            }


            function currentDayChange(day) {
                //TODO find a better way to prevent applying internal changes
                if (day && !currentDateInternalChange) {
                    var viewportX = viewport.getX();
                    // first run, move grid so we see now line
                    if (viewportX === 0) {
                        viewportX = gridUnitConverter.millisecondsToPixels(epgDataShare.displayedNowTime.value - epgDataShare.startTime.value);
                    }
                    var currentTime = gridUnitConverter.pixelToMillisecondsSince1970(viewportX);
                    var currentDate = new Date(currentTime);
                    var currentHours = currentDate.getHours();
                    var currentMinutes = currentDate.getMinutes();
                    var currentSeconds = currentDate.getSeconds();
                    var currentMilliseconds = currentDate.getMilliseconds();
                    var timeOffset = Time.hours(currentHours) + Time.minutes(currentMinutes) + Time.seconds(currentSeconds) + currentMilliseconds;

                    updateViewportPosition(day.time + timeOffset);
                }
                currentDateInternalChange = false;
            }

            function channelsChanged(channelGroups, moveToTop) {
                //console.log('channelsChanged()');
                var noFavorites = false;
                var result = gridRowsFactory.createRowsFromChannelGroups(channelGroups);
                channelGroupGridItemProvider.setChannelGroups(result.groupedChannels);
                channelGroupDelimiterGridItemProvider.setChannelGroupDelimiters(result.groupDelimiters);
                rowContainer.setRows(result.rows);

                testHelper.totalRows = result.total;


                if (moveToTop === true) {
                    if (USE_NATIVE_VERTICAL_SCROLL) {
                        $(window).scrollTop(0);
                    }

                    viewport.setY(0);
                    scrollController.resetScrollVelocity();
                }

                // only if metaData has already been set to avoid flicker
                if (metadata.isSet()) {
                    // show error if no favorites, even if we have most watched channels
                    if (channelGroups && channelGroups.length > 1) {
                        for (var i = 0; i < channelGroups.length; i++) {
                            if (channelGroups[i].type === CHANNEL_MAIN_FILTER_GROUPS.FAVORITES && channelGroups[i].channels.length === 0) {
                                noFavorites = true;
                            }
                        }
                    }

                    // show error if no favorites or no channels in channelGroups
                    if (noFavorites || (result.total === 0 && channelGroups)) {
                        epgDataShare.showNoResultsFilterError = true;
                        // since no programs found, programsLoader will never be called, so dismiss spinner and show toolbar now
                        epgDataShare.showMainToolbar = true;
                        LoadingOverlay.hide();
                        //console.log('channelsChanged::hide');
                    } else {
                        epgDataShare.showNoResultsFilterError = false;
                    }
                }
            }

            function focusOnRow(focusedRow) {
                if (angular.isDefined(focusedRow)) {
                    var y = rowContainer.getRowPosition(focusedRow);
                    if (y !== null) {
                        //row is found...
                        if (USE_NATIVE_VERTICAL_SCROLL) {
                            $window.scrollTo(0, y);
                        } else {
                            viewport.setY(y);
                        }
                        forceRendering.set(true);
                    }
                }
            }


            function startDateChange(value, prev) {
                viewport.setX(viewport.getX() - gridUnitConverter.millisecondsToPixels(value - prev));
                forceRendering.set(true);
                currentDateInternalChange = true;
            }

            function toggleChannelStarState(channel, channelFavoriteState) {
                var favChannels;
                metadata.toggleChannelFavoriteState(channel, channelFavoriteState);
                favChannels = channels.sortChannelsByPosition(metadata.getFavoriteChannels());
                channelGridItemProvider.setFavoriteChannels(favChannels);
                channelsFilter.setFavoriteChannels(favChannels);
                forceRendering.set(true);
                if (!channelFavoriteState.isFavorite) {
                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Ajouter à mes sélections', channel.name);
                } else {
                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Retirer de mes sélections', channel.name);
                }
            }

            function programLoadingStart(event, data) {
                programGridItemProvider.programsLoadingStart(data.startTime, data.endTime);
                forceRendering.set(true);
            }

            function programLoaded(event, data) {
                //console.log('programLoaded()');
                programGridItemProvider.addPrograms(data.programsByChannels, data.requestStartTime);
                forceRendering.set(true);
                epgDataShare.showMainToolbar = true;

                LoadingOverlay.hide();
                //console.log('programLoaded::hide');
            }

            function loadMetadata() {
                //console.log('loadMetadata()');
                return metadataLoader.load().then(function (value) {
                    //console.log('value: ', value);
                    var favChannels;
                    metadata.setMetadata(value);
                    favChannels = channels.sortChannelsByPosition(metadata.getFavoriteChannels());
                    channelGridItemProvider.setFavoriteChannels(favChannels);
                    manualRecordingsGridItemProvider.setManualRecordings(metadata.getManualRecordings());
                    programGridItemProvider.setRecordingPrograms(metadata.getRecordingPrograms());
                    programGridItemProvider.setSelectionPrograms(metadata.getSelectedPrograms());
                    programGridItemProvider.reRenderModifiedPrograms();
                    channelsFilter.setFavoriteChannels(favChannels);
                    channelsChanged(channelsFilter.filter(), false);
                    forceRendering.set(true);
                });
            }

            function horizontalScrollButtonsListener(data) {
                if (data) {
                    viewportXAnimator.startContinuousScroll(data);
                } else {
                    viewportXAnimator.stopContinuousScroll();
                }
            }

            // assign back to scope so this function can be triggered from CtrlEPG
            epgDataShare.scrollButtonListener = horizontalScrollButtonsListener;

            timeSpan.addTimeChangeListener(setTimeSpan);
            gridContainer.addSizeChangeListener(gridContainerSizeChange);
            gridContainer.addOffsetChangeListener(gridContainerOffsetChange);
            scrollController.addScrollListener(scrollListener);
            rowContainer.addHeightChangeListener(rowContainerHeightChange);
            gridCurrentDay.addDayChangeListener(gridDayChange);
            programsLoader.addLoadingStartListener(programLoadingStart);
            programsLoader.addProgramsLoadedListener(programLoaded);


            $scope.$watch(startDateExpression, startDateChange);

            $scope.$watch('epgDataShare.currentDay', currentDayChange);

            $scope.$watch('epgDataShare.now', function (value) {
                nowIndicatorGridItemProvider.setCurrentTime(value);
                forceRendering.set(true);
            });

            $scope.$watch('epgDataShare.mainFilter', function (mainFilter) {
                channelsFilter.setMainFilter(mainFilter);
                channelsChanged(channelsFilter.filter(), true);
                forceRendering.set(true);
            });

            $scope.$watch('epgDataShare.extraFilters', function (extraFilters) {
                channelsFilter.setExtraFilters(extraFilters);
                channelsChanged(channelsFilter.filter(), true);
                forceRendering.set(true);
            });

            $scope.$watch('epgDataShare.channelsSortedBy', function (channelsSortedBy) {
                // not implemented in all platforms so validate first
                if(channelsSortedBy && channelsSortedBy.type){
                    channelsFilter.setChannelsSortOrder(channelsSortedBy.type);
                    channelsChanged(channelsFilter.filter(), true);
                    forceRendering.set(true);
                }
            });

            $scope.$on(epgDataShare.updateMetaDataEventName, function () {
                //console.log("$on::updateMetaDataEventName");
                loadMetadata();
            });

            $scope.$on(epgDataShare.updateProfileDataEventName, function () {
//                console.log("updateProfileDataEventName")
                setTimeSpan();
                loadMetadata();
            });

            $scope.$on(epgDataShare.appWakeUpEventName, function () {
                //console.log("appWakeUpEventName");
                forceRendering.set(true);
                // used on Android because JS process is killed on device sleep and not auto started on wake up
                // by wrapping it in a timeout, it will only get relauched if needed, because new tablets seem to restart the process automatically

                // see GUS-815
                // need to make sure that the render method isn't already running before launching it again
                // because this will start parallel instances on the render function, causing massive slow downs

                // Android seems to optimize the render loops automatically and run it less often if nothing changes
                // so make sure DELAY is sufficiently long, longest delay I ever saw was 3800ms, but it could be worse on old devices

                var DELAY = 10000;
                var timeSinceLastRender = new Date() - lastRenderedAt;
                //console.log("wake up! --> " + timeSinceLastRender + " ms since last render");

                $timeout(function(){
                    if(timeSinceLastRender >= DELAY){
                        console.info("run render() after appWakeUp call, it seems to have stopped since it's been more than " + DELAY + "ms since last run");
                        render();
                    }
                }, DELAY);
                // reload meta data also to make sure data is fresh
                loadMetadata();
            });

            setTimeSpan();

            channelsDataLoader.load().then(function (value) {
                channels.setChannels(value);
                programGridItemProvider.setChannels(channels);
                channelGridItemProvider.setChannels(channels);
                freePreviewToolTipGridItemProvider.setChannels(channels);
                channelsFilter.setChannels(channels);
                channelsChanged(channelsFilter.filter(), true);
                focusOnRow(epgDataShare.focusedRow);
                loadMetadata();
                render();
            });

            clickController.addClickListener(function (event, data) {
                //console.log('clickController.addClickListener()');
                //data.x and data.y should/must be PAGE X and PAGE Y
                var elementOffset = $element.offset();
                var x = data.x - elementOffset.left;
                var y = data.y - elementOffset.top;
                var gridItem = gridRenderer.find(x, y);

                if (gridItem) {

                    // avoid causing click events while grid is moving, allows you to "catch" moving grid
                    if (scrollController.wasScrolling() && gridItem.type !== NOW_BUTTON_GRID_ITEM_TYPE) {
                        return;
                    }

                    switch (gridItem.type) {
                        case NOW_BUTTON_GRID_ITEM_TYPE:

                            var currentGridTime = gridUnitConverter.pixelToMillisecondsSince1970(viewport.getX());
                            var currentTime = epgDataShare.displayedNowTime.value;
                            var diff = currentGridTime - currentTime;
                            var buttonGridX = gridUnitConverter.millisecondsToSceneXPosition(currentTime);
                            if (diff < Time.hours(12)) {
                                viewportXAnimator.goTo(buttonGridX);
                            } else {
                                viewport.setX(buttonGridX);
                                forceRendering.set(true);
                            }
                            break;
                        case CHANNEL_GRID_ITEM_TYPE:
                            var channel = gridItem.data;
                            if (typeof epgDataShare.channelStarClick === "function" && (CHANNEL_CLICK_ONLY_TOGGLES_FAVORITES || data.target.closest(".star-container").length === 1)) {

                                var channelFavoriteState = metadata.extractChannelFavoriteState(channel);
                                //console.log('channelFavoriteState: ',channelFavoriteState);
                                if (channelFavoriteState) {
                                    epgDataShare.channelStarClick(channel, channelFavoriteState.isFavorite).then(null, function () {
                                        // promise rejection, an error occurred with the favorites service
                                        // revert star to previous state
                                        toggleChannelStarState(channel);
                                    });

                                    toggleChannelStarState(channel, channelFavoriteState);
                                }

                            } else if (data.target.hasClass("top-right-pictogram") && channel.freePreview) {
                                freePreviewToolTipGridItemProvider.showFreePreviewTooltip(channel.id);
                            } else {
                                epgDataShare.programOrChannelClick(channel);
                            }
                            break;
                        case CHANNEL_GROUP_GRID_ITEM_TYPE:
                            gridRowsFactory.markChannelGroupAsOpened(gridItem.data.id);
                            rowContainer.hideRow(gridItem.data.id, false, function () {
                                var rowsIds = gridItem.data.channels;
                                for (var i = 0, count = rowsIds.length; i < count; i++) {
                                    rowContainer.showRow(rowsIds[i].id);
                                }
                            });
                            break;
                        case PROGRAM_GRID_ITEM_TYPE:
                            var program = gridItem.data;
                            epgDataShare.programOrChannelClick(program);
                            break;
                        case PROGRAM_GROUP_GRID_ITEM_TYPE:
                            var programs = gridItem.data.programs;
                            var channelId = gridItem.data.channelId;
                            var groupChannel = channels.findChannelByID(channelId);
                            var groupX = gridItem.viewportX;
                            var groupY = gridItem.viewportY;
                            var width = gridItem.width;
                            var height = gridItem.height;
                            var element = gridItem.sprite.getElement();
                            //Copy programs list : the internal data should not be exposed.
                            var programsCopy = angular.copy(programs);
                            for (var i = 0, count = programsCopy.length; i < count; i++) {
                                var groupProgram = programsCopy[i];
                                groupProgram.extra = {
                                    recording: metadata.programIsRecording(groupProgram),
                                    selection: metadata.programIsSelected(groupProgram)
                                };
                            }
                            $scope.$emit(GROUP_CLICK,
                                {
                                    programs: programsCopy,
                                    channel: groupChannel,
                                    x: groupX,
                                    y: groupY,
                                    width: width,
                                    height: height,
                                    element: element
                                });

                            break;
                        default :
                            break;
                    }
                }

            });

            // variables for render loop outside to avoid too many instantiations
            var floor = Math.floor;
            var rows = [];
            var gridItems = [];
            var startX;
            var endX;
            var startY;
            var endY;
            var preloadStartY;
            var preloadEndY;

            //var logCounter = 0;
            //var logTimer = new Date();
            //function logEveryNthTime(n, msg){
            //    var totalTime = msg - logTimer;
            //    if(logCounter >= n){
            //        console.info(n + "th! | Total time : " + totalTime + "ms | Average of " + (totalTime)/n + " ms each run" );
            //        logCounter = 0;
            //        logTimer = new Date();
            //    }else{
            //        logCounter++;
            //    }
            //}

            function render() {
                requestAnimationFrame(render);
                lastRenderedAt = new Date();
                //logEveryNthTime(60, lastRenderedAt);

                //TODO stop the rendering loops when nothing change ?

                gridContainer.update();
                scrollController.update();
                timeSpan.update();
                rowContainer.update();
                viewportXAnimator.update();
                if (viewport.update() || forceRendering.isTrue()) {
                    startX = floor(viewport.getX());
                    endX = floor(startX + viewport.getWidth());
                    startY = floor(viewport.getY());
                    endY = floor(startY + viewport.getHeight());
                    preloadStartY = startY - (viewport.getHeight() * PRELOAD_PREVIOUS_CHANNELS_MULTIPLIER);
                    preloadEndY = endY + (viewport.getHeight() * PRELOAD_NEXT_CHANNELS_MULTIPLIER);

                    gridCurrentDay.update();

                    gridItems.length = 0;

                    rows = rowContainer.findRows(startY, endY, USE_NATIVE_VERTICAL_SCROLL);

                    // TODO clean params?
                    programsLoader.update(startX, endX, rowContainer.findPreloadRowsIds(preloadStartY, preloadEndY), rowContainer.getVisibleProgramRowsLength(), rows, MIN_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME, MAX_NUMBER_OF_CHANNELS_TO_LOAD_AT_A_TIME);


                    channelGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    programGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    channelGroupGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    timeLineGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    timeLineCornerPatchProvider.findGridItems(rows, 0, gridItems);
                    nowIndicatorGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    manualRecordingsGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    channelGroupDelimiterGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    freePreviewToolTipGridItemProvider.findGridItems(rows, startX, endX, gridItems);

                    gridRenderer.render(gridItems);

                    /*
                     // for debugging, see commented code for gridOverview below
                     gridOverview.render();
                     */

                }
                forceRendering.reset();
            }

            /*
             //CODE FOR THE GRID OVERVIEW : DISPLAY A SCALED GRID AND VIEWPORT (useful for debugging)
             var gridOverview = new GridOverview(viewport, 0.005);
             gridOverview.addMoveToListener(function (event, position) {
             viewport.setX(position.x);
             viewport.setY(position.y);
             });
             container.append(gridOverview.getSprite());
             */


        }]);
angular.module("videotron.illico.epg-grid").directive("channelFilterOptionsPanels",
            ["SrvChannelFilters", "$translate", "NativeActions", "$timeout",
    function (SrvChannelFilters, $translate, NativeActions, $timeout) {

    return {
        restrict: "A",
        scope: {
            updateChannelFiltersAndSort: "&",
            close: "&",
            sortTypes: "=",
            channelsSortedBy: "=",
            extraFilters: "="
        },
        templateUrl: "/appEnp/templates/epg/directives/channel-filter-options-panels.template.html",
        replace: true,
        link: function (scope, element, attributes) {



            /***************************************************
             PRIVATE DATA AND METHODS
             ***************************************************/

            var DEFAULT_CHANNEL_TEXT = $translate.instant("ALL CHANNELS");
            var initialFiltersAndSort;
            var selectedCriteria = [].concat(scope.extraFilters); // make a copy so we don't affect original
            var channelFiltersList = SrvChannelFilters.getFilters();
            var defaultChannelSelection = {
                    "key": "",
                    "label": DEFAULT_CHANNEL_TEXT,
                    "value": ""
                };

            if(channelFiltersList[0].key !== ""){
                channelFiltersList.unshift(defaultChannelSelection);
            }

            function getCriteriaByLabel(label){
                var criteria = false;
                for(var i = 0; i < channelFiltersList.length; i++){
                    var filter = channelFiltersList[i];
                    if(filter.label === label){
                        criteria = filter;
                        break;
                    }
                }
                return criteria;
            }
            function removeFilters(){
//                console.log('removeFilters()');
                selectedCriteria = [];
                scope.selectedChannelFilterLabel = DEFAULT_CHANNEL_TEXT;
            }
            function addFilter(criteria){
//                console.log('addFilter()');
//                console.log('criteria: ',criteria);
                if(criteria.key !== ""){
                    selectedCriteria= [criteria];
                    scope.selectedChannelFilterLabel = criteria.label;
                }else{
                    removeFilters()
                }
            }
            function showSecondaryMenu() {
                element.addClass("show-secondary")
            }

            function hideSecondaryMenu() {
                element.removeClass("show-secondary")
            }

            function closeModal(){
                //console.log("closeModal, destroy")
                scope.$destroy();
                scope.close();
            }

            function applyFilters(){
                if(hasChanged()){
                    scope.updateChannelFiltersAndSort()(standardizeFilterAndSortData(selectedCriteria, scope.currentPlatformOnly.toString(), scope.channelsSortedBy));
                    closeModal();
                }
            }

            function standardizeFilterAndSortData(filter, currentPlatform, sort){
                var filtersAndSort = {
                    filter : filter,
                    platform : {currentPlatformOnly : currentPlatform},
                    sort : sort
                };
                //console.log("initialFiltersAndSort", initialFiltersAndSort);
                //console.log("filterAndSort", filtersAndSort);
                return filtersAndSort;
            }
            function hasChanged(){
                var hasChanged = true;
                var currentFilterAndSort = standardizeFilterAndSortData(selectedCriteria, scope.currentPlatformOnly.toString(), scope.channelsSortedBy);
                if(currentFilterAndSort.platform.currentPlatformOnly === initialFiltersAndSort.platform.currentPlatformOnly){
                    if(currentFilterAndSort.sort.type === initialFiltersAndSort.sort.type){
                        if(currentFilterAndSort.filter.length === initialFiltersAndSort.filter.length){
                            if(currentFilterAndSort.filter.length > 0){
                                if(currentFilterAndSort.filter[0].label === initialFiltersAndSort.filter[0].label){
                                    hasChanged = false;
                                }
                            }else{
                                hasChanged = false;
                            }
                        }
                    }
                }
                //console.log("hasChanged", hasChanged);
                return hasChanged;
            }

            function initializeFilterSelectionFromParams(){
                if(!selectedCriteria.length){
                    removeFilters();
                }
                for(var i = 0; i < selectedCriteria.length; i++){
                    var criteria = selectedCriteria[i];
                    //console.log("criteria", criteria);
                    switch (criteria.type) {
                        case "general":
                            addFilter(getCriteriaByLabel(criteria.name))
                            break;
                        case "platform":
                            // we recieve this as an extraFilter but don't send it back as one
                            // so set currentPlatformOnly and remove this from array
                            scope.currentPlatformOnly = true;
                            selectedCriteria.splice(i, 1);
                            i--;
                            break;
                    }
                }
                initialFiltersAndSort = $.extend(true, {}, standardizeFilterAndSortData(selectedCriteria, scope.currentPlatformOnly.toString(), scope.channelsSortedBy));
            }

            /***************************************************
                PUBLIC DATA AND METHODS
            ***************************************************/

            // Web channels only
            scope.currentPlatformOnly = false;
            scope.channelsSortedByLabel = $translate.instant(scope.channelsSortedBy.label);
            scope.toggleSort = function(sort){
                scope.channelsSortedBy = sort;
                // TODO GOOGLE ANALYTICS EVENT MUST BE CREATED
                //if(scope.currentPlatformOnly){
                //    //Google Analytics tracking through Native Bridge
                //    NativeActions.trackEvent('Grille Horaire', 'Chaînes web seulement', 'Sélectionner');
                //}else{
                //    //Google Analytics tracking through Native Bridge
                //    NativeActions.trackEvent('Grille Horaire', 'Chaînes web seulement', 'Désélectionner');
                //}

            };
            scope.channelFiltersAreOpen = false;
            scope.channelFiltersList = channelFiltersList;
            scope.selectedChannelFilterLabel = DEFAULT_CHANNEL_TEXT;
            scope.removeFilters = removeFilters;
            //scope.isFilterActive = isFilterActive;
            scope.showSecondary = showSecondaryMenu;
            scope.hideSecondary = hideSecondaryMenu;
            scope.cancel = closeModal;
            scope.hasChanged = hasChanged;
            scope.applyFilters = applyFilters;

            scope.toggleChannelsFilter = function(criteria){
                //console.log('toggleChannelsFilter()');
                //console.log('criteria: ',criteria);
                //console.log('scope.selectedChannelFilterLabel: ',scope.selectedChannelFilterLabel);
                if(scope.selectedChannelFilterLabel === criteria.label){
                    removeFilters();
                    hideSecondaryMenu();
                }else{
                    addFilter(criteria);

                    // wait a little before closing the menu
                    $timeout(hideSecondaryMenu, 200);
                }
            };

            initializeFilterSelectionFromParams();

        }

    };

}]);
angular.module("videotron.illico.epg-grid").directive("epgGrid", function () {

    return {
        restrict: "A",
        controller: "CtrlEPGGrid",
        require: ["^gridScroll", "^gridClick"],
        template: "<div id='epgGrid' class='epg'><div class='qa-page-info'>{{testHelper|json}}</div></div>",
        replace: true
    };

});
angular.module("videotron.illico.epg-grid").factory("ChannelGridItemProvider",
    ["GridItem", "Value", "SpritePool", "Sprite", function (GridItem, Value, SpritePool, Sprite) {


        function ChannelSpriteFactory() {

            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                var content = document.createElement("div");
                content.className = "content";
                rootElement.appendChild(content);


                var testHelper = document.createElement("div");
                testHelper.className = "qa-channel-id";
                content.appendChild(testHelper);


                var starContainer = document.createElement("div");
                starContainer.className = "star-container";
                content.appendChild(starContainer);

                var star = document.createElement("div");
                star.className = "star";
                starContainer.appendChild(star);

                var logoContainer = document.createElement("div");
                logoContainer.className = "logo-container";
                content.appendChild(logoContainer);

                var topRightPictogram = document.createElement("div");
                topRightPictogram.className = "top-right-pictogram";
                logoContainer.appendChild(topRightPictogram);

                var liveTvPictogram = document.createElement("div");
                liveTvPictogram.className = "live-tv-pictogram";
                logoContainer.appendChild(liveTvPictogram);

                var freeViewPictogram = document.createElement("div");
                freeViewPictogram.className = "free-view-pictogram";
                logoContainer.appendChild(freeViewPictogram);

                var logo = document.createElement("img");
                logo.className = "logo";
                logoContainer.appendChild(logo);

                var positions = document.createElement("span");
                positions.className = "positions";
                logoContainer.appendChild(positions);

                sprite.testHelper = testHelper;
                sprite.star = star;
                sprite.positions = positions;
                sprite.logo = logo;

                return sprite;
            };


        }


        function ChannelRenderer(className, favoriteChannels) {

            this.render = function (sprite, channel) {
                var thisClassName = className;
                // does not currently support channels with multiple definitions if available in uHD
                if(channel.isUhd){
                    sprite.positions.className = "positions uhd";
                    sprite.positions.textContent = channel.availablePositionsByQuality.uhd;
                }else{
                    sprite.positions.className = channel.isHd ? "positions hd" : "positions";
                    sprite.positions.textContent = (channel.isSd ? channel.availablePositionsByQuality.sd + (channel.isHd ? " | " : "") : "") + ( channel.isHd ? channel.availablePositionsByQuality.hd : "");
                }

                if(channel.hasLinearFeed){
                    thisClassName = thisClassName + " live-tv";
                }

                sprite.star.className = favoriteChannels[channel.id] ? "star on" : "star off";
                sprite.logo.src = channel.smallLogo;
                sprite.setClass(thisClassName);

                sprite.testHelper.textContent = channel.id;
            };
        }


        function ChannelGridItemProvider(gridItemType, zIndex, channelWidth, GridItem, container) {
            var CHANNEL_CLASS_NAME = "channel";
            var CHANNEL_FREE_PREVIEW = "channel free-preview";
            var CHANNEL_NOT_IN_PACKAGE_CLASS_NAME = CHANNEL_CLASS_NAME + " not-in-package";


            var channelSpritePool = new SpritePool(container, 10, new ChannelSpriteFactory());

            var favoriteChannels = {};
            var channelRenderer = new ChannelRenderer(CHANNEL_CLASS_NAME, favoriteChannels);
            var channelFreePreviewRenderer = new ChannelRenderer(CHANNEL_FREE_PREVIEW, favoriteChannels);
            var notInPackageChannelRenderer = new ChannelRenderer(CHANNEL_NOT_IN_PACKAGE_CLASS_NAME, favoriteChannels);
            var gridItemsByChannelId = {};

            this.setFavoriteChannels = function (value) {
                var channelIds = [];
                for (var k in favoriteChannels) {
                    if(favoriteChannels.hasOwnProperty(k)){
                        channelIds.push(k);
                        delete favoriteChannels[k];
                    }
                }
                for (var i = 0, iCount = value.length; i < iCount; i++) {
                    favoriteChannels[value[i]] = true;
                    channelIds.push(value[i]);

                }
                for (var j = 0, jCount = channelIds.length; j < jCount; j++) {
                    var gridItem = gridItemsByChannelId[channelIds[j]];
                    if (gridItem && gridItem.sprite) {
                        gridItem.renderer.render(gridItem.sprite, gridItem.data);
                    }
                }
            };

            this.setChannels = function (channels) {
                channels = channels.getChannels();
                var i = channels.length;
                while (i--) {
                    var channel = channels[i];
                    var gridItem;

                    // test for freePreview first since it's also included in inUserPackage in channelFilter.js
                    if (channel.freePreview) {
                        gridItem = new GridItem(gridItemType, 0, 0, channelWidth, 0, channel,
                            channelFreePreviewRenderer);
                    } else if (channel.inPackage) {
                        gridItem = new GridItem(gridItemType, 0, 0, channelWidth, 0, channel, channelRenderer);
                    } else {
                        gridItem = new GridItem(gridItemType, 0, 0, channelWidth, 0, channel,
                            notInPackageChannelRenderer);
                    }
                    gridItem.zIndex = zIndex;
                    gridItem.spritePool = channelSpritePool;
                    gridItemsByChannelId[channel.id] = gridItem;
                }
            };

            this.findGridItems = function (rows, startX, endX, result) {
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    var gridItem = gridItemsByChannelId[row.id];
                    if (gridItem) {
                        gridItem.viewportY = row.viewportStartY;
                        gridItem.height = row.height;
                        result.push(gridItem);
                    }
                }
            };


        }

        return function (gridItemType, zIndex, channelWidth, container) {
            return new ChannelGridItemProvider(gridItemType, zIndex, channelWidth, GridItem, container);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("ChannelGroupDelimiterGridItemProvider",
    ["GridItem", "Sprite", "SpritePool", function (GridItem, Sprite, SpritePool) {


        function ChannelGroupDelimiterSpriteFactory() {

            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = "group-delimiter";
                var content = document.createElement("div");
                content.className = "content";
                rootElement.appendChild(content);
                sprite.content = content;
                return sprite;
            };

        }


        function ChannelGroupDelimiterRenderer() {
            this.render = function (sprite, channelGroupDelimiter) {
                sprite.content.textContent = channelGroupDelimiter.id;
            };
        }


        function ChannelGroupDelimiterGridItemProvider(offsetX, zIndex, container) {

            var gridItemsByChannelGroupDeleimiterId = {};
            var renderer = new ChannelGroupDelimiterRenderer();

            var channelGroupDelimiterSpritePool = new SpritePool(container, 2,
                new ChannelGroupDelimiterSpriteFactory());

            this.setChannelGroupDelimiters = function (channelGroupDelimiters) {

                for (var i = 0, count = channelGroupDelimiters.length; i < count; i++) {
                    var channelGroupDelimiter = channelGroupDelimiters[i];
                    var gridItem = new GridItem(null, 0, 0, 500, 0,
                        channelGroupDelimiter, renderer);
                    gridItem.zIndex = zIndex;
                    gridItem.spritePool = channelGroupDelimiterSpritePool;
                    gridItemsByChannelGroupDeleimiterId[channelGroupDelimiter.id] = gridItem;
                }

            };


            this.findGridItems = function (rows, startX, endX, result) {
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    var gridItem = gridItemsByChannelGroupDeleimiterId[row.id];
                    if (gridItem) {
                        gridItem.viewportX = 0;
                        gridItem.viewportY = row.viewportStartY;
                        gridItem.height = row.height;
                        gridItem.width = endX - startX + offsetX;
                        result.push(gridItem);
                    }
                }
            };
        }

        return function (offsetX, zIndex, container) {
            return new ChannelGroupDelimiterGridItemProvider(offsetX, zIndex, container);
        };

    }]);
angular.module("videotron.illico.epg-grid").factory("ChannelGroupItemProvider",
    ["GridItem", "Value", "$translate", "Sprite", "SpritePool", function (GridItem, Value, $translate, Sprite,
                                                                          SpritePool) {


        function ChannelGroupSpriteFactory(textPre, textPost) {


            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = "channel-group";

                var contentLeft = document.createElement("div");
                contentLeft.className = "content left";
                rootElement.appendChild(contentLeft);

                var contentLeftLogoContainer = document.createElement("div");
                contentLeftLogoContainer.className = "logo-container";
                contentLeft.appendChild(contentLeftLogoContainer);

                var contentLeftLogo = document.createElement("img");
                contentLeftLogo.className = "logo";
                contentLeftLogoContainer.appendChild(contentLeftLogo);

                var contentLeftPositions = document.createElement("span");
                contentLeftPositions.className = "positions";
                contentLeftLogoContainer.appendChild(contentLeftPositions);

                var contentRight = document.createElement("div");
                contentRight.className = "content right";
                rootElement.appendChild(contentRight);

                var contentRightTextAndLogo = document.createElement("div");
                contentRightTextAndLogo.className = "text-and-logo";
                contentRight.appendChild(contentRightTextAndLogo);

                var contentRightText = document.createElement("div");
                contentRightText.className = "text";
                contentRightText.textContent = textPre;
                contentRightTextAndLogo.appendChild(contentRightText);

                var contentRightLogo = document.createElement("img");
                contentRightLogo.className = "logo";
                contentRightTextAndLogo.appendChild(contentRightLogo);

                var contentRightTextPost = document.createElement("div");
                contentRightTextPost.className = "text";
                contentRightTextPost.textContent = textPost;
                contentRightTextAndLogo.appendChild(contentRightTextPost);

                sprite.positions = contentLeftPositions;
                sprite.logoRight = contentRightLogo;
                sprite.logoLeft = contentLeftLogo;

                return sprite;
            };

        }

        function ChannelGroupRenderer() {

            //TODO move this when the group is created ?
            function extractPositions(channelGroup) {
                var channels = channelGroup.channels;
                var min = Number.POSITIVE_INFINITY;
                var max = 0;
                for (var i = 0, count = channels.length; i < count; i++) {
                    var channel = channels[i];
                    // group using sorting position
                    var channelPosition = channel.positionForSorting;
                    min = Math.min(min, channelPosition);
                    max = Math.max(max, channelPosition);
                }
                return min + " " + $translate.instant("to") + " " + max;
            }

            this.render = function (sprite, channelGroup) {
                var channel = channelGroup.firstChannel;
                var hasHd = channel.isHd;
                sprite.positions.className = hasHd ? "positions hd" : "positions";
                sprite.positions.textContent = extractPositions(channelGroup);
                sprite.logoLeft.src = channel.smallLogo;
                sprite.logoRight.src = channel.smallLogo;
            };
        }

        function ChannelGroupItemProvider(gridItemType, zIndex, offsetX, GridItem, container) {

            var gridItemsByChannelGroupId = {};
            var channelGroupRenderer = new ChannelGroupRenderer();

            var channelGroupSpritePool = new SpritePool(container, 2,
                new ChannelGroupSpriteFactory($translate.instant("See all channels - pre"), $translate.instant("See all channels - post")));

            this.setChannelGroups = function (channelGroups) {
                var i = channelGroups.length;
                while (i--) {
                    var channelGroup = channelGroups[i];
                    var gridItem = new GridItem(gridItemType, 0, 0, 0, 0, channelGroup,
                        channelGroupRenderer);
                    gridItem.zIndex = zIndex;
                    gridItem.spritePool = channelGroupSpritePool;
                    gridItemsByChannelGroupId[channelGroup.id] = gridItem;
                }
            };

            this.findGridItems = function (rows, startX, endX, result) {
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    var gridItem = gridItemsByChannelGroupId[row.id];
                    if (gridItem) {
                        gridItem.viewportX = 0;
                        gridItem.viewportY = row.viewportStartY;
                        gridItem.width = endX - startX + offsetX;
                        gridItem.height = row.height;
                        result.push(gridItem);
                    }
                }
            };

        }

        return function (gridItemType, zIndex, offsetX, container) {
            return new ChannelGroupItemProvider(gridItemType, zIndex, offsetX, GridItem, container);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("Channels", function () {


    function Channels() {

        var channels = [];
        var self = this;

        this.setChannels = function (value) {
            channels = value;
        };

        this.getChannels = function () {
            return channels;
        };

        this.findChannelByID = function (id) {
            var result = null;
            for (var i = 0, count = channels.length; i < count; i++) {
                var channel = channels[i];
                if (channel.id === id) {
                    result = channel;
                    break;
                }
            }
            return result;
        };

        this.sortChannelsByPosition = function (channelIdList) {
            var sortedChannelList = [];
            var sortedChannelIdList = [];
            // find position (sd if possible)
            for (var i = 0, iLen = channelIdList.length; i < iLen; i++) {
                var channel = self.findChannelByID(channelIdList[i]);
                // protect against invalid id error
                if (channel) {
                    var sortObj = {};
                    sortObj.id = channel.id;
                    sortObj.position = channel.positionForSorting;
                    sortedChannelList.push(sortObj);
                }
            }
            // sort in ASC order
            sortedChannelList.sort(function (a, b) {
                return a.position - b.position;
            });
            // return list of id's, now sorted
            for (var j = 0, jLen = sortedChannelList.length; j < jLen; j++) {
                sortedChannelIdList.push(sortedChannelList[j].id);
            }
            return sortedChannelIdList;
        }



    }


    return function () {
        return new Channels();

    };


});
angular.module("videotron.illico.epg-grid").factory("ChannelsDataConverter", [function () {

    function ChannelsDataConverter() {

        var TELEVISION_PLATFORM_NAME = "TELEVISION";

        this.setImagePath = function (str, logoBasePath){
            // TODO - web platform image format is different from companion format
            // until platform is modified and all new images are created, we tweak the image names here
            // see JIRA for details : IAPPDEV-5231
            var image = str || "";
            var cleanedString = image.replace("_TF.png", ".png").replace("_TP.png", ".png");
            return logoBasePath + cleanedString;
        };

        this.isDefinitionAvailable = function (definitionGroup, definition, platform){
            // default platform is TELEVISION but can be over written
            var currentPlatform = platform || TELEVISION_PLATFORM_NAME;
            var exists = false;
            for(var i = 0, iLen = definitionGroup.length; i < iLen; i++){
                var def = definitionGroup[i];
                if(def.platform === currentPlatform && def.definition === definition){
                    exists = true;
                    break;
                }
            }
            return exists;
        };

        this.availablePositionsByQuality = function (definitionGroup){
            // default platform is TELEVISION since positions are only available on television
            var currentPlatform = TELEVISION_PLATFORM_NAME;
            var positionObject = {};
            for(var i = 0, iLen = definitionGroup.length; i < iLen; i++){
                var def = definitionGroup[i];
                if(def.platform === currentPlatform && typeof def.definition === "string"){
                    positionObject[def.definition.toLowerCase()] = def.position;
                }
            }
            return positionObject;
        };

        this.getPositionForSorting = function (definitionGroup){
            // default platform is TELEVISION since positions are only available on television
            var currentPlatform = TELEVISION_PLATFORM_NAME;
            var position = "";
            // since channels are grouped by definition (SD/HD), we always use the lowest position for sorting
            for(var i = 0, iLen = definitionGroup.length; i < iLen; i++){
                var def = definitionGroup[i];
                if(def.platform === currentPlatform && position === "" || def.position < position){
                    position = def.position;
                }
            }
            return position;
        };

        this.isInPackage = function (accessInfo){
            return accessInfo.access !== "LOCKED";
        };

    }

    return function () {
        return new ChannelsDataConverter();
    };

}]);

angular.module("videotron.illico.epg-grid").factory("ChannelsDataLoader", ["$http", "HttpConfigs", "ChannelsDataConverter", "NormalizeAccentedCharacters", function ($http, HttpConfigs, ChannelsDataConverter, NormalizeAccentedCharacters) {

    function ChannelsDataLoader(basePath,logoBasePath) { 
    
        var convertChannelData = new ChannelsDataConverter();

        function addExtraKey(obj, name, value){
            //first test if the key is available
            if (obj.hasOwnProperty(name)) {
                throw new Error(name + " is already defined");
            } else {
                obj[name] = value;
            }
        }

        this.load = function () {
            var channelsUrl = basePath + "/guide/channels";
            //stub for debugging
            //channelsUrl = "/appEnp/dev_tools/channels.json";
            return $http.get(channelsUrl, HttpConfigs.getConfigs()).then(function (response) {

                var channels = response.data.body.main;

                for (var i = 0, count = channels.length; i < count; i++) {
                    var channel = channels[i];

                    // Voir IWEB-805, nouvelle attribut gridLogo n'existe pas dans tous les plate-formes
                    var logoImageSrc = channel.gridLogo || channel.image;

                    // extend logo data here at the source

                    // modify existing keys
                    channel.largeLogo = convertChannelData.setImagePath(logoImageSrc, logoBasePath);
                    channel.smallLogo = convertChannelData.setImagePath(logoImageSrc, logoBasePath);

                    // create new custom keys
                    addExtraKey(channel, "isSd", convertChannelData.isDefinitionAvailable(channel.definitionGroup, "SD"));
                    addExtraKey(channel, "isHd", convertChannelData.isDefinitionAvailable(channel.definitionGroup, "HD"));
                    addExtraKey(channel, "isUhd", convertChannelData.isDefinitionAvailable(channel.definitionGroup, "UHD"));
                    addExtraKey(channel, "availablePositionsByQuality", convertChannelData.availablePositionsByQuality(channel.definitionGroup));
                    addExtraKey(channel, "positionForSorting", convertChannelData.getPositionForSorting(channel.definitionGroup));
                    addExtraKey(channel, "nameForSorting", NormalizeAccentedCharacters.get(channel.name));
                    addExtraKey(channel, "inPackage", convertChannelData.isInPackage(channel.accessInfo));
                }



                return channels;
            });

        };

    }

    return function (basePath,logoBasePath) {
        return new ChannelsDataLoader(basePath,logoBasePath);
    };

}]);
angular.module("videotron.illico.epg-grid").factory("ChannelsFilter",
    ["CHANNEL_MAIN_FILTERS", "CHANNEL_MAIN_FILTER_GROUPS", "Filter", "MacroFilter", "ChannelsSorter", function (CHANNEL_MAIN_FILTERS, CHANNEL_MAIN_FILTER_GROUPS, Filter, MacroFilter, ChannelsSorter) {

        function ChannelsFilter() {

            var channelSorter = new ChannelsSorter();
            var mainFilter;
            var extraFilters;
            var channels;
            var favoriteChannels;
            var channelsSortedBy;

            function findChannelsByIds(ids) {
                var result = [];
                for (var i = 0, count = ids.length; i < count; i++) {
                    var id = ids[i];
                    for (var j = 0, countJ = channels.length; j < countJ; j++) {
                        var channel = channels[j];

                        if (channel.id === id) {
                            result.push(channel);
                        }
                    }
                }
                return result;
            }

            function filterAllChannels() {
                    var result = extraFilters.filter(channels);
                    return channelSorter.sortAndGroup(channelsSortedBy, result.filtered, CHANNEL_MAIN_FILTER_GROUPS.ALL);
                }

            function filterFavoriteChannels() {
                var result = extraFilters.filter(findChannelsByIds(favoriteChannels || []));
                return channelSorter.sortAndGroup(channelsSortedBy, result.filtered, CHANNEL_MAIN_FILTER_GROUPS.FAVORITES);
            }

            function filterInPackageChannels() {
                    var result = [];
                    for (var i = 0, count = channels.length; i < count; i++) {
                        var channel = channels[i];

                        // une chaine en freeview est considerer comme dans ton forfait
                        if (channel.inPackage || channel.freePreview) {
                            result.push(channel);
                        }
                    }
                    result = extraFilters.filter(result);
                    return channelSorter.sortAndGroup(channelsSortedBy, result.filtered, CHANNEL_MAIN_FILTER_GROUPS.IN_PACKAGE);
                }

            this.filter = function () {
                var result;
                // if channels or extraFilters not yet set, don't go any further
                if (!channels || !extraFilters) {
                    return undefined;
                }
                switch (mainFilter) {
                    case CHANNEL_MAIN_FILTERS.ALL:
                        result = filterAllChannels();
                        break;
                    case CHANNEL_MAIN_FILTERS.FAVORITES:
                        result = filterFavoriteChannels();
                        break;
                    case CHANNEL_MAIN_FILTERS.IN_PACKAGE:
                        result = filterInPackageChannels();
                        break;
                    default:
                        break;
                }
                return result;
            };

            this.setMainFilter = function (value) {
                mainFilter = value;
            };

            this.setExtraFilters = function (value) {
                var filters = [];
                if(value){
                    for (var i = 0, count = value.length; i < count; i++) {
                        var item = value[i];
                        var filter = new Filter(item.func, item.name);
                        filters.push(filter);
                    }
                }
                extraFilters = new MacroFilter(filters);
            };

            this.setChannels = function (value) {
                channels = value.getChannels();
            };

            this.setFavoriteChannels = function (value) {
                favoriteChannels = value;
            };

            this.setChannelsSortOrder = function (value) {
                channelsSortedBy = value;
            };


        }


        return function () {
            return new ChannelsFilter();
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("ChannelsSorter",
    ["$translate", "CHANNEL_TYPES", function ($translate, CHANNEL_TYPES) {

        function ChannelsSorter() {

            function SortedChannelGroup(type, channels, headerText) {
                this.type = type;
                this.channels = channels;
                this.headerText = headerText || undefined;
            }

            function sortByKey(array, key) {
                return array.sort(function(a, b) {
                    var x = a[key];
                    var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            }

            function sortChannelsByAlpha(mainFilterType, filteredChannels){
                var channelsGroupedByTypes = splitChannelsIntoTypes(mainFilterType, filteredChannels);

                for(var i = 0, len = channelsGroupedByTypes.length; i < len; i++){
                    var channels = channelsGroupedByTypes[i].channels;
                    channels = sortByKey(channels, "nameForSorting");

                }
                return channelsGroupedByTypes;
            }

            function isTypeDefined(type){
                return typeof CHANNEL_TYPES[type] !== "undefined";
            }

            function splitChannelsIntoTypes(mainFilterType, filteredChannels){
                var groups = {};
                var groupsList = [];
                // channelsByType is useful for printing out list of channels and types
                //var channelsByType = {};
                for(var i = 0, len = filteredChannels.length; i < len; i++){
                    var channel = filteredChannels[i];
                    var channelType = channel.channelType;
                    if(isTypeDefined(channelType)){
                        if(!groups[channelType]){
                            groups[channelType] = [];
                        }
                        groups[channelType].push(channel);
                        //channelsByType[channel.nameForSorting] = channelType;
                    }
                }
                for(var type in groups){
                    groupsList.push(new SortedChannelGroup(mainFilterType, groups[type], $translate.instant(CHANNEL_TYPES[type].label)));
                }
                //console.dir(channelsByType)
                //console.log(JSON.stringify(channelsByType))
                return groupsList;
            }

            this.sortAndGroup = function(channelsSortedBy, filteredChannels, mainFilterType){
                //console.info("Channels sorted by", channelsSortedBy);
                var groups = [];
                if(channelsSortedBy === "ALPHA"){
                    groups = sortChannelsByAlpha(mainFilterType, filteredChannels)
                }else{
                    // default sort by channel position
                    groups.push(new SortedChannelGroup(mainFilterType, filteredChannels));
                }
                return groups;
            };


        }


        return function () {
            return new ChannelsSorter();
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("Filter", function () {

    function Filter(filter, name) {

        this.filter = function (data) {
            var result = {
                filtered: [],
                notFiltered: []
            };
            for (var i = 0, count = data.length; i < count; i++) {
                var item = data[i];
                if (filter(item)) {
                    result.filtered.push(item);
                } else {
                    result.notFiltered.push(item);
                }
            }
            return result;
        };

        this.getName = function () {
            return name;
        };


    }

    return function (filter, name) {
        return new Filter(filter, name);
    };


});
angular.module("videotron.illico.epg-grid").factory("FreePreviewToolTipGridItemProvider",
    ["GridItem", "$translate", "Sprite", "SpritePool", function (GridItem, $translate, Sprite, SpritePool) {


        function FreePreviewToolTipSpriteFactory(text) {
            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = "free-preview-tooltip";
                var content = document.createElement("div");
                content.textContent = text;
                rootElement.appendChild(content);
                return sprite;
            };
        }

        function FreePreviewToolTipRenderer() {

            this.render = function (sprite, channel) {
            };

        }


        function FreePreviewToolTipGridItemProvider(type, zIndex, offsetX, hideDelay, showDelay, container) {

            var gridItemsByChannelId = {};

            var TOOLTIP_WIDTH = 80;

            var freePreviewToolTipSpritePool = new SpritePool(container, 10, new FreePreviewToolTipSpriteFactory($translate.instant("free preview")));

            var renderer = new FreePreviewToolTipRenderer();

            this.setChannels = function (channels) {
                channels = channels.getChannels();

                for (var i = 0, count = channels.length; i < count; i++) {
                    var channel = channels[i];
                    if (channel.freePreview) {
                        var gridItem = new GridItem(type, 0, 0, TOOLTIP_WIDTH, 22, channel, renderer);
                        gridItem.zIndex = zIndex;
                        gridItemsByChannelId[channel.id] = gridItem;
                        gridItem.spritePool = freePreviewToolTipSpritePool;
                    }

                }

            };


            function GridItemAnimation(gridItem, showDelay, hideDelay) {

                function show(showDelay) {
                    return setTimeout(function () {
                        if (gridItem.sprite) {
                            gridItem.sprite.element.className = "free-preview-tooltip visible";
                        }
                        visible = true;
                    }, showDelay);
                }

                function hide() {
                    return setTimeout(function () {
                        if (gridItem.sprite) {
                            gridItem.sprite.element.className = "free-preview-tooltip hidden";
                        }
                        visible = false;
                    }, hideDelay);
                }


                var visible = false;

                var hideTimeoutId = hide(hideDelay);

                var showTimeoutId = show(showDelay);


                this.show = function () {
                    if (!visible) {
                        clearTimeout(showTimeoutId);
                        clearTimeout(hideTimeoutId);
                        showTimeoutId = show(0);
                        hideTimeoutId = hide(hideDelay);
                    }
                };

                function gridItemRelease() {
                    clearTimeout(showTimeoutId);
                    clearTimeout(hideTimeoutId);
                    gridItem.sprite.element.className = "free-preview-tooltip hidden";
                    gridItemsAnimations[gridItem.data.id] = null;
                }

                gridItem.onRelease = gridItemRelease;
            }

            var gridItemsAnimations = {};


            function animateGridItem(gridItem, showDelay, hideDelay) {

                var id = gridItem.data.id;
                var animation = gridItemsAnimations[id];
                if (!animation) {
                    gridItemsAnimations[id] = new GridItemAnimation(gridItem, showDelay, hideDelay);
                }

            }

            this.showFreePreviewTooltip = function (channelId) {
                var gridItemsAnimation = gridItemsAnimations[channelId];
                gridItemsAnimation.show();
            };

            this.findGridItems = function (rows, startX, endX, result) {
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    var gridItem = gridItemsByChannelId[row.id];
                    if (gridItem) {
                        animateGridItem(gridItem, showDelay, hideDelay);
                        gridItem.viewportX = offsetX;
                        gridItem.viewportY = row.viewportStartY;
                        result.push(gridItem);
                    }
                }
            };


        }


        return function (type, zIndex, offsetX, hideDelay, showDelay, container) {
            return new FreePreviewToolTipGridItemProvider(type, zIndex, offsetX, hideDelay, showDelay, container);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("GridCurrentDay",
    ["Day", "Time", "EventDispatcher", function (Day, Time, EventDispatcher) {


        var DAY_CHANGE = "day_change";

        function GridCurrentTime(gridUnitConverter, viewport, eventDispatcher) {

            var dayObj;
            var days = [];
            var currentDay;
            var currentStartX = 0;

            this.setTimeSpan = function (start, end) {
                currentDay = null;
                var midnightStartDate = Time.extractMidnightDate(start);
                var day = Time.day();
                var t = midnightStartDate;
                days.length = 0;
                while (t < end) {
                    var x = gridUnitConverter.millisecondsToSceneXPosition(t);
                    days.push({
                        x: x,
                        maxX: x + day,
                        time: t
                    });
                    t += day;
                }
            };

            this.update = function () {
                var startX = viewport.getX();
                var i = days.length;
                while (i--) {
                    var day = days[i];
                    if (day.x <= startX && day.maxX >= startX) {
                        if (currentDay !== day) {
                            currentDay = day;
                            dayObj = new Day(day.time);
                            eventDispatcher.dispatch(DAY_CHANGE);
                        }
                        break;
                    }
                }
                currentStartX = startX;
            };

            this.addDayChangeListener = function (listener) {
                return eventDispatcher.addListener(DAY_CHANGE, listener);
            };

            this.getDay = function () {
                return dayObj;
            };

        }

        return function (gridUnitConverter, viewport) {
            return new GridCurrentTime(gridUnitConverter, viewport, new EventDispatcher());
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("GridRowsFactory",
    [ "CHANNEL_MAIN_FILTER_GROUPS", "Row", "$translate", function (CHANNEL_MAIN_FILTER_GROUPS, Row, $translate) {

        var CHANNEL_GROUP_PREFIX = "channel-group-";
        var channelGroupsMarkedAsOpened = [];

        function ChannelGroup(id, channel) {
            this.id = id;
            this.channels = [];
            this.firstChannel = channel;
        }

        function isGroupMarkedAsOpened(prefixedGroupId){
            //console.info(prefixedGroupId + " has been marked as open already", channelGroupsMarkedAsOpened.indexOf(prefixedGroupId) != -1);
            return channelGroupsMarkedAsOpened.indexOf(prefixedGroupId) != -1;
        }


        function GridRowsFactory(channelRowHeight, groupRowHeight, groupDelimiterRowHeight,
                                 firstGroupDelimiterRowHeight) {


            function createRowsWithGroupedChannels(channelGroup, rows, groups, groupHeaders) {

                var currentChannelGroup = null;
                var channels = channelGroup.channels;

                function createNewGroup(channel){
                    currentChannelGroup = new ChannelGroup(CHANNEL_GROUP_PREFIX + channel.groupId, channel);
                    currentChannelGroup.channels.push(channel);
                }

                function finalizeGroup(){
                    var numChannels = currentChannelGroup.channels.length;

                    // group must have more then 1 channel
                    if(numChannels > 1){
                        // add to groups
                        groups.push(currentChannelGroup);
                        // add group to rows
                        rows.push(new Row(currentChannelGroup.id, groupRowHeight, true));
                        for(var i = 0; i < numChannels; i++){
                            // add hidden channels to rows
                            rows.push(new Row(currentChannelGroup.channels[i].id, channelRowHeight, false));
                        }
                    }else if(numChannels === 1){
                        // if only one channel, add it as a normal row
                        rows.push(new Row(currentChannelGroup.channels[0].id, channelRowHeight, true));
                    }
                    currentChannelGroup = null;
                }

                if(channelGroup.headerText){
                    var isFirstGroup = groupHeaders.length === 0;
                    createGroupHeader(channelGroup.headerText, rows, groupHeaders, isFirstGroup);
                }

                for (var i = 0, count = channels.length; i < count; i++) {
                    var channel = channels[i];
                    if (channel.groupId && !isGroupMarkedAsOpened(CHANNEL_GROUP_PREFIX + channel.groupId)) {
                        //if no channelGroup exists, create it and add channel
                        if (!currentChannelGroup) {
                            createNewGroup(channel);
                        }else{
                            // if channel belongs in this group
                            if (currentChannelGroup.id === CHANNEL_GROUP_PREFIX + channel.groupId) {
                                //add channel
                                currentChannelGroup.channels.push(channel);

                                // if this channel is the last in the list, close this group
                                if(i === count-1){
                                    finalizeGroup();
                                }
                            }else{
                                // this channel is in another group, close and create
                                finalizeGroup();
                                createNewGroup(channel);
                            }
                        }
                    } else {
                        // since groups are sequential, if we get here and still have a group, it's time to close it
                        if (currentChannelGroup !== null) {
                            finalizeGroup();
                        }
                        rows.push(new Row(channel.id, channelRowHeight, true));
                    }
                }

            }

            function createRows(channels, rows) {
                for (var i = 0, count = channels.length; i < count; i++) {
                    var channel = channels[i];
                    rows.push(new Row(channel.id, channelRowHeight, true));
                }

            }


            function createGroupHeader(title, rows, groupHeaders, firstGroup) {
                var groupHeader = {
                    id: title
                };
                var thisGroupHeight = (firstGroup) ? firstGroupDelimiterRowHeight : groupDelimiterRowHeight;

                rows.push(new Row(title, thisGroupHeight, true));
                groupHeaders.push(groupHeader);

            }


            this.createRowsFromChannelGroups = function (channelGroups) {
                var rows = [];
                var groupedChannels = [];
                var groupHeaders = [];


                channelGroups = channelGroups || [];

                for (var i = 0, count = channelGroups.length; i < count; i++) {
                    var channelGroup = channelGroups[i];
                    var channels = channelGroup.channels;

                    if (channels && channels.length > 0){
                        switch (channelGroup.type) {
                            case  CHANNEL_MAIN_FILTER_GROUPS.ALL:
                                createRowsWithGroupedChannels(channelGroup, rows, groupedChannels, groupHeaders);
                                break;
                            case  CHANNEL_MAIN_FILTER_GROUPS.FAVORITES:
                                // we no longer need the header here but I might need it later, so just commenting out
                                //createGroupHeader($translate.instant("favorites heading"), rows, groupHeaders, true);
                                createRows(channelGroup.channels, rows);
                                break;
                            case  CHANNEL_MAIN_FILTER_GROUPS.IN_PACKAGE:
                                createRowsWithGroupedChannels(channelGroup, rows, groupedChannels, groupHeaders);
                                break;
                        }

                    }

                }


                return {rows: rows, groupedChannels: groupedChannels, groupDelimiters: groupHeaders, total: rows.length + groupedChannels.length + groupHeaders.length};
            };

            // Keep state of opened groups so that they stay open during session
            // even if filters change or external actions called (updateData etc.)
            // See NES-985 for examples
            this.markChannelGroupAsOpened = function(prefixedGroupId){
                //console.info("markChannelGroupAsOpened", prefixedGroupId);
                if(!isGroupMarkedAsOpened(prefixedGroupId)){
                    channelGroupsMarkedAsOpened.push(prefixedGroupId);
                }else{
                    console.warn(prefixedGroupId + " already added, ignoring request");
                }
            }


        }


        return function (channelRowHeight, groupRowHeight, groupDelimiterRowHeight, firstGroupDelimiterRowHeight) {
            return new GridRowsFactory(channelRowHeight, groupRowHeight, groupDelimiterRowHeight,
                firstGroupDelimiterRowHeight);
        };

    }]);
angular.module("videotron.illico.epg-grid").factory("GridUnitConverter", ["Time", function (Time) {


    var round = Math.round;

    function GridUnitConverter(pixelPerMinutes, viewport, timeSpan) {
        var millisecondsPerPixel = Time.minute() / pixelPerMinutes;

        this.millisecondsToSceneXPosition = function (value) {
            return this.millisecondsToPixels(value - timeSpan.getStart());
        };

        this.millisecondsToViewportXPosition = function (value) {
            return this.millisecondsToPixels(value - timeSpan.getStart()) - viewport.getX();
        };

        this.sceneXPositionToMilliseconds = function (value) {
            return timeSpan.getStart() + this.pixelToMilliseconds(value);
        };

        this.millisecondsToPixels = function (value) {
            return Time.millisecondsToMinutes(value) * pixelPerMinutes;
        };

        this.pixelToMilliseconds = function (pixels) {
            return round(pixels * millisecondsPerPixel);
        };

        this.pixelToMillisecondsSince1970 = function (pixels) {
            return this.pixelToMilliseconds(pixels) + timeSpan.getStart();
        };


    }

    return function (pixelPerMinutes, viewport, timeSpan) {
        return new GridUnitConverter(pixelPerMinutes, viewport, timeSpan);
    };


}]);
angular.module("videotron.illico.epg-grid").factory("MacroFilter", function () {

    function MacroFilter(filters) {

        this.filter = function (data) {
                var result = {
                filtered: data,
                notFiltered: []
            };
            for (var i = 0, count = filters.length; i < count; i++) {
                var filter = filters[i];
                var tmpResult = filter.filter(result.filtered);
                result.filtered = tmpResult.filtered;
                result.notFiltered = result.notFiltered.concat(tmpResult.notFiltered);
            }
            return result;
        };

    }

    return function (filters) {
        return new MacroFilter(filters);
    };


});
angular.module("videotron.illico.epg-grid").factory("ManualRecordingsGridItemProvider",
    ["GridItem", "Sprite", "SpritePool", function (GridItem, Sprite, SpritePool) {


        function ManualRecordingSpriteFactory() {

            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = "manual-recording";
                return sprite;
            };

        }


        function ManualRecordingRenderer() {
            this.render = function (sprite, manualRecording) {
            };
        }


        function ManualRecordingsGridItemProvider(zIndex, channelsColumnWidth, gridUnitConverter, container) {
            var MANUAL_RECORDING_HEIGHT = 5;
            var gridItemsByChannelId = {};

            var manualRecordingSpritePool = new SpritePool(container, 5, new ManualRecordingSpriteFactory());

            var manualRecordingRenderer = new ManualRecordingRenderer();


            this.reset = function () {
                gridItemsByChannelId = {};
            };


            this.setManualRecordings = function (manualRecordings) {
                gridItemsByChannelId = {};

                for (var i = 0, count = manualRecordings.length; i < count; i++) {
                    var manualRecording = manualRecordings[i];

                    var channelId = manualRecording.channelId;
                    var channelGridItems = gridItemsByChannelId[channelId];
                    if (!channelGridItems) {
                        channelGridItems = gridItemsByChannelId[channelId] = [];
                    }

                    manualRecording.startTime = ENP.tsFromCustomDate(manualRecording.startTime);
                    manualRecording.endTime = ENP.tsFromCustomDate(manualRecording.endTime);

                    var x = gridUnitConverter.millisecondsToSceneXPosition(manualRecording.startTime) + channelsColumnWidth;
                    var y = 0;
                    var width = gridUnitConverter.millisecondsToPixels(manualRecording.endTime - manualRecording.startTime);


                    var gridItem = new GridItem(null, x, y, width, MANUAL_RECORDING_HEIGHT, manualRecording,
                        manualRecordingRenderer);
                    gridItem.zIndex = zIndex;
                    gridItem.spritePool = manualRecordingSpritePool;

                    channelGridItems.push(gridItem);

                }

            };


            this.findGridItems = function (rows, startX, endX, result) {
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    //
                    var channelGridItems = gridItemsByChannelId[row.id];
                    if (channelGridItems) {
                        var j = channelGridItems.length;
                        while (j--) {
                            var gridItem = channelGridItems[j];
                            if (gridItem.x <= endX && gridItem.maxX >= startX) {
                                gridItem.viewportX = gridItem.x - startX;
                                gridItem.viewportY = row.viewportStartY + 2;
                                result.push(gridItem);
                            }
                        }
                    }
                }

            };


        }

        return function (zIndex, channelsColumnWidth, gridUnitConverter, container) {
            return new ManualRecordingsGridItemProvider(zIndex, channelsColumnWidth, gridUnitConverter, container);
        };

    }]);
angular.module("videotron.illico.epg-grid").factory("Metadata", function () {

        function Metadata() {

            var metadata = [];
            var hasBeenSet = false;

            this.isSet = function () {
                return hasBeenSet;
            };

            this.setMetadata = function (value) {
                metadata = value;
                hasBeenSet = true;

                // in case value is null (500 error on metadata service for example)
                // create default values here to avoid crash
                metadata.favoriteChannels = metadata.favoriteChannels || [];
                metadata.manualRecordings = metadata.manualRecordings || [];
                metadata.recordingPrograms = metadata.recordingPrograms || [];
                metadata.selectedPrograms = metadata.selectedPrograms || [];
            };

            this.getMetadata = function () {
                return metadata;
            };


            this.extractChannelFavoriteState = function (channel) {
                //console.log('extractChannelFavoriteState()');
                //console.log('channel: ', channel);
                //console.log('metadata: ', metadata);
                var result = {isFavorite: false, index: -1};
                var array = metadata.favoriteChannels;
                //console.log('array: ', array);
                if (array) {
                    for (var i = 0, count = array.length; i < count; i++) {
                        var id = array[i];
                        if (id === channel.id) {
                            result.isFavorite = true;
                            result.index = i;
                            break;
                        }
                    }

                    return result;
                }

                return null;
            };

            this.toggleChannelFavoriteState = function (channel, channelFavoriteState) {
                channelFavoriteState = channelFavoriteState || this.extractChannelFavoriteState(channel);
                if (channelFavoriteState.isFavorite) {
                    metadata.favoriteChannels.splice(channelFavoriteState.index, 1);
                } else {
                    metadata.favoriteChannels.push(channel.id);
                }
            };

            this.getFavoriteChannels = function () {
                return metadata.favoriteChannels;
            };

            this.getManualRecordings = function () {
                return metadata.manualRecordings;
            };

            this.getRecordingPrograms = function () {
                return metadata.recordingPrograms;
            };

            this.getSelectedPrograms = function () {
                return metadata.selectedPrograms;
            };

            function programExists(programId, array) {
                var result = false;
                if (array) {
                    for (var i = 0, count = array.length; i < count; i++) {
                        if (array[i] === programId) {
                            result = true;
                            break;
                        }
                    }
                }
                return result;
            }

            this.programIsSelected = function (program) {
                return programExists(program.programId, this.getSelectedPrograms());
            };

            this.programIsRecording = function (program) {
                return programExists(program.programId, this.getRecordingPrograms());
            };


        }


        return function () {
            return new Metadata();
        };


    }
)
;
angular.module("videotron.illico.epg-grid").factory("MetadataLoader", ["$http", "HttpConfigs", function ($http, HttpConfigs) {

    function MetadataLoader(basePath) {

        var localHttpConfigs = {cache: false};
        // create local no cache version of http configs
        angular.extend(localHttpConfigs, HttpConfigs.getConfigs());


        this.load = function () {
            return $http.get(basePath + "/guide/metadata?forceRefresh=true", localHttpConfigs).then(
                function (response) {
                    return response.data.body.main;
                }, function (error) {
                    // Currently letting error slide and returning empty object
                    // This can happen if theres a network/server error or user is in perception
                    // But we don't want to crash the grid for this
                    // TODO - add message for user?
                    return {};
                });
        };


    }

    return function (basePath) {
        return new MetadataLoader(basePath);
    };

}]);
angular.module("videotron.illico.epg-grid").factory("ModalChannelDisplayOptions",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, AppConfig, $window) {

        function ModalChannelDisplayOptions(template, modalOptions) {
            var templateString;
            var customModalOptions = modalOptions || {};
            var simpleModal = new SimpleModal();
            var APP_CONST = AppConfig.getEPGAppConstants();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.show = function (sortTypes, channelsSortedBy, extraFilters, yesCallback) {
                var scope = $rootScope.$new(true);
                var defaultModalOptions = {
                    opacity: 90
                };
                var modalOptions = $.extend(defaultModalOptions, customModalOptions);
                var element = SrvModalTemplateLoader.compile(templateString, scope);

                scope.sortTypes = sortTypes;
                scope.channelsSortedBy = channelsSortedBy;
                scope.extraFilters = extraFilters;

                scope.updateChannelFiltersAndSort = function (filtersAndSort) {
                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null, filtersAndSort);
                    }
                };

                scope.close = function () {
                    simpleModal.close();
                };

                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (templateId, modalOptions) {
            return new ModalChannelDisplayOptions(templateId, modalOptions);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("ModalChannelFilter",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, AppConfig, $window) {

        function ModalChannelFilter(template) {
            var templateString;
            var simpleModal = new SimpleModal();
            var APP_CONST = AppConfig.getEPGAppConstants();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.show = function (filters, selectedFilter, yesCallback) {
                var scope = $rootScope.$new(true);
                var modalOptions = {
                    opacity: 90
                };

                scope.filters = filters;
                scope.selectedFilter = selectedFilter;

                scope.updateChannelFilter = function (filter) {
                    simpleModal.close();
                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null, filter);
                    }
                };

                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (templateId) {
            return new ModalChannelFilter(templateId);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("ModalGroupedPrograms",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "$filter", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, $filter, AppConfig, $window) {

        function ModalGroupedPrograms(template, modalOptions) {
            var templateString;
            var customModalOptions = modalOptions || {};
            var APP_CONST = AppConfig.getEPGAppConstants();
            var simpleModal = new SimpleModal();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.show = function (programsList, channelName, yesCallback) {
                var scope = $rootScope.$new(true);
                var defaultModalOptions = {
                    opacity: 90
                };
                var modalOptions = $.extend(defaultModalOptions, customModalOptions);
                var dateFilter = $filter("date");
                var programs = [];

                for(var i = 0; i < programsList.length; i++){
                    var program = programsList[i];
                    var newProgramObj = {
                        title : program.title,
                        formattedTime : dateFilter(ENP.tsFromCustomDate(program.startTime), "shortTime"),
                        isSelection : program.extra.selection,
                        isRecording : program.extra.recording,
                        isAdult : program.ratingIcon === "ADULT",
                        data : $.extend(true, {}, program)
                    };

                    programs.push(newProgramObj);
                }

                scope.programs = programs;
                scope.channelName = channelName;

                scope.selectProgram = function (program) {
                    simpleModal.close();
                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null, program);
                    }
                };

                scope.close = function () {
                    simpleModal.close();
                };

                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (templateId, modalOptions) {
            return new ModalGroupedPrograms(templateId, modalOptions);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("ModalSelectDay",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "Time", "Day", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, Time, Day, AppConfig, $window) {

        function ModalSelectDay(template, modalOptions) {
            var templateString;
            var customModalOptions = modalOptions || {};
            var APP_CONST = AppConfig.getEPGAppConstants();
            var simpleModal = new SimpleModal();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.show = function (startDay, endDay, now, currentDay, yesCallback) {
                var scope = $rootScope.$new(true);
                // auto focus causes strange glitch on tablet in this case so deactivate it here
                var defaultModalOptions = {
                    opacity: 90,
                    minHeight: 400,
                    focus: false
                };
                var modalOptions = $.extend(defaultModalOptions, customModalOptions);

                scope.days = [];
                scope.now = now;
                scope.currentDay = currentDay;

                (function updateAvailableDays() {
                    var startDayAtMidnight = Time.extractMidnightDate(startDay);
                    var endDayAtMidnight = Time.extractMidnightDate(endDay);
                    if (startDayAtMidnight > endDayAtMidnight){
                        throw new Error("Illegal arguments error");
                    }
                    var days = [];
                    var t = startDayAtMidnight;
                    do {
                        days.push(new Day(t));
                        t = Time.nextDay(t);
                    } while (t < endDayAtMidnight);
                    scope.days = days;
                })();

                scope.updateDay = function (selectedDay) {
                    simpleModal.close();

                    if (selectedDay && (selectedDay.time < startDay || selectedDay.time > endDay)) {
                        selectedDay = scope.days[0];
                    }

                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null, selectedDay);
                    }
                };

                scope.close = function () {
                    simpleModal.close();
                };



                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (templateId, modalOptions) {
            return new ModalSelectDay(templateId, modalOptions);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("NowIndicatorGridItemProvider",
    ["GridItem", "$filter", "Time", "$translate", "Sprite", "SpritePool", function (GridItem, $filter, Time, $translate,
                                                                                    Sprite, SpritePool) {


        function NowBarSpriteFactory() {

            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = "now-bar";
                return sprite;
            };

        }

        function NowButtonSpriteFactory(text) {

            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = "now-button";

                var label = document.createElement("div");
                label.textContent = text;
                rootElement.appendChild(label);

                return sprite;
            };

        }


        function NowLabelSpriteFactory() {

            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = "now-label";

                var label = document.createElement("div");
                label.className = "label";
                rootElement.appendChild(label);

                sprite.label = label;

                return sprite;
            };

        }

        function NOOPRenderer() {

            this.render = function (sprite, now) {
            };

        }

        function NowLabelRenderer() {
            var dateFilter = $filter("date");

            this.render = function (sprite, now) {
                sprite.label.textContent = dateFilter(new Date(now), "shortTime");
            };
        }


        function NowIndicatorGridItemProvider(nowButtonGridItemType, nowButtonWidth, nowButtonHeight, nowButtonZIndex, offsetX, offsetY,
                                              barZIndex, labelZIndex, gridUnitConverter, viewport, container, TIMELINE_IS_POSITION_ABSOLUTE) {

            var NOW_BUTTON_X_POSITION = 0;
            var NOW_BUTTON_Y_POSITION = 0;
            var currentTime = 0;

            var nowBarGridItem = new GridItem(null, 0, 0, 1, 0, null, new NOOPRenderer());
            nowBarGridItem.positionAbsolute = TIMELINE_IS_POSITION_ABSOLUTE;
            nowBarGridItem.zIndex = barZIndex;
            nowBarGridItem.isClickable = false;
            nowBarGridItem.spritePool = new SpritePool(container, 1, new NowBarSpriteFactory());

            var nowLabelGridItem = new GridItem(null, 0, 0, 1, 3, null, new NowLabelRenderer());
            nowLabelGridItem.positionAbsolute = TIMELINE_IS_POSITION_ABSOLUTE;
            nowLabelGridItem.zIndex = labelZIndex;
            nowLabelGridItem.spritePool = new SpritePool(container, 1, new NowLabelSpriteFactory());

            var nowButtonGridItem = new GridItem(nowButtonGridItemType, NOW_BUTTON_X_POSITION, NOW_BUTTON_Y_POSITION,
                nowButtonWidth, nowButtonHeight, null,
                new NOOPRenderer());
            nowButtonGridItem.positionAbsolute = TIMELINE_IS_POSITION_ABSOLUTE;
            nowButtonGridItem.zIndex = nowButtonZIndex;
            nowButtonGridItem.spritePool = new SpritePool(container, 1, new NowButtonSpriteFactory($translate.instant("now")));

            this.findGridItems = function (rows, startX, endX, result) {
                var startTime = (gridUnitConverter.sceneXPositionToMilliseconds(startX));
                var endTime = (gridUnitConverter.sceneXPositionToMilliseconds(endX));

                if (currentTime >= startTime && currentTime <= endTime) {
                    var x = gridUnitConverter.millisecondsToViewportXPosition(currentTime) + offsetX;
                    nowBarGridItem.viewportX = offsetX;
                    nowBarGridItem.width = x - offsetX +1;
                    nowBarGridItem.height = viewport.getSceneHeight() - viewport.getY() + offsetY;


                    nowLabelGridItem.viewportX = x;
                    nowLabelGridItem.data = currentTime;

                    //TODO... is this the way to update a GRID ITEM already on the grid ?
                    if (nowLabelGridItem.sprite) {
                        nowLabelGridItem.renderer.render(nowLabelGridItem.sprite, nowLabelGridItem.data);
                    }
                    result.push(nowBarGridItem);
                    result.push(nowLabelGridItem);
                } else if (currentTime <= startTime) {
                    result.push(nowButtonGridItem);
                }
            };

            this.setCurrentTime = function (value) {
                value = Math.floor(value / Time.minute()) * Time.minute();
                currentTime = value;
            };

        }


        return function (nowButtonGridItemType, nowButtonWidth, nowButtonHeight, nowButtonZIndex, offsetX, offsetY, barZIndex,
                         labelZIndex, gridUnitConverter, viewport, container, TIMELINE_IS_POSITION_ABSOLUTE) {
            return new NowIndicatorGridItemProvider(nowButtonGridItemType, nowButtonWidth, nowButtonHeight, nowButtonZIndex, offsetX,
                offsetY, barZIndex, labelZIndex,
                gridUnitConverter, viewport, container, TIMELINE_IS_POSITION_ABSOLUTE);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("ProgramGridItemProvider",
    ["GridItem", "Value", "SpritePool", "Sprite", "$translate", function (GridItem, Value, SpritePool, Sprite, $translate) {


        function SpriteWithContentFactory(textContent) {
            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                var content = document.createElement("div");
                content.className = "content";
                content.textContent = textContent;
                rootElement.appendChild(content);
                return sprite;
            };
        }


        function ProgramSpriteFactory() {
            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                //rootElement.className = "program";
                var content = document.createElement("div");
                content.className = "content";
                rootElement.appendChild(content);
                var title = document.createElement("div");
                title.className = "title";
                content.appendChild(title);
                var extra1 = document.createElement("div");
                content.appendChild(extra1);


                /*
                 // see IENP-348 & GUS-702
                 // selectedPrograms hidden for now, possibly removed from back-end in later release

                var extra2 = document.createElement("div");
                content.appendChild(extra2);
                sprite.extra2 = extra2;
                */


                var extra3 = document.createElement("div");
                content.appendChild(extra3);

                var testHelper = document.createElement("div");
                testHelper.className = "qa-parent-channel-id";
                content.appendChild(testHelper);

                sprite.content = content;
                sprite.title = title;
                sprite.extra1 = extra1;
                sprite.extra3 = extra3;
                sprite.testHelper = testHelper;
                return sprite;
            };
        }

        function trimLongText(text, maxWidth, hasMeta) {

            // this will need to change if the css changes
            var WIDTH_PADDING = (hasMeta) ? 74 : 24; // total padding in cell, depending on if meta data needs to be shown or not
            var MAX_LINES = 2;
            var FONT_SIZE = 14;
            var CPL_CONSTANT = 2.04; // an average of 2.24 characters of Helvitica Neue will fit in 14px of width - http://www.pearsonified.com/2012/01/characters-per-line.php
            var ELLIPSE_SYMBOL = "...";
            var ELLIPSE_BUFFER_SIZE = 3;
            var charsPerLine = Math.floor(((maxWidth - WIDTH_PADDING) / FONT_SIZE) * CPL_CONSTANT);
            var trimSize = (charsPerLine - ELLIPSE_BUFFER_SIZE > 1) ? charsPerLine - ELLIPSE_BUFFER_SIZE : 2;
            var words = "";
            var line = "";
            var lines = [];
            var forceLastLine = false;

            if (text.length > charsPerLine) {
                words = text.split(" ");
                while (words.length > 0) {
                    var tempLine = (line === "") ? words[0] : line + " " + words[0];
                    if (tempLine.length <= charsPerLine) {

                        // text fits on line without wrapping
                        line = (line === "") ? words.shift() : line + " " + words.shift();
                    } else {
                        if (words[0].length > charsPerLine) {

                            // word is longer then line, trim here
                            forceLastLine = true;
                            line = words[0];
                        }

                        // line full, start new line
                        lines.push(line + " ");
                        line = "";
                        if (lines.length === MAX_LINES || forceLastLine) {

                            // we've reached max length on max line or forcing last line
                            lines[lines.length - 1] = tempLine.substring(0, trimSize) + ELLIPSE_SYMBOL;
                            return lines.join("");
                        }
                    }
                }
            }
            return text;
        }


        function ProgramRenderer(classes, recordingPrograms, selectedPrograms) {
            this.render = function (sprite, program, gridItem) {
                var extraClasses = classes;
                var hasMeta = false;
                if (recordingPrograms[program.programId]) {
                    extraClasses += " meta meta_recording";
                    hasMeta = true;
                    sprite.extra1.className = "recording";
                } else {
                    sprite.extra1.className = "";
                }

                /*
                // see IENP-348 & GUS-702
                // selectedPrograms hidden for now, possibly removed from back-end in later release


                if (selectedPrograms[program.programId]) {
                    extraClasses += " meta meta_selection";
                    hasMeta = true;
                    sprite.extra2.className = "selection";
                } else {
                    sprite.extra2.className = "";
                }

                */


                if (program.ratingIcon === "ADULT") {
                    extraClasses += " blocked meta_blocked";
                    hasMeta = true;
                    sprite.extra3.className = "adult";
                } else {
                    sprite.extra3.className = "";
                }
                sprite.setClass(extraClasses);
                sprite.title.textContent = trimLongText(program.title, gridItem.width, hasMeta);

                // useful for debugging, add params to sprite
                // remove before prod
//                sprite.title.id = program.programId;
//                sprite.title.title = program.title;

                //add a title attributes for short programs
                // console.log("gridItem.width", gridItem);
                if(gridItem.width < 100){
                    gridItem.sprite.content.setAttribute('title', program.title);
                }else{
                    //need this empty title attr otherwise will eventually attribute to wrong sprites in the grid
                    gridItem.sprite.content.setAttribute('title', '');
                }

                sprite.testHelper.textContent = program.channelId;
            };

        }


        function SetClassRenderer(classes) {
            this.render = function (sprite) {
                sprite.setClass(classes);
            };
        }

        function GridItemsContainer(programRenderer, programGroupRenderer, loadingRenderer, holeProgramRenderer, pendingProgramRenderer, loadingGridItemsPoolSize, holeGridItemsPoolSize, pendingGridItemsPoolSize, spritesPools) {


            this.gridItemsMap = [];
            this.programRenderer = programRenderer;
            this.programGroupRenderer = programGroupRenderer;

            var loadingGridItemPool = [];


            this.getLoadingGridItem = function (poolIndex) {
                if (!loadingGridItemPool[poolIndex]) {
                    loadingGridItemPool[poolIndex] = new GridItem(null, 0, 0, 0, 0, {}, loadingRenderer);
                    return loadingGridItemPool[poolIndex];
                }
                return loadingGridItemPool[poolIndex];
            };


            for (var i = 0; i < loadingGridItemsPoolSize; i++) {
                loadingGridItemPool.push(new GridItem(null, 0, 0, 0, 0, {}, loadingRenderer));
            }


            var holeGridItemPool = [];

            this.getHoleGridItem = function (poolIndex) {
                if (!holeGridItemPool[poolIndex]) {
                    holeGridItemPool[poolIndex] = new GridItem(null, 0, 0, 0, 0, null, holeProgramRenderer);
                    return holeGridItemPool[poolIndex];
                }
                return holeGridItemPool[poolIndex];
            };

            for (var j = 0; j < holeGridItemsPoolSize; j++) {
                holeGridItemPool.push(new GridItem(null, 0, 0, 0, 0, null, holeProgramRenderer));
            }

            var pendingGridItemPool = [];

            this.getPendingGridItem = function (poolIndex) {
                if (!pendingGridItemPool[poolIndex]) {
                    pendingGridItemPool[poolIndex] = new GridItem(null, 0, 0, 0, 0, null, pendingProgramRenderer);
                }
                return pendingGridItemPool[poolIndex];
            };

            for (var k = 0; k < pendingGridItemsPoolSize; k++) {
                pendingGridItemPool.push(new GridItem(null, 0, 0, 0, 0, null, pendingProgramRenderer));
            }

            this.spritesPools = spritesPools;
        }

        function ProgramsLoadingState(startIndex, endIndex) {
            this.startIndex = startIndex;
            this.endIndex = endIndex;
        }


        function ProgramsLoadingStateGridItemProxy(startX, gridItemsContainer, poolIndex, data) {
            this.startX = startX;
            this.endX = null;
            this.gridItemsContainer = gridItemsContainer;
            this.poolIndex = poolIndex;
            this.data = data;
        }


        function ProgramsGroupData(channelId, initialProgram) {
            this.channelId = channelId;
            this.programs = [initialProgram];

        }


        function ProgramGridItemProvider(programGridItemType, programGroupGridItemType, zIndex, offsetX, gridUnitConverter, container, minProgramDurationInMinutes, pixelsPerMinute) {


            var PENDING = null;
            var LOADING = 1;
            var NO_DATA = 2;

            //enable program grouping
            //var cellMinWidth = minProgramDurationInMinutes * pixelsPerMinute;

            //disable program grouping
            var cellMinWidth = 1;

            var programsLoadingStates = {};
            var recordingPrograms = {};
            var selectedPrograms = {};
            var gridItemsContainersByChannelIndex;

            // these arrays are used to find changes in programs after meta data update
            var recordingProgramsList = [];
            var recordingProgramsListBackup = [];
            var selectedProgramsList = [];
            var selectedProgramsListBackup = [];

            var spritesPools = {
                programSpritePool: new SpritePool(container, 10, new ProgramSpriteFactory()),
                programGroupSpritePool: new SpritePool(container, 10, new SpriteWithContentFactory(null)),
                loadingSpritePool: new SpritePool(container, 5, new SpriteWithContentFactory($translate.instant("epg grid cell loading"))),
                holeSpritePool: new SpritePool(container, 5, new SpriteWithContentFactory($translate.instant("epg grid cell no data"))),
                pendingSpritePool: new SpritePool(container, 5, new SpriteWithContentFactory($translate.instant("epg grid cell pending")))
            };


            this.setChannels = function (channels) {
                //initialize the channels
                //each channel will provide different renderer depending on the channel state
                var programRenderer = new ProgramRenderer("program", recordingPrograms, selectedPrograms);
                var notInPackageProgramRenderer = new ProgramRenderer("program not-in-package", recordingPrograms,
                    selectedPrograms);
                var programGroupRenderer = new SetClassRenderer("program group");
                var notInPackageProgramGroupRenderer = new SetClassRenderer("program group not-in-package");
                var loadingProgramRenderer = new SetClassRenderer("loading-program");
                var notInPackageLoadingProgramRenderer = new SetClassRenderer("loading-program not-in-package");
                var holeProgramRenderer = new SetClassRenderer("program-hole");
                var notInPackageHoleProgramRenderer = new SetClassRenderer("program-hole not-in-package");
                var pendingProgramRenderer = new SetClassRenderer("loading-program");
                var notInPackagePendingProgramRenderer = new SetClassRenderer("loading-program not-in-package");

                var loadingGridItemsPoolSize = 2;
                var pendingGridItemsPoolSize = 2;
                var holeGridItemsPoolSize = 1;

                channels = channels.getChannels();
                gridItemsContainersByChannelIndex = {};
                for (var i = 0, count = channels.length; i < count; i++) {
                    var channel = channels[i];
                    var id = channel.id;

                    if (channel.inPackage || channel.freePreview) {
                        gridItemsContainersByChannelIndex[id] = new GridItemsContainer(programRenderer,
                            programGroupRenderer, loadingProgramRenderer, holeProgramRenderer, pendingProgramRenderer,
                            loadingGridItemsPoolSize, holeGridItemsPoolSize, pendingGridItemsPoolSize, spritesPools);
                    } else {
                        gridItemsContainersByChannelIndex[id] = new GridItemsContainer(notInPackageProgramRenderer,
                            notInPackageProgramGroupRenderer, notInPackageLoadingProgramRenderer,
                            notInPackageHoleProgramRenderer, notInPackagePendingProgramRenderer,
                            loadingGridItemsPoolSize, holeGridItemsPoolSize, pendingGridItemsPoolSize, spritesPools);
                    }
                }


            };


            function programsLoadingComplete(channelIdList, startTime) {
                //called when loading program range end
                var programsLoadingState = programsLoadingStates[startTime];
                var startIndex = programsLoadingState.startIndex;
                var endIndex = programsLoadingState.endIndex;
                if (programsLoadingState) {
                    //for each channels in channelIdList
                    for (var k = 0, kLen = channelIdList.length; k < kLen; k++) {
                        var gridItemsContainer = gridItemsContainersByChannelIndex[channelIdList[k]];
                        if (gridItemsContainer) {
                            var gridItemsMap = gridItemsContainer.gridItemsMap;

                            //if in the cell we found LOADING state, it means that no data have been found so we mark the cell with the NO_DATA state flag
                            for (var i = startIndex; i <= endIndex; i++) {
                                var gridItem = gridItemsMap[i];
                                if (gridItem === LOADING) {
                                    gridItemsMap[i] = NO_DATA;
                                }
                            }
                        }
                    }
                } else {
                    throw new Error("Illegal state error.");
                }
            }


            this.addPrograms = function (programsByChannels, requestStartTime) {
                var mathMax = Math.max;
                var mathRound = Math.round;
                var channelIdList = [];
                //loop over programs grouped by channel
                for (var i = 0, countI = programsByChannels.length; i < countI; i++) {
                    var programsByChannel = programsByChannels[i];
                    //extract the current chanel ID
                    var channelId = programsByChannel.channelId;
                    // add to list
                    channelIdList.push(channelId);
                    //find the object that store all the programs for this chanel
                    var gridItemsContainer = gridItemsContainersByChannelIndex[channelId];
                    //extract the programs
                    var programs = programsByChannel.programs || [];
                    //extract the array where all programs (programs a wrapped in GridItem) will be stored
                    var gridItemsMap = gridItemsContainer.gridItemsMap;
                    //loop over programs
                    main:
                        for (var j = 0, countJ = programs.length; j < countJ; j++) {
                            var program = programs[j];
                            var startTime = ENP.tsFromCustomDate(program.startTime);
                            var endTime = ENP.tsFromCustomDate(program.endTime);
                            var x = gridUnitConverter.millisecondsToSceneXPosition(startTime);
                            var width = gridUnitConverter.millisecondsToPixels(endTime - startTime);

                            var startIndex = mathRound(x / cellMinWidth);
                            //-1 : never use the last index, last program index is often the first index of the next program
                            //mathMax : end index can't be lower than the start index
                            var endIndex = mathMax(startIndex, mathRound((x + width) / cellMinWidth) - 1);
                            var gridItem;

                            //add channelId to program so it can be added to testHelper at render time, only if it doesn't exist
                            if(!program.channelId){
                                program.channelId = channelId
                            }

                            //test if the program duration is lower than the minimum duration (OK tu use size in pixel)
                            if (width <= cellMinWidth) {

                                //if yes : create a GridItem who will render grouped programs
                                gridItem = new GridItem(programGroupGridItemType, x, 0, width, 0,
                                    new ProgramsGroupData(channelId, program), gridItemsContainer.programGroupRenderer);
                                gridItem.spritePool = gridItemsContainer.spritesPools.programGroupSpritePool;
                            } else {

                                //if no : create a GridItem who will render a program
                                gridItem = new GridItem(programGridItemType, x, 0, width, 0, program,
                                    gridItemsContainer.programRenderer);
                                gridItem.spritePool = gridItemsContainer.spritesPools.programSpritePool;
                            }

                            //we store the endIndex, used on rendering in order to skip array lookup (findGridItems function)
                            gridItem.endIndex = endIndex;
                            gridItem.zIndex = zIndex;


                            //extract the object already at startIndex
                            var itemAtStartIndex = gridItemsMap[startIndex];


                            if (itemAtStartIndex === LOADING || !itemAtStartIndex || itemAtStartIndex === NO_DATA) {
                                //if at startIndex there is LOADING or NO_DATA or undefined
                                //replace all the cells for startIndex to endIndex included by the GridItem
                                for (var k = startIndex; k <= endIndex; k++) {
                                    gridItemsMap[k] = gridItem;
                                }
                            } else if (itemAtStartIndex) {//
                                //if itemAtStartIndex exist it should be a programs group or an already added program (we always have duplicated programs between loading zone)
                                //if it's a program do nothing
                                if (itemAtStartIndex.type === programGroupGridItemType) {
                                    //if it's a programs group add this program to the group
                                    var groupedPrograms = itemAtStartIndex.data.programs;
                                    //do nothing if program is already in the group (may happen between loading area :)
                                    for (var l = 0, countL = groupedPrograms.length; l < countL; l++) {
                                        if (groupedPrograms[l].programId === program.programId) {
                                            continue main;
                                        }
                                    }
                                    groupedPrograms.push(program);
                                    //update the width of the group
                                    itemAtStartIndex.width += width;
                                    for (var u = itemAtStartIndex.endIndex + 1; u <= endIndex; u++) {
                                        gridItemsMap[u] = itemAtStartIndex;
                                    }
                                    //update with the new endIndex
                                    itemAtStartIndex.endIndex = endIndex;
                                }
                            }


                        }


                }

                programsLoadingComplete(channelIdList, requestStartTime);
            };


            this.programsLoadingStart = function (startTime, endTime) {
                //called when the loading of a program range start
                var mathRound = Math.round;

                var startX = gridUnitConverter.millisecondsToSceneXPosition(startTime);
                var endX = gridUnitConverter.millisecondsToSceneXPosition(endTime);

                var startIndex = mathRound(startX / cellMinWidth) - 1;
                var endIndex = mathRound(endX / cellMinWidth) - 1;

                programsLoadingStates[startTime] = new ProgramsLoadingState(startIndex, endIndex);

                //for each channels
                for (var k in gridItemsContainersByChannelIndex) {
                    if (gridItemsContainersByChannelIndex.hasOwnProperty(k)) {
                        var gridItemsContainer = gridItemsContainersByChannelIndex[k];
                        if (gridItemsContainer) {
                            var gridItemsMap = gridItemsContainer.gridItemsMap;
                            //mark the position where the loading occurs
                            for (var i = startIndex; i <= endIndex; i++) {
                                var gridItem = gridItemsMap[i];
                                if (gridItem === undefined) {
                                    gridItemsMap[i] = 1;
                                }
                            }
                        }
                    }
                }

            };

            // returns additions and subtractions between 2 arrays
            //example diff between [1,2,3] and [2,3,4] is [1,4]
            function diffFromArrays(arr1, arr2){
                var a, b;
                a = $(arr1).not(arr2).get();
                b = $(arr2).not(arr1).get();
                return a.concat(b);
            }


            function resetRecordingsPrograms() {
                // empty last version of backup
                recordingProgramsListBackup = [];
                for (var k in recordingPrograms) {
                    if (recordingPrograms.hasOwnProperty(k)) {
                        recordingProgramsListBackup.push(k);
                        delete recordingPrograms[k];
                    }
                }
            }

            function resetSelectionPrograms() {
                // empty last version of backup
                selectedProgramsListBackup = [];
                for (var k in selectedPrograms) {
                    if (selectedPrograms.hasOwnProperty(k)) {
                        selectedProgramsListBackup.push(k);
                        delete selectedPrograms[k];
                    }
                }
            }


            this.reset = function () {
                //reset the ProgramGridItemProvider
                for (var key in gridItemsContainersByChannelIndex) {
                    if (gridItemsContainersByChannelIndex.hasOwnProperty(key)) {
                        var gridItemContainer = gridItemsContainersByChannelIndex[key];
                        gridItemContainer.gridItemsMap = [];
                    }
                }
                resetRecordingsPrograms();
                resetSelectionPrograms();
            };

            this.setRecordingPrograms = function (value) {
                resetRecordingsPrograms();
                // empty last version of list
                recordingProgramsList = [];
                for (var i = 0, count = value.length; i < count; i++) {
                    recordingProgramsList.push(value[i]);
                    recordingPrograms[value[i]] = true;
                }
            };


            this.setSelectionPrograms = function (value) {
                resetSelectionPrograms();
                // empty last version of list
                selectedProgramsList = [];
                for (var i = 0, count = value.length; i < count; i++) {
                    selectedProgramsList.push(value[i]);
                    selectedPrograms[value[i]] = true;
                }
            };


            this.reRenderModifiedPrograms = function () {
                var updatedRecordingsDelta = diffFromArrays(recordingProgramsList, recordingProgramsListBackup);
                var updatedSelectionsDelta = diffFromArrays(selectedProgramsList, selectedProgramsListBackup);

                // create an array of all programs that have changed in this update
                var updatedProgramsDelta = updatedRecordingsDelta.concat(updatedSelectionsDelta);

                if(updatedProgramsDelta.length > 0){
                    for (var key in gridItemsContainersByChannelIndex) {
                        if (gridItemsContainersByChannelIndex.hasOwnProperty(key)) {
                            var gridItemsMap = gridItemsContainersByChannelIndex[key].gridItemsMap;
                            for(var i = 0; i < gridItemsMap.length; i++){
                                var gridItem = gridItemsMap[i];
                                // make sure gridItem has already been rendered (has a sprite), it has program data, it has a programId and is in the updateProgramsDelta list
                                if(gridItem && gridItem.sprite && gridItem.data && gridItem.data.programId && $.inArray(gridItem.data.programId, updatedProgramsDelta) >= 0){
                                    // re render gridItem
                                    gridItem.renderer.render(gridItem.sprite, gridItem.data, gridItem);
                                }
                            }
                        }
                    }
                }
            };

            function renderProgramsLoadingStateGridItemProxy(programsLoadingStateGridItem, result, row, endX) {
                //this is an utility function that will create the proper GridItem for the STATE
                var gridItemsContainer = programsLoadingStateGridItem.gridItemsContainer;
                var x = programsLoadingStateGridItem.startX;
                programsLoadingStateGridItem.endX = endX;
                var width = programsLoadingStateGridItem.endX - x;
                if (width < 0) {
                    width = 0;
                }
                x += offsetX;
                var gridItem;
                var poolIndex = programsLoadingStateGridItem.poolIndex;
                if (programsLoadingStateGridItem.data === NO_DATA) {
                    gridItem = gridItemsContainer.getHoleGridItem(poolIndex);
                    gridItem.spritePool = gridItemsContainer.spritesPools.holeSpritePool;
                } else if (programsLoadingStateGridItem.data === LOADING) {
                    gridItem = gridItemsContainer.getLoadingGridItem(poolIndex);
                    gridItem.spritePool = gridItemsContainer.spritesPools.loadingSpritePool;
                } else {
                    gridItem = gridItemsContainer.getPendingGridItem(poolIndex);
                    gridItem.spritePool = gridItemsContainer.spritesPools.pendingSpritePool;
                }
                gridItem.viewportX = x;
                gridItem.viewportY = row.viewportStartY;
                gridItem.height = row.height;
                gridItem.width = width;
                gridItem.zIndex = zIndex;
                result.push(gridItem);
            }




            this.findGridItems = function (rows, startX, endX, result) {
                var mathMax = Math.max;
                var mathMin = Math.min;
                var mathRound = Math.round;

                // we always start one cell behind in order not to miss programs that started before our start Time
                // possible to have negative startIndex at beginning of grid
                var startIndex = mathRound(startX / cellMinWidth) - 1;
                var endIndex = mathRound(endX / cellMinWidth);
                var relativeEndX = endX - startX;
                var i = rows.length; //for iterating rows
                var j = startIndex; //for iterating cell indexes

                var returnNextIndex = function(index, type, state){
                    if(type === "pending"){

                        // Since we're pending
                        // we loop through the rest of the gridItemsMap to see where our current gridItem should end
                        // if it's the same state (aka no pre-defined gridItem), we keep going until the end of the screen
                        while (gridItemsMap[index] === undefined && index <= endIndex) {
                            // empty on purpose, just searching through gridItemsMap while incrementing j
                            index++;
                        }
                    }else{

                        // Since we're either loading or no_data
                        // we loop through the rest of the gridItemsMap to see where our current gridItem should end
                        // if it's the same state (aka no pre-defined gridItem), we keep going until the end of the gridItemsMap
                        while (gridItemsMap[index] === state) {
                            // empty on purpose, just searching through gridItemsMap while incrementing j
                            index++;
                        }
                    }
                    return index;
                };

                var nextGridItemType = function (type){
                    if(type === "pending"){
                        return nextGridItem === LOADING || nextGridItem === NO_DATA || nextGridItem === undefined;
                    }
                    return !nextGridItem || !nextGridItem.hasOwnProperty("type");
                };

                var prepareProgramsLoadingStateGridItemProxy = function (type, state){

                    //if it's a state : this state must be rendered in the grid
                    programsLoadingStateGridItemProxy = new ProgramsLoadingStateGridItemProxy(
                        mathMax(px, 0),
                        gridItemsContainer,
                        gridItemPoolIndex++,
                        state
                    );

                    j = returnNextIndex(j, type, state);
                    nextGridItem = gridItemsMap[j];

                    //if the next item is a STATE or a Program
                    if (nextGridItemType(type)) {
                        px = (j * cellMinWidth) - startX;
                        programsLoadingStateEndX = mathMin(relativeEndX, px);
                    } else {
                        programsLoadingStateEndX = mathMin(relativeEndX, nextGridItem.x - startX);
                    }

                    //call to an utility function that will push a GridItem into the result array
                    renderProgramsLoadingStateGridItemProxy(
                        programsLoadingStateGridItemProxy,
                        result,
                        row,
                        programsLoadingStateEndX
                    );

                    // decrement j so we don't skip an index on next pass
                    j--;
                };

                /*
                    Loop through all the channels and place the programs
                 */

                while (i--) {
                    var row = rows[i];
                    var gridItemsContainer = gridItemsContainersByChannelIndex[row.id];

                    //this value is very important : it allow to return always the same GridItem for STATES objects
                    //if not used a new GridItem and a new Sprite will be created each time we need a STATE object to be rendered
                    var gridItemPoolIndex = 0;

                    if (gridItemsContainer) {

                        //extract the array where all the grid items are stored
                        var gridItemsMap = gridItemsContainer.gridItemsMap;
                        var gridItem;
                        var px = 0;
                        //dynamic grid items : display pending, loading and holes
                        var programsLoadingStateGridItemProxy;

                        //lookup in all cells in the range : startIndex -> endIndex
                        for (j = startIndex; j <= endIndex; j++) {

                            gridItem = gridItemsMap[j];

                            //this is the next item after this state this item will mark the end of the current state
                            var nextGridItem;
                            //this variable will store the end X position of the current state
                            var programsLoadingStateEndX;
                            if (gridItem !== undefined) {

                                //if the cell is not empty, check if it's a program or a loading state
                                //states are LOADING or NO_DATA (1 or 2), programs are GridItem with a 'type' property
                                if (!gridItem.hasOwnProperty("type")) {

                                    prepareProgramsLoadingStateGridItemProxy("loading", gridItem);

                                } else {

                                    //if it's a program
                                    var x = gridItem.x - startX;
                                    px = x + gridItem.width;
                                    x += offsetX;
                                    gridItem.viewportX = x;
                                    gridItem.viewportY = row.viewportStartY;
                                    gridItem.height = row.height;
                                    result.push(gridItem);
                                    //jump to the next index
                                    j = gridItem.endIndex;
                                    //the next 'j' will be 'gridItem.endIndex + 1' : 'j++' in the for loop
                                }

                            } else {

                                //if the cell at index j is undefined : cell is empty AND loading has not started
                                //this is a pending state, so pass PENDING
                                prepareProgramsLoadingStateGridItemProxy("pending", PENDING);

                            }
                        }
                    }
                }
            };
        }


        return function (programGridItemType, programGroupGridItemType, zIndex, xOffset, gridUnitConverter, container, minProgramDurationInMinutes, pixelsPerMinute) {
            return new ProgramGridItemProvider(programGridItemType, programGroupGridItemType, zIndex, xOffset,
                gridUnitConverter, container, minProgramDurationInMinutes, pixelsPerMinute);
        };


    }])
;
angular.module("videotron.illico.epg-grid").factory("ProgramsDataLoader",
    ["$http", "HttpConfigs", "$translate",
        function ($http, HttpConfigs, $translate) {


            function ProgramsDataLoader(basePath) {
                this.load = function (startTime, timeSpan, channelList) {
                    //console.info("programsDataLoader", startTime, timeSpan, channelList)

                    var localeLang = "localeLang=" + $translate.instant('lang');
                    var channelsIdList = "id=" + channelList.join("&id=");
                    var params = "?startTime=" + startTime + "&timeSpan=" + timeSpan + "&" + channelsIdList + "&" + localeLang;
                    var localHttpConfigs = HttpConfigs.getConfigs();
                    // since requests have super precise signatures because of
                    // time and channelsList, use cache for this request
                    var httpConfig = {
                        cache: true
                    };

                    angular.extend(httpConfig, localHttpConfigs);

                    // for debugging see number of ids requested in url
                    //params = "?REQ_LENGTH=" + channelList.length  + startTime + "&" + timeSpan + "&" + channelsIdList + "&" + localeLang;
                    return $http.get(basePath + "/guide/programs" + params, httpConfig).then(
                        function (response){
                            // TODO should we be hydrating response here maybe???
                            return response.data.body.main;
                        }
                    )
                };
            }


            return function (basePath) {
                return new ProgramsDataLoader(basePath);
            };

        }]);
angular.module("videotron.illico.epg-grid").factory("ProgramsLoader",
    ["$rootScope", "Time", "EventDispatcher", "$timeout", "ProgramsDataLoader",
        function ($rootScope, Time, EventDispatcher, $timeout, ProgramsDataLoader) {

        function ProgramsRequest(startTime, endTime, index) {
            this.startTime = startTime;
            this.endTime = endTime;
            this.timeSpan = Time.millisecondsToMinutes(endTime - startTime);
            this.index = index;
            this.channelsCache = [];
            this.channelsQuene = [];
            this.isLoading = false;
            this.canceled = false;
        }


        function ProgramsLoader(basePath, viewport, gridUnitConverter) {
            var LOADING_START = "loading_start";
            var PROGRAMS_LOADED = "programs_loaded";
            var eventDispatcher = new EventDispatcher();
            var programsDataLoader = new ProgramsDataLoader(basePath);
            var programsRequests = [];
            var requestNowExecuting = false;
            var nextProgramsRequestToExecute = [];
            var activeProgramsRequest;
            var oldTotalRows = 0;

            this.addLoadingStartListener = function (listener) {
                return eventDispatcher.addListener(LOADING_START, listener);
            };

            this.addProgramsLoadedListener = function (listener) {
                return eventDispatcher.addListener(PROGRAMS_LOADED, listener);
            };

            function extractRowIds(rows){
                var ids = [];
                var i = rows.length;
                while(i--){
                    ids.push(rows[i].id);
                }
                return ids;
            }

            function generateEmptyServerResponse(programIdList){
                var fakeResponse = [];
                var i = programIdList.length;
                while(i--){
                    fakeResponse.push({channelId: programIdList[i], programs:[]});
                }
                return fakeResponse;
            }

            function executeNextRequests() {
                if (!requestNowExecuting && nextProgramsRequestToExecute && nextProgramsRequestToExecute.length > 0) {
                    var programsRequest;
                    var startTime;
                    var timeSpan;
                    var channelList;
                    var params;
                    var localeLang;

                    // to avoid calling service with no ids, do a little check here
                    if (nextProgramsRequestToExecute[0].channelsQuene.length > 0) {
                        programsRequest = nextProgramsRequestToExecute.shift();
                        activeProgramsRequest = programsRequest;

                        // groups etc don't actually need to be loaded from the server
                        // so we remove them from the queue and move them to the cache here
                        // to avoid an endless loop
                        programsRequest.channelsQuene = $.grep(programsRequest.channelsQuene, function (a) {
                            var isGroup = isNaN(a);
                            if(isGroup){
                                programsRequest.channelsCache.push(a);
                            }
                            return !isGroup;
                        });

                        eventDispatcher.dispatch(
                            LOADING_START,
                            {
                                startTime: programsRequest.startTime,
                                endTime: programsRequest.endTime
                            }
                        );

                        programsRequest.isLoading = true;
                        requestNowExecuting = true;

                        programsDataLoader.load(ENP.customDateFromTs(programsRequest.startTime), programsRequest.timeSpan, programsRequest.channelsQuene).then(function (response) {

                            // timeout here helps while debugging loading programs by slowing everything down
                            // so you can see the loading/pending process more clearly
                            // MAKE SURE THIS IS NEVER UNCOMMENTED IN PRODUCTION
                            //$timeout(function () {
                            if (!activeProgramsRequest.canceled) {
                                eventDispatcher.dispatch(
                                    PROGRAMS_LOADED,
                                    {
                                        programsByChannels: response,
                                        requestStartTime: programsRequest.startTime
                                    }
                                );
                                programsRequest.isLoading = false;
                                requestNowExecuting = false;
                                activeProgramsRequest = null;
                                // update the cache list with loaded channels
                                programsRequest.channelsCache = programsRequest.channelsCache.concat(programsRequest.channelsQuene);
                                // empty the queue
                                programsRequest.channelsQuene = [];

                                //console.log("----> Load done", programsRequest.index, new Date(programsRequest.startTime).toLocaleTimeString(), programsRequest);
                            }
                            executeNextRequests();
                            //}, 1000);   // end of $timeout
                        }, function () {
                            // in case of server error, generate a fake response with no programs to create "holes" in the grid instead of a crash
                            // TODO too much duplication between success and failure
                            console.info("PROGRAMS LOADER ERROR, generating empty cells");
                            eventDispatcher.dispatch(
                                PROGRAMS_LOADED,
                                {
                                    programsByChannels: generateEmptyServerResponse(programsRequest.channelsQuene),
                                    requestStartTime: programsRequest.startTime
                                }
                            );
                            programsRequest.isLoading = false;
                            requestNowExecuting = false;
                            activeProgramsRequest = null;
                            // update the cache list with loaded channels
                            programsRequest.channelsCache = programsRequest.channelsCache.concat(programsRequest.channelsQuene);
                            // empty the queue
                            programsRequest.channelsQuene = [];
//                            console.log("----> Load failed", programsRequest.index, new Date(programsRequest.startTime).toLocaleTimeString(), programsRequest);
                            executeNextRequests();
                        });
                    }
                    // this code force http loading if not in a digest cycle
                    if (!$rootScope.$$phase) {
                        $rootScope.$apply();
                    }
                }
            }

            this.initialize = function (startTime, endTime, stepSize) {
                programsRequests.length = 0;
                if (activeProgramsRequest) {
                    activeProgramsRequest.canceled = true;
                }
                var index = 0;
                for (var i = startTime; i < endTime; i += stepSize) {
                    index = programsRequests.push(new ProgramsRequest(i, i + stepSize, index));
                }
            };


            function hasListChanged(newTotalRows) {
                if (oldTotalRows !== newTotalRows) {
                    oldTotalRows = newTotalRows;
                    return true;
                }
                return false;
            }


            this.update = function (startX, endX, rowsToLoad, newTotalRows, onScreenRows, minQueue, maxQueue) {

                var startTime = gridUnitConverter.pixelToMillisecondsSince1970(startX);
                var endTime = gridUnitConverter.pixelToMillisecondsSince1970(endX);
                var minimumQueueSize = (newTotalRows < minQueue) ? newTotalRows : minQueue;
                var i = programsRequests.length;
                var forceLoad = false;
                var onScreenRowsIds;
                nextProgramsRequestToExecute.length = 0;

                while (i--) {
                    var programsRequest = programsRequests[i];
                    var queue = programsRequest.channelsQuene;
                    var cache = programsRequest.channelsCache;

                    // if we've changed section/tab or we've reached the top or bottom of the scene, force load
                    forceLoad = hasListChanged(newTotalRows);

                    // if we're in the right time frame and not already loading data for this request
                    if (programsRequest && !programsRequest.isLoading && startTime <= programsRequest.endTime && endTime >= programsRequest.startTime) {

                        // extract ids out of onScreenRows
                        onScreenRowsIds = extractRowIds(onScreenRows);

                        // check to see if we've already loaded these channels
                        for (var j = 0, jLength = rowsToLoad.length; j < jLength; j++) {
                            var rowId = rowsToLoad[j];

                            // make sure id isn't already in queue or cache and that we haven't reached maxQueue
                            if (queue.length < maxQueue && queue.indexOf(rowId) === -1 && cache.indexOf(rowId) === -1) {

                                queue.push(rowId);

                                // see what was added to queue
                                //console.log("add to queue", programsRequest.index, forceLoad, new Date(programsRequest.startTime).toLocaleTimeString(), queue);
                            }

                            // if this id is currently on screen and it hasn't already been loaded, forceLoad
                            if (!forceLoad && onScreenRowsIds.indexOf(rowId) !== -1 && cache.indexOf(rowId) === -1) {
                                forceLoad = true;

                                //console.log(">>>>> forceLoad", programsRequest.index, programsRequest.channelsQuene)
                            }
                        }

                        // if forceLoad or queue is longer then minimumQueueSize, add request to queue
                        if (queue.length > 0 && (forceLoad || queue.length >= minimumQueueSize)) {
                            nextProgramsRequestToExecute.push(programsRequest);

                            //console.log("push request", programsRequest.index, programsRequest.channelsQuene, forceLoad, nextProgramsRequestToExecute.length)
                        }
                    }
                }
                executeNextRequests();
            };
        }

        return function (basePath, viewport, gridUnitConverter) {
            return new ProgramsLoader(basePath, viewport, gridUnitConverter);
        };

    }]);
angular.module("videotron.illico.epg-grid").factory("TimeLineCornerPatchProvider",
    ["GridItem", "Sprite", "SpritePool", function (GridItem, Sprite, SpritePool) {

        // Creates the little corner patch that hides the timeline above the channels
        // factory only used to follow other gridItems' pattern, admitteldly a little overkill in this case


        function CornerPatchSpriteFactory(className) {
            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = className;
                return sprite;
            };
        }


        function CornerPatchRenderer() {
            this.render = function (sprite) {
                // nothing to do here since corner patch is empty container
                // but we need renderer to follow pattern
            };
        }


        function TimeLineCornerPatchProvider(zIndex, offsetX, height, GridItem, container, TIMELINE_IS_POSITION_ABSOLUTE) {
            var cornerPatchRenderer = new CornerPatchRenderer();
            var cornerPatchSpritePool = new SpritePool(container, 1, new CornerPatchSpriteFactory("corner-patch"));
            var gridItem;

            gridItem = new GridItem(null, 0, 0, offsetX, height, null, cornerPatchRenderer);
            gridItem.positionAbsolute = TIMELINE_IS_POSITION_ABSOLUTE;
            gridItem.spritePool = cornerPatchSpritePool;
            gridItem.zIndex = zIndex;

            this.findGridItems = function (rows, offsetY, result) {
                gridItem.viewportY = offsetY;
                result.push(gridItem);
            };

        }


        return function (zIndex, offsetX, height, container, TIMELINE_IS_POSITION_ABSOLUTE) {
            return new TimeLineCornerPatchProvider(zIndex, offsetX, height, GridItem, container, TIMELINE_IS_POSITION_ABSOLUTE);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("TimeLineGridItemProvider",
    ["GridItem", "Time", "$filter", "Sprite", "SpritePool",
        function (GridItem, Time, $filter, Sprite, SpritePool) {


        function TimeSpriteFactory(className) {

            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                rootElement.className = className;
                var content = document.createElement("div");
                content.className = "content";
                rootElement.appendChild(content);

                sprite.content = content;

                return sprite;
            };

        }


        function TimeRenderer() {

            this.render = function (sprite, label) {
                sprite.content.textContent = label;
            };

        }


        function TimeLineGridItemProvider(zIndex, offsetX, height, GridItem, Time, gridUnitConverter, container, TIMELINE_IS_POSITION_ABSOLUTE) {
            var timeRenderer = new TimeRenderer();

            var gridItems = [];
            var halfHourSpritePool = new SpritePool(container, 10, new TimeSpriteFactory("time half-hour"));
            var daySpritePool = new SpritePool(container, 1, new TimeSpriteFactory("time day"));
            var dateFilter = $filter("date");


            this.setTimeSpan = function (startTime, endTime) {
                var floor = Math.floor;
                var unit = Time.minutes(30);
                var t = floor((startTime / unit)) * unit;

                var width = gridUnitConverter.millisecondsToPixels(unit);
                var offset = -(width * 0.5);
                gridItems.length = 0;
                while (t < endTime) {
                    var x = gridUnitConverter.millisecondsToSceneXPosition(t) + offset;
                    var date = new Date(t);
                    var gridItem;
                    gridItem = new GridItem(null, x, 0, width, height, null, timeRenderer);
                    gridItem.positionAbsolute = TIMELINE_IS_POSITION_ABSOLUTE;
                    if (date.getHours() + date.getMinutes() === 0) {
                        gridItem.data = dateFilter(date, "vl_short_date_format");
                        gridItem.spritePool = daySpritePool;
                    } else {
                        gridItem.data = dateFilter(date, "shortTime");
                        gridItem.spritePool = halfHourSpritePool;
                    }


                    gridItem.zIndex = zIndex;
                    gridItems.push(gridItem);
                    t += unit;
                }

            };


            this.findGridItems = function (rows, startX, endX, result) {

                var j = gridItems.length;
                while (j--) {
                    var gridItem = gridItems[j];
                    if (gridItem.x <= endX && gridItem.maxX >= startX) {
                        gridItem.viewportX = gridItem.x - startX + offsetX;
                        result.push(gridItem);
                    }
                }

            };

        }


        return function (zIndex, offsetX, height, gridUnitConverter, container, TIMELINE_IS_POSITION_ABSOLUTE) {
            return new TimeLineGridItemProvider(zIndex, offsetX, height, GridItem, Time, gridUnitConverter, container, TIMELINE_IS_POSITION_ABSOLUTE);
        };


    }]);
angular.module("videotron.illico.epg-grid").factory("TimeSpan",
    ["$parse", "EventDispatcher", function ($parse, EventDispatcher) {
        var CHANGE = "change";

        function TimeSpan(scope, startExpression, endExpression, $parse, eventDispatcher) {
            //scope is only used to get data from the 'outside world'
            //there is no data binding here

            var start = $parse(startExpression)(scope);
            var newStart = start;
            var end = $parse(endExpression)(scope);
            var newEnd = end;

            this.update = function () {
                if (start !== newStart || end !== newEnd) {
                    if (newStart > newEnd) {
                        newStart = newEnd;
                    }
                    start = newStart;
                    end = newEnd;



                    eventDispatcher.dispatch(CHANGE);
                }
            };

            this.getStart = function () {
                return start;
            };

            this.getEnd = function () {
                return end;
            };

            this.getDuration = function () {
                return end - start;
            };

            this.addTimeChangeListener = function (listener) {
                return eventDispatcher.addListener(CHANGE, listener);
            };

            scope.$watch(startExpression, function (value) {
                newStart = value;
            });


            scope.$watch(endExpression, function (value) {

                newEnd = value;
            });
        }

        return function (scope, startExpression, endExpression) {
            return new TimeSpan(scope, startExpression, endExpression, $parse,
                new EventDispatcher());
        };


    }]);
angular.module("videotron.illico.epg-grid").service("SrvChannelFilters", [ "$translate", function SrvChannelFilters($translate) {

    // taken from http://tabios.videotron.com/illicoservice/menu/5770
    // this info should come from the backend via http call eventually
    // but since it's hardcoded for now, simplify by keeping only criteria and translating directly since we're not using the rest

    var filters = [
        {
            "key": "isHd",
            "label": $translate.instant("Chaines HD"),
            "value": "true"
        },
        // Currently not activated
        //{
        //    "key": "isUhd",
        //    "label": $translate.instant("Chaines UHD"),
        //    "value": "true"
        //},
        {
            "key": "lang",
            "label": $translate.instant("Chaines francophones"),
            "value": "fr"
        },
        {
            "key": "lang",
            "label": $translate.instant("Chaines anglophones"),
            "value": "en"
        },
        {
            "key": "lang",
            "label": $translate.instant("Chaines internationales"),
            "value": "it"
        },
        {
            "key": "genre",
            "label": $translate.instant("Chaines de nouvelles"),
            "value": "1"
        },
        {
            "key": "genre",
            "label": $translate.instant("Chaines de films"),
            "value": "2"
        },
        {
            "key": "genre",
            "label": $translate.instant("Chaines famille et enfants"),
            "value": "3"
        },
        {
            "key": "genre",
            "label": $translate.instant("Chaines de sports"),
            "value": "4"
        },
        {
            "key": "genre",
            "label": $translate.instant("Chaines de musique"),
            "value": "5"
        },
        {
            "key": "freePreview",
            "label": $translate.instant("Chaines débrouillées"),
            "value": "true"
        }
    ];

    this.getFilters = function () {
        return filters;
    };


}]);
angular.module("videotron.illico.epg-grid").service("SrvFavoriteChannel",
    ["$http", "HttpConfigs", "SERVICES_BASE_PATH", function ($http, HttpConfigs, SERVICES_BASE_PATH) {

        this.updateChannelFavoriteState = function (channel, channelIsFavorite) {
            var result;

            if (channelIsFavorite) {
                result = $http.delete(SERVICES_BASE_PATH + channel.selectionUrl, HttpConfigs.deleteConfigs());
            } else {
                result = $http.put(SERVICES_BASE_PATH + channel.selectionUrl, null, HttpConfigs.putConfigs());
            }
            return result;
        };

    }]);
angular.module("videotron.illico.epg-grid").service("SrvInitializeChannelSorter",
    ["$location", "LocalStorage", function ($location, LocalStorage) {

        function getChannelSorterIndex(channelSortTypes, str){
            var extractedFilterIndex = -1;
            for (var i = 0, count = channelSortTypes.length; i < count; i++) {
                if (str === channelSortTypes[i].type) {
                    extractedFilterIndex = i;
                    break;
                }
            }
            return extractedFilterIndex;
        }

        function extractChannelSorterFromUrl(channelSortTypes){
            var filterRegex = /sortBy=([^&#\?]*)/.exec($location.$$absUrl);
            var extractedIndex = -1;
            if(filterRegex && filterRegex[1]){
                extractedIndex = getChannelSorterIndex(channelSortTypes, filterRegex[1].toUpperCase());
            }
            return extractedIndex;
        }

        function extractChannelSorterFromLocalStorage(channelSortTypes, key){
            var storedChannelSortBy = LocalStorage.get(key);
            var extractedIndex = -1;
            if (storedChannelSortBy) {
                extractedIndex = getChannelSorterIndex(channelSortTypes, storedChannelSortBy.type);
            }
            return extractedIndex;
        }

        function initializeChannelSorter(channelSortTypes, localStorageKey) {
            var index = 0;//index 0 is the default filter : CHANNEL_SORTS.POSITION
            var extractedFromUrl = extractChannelSorterFromUrl(channelSortTypes);
            var extractedFromLocalStorage = extractChannelSorterFromLocalStorage(channelSortTypes, localStorageKey);
            if(extractedFromUrl !== -1){
                index = extractedFromUrl;
            }else if(extractedFromLocalStorage !== -1){
                index = extractedFromLocalStorage;
            }
            return channelSortTypes[index];
        }

        this.getIndex = function (channelSortTypes, localStorageKey) {
            return initializeChannelSorter(channelSortTypes, localStorageKey);
        };

    }]);
angular.module("videotron.illico.epg-grid").service("SrvInitializeMainFilter",
    ["$location", "LocalStorage", "AppConfig", function ($location, LocalStorage, AppConfig) {

        function getMainFilterIndex(mainFilters, str){
            var extractedFilterIndex = -1;
            for (var i = 0, count = mainFilters.length; i < count; i++) {
                if (str === mainFilters[i].id) {
                    extractedFilterIndex = i;
                    break;
                }
            }
            return extractedFilterIndex;
        }

        function extractMainFilterFromUrl(mainFilters){
            var filterRegex = /mainFilter=([^&#\?]*)/.exec($location.$$absUrl);
            var extractedIndex = -1;
            if(filterRegex && filterRegex[1]){
                extractedIndex = getMainFilterIndex(mainFilters, filterRegex[1].toUpperCase());
            }
            return extractedIndex;
        }

        function extractMainFilterFromLocalStorage(mainFilters, key){
            var storedMainFilter = LocalStorage.get(key);
            var extractedIndex = -1;
            if (storedMainFilter) {
                extractedIndex = getMainFilterIndex(mainFilters, storedMainFilter.id);
            }
            return extractedIndex;
        }

        function initializeMainFilter(mainFilters, localStorageKey) {
            var index = 0;//index 0 is the default filter : CHANNEL_MAIN_FILTERS.ALL
            var extractedFromUrl = extractMainFilterFromUrl(mainFilters);
            var extractedFromLocalStorage = extractMainFilterFromLocalStorage(mainFilters, localStorageKey);
            //AppConfig.showChannel() if we must show a channel on start up the main filter must be CHANNEL_MAIN_FILTERS.ALL
            if(!AppConfig.showChannel()){
                if(extractedFromUrl !== -1){
                    index = extractedFromUrl;
                }else if(extractedFromLocalStorage !== -1){
                    index = extractedFromLocalStorage;
                }
            }
            return mainFilters[index];
        }

        this.getIndex = function (mainFilters, localStorageKey) {
            return initializeMainFilter(mainFilters, localStorageKey);
        };

    }]);
angular.module("videotron.illico.pvr-grid").constant("RECORDINGS_CATEGORIES", {
    RECORDED: {name: "recorded"},
    UPCOMING: {name: "upcoming"}
});

angular.module("videotron.illico.pvr-grid").constant("RECORDINGS_SORT", {
    DATE: {
        id: "DATE",
        label: "By date",
        groupBy: "dayAndMonth",
        groupName: "dayAndMonth",
        groupsAreVisible: true,
        sort: function (a, b) {
            return b.startTime - a.startTime;
        }},
    TERMINAL: { id: "TERMINAL",
        label: "By PVR",
        groupBy: "terminalId",
        groupName: "terminalName",
        groupsAreVisible: true,
        sort: function (a, b) {
            if(a.terminalName > b.terminalName){
                return 1;
            }else if(b.terminalName > a.terminalName){
                return -1;
            }else{
                return 0;
            }
        }},
    ALPHABETICAL: { id: "ALPHABETICAL",
        label: "Alphabetically",
        groupBy: "alphabet",
        groupName: "alphabet",
        groupsAreVisible: false,
        sort: function (a, b) {

            // remplace tous les charactere speciaux par des équivalents
            // transforme aussi tous les charactere en minuscule
            var normalizeAccentedChars = (function() {
                var translate_re = /[àâçéèêëîïôûùüÿæœ]/ig;
                var translate = {
                    "à": "a",
                    "â" : "a",
                    "ç" : "c",
                    "é" : "e",
                    "è" : "e",
                    "ê" : "e",
                    "ë" : "e",
                    "î" : "i",
                    "ï" : "i",
                    "ô" : "o",
                    "û" : "u",
                    "ù" : "u",
                    "ü" : "u",
                    "ÿ" : "y",
                    "æ" : "ae",
                    "œ" : "oe"
                };
                return function(s) {
                    // handle recording without a title to avoid crash
                    if(!s){
                        return "undefined";
                    }
                    return ( s.toLowerCase().replace(translate_re, function(match) {
                        return translate[match];
                    }) );
                };
            })();

            // necessaire pour bien trier les minuscules/ majuscule et les accents
            var aTitle = normalizeAccentedChars(a.seriesTitle || a.title);
            var bTitle = normalizeAccentedChars(b.seriesTitle || b.title);

            if (aTitle > bTitle){
                return 1;
            }else if (bTitle > aTitle){
                return -1;
            }else{
                return 0;
            }
        }}
});

angular.module("videotron.illico.pvr-grid").constant("RECORDING_STATE", {
    RECORD_ERROR: "RECORD_ERROR",
    SAVED: "SAVED",
    IN_PROGRESS: "IN_PROGRESS",
    UPCOMING: "UPCOMING"
});

angular.module("videotron.illico.pvr-grid").controller("CtrlPVRGrid",
    ["$scope", "$element", "$attrs", "$parse", "$timeout", "AppConfig", "Viewport", "GridOverview", "Sprite", "GridContainer", "GridRenderer", "RowContainer", "RecordingsDataLoader", "RecordingGridItemProvider", "SeriesGroupGridItemProvider", "SortingGroupTitleGridItemProvider", "LegacyTerminalWarningGridItemProvider", "BooleanObj", "$rootScope", "RecordingsFilterSort", "PvrGridRowsFactory", "Recordings", "LoadingOverlay", "RECORDINGS_CATEGORIES",
        function ($scope, $element, $attrs, $parse, $timeout, AppConfig, Viewport, GridOverview, Sprite, GridContainer, GridRenderer, RowContainer, RecordingsDataLoader, RecordingGridItemProvider, SeriesGroupGridItemProvider, SortingGroupTitleGridItemProvider, LegacyTerminalWarningGridItemProvider, BooleanObj, $rootScope, RecordingsFilterSort, PvrGridRowsFactory, Recordings, LoadingOverlay, RECORDINGS_CATEGORIES) {
            //console.info('CtrlPVRGrid');
            var Z_INDEX_SORTING_GROUP_DELIMITER = 600;
            var Z_INDEX_RECORDING_AND_SERIES_GROUP = 400;
            var Z_INDEX_EPISODES_IN_SERIES = 200;
            var SWIPE_DISTANCE_THRESHOLD = 10;
            var SHOW_SELECT_BUTTONS_CLASS_NAME = "show-select-buttons";
            var RECORD_AND_GROUPED_RECORDS_HEADER_SELECTOR = ".recording, .seriesGroup";
            var SHOW_DELETE_BUTTONS_CLASS_NAME = "show-delete-button";
            var GROUPED_RECORDS_HEADER_CLASS_NAME = "seriesGroup";

            var gConst = AppConfig.getPVRAppConstants();

            // app specific configs here
            var SHOW_LEGACY_TERMINAL_WARNINGS = gConst.SHOW_LEGACY_TERMINAL_WARNINGS;
            var RECORDING_ROW_HEIGHT = gConst.RECORDING_ROW_HEIGHT;
            var SERIES_GROUP_ROW_HEIGHT = gConst.SERIES_GROUP_ROW_HEIGHT;
            var GROUP_DELIMITER_ROW_HEIGHT = gConst.GROUP_DELIMITER_ROW_HEIGHT;
            var FIRST_GROUP_DELIMITER_ROW_HEIGHT = gConst.FIRST_GROUP_DELIMITER_ROW_HEIGHT;
            var RECORDING_ROW_STYLE = gConst.RECORDING_ROW_STYLE;
            var RECORDING_DATE_FORMAT = gConst.RECORDING_DATE_FORMAT;
            var ALLOW_SWIPE_DELETE = gConst.ALLOW_SWIPE_DELETE;
            var ALLOW_LONG_PRESS = gConst.ALLOW_LONG_PRESS;
            var USE_NATIVE_VERTICAL_SCROLL = gConst.USE_NATIVE_VERTICAL_SCROLL;

            $scope.RECORDING_ROW_STYLE = RECORDING_ROW_STYLE;

            var RECORDING_GRID_ITEM_TYPE = {name: "recording"};
            var SORTING_GROUP_GRID_ITEM_TYPE = {name: "sorting_group"};
            var SERIES_GROUP_GRID_ITEM_TYPE = {name: "series_group"};
            var LEGACY_TERMINAL_WARNING_GRID_ITEM_TYPE = {name: "legacy_terminal_warning"};

            var recordings = new Recordings();


            var pvrDataShare = $parse($attrs.pvrDataShare)($scope);
            $scope.pvrDataShare = pvrDataShare;
            //debugger;


            var gridContainerParentId = pvrDataShare.gridContainerParentId || $($element).parent();

            var forceRendering = new BooleanObj();
            var lastRenderedAt;

            var recordingsDataLoader = new RecordingsDataLoader(pvrDataShare.servicesBasePath, pvrDataShare.logoBasePath, pvrDataShare.thumbsBasePath);
            var viewport = new Viewport();
            //gridScroll directive is required by epgGrid directive
            var scrollController = $element.controller("gridScroll");
            //gridClick directive is required by epgGrid directive
            var clickController = $element.controller("gridClick");
            var longPressController = $element.controller("gridLongPress");
            var gridContainer = new GridContainer($element, gridContainerParentId);
            var container = gridContainer.getSprite();
            var rowContainer = new RowContainer();

            // can't figure out why this was called here...
            // removed since it was causing me a problem once anchored to window offset
            // TODO leaving here temporarily in case removing it had unforseen consequences
//            gridContainer.update();

            var recordingGridItemProvider = new RecordingGridItemProvider(RECORDING_GRID_ITEM_TYPE, Z_INDEX_RECORDING_AND_SERIES_GROUP, Z_INDEX_EPISODES_IN_SERIES, container, gridContainer.getWidth(), RECORDING_ROW_STYLE, RECORDING_DATE_FORMAT);
            var seriesGroupGridItemProvider = new SeriesGroupGridItemProvider(SERIES_GROUP_GRID_ITEM_TYPE, Z_INDEX_RECORDING_AND_SERIES_GROUP, container, RECORDING_ROW_STYLE);
            var sortingGroupTitleGridItemProvider = new SortingGroupTitleGridItemProvider(SORTING_GROUP_GRID_ITEM_TYPE, gridContainer.getWidth(), Z_INDEX_SORTING_GROUP_DELIMITER, container, RECORDING_ROW_STYLE);
            var legacyTerminalWarningGridItemProvider = new LegacyTerminalWarningGridItemProvider(LEGACY_TERMINAL_WARNING_GRID_ITEM_TYPE, Z_INDEX_SORTING_GROUP_DELIMITER, container, SHOW_LEGACY_TERMINAL_WARNINGS);
            var gridRenderer = new GridRenderer();
            var recordingsFilterSort = new RecordingsFilterSort();
            var pvrGridRowsFactory = new PvrGridRowsFactory(RECORDING_ROW_HEIGHT, SERIES_GROUP_ROW_HEIGHT, GROUP_DELIMITER_ROW_HEIGHT, FIRST_GROUP_DELIMITER_ROW_HEIGHT);

            function init() {
                viewport.setSceneWidth(gridContainer.getWidth());
                //always re-apply the viewport width when changing the scene width (it may be changed by the bounded range)
                viewport.setWidth(gridContainer.getWidth());
                loadRecordings(false);
                render();
            }

            function gridContainerSizeChange() {
                var containerWidth = gridContainer.getWidth();
                viewport.setSceneWidth(containerWidth);
                viewport.setWidth(containerWidth);
                viewport.setHeight(gridContainer.getCalculatedHeight());
            }

            function gridContainerOffsetChange() {
                viewport.setHeight(gridContainer.getCalculatedHeight());
                viewport.move(0, gridContainer.getScrollDiff());
            }

            function gridItemFinder(posX, posY){
                //use click coordinates and element offset to find gridItem
                var elementOffset = $element.offset();
                var x = posX - elementOffset.left;
                var y = posY - elementOffset.top;
                return gridRenderer.find(x, y);
            }

            function scrollListener(event, data) {

                if (data.scrollY !== 0) {
                    viewport.move(data.scrollX, data.scrollY);
                } else {
                    // IAPPDEV-4052
                    // since the viewport never moves on the x axis but the scrollListener doesn't know that
                    // we resetScrollVelocity to avoid the x axis inertia which will falsely report "wasScrolling"
                    // and cause the clickController to ignore a valid click after a swipe
                    if (data.scrollX !== 0) {
                        scrollController.resetScrollVelocity();
                    }

                    if(ALLOW_SWIPE_DELETE){
                        var gridItem = gridItemFinder(event.touches[0].pageX, event.touches[0].pageY);

                        if (data.scrollX > SWIPE_DISTANCE_THRESHOLD) {
                            handleSwipeLeft(gridItem);
                        } else if (data.scrollX < -SWIPE_DISTANCE_THRESHOLD) {
                            handleSwipeRight(gridItem);
                        }
                    }

                }
            }

            function handleSwipeLeft(gridItem) {
                var recordingAlreadySwiped = $(gridItem.sprite.element).hasClass(SHOW_DELETE_BUTTONS_CLASS_NAME);
                var selectButtonsVisible = $element.hasClass(SHOW_SELECT_BUTTONS_CLASS_NAME);
                var isGroup = $(gridItem.sprite.element).hasClass(GROUPED_RECORDS_HEADER_CLASS_NAME);
                if (!recordingAlreadySwiped && !selectButtonsVisible && !isGroup) {
                    $(gridItem.sprite.element).addClass(SHOW_DELETE_BUTTONS_CLASS_NAME);
                    forceRendering.set(true);
                }


            }

            function handleSwipeRight(gridItem) {
                var recordingAlreadySwiped = $(gridItem.sprite.element).hasClass(SHOW_DELETE_BUTTONS_CLASS_NAME);
                if (recordingAlreadySwiped) {
                    $(gridItem.sprite.element).removeClass(SHOW_DELETE_BUTTONS_CLASS_NAME);
                    forceRendering.set(true);
                }
            }

            function rowContainerHeightChange() {
                viewport.setSceneHeight(rowContainer.getHeight());
                if(USE_NATIVE_VERTICAL_SCROLL){
                    gridContainer.setHeight(rowContainer.getHeight());
                }else{
                    viewport.setHeight(gridContainer.getHeight());
                }
            }


            function recordingsChanged(groupedSortedRecordingsList, moveToTop) {
                var hasLegacyTerminal = pvrDataShare.userHasLegacyTerminals;
                var result = pvrGridRowsFactory.createRowsFromGroups(groupedSortedRecordingsList, recordingGridItemProvider, hasLegacyTerminal);
                seriesGroupGridItemProvider.setGroups(result.seriesGroups);
                sortingGroupTitleGridItemProvider.setSortingGroupDelimiters(result.sortingGroupsHeaders);
                legacyTerminalWarningGridItemProvider.setLegacyTerminalWarning();

                // sorted, filtered and renderer set
                rowContainer.setRows(result.rows);
                pvrDataShare.showMainToolbar = true;

                if (moveToTop === true) {
                    if(USE_NATIVE_VERTICAL_SCROLL){
                        $(window).scrollTop(0);
                    }

                    viewport.setY(0);
                    scrollController.resetScrollVelocity();
                }

                // handle display for empty recording list
                if (groupedSortedRecordingsList && groupedSortedRecordingsList.length > 0) {
                    pvrDataShare.recordingsReturnNoResult = false;
                } else if (groupedSortedRecordingsList && groupedSortedRecordingsList.length === 0) {
                    pvrDataShare.recordingsReturnNoResult = true;
                }

                forceRendering.set(true);
            }



            function emptySelectedRecordingsCollection() {
                pvrDataShare.selectedRecordings = [];
                recordingGridItemProvider.resetSelectedRecordingsGridItems();
                seriesGroupGridItemProvider.resetSelectedSeriesGroupsGridItems();
            }

            function selectRecordingForDeletion(recording, gridItem) {
                var recordingId = recording.recordingId || recording.id;
                var selectedRecordings = pvrDataShare.selectedRecordings;
                var allEpisodesSelected;
                var episodes;

                function areAllEpisodesSelected(episodes){
                    var selectedEpisodes = $.grep(episodes, function(a) {
                        return a.selectedForDeletion;
                    });
                    return selectedEpisodes.length === episodes.length;
                }


                if (recording.isGroup) {
                    episodes = recording.recordings;
                    allEpisodesSelected = areAllEpisodesSelected(episodes);

                    // if all children selected, deselect this and children
                    // else select this and children
                    recording.selectedForDeletion = !allEpisodesSelected;

                    for (var i = 0, iCount = episodes.length; i < iCount; i++) {
                        var episode = recording.recordings[i];
                        var episodeId = episode.recordingId;

                        recordingGridItemProvider.setEpisodeSelectedClass(episodes[i], !allEpisodesSelected);

                        if (allEpisodesSelected) {
                            selectedRecordings.splice(selectedRecordings.indexOf(episodeId), 1);
                        } else {
                            if (selectedRecordings.indexOf(episodeId) === -1) {
                                selectedRecordings.push(episodeId);
                            }
                        }
                    }

                    gridItem.renderer.render(gridItem.sprite, recording);

                } else {
                    if (recording.selectedForDeletion) {
                        selectedRecordings.splice(selectedRecordings.indexOf(recordingId), 1);
                    } else {
                        if (selectedRecordings.indexOf(recordingId) === -1) {
                            selectedRecordings.push(recordingId);
                        }
                    }
                    // toggle boolean
                    recording.selectedForDeletion = !recording.selectedForDeletion;
                    gridItem.renderer.render(gridItem.sprite, recording);

                    if(recording.isChild){
                        var parentGridItem = seriesGroupGridItemProvider.findGridItemById(recording.parentId);
                        parentGridItem.data.selectedForDeletion = areAllEpisodesSelected(parentGridItem.data.recordings);

                        if(parentGridItem.sprite){
                            parentGridItem.renderer.render(parentGridItem.sprite, parentGridItem.data);
                        }
                    }

                }

                pvrDataShare.selectedRecordings = selectedRecordings;
                forceRendering.set(true);
                
                //show/hide delete action button in toolbar

                //IENP-417 - This caused the modify state to close when unchecking last item
                //pvrDataShare.showRecordingsSelection = (pvrDataShare.selectedRecordings.length > 0);
                pvrDataShare.showRecordingsSelection = true;

            }

            function showRecordsSelectionChange(value) {
                $element.find(RECORD_AND_GROUPED_RECORDS_HEADER_SELECTOR).each(function () {
                    angular.element(this).removeClass(SHOW_DELETE_BUTTONS_CLASS_NAME);
                });

                if (value) {
                    $element.addClass(SHOW_SELECT_BUTTONS_CLASS_NAME);
                } else {
                    emptySelectedRecordingsCollection();
                    $element.removeClass(SHOW_SELECT_BUTTONS_CLASS_NAME);
                }
            }


            gridContainer.addSizeChangeListener(gridContainerSizeChange);
            gridContainer.addOffsetChangeListener(gridContainerOffsetChange);
            scrollController.addScrollListener(scrollListener);
            rowContainer.addHeightChangeListener(rowContainerHeightChange);


            $scope.$watch('pvrDataShare.recordingsSortedBy', function (sortBy) {
                recordingsFilterSort.setSortBy(sortBy);
                sortingGroupTitleGridItemProvider.setSortBy(sortBy);
                recordingsChanged(recordingsFilterSort.getGroupedRecordings(recordingGridItemProvider, RECORDING_ROW_STYLE), true);
                forceRendering.set(true);
            });

            $scope.$watch('pvrDataShare.recordingsCategory', function (category) {
                recordingsFilterSort.setCategory(category);
                recordingsChanged(recordingsFilterSort.getGroupedRecordings(recordingGridItemProvider, RECORDING_ROW_STYLE), true);
                forceRendering.set(true);
            });

            $scope.$watch('pvrDataShare.showRecordingsSelection', showRecordsSelectionChange);

            $scope.$on(pvrDataShare.updateRecordingDataEventName, function (event, args) {
                //console.log("updateRecordingDataEventName", event, args);
                // TODO reload terminals here also?
                loadRecordings(args);
            });

            $scope.$on(pvrDataShare.appWakeUpEventName, function () {
//                console.log("pvrDataShare.appWakeUpEventName");
                forceRendering.set(true);
                // used on Android because JS process is killed on device sleep and not auto started on wake up
                // by wrapping it in a timeout, it will only get relauched if needed, because new tablets seem to restart the process automatically

                // see GUS-815
                // need to make sure that the render method isn't already running before launching it again
                // because this will start parallel instances on the render function, causing massive slow downs

                var DELAY = 1000;
                var timeSinceLastRender = new Date() - lastRenderedAt;
                //console.log("wake up! --> " + timeSinceLastRender + " ms since last render");

                $timeout(function(){
                    if(timeSinceLastRender >= DELAY){
                        console.info("run render() after appWakeUp call, it seems to have stopped since it's been more than " + DELAY + "ms since last run");
                        render();
                    }
                }, DELAY);
                // reload recordings also to make sure data is fresh
                loadRecordings(false);
            });



            function loadRecordings(force) {
                //console.log('loadRecordings('+force+')');
                var forceReload = (force === true);

                LoadingOverlay.show();
                //console.log('loadRecordings::show');

                return recordingsDataLoader.load(forceReload).then(function (value) {
                    recordings.setRecordings(value);
                    recordingGridItemProvider.setRecordings(recordings);
                    recordingsFilterSort.setRecordings(recordings);

                    // currently only used in tabdroid, so we test before assigning instead of adding attrs to all platforms
                    if(angular.isDefined(pvrDataShare.recordedRecordCount) && angular.isDefined(pvrDataShare.upcomingRecordCount)){
                        pvrDataShare.recordedRecordCount = recordings.getSavedRecordings().list.length;
                        pvrDataShare.upcomingRecordCount = recordings.getUpcomingRecordings().list.length;
                    }

                    //console.warn("recordingsFilterSort.getGroupedRecordings(recordingGridItemProvider)", recordingsFilterSort.getGroupedRecordings(recordingGridItemProvider))
                    recordingsChanged(recordingsFilterSort.getGroupedRecordings(recordingGridItemProvider, RECORDING_ROW_STYLE), false);

                    forceRendering.set(true);

                    LoadingOverlay.hide();
                    //console.log('loadRecordings::hide');
                });
            }


            if(ALLOW_LONG_PRESS){

                longPressController.addClickListener(function (event, data) {


                    var gridItem = gridItemFinder(data.x, data.y);
                    if (gridItem) {
                        switch (gridItem.type) {
                            case RECORDING_GRID_ITEM_TYPE:
                            case SERIES_GROUP_GRID_ITEM_TYPE:
                                var recording = gridItem.data;
                                //console.log("recording longPress", recording.title);

                                // longpress only assigned in "Recorded" tab, not in "Upcoming"
                                if(pvrDataShare.recordingsCategory === RECORDINGS_CATEGORIES.RECORDED) {

                                    // toggle edit mode
                                    pvrDataShare.recordingLongPress();
                                    // pre-select current recording once in edit mode
                                    selectRecordingForDeletion(recording, gridItem);
                                }

                                //do nothing for upcoming recordings
                                //do nothing for in progress recordings while in the Upcoming tab

                                break;
                            default :
                                // do nothing by default
                                //console.log("default longPress catch", gridItem.type)
                                break;
                        }
                    }

                });
            }

            clickController.addClickListener(function (event, data) {

                var gridItem = gridItemFinder(data.x, data.y);

                // avoid causing click events while grid is moving, allows you to "catch" moving grid
                // avoid causing click events after a longPress event has fired
                if (scrollController.wasScrolling() || longPressController.hasLongPressFired()) {
//                    console.log("wasScrolling or longPress")
                    return;
                }

                if (gridItem) {
                    var currentlyModifyingRecordings = $element.hasClass(SHOW_SELECT_BUTTONS_CLASS_NAME);
                    var currentItemDeleteButtonVisible = $(gridItem.sprite.element).hasClass(SHOW_DELETE_BUTTONS_CLASS_NAME);
                    switch (gridItem.type) {
                        case RECORDING_GRID_ITEM_TYPE:
                            var recording = gridItem.data;
                            if (currentlyModifyingRecordings || data.target.closest(".select-button").size() > 0) {
                                selectRecordingForDeletion(recording, gridItem);
                            }else if (data.target.closest(".delete-icon").size() > 0) {
                                pvrDataShare.deleteRecord(recording);
                            } else if (currentItemDeleteButtonVisible) {
                                if (data.target.closest(".delete-button").size() > 0) {
//                                    console.log("delete", recording.recordingId, data.target.closest(".delete-button").size())
                                    pvrDataShare.deleteRecord(recording);
                                }
                            } else if (recording.provider && data.target.closest(".channel").size() > 0) {
//                                console.log("provider", data.target.closest(".channel").size());
                                pvrDataShare.programOrChannelClick(recording.provider);
                            } else {
//                                console.log("recording");
                                pvrDataShare.programOrChannelClick(recording);
                            }
                            break;
                        case SORTING_GROUP_GRID_ITEM_TYPE:
                            if (currentlyModifyingRecordings) {
                                // currently only terminals have sorting groups while in edit mode
                                // might need to test this further in the future
                                pvrDataShare.editTerminalName();
                            }
                            break;
                        case SERIES_GROUP_GRID_ITEM_TYPE:
                            var series_group = gridItem.data;
                            if (currentlyModifyingRecordings || data.target.closest(".select-button").size() > 0) {
                                selectRecordingForDeletion(series_group, gridItem);
                            } else {
                                rowContainer.toggleChildrenVisibility(series_group.id, series_group.recordings, function () {
                                    forceRendering.set(true);
                                });
                                seriesGroupGridItemProvider.toggleShowEpisodes(series_group, rowContainer.getRowVisibilityById(series_group.recordings[0].recordingId));
                            }
                            break;
                        case LEGACY_TERMINAL_WARNING_GRID_ITEM_TYPE:
                            $scope.helpMissingTerminal();
                            break;
                        default :
//                            console.log("default click catch", gridItem.type)
                            break;
                    }
                }

            });

            // variables for render loop outside to avoid too many instantiations
            var floor = Math.floor;
            var rows = [];
            var gridItems = [];
            var startX;
            var endX;
            var startY;
            var endY;

            //// for debugging only
            //var logCounter = 0;
            //var logTimer = new Date();
            //function logEveryNthTime(n, msg){
            //    var totalTime = msg - logTimer;
            //    if(logCounter >= n){
            //        console.info(n + "th! | Total time : " + totalTime + "ms | Average of " + (totalTime)/n + " ms each run" );
            //        logCounter = 0;
            //        logTimer = new Date();
            //    }else{
            //        logCounter++;
            //    }
            //}


            function render() {
                requestAnimationFrame(render);
                lastRenderedAt = new Date();
                //logEveryNthTime(60, lastRenderedAt);

                //TODO stop the rendering loops when nothing change ?

                gridContainer.update();
                scrollController.update();
                rowContainer.update();
                if (viewport.update() || forceRendering.isTrue()) {
                    startX = floor(viewport.getX());
                    endX = floor(startX + viewport.getWidth());
                    startY = floor(viewport.getY());
                    endY = floor(startY + viewport.getHeight());

                    gridItems.length = 0;

                    rows = rowContainer.findRows(startY, endY, USE_NATIVE_VERTICAL_SCROLL);

                    recordingGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    seriesGroupGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    sortingGroupTitleGridItemProvider.findGridItems(rows, startX, endX, gridItems);
                    legacyTerminalWarningGridItemProvider.findGridItems(rows, startX, endX, gridItems);

                    gridRenderer.render(gridItems);


                    // for debugging, see commented code for gridOverview below
//                    gridOverview.render();


                }
                forceRendering.reset();
            }



            init();


//             //CODE FOR THE GRID OVERVIEW : DISPLAY A SCALED GRID AND VIEWPORT (useful for debugging)
//             var gridOverview = new GridOverview(viewport, 0.005);
//             gridOverview.addMoveToListener(function (event, position) {
//             viewport.setX(position.x);
//             viewport.setY(position.y);
//             });
//             container.append(gridOverview.getSprite());



        }]);

angular.module("videotron.illico.pvr-grid").directive("pvrGrid", function () {

    return {
        restrict: "A",
        controller: "CtrlPVRGrid",
        require: ["^gridScroll", "^gridClick", "^gridLongPress"],
        template: "<div class='pvr'></div>",
        replace: true
    };

});

angular.module("videotron.illico.pvr-grid").factory("GroupedRecordedSeries", function () {


    function GroupedRecordedSeries(groupId, firstRecording) {

        this.alphabet = firstRecording.alphabet;
        this.channelId = null;
        this.channelLogo = null;
        this.channelPosition = null;
        this.definition = firstRecording.definition;
        this.definitionClassName = firstRecording.definitionClassName;
        this.episodesCount = null;
        this.extractViewedStatusIcon = null;
        this.id = groupId;
        this.image = null;
        this.isGroup = true;
        this.isGroupOpen = false;
        this.fallbackSrc = null;
        this.recordings = [firstRecording]
        this.selectedForDeletion = false;
        this.seriesTitle = null;
        this.status = null;
        this.terminalName = firstRecording.terminalName;
        this.terminalId = firstRecording.terminalId;

    }

    return function (groupId, firstRecording) {
        return new GroupedRecordedSeries(groupId, firstRecording);
    };

});

angular.module("videotron.illico.pvr-grid").factory("GroupedSortedRecordings", function () {


    function GroupedSortedRecordings(id, name, visible, recordings) {

        this.id = id;
        this.name = name;
        this.visible = visible;
        this.recordings = recordings;

    }

    return function (id, name, visible, records) {
        return new GroupedSortedRecordings(id, name, visible, records);
    };

});
angular.module("videotron.illico.pvr-grid").factory("LegacyTerminalWarningGridItemProvider",
    ["GridItem", "Sprite", "SpritePool", "$translate", function (GridItem, Sprite, SpritePool, $translate) {


        function LegacyTerminalWarningSpriteFactory() {
            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;

                var content = document.createElement("div");
                content.id = "missing-terminal";
                rootElement.appendChild(content);

                var title = document.createElement("h1");
                content.appendChild(title);

                var paragraph_1 = document.createElement("p");
                content.appendChild(paragraph_1);

                var paragraph_2 = document.createElement("p");
                content.appendChild(paragraph_2);

                var link = document.createElement("a");
                paragraph_2.appendChild(link);

                sprite.title = title;
                sprite.paragraph_1 = paragraph_1;
                sprite.link = link;
                return sprite;
            };

        }

        function LegacyTerminalWarningRenderer() {
            this.render = function (sprite, legacyTerminals) {
                sprite.title.textContent = $translate.instant("Where are my other terminals");
                sprite.paragraph_1.textContent = $translate.instant("Only illico TV new generation terminals");
                sprite.link.textContent = $translate.instant("Learn more");
            };
        }


        function LegacyTerminalWarningGridItemProvider(gridItemType, zIndex, container, SHOW_LEGACY_TERMINAL_WARNINGS) {

            var gridItemsByLegacyTerminalWarningId = {};
            var renderer = new LegacyTerminalWarningRenderer();

            var LegacyTerminalWarningSpritePool = new SpritePool(container, 2,
                new LegacyTerminalWarningSpriteFactory());

            this.setLegacyTerminalWarning = function () {
                if(!SHOW_LEGACY_TERMINAL_WARNINGS){
                    return;
                }
                var legacyTerminalWarning = {id:"legacyTerminalWarning"};
                var gridItem = new GridItem(gridItemType, 0, 0, 0, 0, legacyTerminalWarning, renderer);
                gridItem.zIndex = zIndex;
                gridItem.spritePool = LegacyTerminalWarningSpritePool;
                gridItemsByLegacyTerminalWarningId[legacyTerminalWarning.id] = gridItem;
            };


            this.findGridItems = function (rows, startX, endX, result) {
                if(!SHOW_LEGACY_TERMINAL_WARNINGS){
                    return;
                }
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    var gridItem = gridItemsByLegacyTerminalWarningId[row.id];
                    if (gridItem) {
                        gridItem.viewportX = 0;
                        gridItem.viewportY = row.viewportStartY;
                        gridItem.height = row.height;
                        gridItem.width = endX - startX;
                        result.push(gridItem);
                    }
                }
            };
        }

        return function (gridItemType, zIndex, container, SHOW_LEGACY_TERMINAL_WARNINGS) {
            return new LegacyTerminalWarningGridItemProvider(gridItemType, zIndex, container, SHOW_LEGACY_TERMINAL_WARNINGS);
        };

    }]);

angular.module("videotron.illico.pvr-grid").factory("ModalSortBy",
    ["$templateCache", "$compile", "$rootScope", "SimpleModal", "SrvModalTemplateLoader", "AppConfig", "$window",
        function ($templateCache, $compile, $rootScope, SimpleModal, SrvModalTemplateLoader, AppConfig, $window) {

        function ModalSortBy(template, modalOptions) {
            var templateString;
            var customModalOptions = modalOptions || {};
            var simpleModal = new SimpleModal();
            var APP_CONST = AppConfig.getPVRAppConstants();
            SrvModalTemplateLoader.load(template).then(function(result){
                templateString = result;
            });

            function triggerClose(){
                if(APP_CONST.MODALS_TRIGGERED_BY_ROUTE_CHANGE){
                    $window.history.back();
                }else{
                    simpleModal.close();
                }
            }

            this.show = function (recordingsSortableBy, recordingsSortedBy, yesCallback, noCallback) {
                var scope = $rootScope.$new(true);
                var defaultModalOptions = {
                    opacity: 90
                };
                var modalOptions = $.extend(defaultModalOptions, customModalOptions);

                scope.filters = recordingsSortableBy;
                scope.recordingsSortedBy = recordingsSortedBy;

                scope.updateSortedBy = function (filter) {
                    simpleModal.close();
                    if (angular.isFunction(yesCallback)) {
                        yesCallback.call(null, filter);
                    }
                };

                scope.close = function () {
                    simpleModal.close();
                    if (angular.isFunction(noCallback)) {
                        noCallback.call(null);
                    }
                };



                var element = SrvModalTemplateLoader.compile(templateString, scope);
                simpleModal.show(element, modalOptions, function close() {
                    triggerClose();
                    scope.$destroy();
                });

            };

            this.hide = function(){
                simpleModal.close();
            };

        }


        return function (templateId, modalOptions) {
            return new ModalSortBy(templateId, modalOptions);
        };


    }]);
angular.module("videotron.illico.pvr-grid").factory("PvrGridRowsFactory",
    [ "Row", function (Row) {


        function PvrGridRowsFactory(recordingRowHeight, seriesGroupRowHeight, sortingGroupHeaderRowHeight, firstSortingGroupHeaderRowHeight) {

            function createRows(recordings, rows, seriesGroups, recordingGridItemProvider) {

                //console.log("createRows", recordings.length)

                for (var i = 0, count = recordings.length; i < count; i++) {
                    var recording = recordings[i];
                    var episodes = recording.recordings || [];
                    //console.warn(i, (recording.title || recording.seriesTitle), recording.isGroup, episodes.length > 1)
                    if (recording.isGroup && episodes.length > 1) {
                        // add to seriesGroups
                        seriesGroups.push(recording);
                        // add group to rows
                        rows.push(new Row(recording.id, seriesGroupRowHeight, true));

                        for(var j = 0; j < episodes.length; j++){
                            // add hidden recordings to rows
                            //console.log("episodes", episodes[j].recordingId, episodes[j])
                            recordingGridItemProvider.makeRecordingAnEpisode(episodes[j], recording);
                            rows.push(new Row(episodes[j].recordingId, recordingRowHeight, false));
                        }

                    } else {

                        //console.log("recording", recording.title || recording.seriesTitle)
//                        console.log("recordingId", recording.recordingId, recording)
                        rows.push(new Row(recording.recordingId, recordingRowHeight, true));
                    }
                }

            }


            function createGroupHeader(title, rows, groupHeaders, isFirstGroup) {
                var groupHeader = {
                    id: title
                };
                var thisGroupHeight = (isFirstGroup) ? firstSortingGroupHeaderRowHeight : sortingGroupHeaderRowHeight;

                rows.push(new Row(title, thisGroupHeight, true));
                groupHeaders.push(groupHeader);

            }


            function createLegacyTerminalWarning(rows) {
                rows.push(new Row("legacyTerminalWarning", seriesGroupRowHeight, true));

            }


            this.createRowsFromGroups = function (groupedSortedRecordingsList, recordingGridItemProvider, hasLegacyTerminal) {
                var rows = [];
                var seriesGroups = [];
                var sortingGroupsHeaders = [];

                groupedSortedRecordingsList = groupedSortedRecordingsList || [];

                for (var i = 0, count = groupedSortedRecordingsList.length; i < count; i++) {
                    var sortedRecordingsGroup = groupedSortedRecordingsList[i];
                    var recordings = sortedRecordingsGroup.recordings;
                    var isFirstGroup = false;

                    if (recordings && recordings.length > 0){
                        if(sortedRecordingsGroup.visible && sortedRecordingsGroup.name){
                            isFirstGroup = sortingGroupsHeaders.length === 0;
                            createGroupHeader(sortedRecordingsGroup.name, rows, sortingGroupsHeaders, isFirstGroup);

                        }
                        createRows(recordings, rows, seriesGroups, recordingGridItemProvider);
                    }

                }

                if(hasLegacyTerminal && rows.length !== 0){
                    createLegacyTerminalWarning(rows);
                }

                return {rows: rows, seriesGroups: seriesGroups, sortingGroupsHeaders: sortingGroupsHeaders, total: rows.length + seriesGroups.length + sortingGroupsHeaders.length};
            };


        }


        return function (recordingRowHeight, seriesGroupRowHeight, sortingGroupHeaderRowHeight, firstSortingGroupHeaderRowHeight) {
            return new PvrGridRowsFactory(recordingRowHeight, seriesGroupRowHeight, sortingGroupHeaderRowHeight, firstSortingGroupHeaderRowHeight);
        };

    }]);

angular.module("videotron.illico.pvr-grid").factory("RecordingGridItemProvider",
    ["GridItem", "Value", "SpritePool", "Sprite", "RECORDING_STATE", "$translate",
        function (GridItem, Value, SpritePool, Sprite, RECORDING_STATE, $translate) {


            function RecordingSpriteFactory_web() {


                this.create = function () {
                    var sprite = new Sprite();
                    var rootElement = sprite.element;


                    var recordingContent = document.createElement("div");
                    recordingContent.className = "row-content";
                    rootElement.appendChild(recordingContent);

                    // LEFT COL
                    var leftCol = document.createElement("div");
                    leftCol.className = "column left";
                    recordingContent.appendChild(leftCol);

                    // CHECK BOX
                    var checkBox = document.createElement("div");
                    checkBox.className = "select-button";
                    leftCol.appendChild(checkBox);

                    // DELETE ICON
                    var deleteIcon = document.createElement("div");
                    deleteIcon.className = "delete-icon";
                    leftCol.appendChild(deleteIcon);

                    var thumb = document.createElement("div");
                    thumb.className = "thumbnail";
                    leftCol.appendChild(thumb);

                    var thumbImage = document.createElement("img");
                    thumb.appendChild(thumbImage);

                    var thumbIconsContainer = document.createElement("div");
                    thumbIconsContainer.className = "icons-container";
                    thumb.appendChild(thumbIconsContainer);

                    var thumbIcons1 = document.createElement("i");
                    thumbIconsContainer.appendChild(thumbIcons1);

                    var thumbIcons2 = document.createElement("i");
                    thumbIconsContainer.appendChild(thumbIcons2);

                    var thumbIcons3 = document.createElement("i");
                    thumbIconsContainer.appendChild(thumbIcons3);

                    // CENTER COL
                    var centerCol = document.createElement("ul");
                    centerCol.className = "column center";
                    recordingContent.appendChild(centerCol);

                    var titleOuter = document.createElement("li");
                    titleOuter.className = "title";
                    centerCol.appendChild(titleOuter);

                    var title = document.createElement("span");
                    titleOuter.appendChild(title);

                    var viewingStatusIcon = document.createElement("i");
                    titleOuter.appendChild(viewingStatusIcon);

                    var duration = document.createElement("li");
                    duration.className = "duration";
                    centerCol.appendChild(duration);

                    var info = document.createElement("li");
                    info.className = "info";
                    centerCol.appendChild(info);

                    var date = document.createElement("span");
                    info.appendChild(date);

                    var splitter = document.createElement("span");
                    splitter.className = "splitter"
                    splitter.textContent = " | "
                    info.appendChild(splitter);

                    var startToEnd = document.createElement("span");
                    info.appendChild(startToEnd);

                    var splitter2 = document.createElement("span");
                    splitter2.className = "splitter"
                    splitter2.textContent = " | "
                    info.appendChild(splitter2);

                    var terminalName = document.createElement("span");
                    info.appendChild(terminalName);

                    var warning = document.createElement("li");
                    warning.className = "warning";
                    centerCol.appendChild(warning);

                    // RIGHT COL
                    var rightCol = document.createElement("div");
                    rightCol.className = "column right";
                    recordingContent.appendChild(rightCol);

                    var channel = document.createElement("div");
                    channel.className = "channel";
                    rightCol.appendChild(channel);

                    var innerChannel = document.createElement("div");
                    channel.appendChild(innerChannel);

                    var channelLogo = document.createElement("img");
                    innerChannel.appendChild(channelLogo);

                    var channelPosition = document.createElement("p");
                    channel.appendChild(channelPosition);

                    var channelPositionInner = document.createElement("span");
                    channelPosition.appendChild(channelPositionInner);

                    // DELETE
                    var deleteButton = document.createElement("div");
                    deleteButton.className = "delete-button";
                    rootElement.appendChild(deleteButton);

                    var deleteText = document.createElement("span");
                    deleteButton.appendChild(deleteText);

                    sprite.thumb = thumbImage;
                    sprite.thumbIcons1 = thumbIcons1;
                    sprite.thumbIcons2 = thumbIcons2;
                    sprite.thumbIcons3 = thumbIcons3;
                    sprite.title = title;
                    sprite.viewingStatusIcon = viewingStatusIcon;
                    sprite.duration = duration;
                    sprite.date = date;
                    sprite.startToEnd = startToEnd;
                    sprite.terminalName = terminalName;
                    sprite.warning = warning;
                    sprite.positions = channelPositionInner;
                    sprite.logo = channelLogo;
                    sprite.deleteText = deleteText;

                    return sprite;
                };


            }

            //for tablets
            function RecordingSpriteFactory_tablet() {


                this.create = function () {
                    var sprite = new Sprite();
                    var rootElement = sprite.element;

                    var recordingWrapper = document.createElement("div");
                    recordingWrapper.className = "row-wrapper";
                    rootElement.appendChild(recordingWrapper);

                    // CHECK BOX
                    var checkBox = document.createElement("div");
                    checkBox.className = "select-button";
                    recordingWrapper.appendChild(checkBox);

                    var recordingContent = document.createElement("div");
                    recordingContent.className = "row-content";
                    recordingWrapper.appendChild(recordingContent);

                    // LEFT COL
                    var leftCol = document.createElement("div");
                    leftCol.className = "column left";
                    recordingContent.appendChild(leftCol);

                    var thumb = document.createElement("div");
                    thumb.className = "thumbnail";
                    leftCol.appendChild(thumb);

                    var thumbImage = document.createElement("img");
                    thumb.appendChild(thumbImage);

                    var thumbIconsContainer = document.createElement("div");
                    thumbIconsContainer.className = "icons-container";
                    thumb.appendChild(thumbIconsContainer);

                    var thumbIcons1 = document.createElement("i");
                    thumbIconsContainer.appendChild(thumbIcons1);

                    var recordingInProgressIcon = document.createElement("i");
                    thumbIconsContainer.appendChild(recordingInProgressIcon);

                    // CENTER COL
                    var centerCol = document.createElement("ul");
                    centerCol.className = "column center";
                    recordingContent.appendChild(centerCol);

                    var titleOuter = document.createElement("li");
                    titleOuter.className = "title";
                    centerCol.appendChild(titleOuter);

                    var viewingStatusIcon = document.createElement("i");
                    titleOuter.appendChild(viewingStatusIcon);

                    var title = document.createElement("span");
                    titleOuter.appendChild(title);

                    var repeatIcon = document.createElement("i");
                    titleOuter.appendChild(repeatIcon);

                    var info = document.createElement("li");
                    info.className = "info";
                    centerCol.appendChild(info);

                    var date = document.createElement("span");
                    info.appendChild(date);

                    var splitter = document.createElement("span");
                    splitter.className = "splitter"
                    splitter.textContent = " | "
                    info.appendChild(splitter);

                    var duration = document.createElement("span");
                    info.appendChild(duration);

                    var splitter2 = document.createElement("span");
                    splitter2.className = "splitter"
                    splitter2.textContent = " | "
                    info.appendChild(splitter2);

                    var terminalName = document.createElement("span");
                    info.appendChild(terminalName);

                    var warning = document.createElement("li");
                    warning.className = "warning";
                    centerCol.appendChild(warning);

                    // RIGHT COL
                    var rightCol = document.createElement("div");
                    rightCol.className = "column right";
                    recordingContent.appendChild(rightCol);

                    var channel = document.createElement("div");
                    channel.className = "channel";
                    rightCol.appendChild(channel);

                    var innerChannel = document.createElement("div");
                    channel.appendChild(innerChannel);

                    var channelLogo = document.createElement("img");
                    innerChannel.appendChild(channelLogo);

                    var channelPosition = document.createElement("p");
                    channel.appendChild(channelPosition);

                    var channelPositionInner = document.createElement("span");
                    channelPosition.appendChild(channelPositionInner);

                    // DELETE
                    var deleteButton = document.createElement("div");
                    deleteButton.className = "delete-button";
                    rootElement.appendChild(deleteButton);

                    var deleteText = document.createElement("span");
                    deleteButton.appendChild(deleteText);

                    sprite.thumb = thumbImage;
                    sprite.recordingInProgressIcon = recordingInProgressIcon;
                    sprite.thumbIcons1 = thumbIcons1;
                    sprite.viewingStatusIcon = viewingStatusIcon;
                    sprite.title = title;
                    sprite.repeatIcon = repeatIcon;
                    sprite.date = date;
                    sprite.duration = duration;
                    sprite.terminalName = terminalName;
                    sprite.warning = warning;
                    sprite.positions = channelPositionInner;
                    sprite.logo = channelLogo;
                    sprite.deleteText = deleteText;

                    return sprite;
                };


            }


            function RecordingSpriteFactory_mobile() {


                this.create = function () {
                    var sprite = new Sprite();
                    var rootElement = sprite.element;

                    var recordingWrapper = document.createElement("div");
                    recordingWrapper.className = "row-wrapper";
                    rootElement.appendChild(recordingWrapper);

                    // CHECK BOX
                    var checkBox = document.createElement("div");
                    checkBox.className = "select-button";
                    recordingWrapper.appendChild(checkBox);

                    var recordingContent = document.createElement("div");
                    recordingContent.className = "row-content";
                    recordingWrapper.appendChild(recordingContent);

                    // LEFT COL
                    var leftCol = document.createElement("div");
                    leftCol.className = "column left";
                    recordingContent.appendChild(leftCol);

                    var thumb = document.createElement("div");
                    thumb.className = "thumbnail";
                    leftCol.appendChild(thumb);

                    var thumbImage = document.createElement("img");
                    thumb.appendChild(thumbImage);

                    var thumbIconsContainer = document.createElement("div");
                    thumbIconsContainer.className = "icons-container";
                    thumb.appendChild(thumbIconsContainer);

                    var recordingInProgressIcon = document.createElement("i");
                    thumbIconsContainer.appendChild(recordingInProgressIcon);


                    // CENTER COL
                    var centerCol = document.createElement("ul");
                    centerCol.className = "column center";
                    recordingContent.appendChild(centerCol);

                    var titleOuter = document.createElement("li");
                    titleOuter.className = "title";
                    centerCol.appendChild(titleOuter);

                    var viewingStatusIcon = document.createElement("i");
                    titleOuter.appendChild(viewingStatusIcon);

                    var title = document.createElement("span");
                    titleOuter.appendChild(title);

                    var channelName = document.createElement("li");
                    channelName.className = "channelName";
                    centerCol.appendChild(channelName);

                    var info = document.createElement("li");
                    info.className = "info";
                    centerCol.appendChild(info);

                    var date = document.createElement("span");
                    info.appendChild(date);

                    var splitter = document.createElement("span");
                    splitter.className = "splitter";
                    splitter.textContent = " | ";
                    info.appendChild(splitter);

                    var duration = document.createElement("span");
                    info.appendChild(duration);

                    var splitter2 = document.createElement("span");
                    splitter2.className = "splitter";
                    splitter2.textContent = " | ";
                    info.appendChild(splitter2);

                    var terminalName = document.createElement("span");
                    info.appendChild(terminalName);

                    var warning = document.createElement("li");
                    warning.className = "warning";
                    centerCol.appendChild(warning);

                    // RIGHT COL
                    var rightCol = document.createElement("div");
                    rightCol.className = "column right";
                    recordingContent.appendChild(rightCol);

                    var repeatIconContainer = document.createElement("div");
                    repeatIconContainer.className = "icons-container";
                    rightCol.appendChild(repeatIconContainer);

                    var repeatIcon = document.createElement("i");
                    repeatIconContainer.appendChild(repeatIcon);

                    // DELETE
                    var deleteButton = document.createElement("div");
                    deleteButton.className = "delete-button";
                    rootElement.appendChild(deleteButton);

                    var deleteText = document.createElement("span");
                    deleteButton.appendChild(deleteText);

                    sprite.thumb = thumbImage;
                    sprite.recordingInProgressIcon = recordingInProgressIcon;
                    sprite.viewingStatusIcon = viewingStatusIcon;
                    sprite.title = title;
                    sprite.channelName = channelName;
                    sprite.date = date;
                    sprite.duration = duration;
                    sprite.terminalName = terminalName;
                    sprite.warning = warning;
                    sprite.repeatIcon = repeatIcon;
                    sprite.deleteText = deleteText;

                    return sprite;
                };


            }


            // heavily inspired by fallbackSrc directive,
            // but since gridItems aren't parsed by Angular for performance reasons,
            // vanilla implementation here
            function replaceSrcWithFallbackSrc() {
                // first make sure we haven't already switched the src
                // this avoids endless calls if fallback image returns a 404
                if(this.dataset.fallbackSrc && this.src !== this.dataset.fallbackSrc){
                    //console.error("use fallback image - recording", this.src);
                    this.src = this.dataset.fallbackSrc;
                }
            }

            function RecordingRenderer(className, dateFormat, recordingRowStyle) {

                this.render = function (sprite, recording) {

                    var selectedClass = (recording.selectedForDeletion) ? " selected" : "";
                    var childClass = (recording.isChild) ? " episode" : "";
                    var recordingInProgress = (recording.status === RECORDING_STATE.IN_PROGRESS);

                    switch(recordingRowStyle){
                        case "tablet":
                        case "mobile":
                            sprite.recordingInProgressIcon.className = (recordingInProgress) ? "icon recordingInProgress" : "";
                            if(sprite.channelName){
                                sprite.channelName.textContent = recording.channelName;
                            }
                            break;
                        case "web":
                        default:
                            sprite.startToEnd.textContent = recording.startToEnd;
                            sprite.thumbIcons2.className = (recordingInProgress) ? "icon rec" : "";
                            break;
                    }

                    // these sprites don't exist in _small factory
                    if(sprite.thumb){
                        sprite.thumb.src = recording.image;
                        sprite.thumb.dataset.fallbackSrc = recording.fallbackSrc;
                        sprite.thumb.onerror = replaceSrcWithFallbackSrc
                    }
                    if(sprite.thumbIcons1){
                        sprite.thumbIcons1.className = (recording.status === RECORDING_STATE.RECORD_ERROR) ? "icon alert" : "";
                    }


                    // thumbIcons3 is set later, once groups are built
                    //sprite.thumbIcons3.className = (recording.isChild) ? "icon group-child" : "";
                    
					// only children of a grouped series (episodes) should show titles, everything else should show series title, unless it's undefined
					sprite.title.textContent = (!recording.isChild && recording.seriesTitle) ? recording.seriesTitle : recording.title;


                    sprite.viewingStatusIcon.className = (recording.statusIcon !== "icon repeated") ? recording.statusIcon : "";

                    if(sprite.repeatIcon){
                        sprite.repeatIcon.className = (recording.statusIcon === "icon repeated") ? recording.statusIcon : "";
                    }

                    if(sprite.duration){
                        sprite.duration.textContent = recording.duration;
                    }
                    sprite.date.textContent = recording[dateFormat];
                    sprite.terminalName.textContent = recording.terminalName;
                    sprite.warning.textContent = (recording.status === RECORDING_STATE.RECORD_ERROR && recording.statusMessage) ? recording.statusMessage : "";
                    if(sprite.positions){
                        //console.error("recording.definition", recording.definition)
                        sprite.positions.className = (typeof recording.definition === "string") ? recording.definition.toLowerCase() : "";
                        sprite.positions.textContent = recording.channelPosition;
                    }
                    if(sprite.logo){
                        sprite.logo.src = recording.logo;
                    }
                    sprite.deleteText.textContent = (recording.status === RECORDING_STATE.IN_PROGRESS) ? $translate.instant("Stop") : $translate.instant("Delete");
                    sprite.setClass(className + selectedClass + childClass);
                };
            }


            function RecordingGridItemProvider(gridItemType, recordingZIndex, episodeZIndex, container, containerWidth, recordingRowStyle, RECORDING_DATE_FORMAT, GridItem) {
                var RECORDING_CLASS_NAME = "recording";
                var UPCOMING_RECORDING_CLASS_NAME = RECORDING_CLASS_NAME + " upcoming";
                var IN_PROGRESS_RECORDING_CLASS_NAME = RECORDING_CLASS_NAME + " in-progress";

                var SpriteFactory;
                switch(recordingRowStyle){
                    case "web": SpriteFactory = RecordingSpriteFactory_web; break;
                    case "tablet": SpriteFactory = RecordingSpriteFactory_tablet; break;
                    case "mobile": SpriteFactory = RecordingSpriteFactory_mobile; break;
                }

                var dateFormat = (RECORDING_DATE_FORMAT === "short") ? "dayAndMonthShort" : "dayAndMonth";

                var recordingSpritePool = new SpritePool(container, 10, new SpriteFactory());

                var savedRecordingsRenderer = new RecordingRenderer(RECORDING_CLASS_NAME, dateFormat, recordingRowStyle);
                var upcomingRecordingsRenderer = new RecordingRenderer(UPCOMING_RECORDING_CLASS_NAME, dateFormat, recordingRowStyle);
                var inProgressRecordingsRenderer = new RecordingRenderer(IN_PROGRESS_RECORDING_CLASS_NAME, dateFormat, recordingRowStyle);
                var gridItemsByRecordingId = {};

                this.setRecordings = function (recordings) {
                    recordings = recordings.getAllRecordings();
                    var i = recordings.length;
                    while (i--) {
                        var recording = recordings[i];
                        var gridItem;
                        //console.log(recording)
                        switch (recording.status) {
                            case RECORDING_STATE.UPCOMING:
                                gridItem = new GridItem(gridItemType, 0, 0, containerWidth, 0, recording, upcomingRecordingsRenderer);
                                break;
                            case RECORDING_STATE.IN_PROGRESS:
                                gridItem = new GridItem(gridItemType, 0, 0, containerWidth, 0, recording, inProgressRecordingsRenderer);
                                break;
                            case RECORDING_STATE.RECORD_ERROR:
                            case RECORDING_STATE.SAVED:
                                gridItem = new GridItem(gridItemType, 0, 0, containerWidth, 0, recording, savedRecordingsRenderer);
                                break;
                        }
//                    console.log("recording.id", recording.recordingId)
                        gridItem.zIndex = recordingZIndex;
                        gridItem.spritePool = recordingSpritePool;
                        gridItemsByRecordingId[recording.recordingId] = gridItem;
                    }
                };

                this.makeRecordingAnEpisode = function (episode, seriesGroup) {
//                console.log("makeRecordingAnEpisode", episode.isChild);
                    episode.isChild = true;
                    episode.parentId = seriesGroup.id;

                    var gridItem = gridItemsByRecordingId[episode.recordingId];

                    gridItem.zIndex = episodeZIndex;

                    if(gridItem.sprite){
//                    console.log("makeRecordingAnEpisode - re-render");
                        gridItem.renderer.render(gridItem.sprite, episode);
                    }
                };

                this.makeEpisodeARecording = function (recording) {
                    recording.isChild = false;
                    recording.parentId = null;

                    var gridItem = gridItemsByRecordingId[recording.recordingId];

                    gridItem.zIndex = recordingZIndex;

                    if(gridItem.sprite){
//                    console.log("makeEpisodeARecording - re-render");
                        gridItem.renderer.render(gridItem.sprite, recording);
                    }
                };

                this.setEpisodeSelectedClass = function (recording, value) {

                    recording.selectedForDeletion = value;

                    var gridItem = gridItemsByRecordingId[recording.recordingId];


                    if(gridItem.sprite){
//                    console.log("setEpisodeSelectedClass - re-render");
                        gridItem.renderer.render(gridItem.sprite, recording);
                    }
                };

                this.findGridItems = function (rows, startX, endX, result) {

                    var i = rows.length;
                    while (i--) {
                        var row = rows[i];
                        var gridItem = gridItemsByRecordingId[row.id];
                        if (gridItem && row.height > 0) {
                            gridItem.viewportY = row.viewportStartY;
                            gridItem.width = endX - startX;
                            gridItem.height = row.height;
                            result.push(gridItem);
                        }
                    }
                };

                this.resetSelectedRecordingsGridItems = function () {

                    for(var i in gridItemsByRecordingId){
                        var gridItem = gridItemsByRecordingId[i];
                        if (gridItem && gridItem.data && gridItem.data.selectedForDeletion) {
                            gridItem.data.selectedForDeletion = false;
                            if(gridItem.sprite){
                                gridItem.renderer.render(gridItem.sprite, gridItem.data)
                            }
                        }
                    }

                };


            }

            return function (gridItemType, recordingZIndex, episodeZIndex, container, containerWidth, RECORDING_ROW_STYLE, RECORDING_DATE_FORMAT) {
                return new RecordingGridItemProvider(gridItemType, recordingZIndex, episodeZIndex, container, containerWidth, RECORDING_ROW_STYLE, RECORDING_DATE_FORMAT, GridItem);
            };


        }]);

angular.module("videotron.illico.pvr-grid").factory("Recordings", function () {


    function Recordings() {

        var recordings;

        this.setRecordings = function (value) {
            recordings = value;
        };

        this.getSavedRecordings = function () {
            return recordings.saved;
        };

        this.getUpcomingRecordings = function () {
            return recordings.upcoming;
        };

        this.getAllRecordings = function () {
            if(recordings && recordings.all){
                return recordings.all;
            }else{
                return [];
            }

        };

        this.getRecordingById = function (id) {
            var result = null;
            for (var i = 0, count = recordings.length; i < count; i++) {
                var recording = recordings[i];
                if (recording.recordingId === id) {
                    result = recording;
                    break;
                }
            }
            return result;
        };



    }


    return function () {
        return new Recordings();

    };


});

angular.module("videotron.illico.pvr-grid").factory("RecordingsDataLoader",
    ["$http", "HttpConfigs", "$filter", "RECORDING_STATE", "RECORDINGS_CATEGORIES", "$translate", "RecordingsList", "AppConfig",
    function ($http, HttpConfigs, $filter, RECORDING_STATE, RECORDINGS_CATEGORIES, $translate, RecordingsList, AppConfig) {

        var dateFilter = $filter("date");
        var formatProgramDurationFilter = $filter("formatProgramDuration");
        var formatTime = $filter("formatStartOrEndTime");
        var saved = new RecordingsList(RECORDINGS_CATEGORIES.RECORDED);
        var upcoming = new RecordingsList(RECORDINGS_CATEGORIES.UPCOMING);

        function RecordingsDataLoader(basePath, logoBasePath, thumbsBasePath) {



            function setLogoPath(str) {
                // TODO - web platform image format is different from companion format
                // until platform is modified and all new images are created, we tweak the image names here
                // see JIRA for details : IAPPDEV-5231
                var image = str || "";
                var cleanedString = image.replace("_TF.png", ".png").replace("_TP.png", ".png");
                return logoBasePath + cleanedString;
            }

            function setImagePath(str) {
                return thumbsBasePath + str;
            }

            function extractStatusPictogram(recording) {
                var result;
                switch (true) {
                    // only if repeated is defined and upcoming or in progress
                    case recording.repeated && recording.status !== RECORDING_STATE.SAVED:
                        result = "icon repeated";
                        break;
                    case recording.viewStatus === "VIEWED":
                        result = "icon watched-all";
                        break;
                    case recording.viewStatus === "PARTIALLY_VIEWED":
                        result = "icon watched-partial";
                        break;
                    // don't want the not viewed icon for upcoming or in progress
                    case recording.viewStatus === "NOT_VIEWED" && recording.status === RECORDING_STATE.SAVED:
                        result = "icon watched-none";
                        break;
                    default:
                        result = "";
                        break;
                }

                return result;
            }

            function addExtraKey(obj, name, value){
                //first test if the key is available
                if (obj.hasOwnProperty(name)) {
                    throw new Error(name + " is already defined");
                } else {
                    obj[name] = value;
                }
            }

            function extendRecordingData(recording){

                var defaultImageName = AppConfig.getDefaultImageName(); // don't cache response like the others so random image selection takes place
                var logoImageSrc;

                // avoid app crash in case the provider block is missing
                if (!recording.provider) {
                    recording.provider = {};
                }

                // modify existing keys
                recording.image = setImagePath(recording.image);
                recording.startTime = ENP.tsFromCustomDate(recording.startTime);
                recording.endTime = ENP.tsFromCustomDate(recording.endTime);

                // Voir IWEB-805, nouvelle attribut gridLogo n'existe pas dans tous les plate-formes
                logoImageSrc = recording.provider.gridLogo || recording.provider.image;
                //add extra properties to the record
                addExtraKey(recording, "logo", setLogoPath(logoImageSrc));
                addExtraKey(recording, "fallbackSrc", setImagePath(defaultImageName));
                addExtraKey(recording, "channelName", recording.provider.name);
                addExtraKey(recording, "duration", formatProgramDurationFilter(recording.endTime - recording.startTime));
                addExtraKey(recording, "startToEnd", formatTime(recording.startTime) + $translate.instant("pvr_recording_times_splitter") + formatTime(recording.endTime));
                addExtraKey(recording, "statusIcon", extractStatusPictogram(recording));
                addExtraKey(recording, "dayAndMonth", dateFilter(new Date(recording.startTime), "vl_day_and_month_format"));
                addExtraKey(recording, "dayAndMonthShort", dateFilter(new Date(recording.startTime), "vl_day_and_month_short_format"));
                addExtraKey(recording, "alphabet", (recording.seriesTitle ? recording.seriesTitle.substring(0, 1) : recording.title.substring(0, 1))); //return first letter of title for grouping
                addExtraKey(recording, "seriesKey", ((recording.seriesId && recording.terminalId) ? recording.terminalId  + "-" + recording.seriesId : null));
                addExtraKey(recording, "definitionClassName", (typeof recording.definition === "string") ? recording.definition.toLowerCase() : "");


                // state variables
                addExtraKey(recording, "isChild", null); // set later in PVRGridRowsFactory
                addExtraKey(recording, "parentId", null); // set later in PVRGridRowsFactory
                addExtraKey(recording, "selectedForDeletion", false);

                return recording;

            }

            this.load = function (force) {
                var params = (force === true) ? "?forceRefresh=true" : "";
                var url = basePath + "/recordings" + params;
                // local mock
                // var url = "/appEnp/dev_tools/recordings.json";

                return $http.get(url, HttpConfigs.getConfigs()).then(function (response) {



                    var recordings = response.data.body.main;
                    var count = recordings.length;
                    saved.reset();
                    upcoming.reset();

                    for (var i = 0; i < count; i++) {
                        var recording = recordings[i];


                        // extend logo data here at the source
                        recording = extendRecordingData(recording);


                        switch (recording.status) {
                            case RECORDING_STATE.SAVED:
                            case RECORDING_STATE.RECORD_ERROR:
                                saved.addRecording(recording);
                                break;
                            case RECORDING_STATE.UPCOMING:
                                upcoming.addRecording(recording);
                                break;
                            case RECORDING_STATE.IN_PROGRESS:
                                upcoming.addRecording(recording);
                                saved.addRecording(recording);
                                break;
                            default :
                                break;
                        }
                    }

                    return {saved : saved, upcoming : upcoming, all: recordings};
                });

            };

        }

        return function (basePath, logoBasePath, thumbsBasePath) {
            return new RecordingsDataLoader(basePath, logoBasePath, thumbsBasePath);
        };

    }]);

angular.module("videotron.illico.pvr-grid").factory("RecordingsFilterSort",
    ["RECORDINGS_SORT", "RECORDINGS_CATEGORIES", "RECORDING_STATE", "GroupedRecordedSeries", "GroupedSortedRecordings", "SrvTerminals",
        function (RECORDINGS_SORT, RECORDINGS_CATEGORIES, RECORDING_STATE, GroupedRecordedSeries, GroupedSortedRecordings, SrvTerminals) {

        function RecordingsFilterSort() {


            var category;
            var sortBy;
            var allRecordings;
            var upcoming;
            var saved;
            var recordingGridItemProviderPointer;

            function groupSortedRecordings(recordingsList, sortBy, seriesGroups, groupedSortedRecordingsList, IS_RECORDED, groupsAreVisible){
                var sortingGroup = {};
                var seriesGroup = {};
                var groupBy = sortBy.groupBy;
                var groupName = sortBy.groupName;
                var recordsCount = recordingsList.length;

                for (var i = 0; i < recordsCount; i++) {
                    var recording = recordingsList[i];
                    var recordingGroupBy = recording[groupName];
                    var recordingId = recording[groupBy];
                    var recordingSortingGroup = sortingGroup[recordingGroupBy];
                    // in order to correctly group together a serie when not sorted by terminal (and kepp them apart when we are), we use different ids
                    var recordingSeriesKey = (sortBy === RECORDINGS_SORT.TERMINAL) ?  recording.seriesKey : recording.seriesId;
                    var recordingSeriesGroup = seriesGroup[recordingSeriesKey];

                    if(IS_RECORDED && recordingSeriesKey){
                        // if series recordingGroupBy already exists
                        if(recordingSeriesGroup){
                            recordingSeriesGroup.recordings.push(recording);
                            recording = null;
                        } else {
                            //set the records group data when all children are defined, see : initializeRecordsGroup
                            recordingSeriesGroup = new GroupedRecordedSeries(recordingSeriesKey, recording);
                            seriesGroup[recordingSeriesKey] = recordingSeriesGroup;
                            recording = recordingSeriesGroup;
                            seriesGroups.push(recordingSeriesGroup);
                        }
                    }


                    if (recording) {
                        if(recordingGridItemProviderPointer && !IS_RECORDED && recordingSeriesKey && recording.isChild){
                            recordingGridItemProviderPointer.makeEpisodeARecording(recording);
                        }

                        if (recordingSortingGroup) {
                            recordingSortingGroup.recordings.push(recording);
                        } else {
                            recordingSortingGroup = new GroupedSortedRecordings(recordingId, recordingGroupBy, groupsAreVisible, [recording]);
                            sortingGroup[recordingGroupBy] = recordingSortingGroup;
                            groupedSortedRecordingsList.push(recordingSortingGroup);
                        }
                    }
                }
            }

            function sortByKey(array, key) {
                return array.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            }

            // TODO move to SrvTerminal
            function getDefaultTerminalIndex(recordListGroups) {
                var i = recordListGroups.length;
                var result = -1;
                while (i--) {
                    var recordListGroup = recordListGroups[i];
                    var terminal = SrvTerminals.getTerminalById(recordListGroup.id);
                    if (terminal && terminal.default) {
                        result = i;
                        break;
                    }
                }
                return result;
            }

            function initializeRecordsGroup(seriesGroup) {
                var episodes = seriesGroup.recordings;
                var firstEpisode = episodes[0];

                function extractSeriesTitle() {
                    return firstEpisode.seriesTitle || firstEpisode.title;
                }

                function extractImage() {
                    return firstEpisode.image;
                }

                function extractFallbackSrc() {
                    return firstEpisode.fallbackSrc;
                }

                function extractChannelID() {
                    return firstEpisode.provider.id;
                }

                function extractChannelLogo() {
                    return firstEpisode.logo;
                }

                function extractStatus() {
                    var result = {
                        hasError: false,
                        hasRecordingInProgress: false
                    };
                    var records = seriesGroup.recordings;
                    for (var i = 0, count = records.length; i < count; i++) {
                        result.hasError = result.hasError || records[i].status === RECORDING_STATE.RECORD_ERROR;
                        result.hasRecordingInProgress = result.hasRecordingInProgress || records[i].status === RECORDING_STATE.IN_PROGRESS;
                    }
                    return result;
                }

                function extractViewedStatusIcon() {
                    // if any not viewed, mark as new
                    // or if no new and any partially watched, mark as partial
                    // or mark as viewed
                    var result = "";
                    var partiallyWatched = 0;
                    var newRecording = 0;
                    for (var i = 0, count = episodes.length; i < count; i++) {
                        var episode = episodes[i];
                        if(episode.viewStatus === "PARTIALLY_VIEWED"){
                            partiallyWatched++;
                        }else if(episode.viewStatus === "NOT_VIEWED"){
                            newRecording++;
                        }
                    }

                    if(newRecording > 0){
                        result = "icon watched-none";
                    }else if(newRecording === 0 && partiallyWatched > 0){
                        result = "icon watched-partial";
                    }else{
                        // all_viewed
                        result = "icon watched-all";
                    }
                    return result;
                }
                function extractEpisodesCount() {
                    return episodes.length;
                }

                function extractChannelPosition() {
                    return firstEpisode.channelPosition;
                }


                seriesGroup.seriesTitle = extractSeriesTitle();
                seriesGroup.episodesCount = extractEpisodesCount();
                seriesGroup.extractViewedStatusIcon = extractViewedStatusIcon();
                seriesGroup.image = extractImage();
                seriesGroup.fallbackSrc = extractFallbackSrc();
                seriesGroup.channelId = extractChannelID();
                seriesGroup.channelLogo = extractChannelLogo();
                seriesGroup.status = extractStatus();
                seriesGroup.channelPosition = extractChannelPosition();

                //console.log("seriesGroup", seriesGroup.seriesTitle, seriesGroup)

            }

            function breakRecordingsGroupContainingOnlyOneChild(data) {


                for (var j = 0, countJ = data.length; j < countJ; j++) {
                    var recs = data[j].recordings;
                    for (var i = 0, countI = recs.length; i < countI; i++) {
                        var rec = recs[i];
                        if (rec.recordings){
                            // only one recording, not a real group
                            if (rec.recordings.length === 1) {
//                                console.warn("breaking up group of 1", recs[i])
                                recs[i] = rec.recordings[0];
                                if(recordingGridItemProviderPointer && recs[i].isChild){
                                    recordingGridItemProviderPointer.makeEpisodeARecording(recs[i]);
                                }
                            }
                        }
                    }
                }
            }

            function sortRecordings(recordingsListObj, recordingRowStyle) {

                var IS_RECORDED = RECORDINGS_CATEGORIES.RECORDED === category;
                var IS_UPCOMING = RECORDINGS_CATEGORIES.UPCOMING === category;
                var recordingsList = recordingsListObj.list;

                var groupedSortedRecordingsList = [];
                var groupsAreVisible = sortBy.groupsAreVisible;
                var seriesGroups = [];

                if (sortBy !== RECORDINGS_SORT.TERMINAL) {

                    if (IS_RECORDED && sortBy === RECORDINGS_SORT.DATE) {
                        groupsAreVisible = true;
                    }
                    recordingsList.sort(sortBy.sort);
                    if(IS_UPCOMING && sortBy === RECORDINGS_SORT.DATE){
                        recordingsList.reverse();
                    }

                    // moved to external function
                    groupSortedRecordings(recordingsList, sortBy, seriesGroups, groupedSortedRecordingsList, IS_RECORDED, groupsAreVisible);

                    //console.log("********recordingsList", groupedSortedRecordingsList)
                } else {
                    recordingsList.sort(RECORDINGS_SORT.DATE.sort);

                    if(IS_UPCOMING){
                        recordingsList.reverse();
                    }

                    groupSortedRecordings(recordingsList, sortBy, seriesGroups, groupedSortedRecordingsList, IS_RECORDED, groupsAreVisible);

                    sortByKey(groupedSortedRecordingsList, 'name');

                    //when sorted by TERMINALS, the default terminal should appear first
                    var defaultTerminalIndex = getDefaultTerminalIndex(groupedSortedRecordingsList);
                    if (defaultTerminalIndex > 0) {
                        var tmp = groupedSortedRecordingsList[0];
                        groupedSortedRecordingsList[0] = groupedSortedRecordingsList[defaultTerminalIndex];
                        groupedSortedRecordingsList[defaultTerminalIndex] = tmp;
                    }


                }

                if(IS_RECORDED){
                    for (var j = 0, count = seriesGroups.length; j < count; j++) {
                        var groupContents = seriesGroups[j];
                        var groupRecordings = groupContents.recordings;
//                        console.log("**************************************************************")
                        //console.log(groupRecordings.length, groupRecordings, groupedSortedRecordingsList)
                        if(groupRecordings.length > 1){
                            //console.log("make seriesGroups with ", groupRecordings)
                            initializeRecordsGroup(groupContents);
                        }else if(groupRecordings.length === 1){
                            // not really a group since only 1 recording
                            breakRecordingsGroupContainingOnlyOneChild(groupedSortedRecordingsList);
                        }
                    }
                }

                return groupedSortedRecordingsList;
            }




            this.getGroupedRecordings = function (recordingGridItemProvider, recordingRowStyle) {

//                console.time("getGroupedRecordings")
                recordingGridItemProviderPointer = recordingGridItemProvider || false;

                var result;
//                console.log("getGroupedRecordings", sortBy, category, allRecordings)
                // if recordings or extraFilters not yet set, don't go any further
                if (!allRecordings || !category || !sortBy) {
                    return result;
                }

                //filter by category
                switch (category) {
                    case RECORDINGS_CATEGORIES.RECORDED:
                        result = sortRecordings(saved, recordingRowStyle);
                        break;
                    case RECORDINGS_CATEGORIES.UPCOMING:
                        result = sortRecordings(upcoming, recordingRowStyle);
                        break;
                }

//                console.timeEnd("getGroupedRecordings")
                return result;
            };

            this.setCategory = function (value) {
                category = value;
            };

            this.setSortBy = function (value) {
                sortBy = value;
            };

            this.setRecordings = function (value) {
                allRecordings = value.getAllRecordings();
                upcoming = value.getUpcomingRecordings();
                saved = value.getSavedRecordings();
//                console.log("setRecordings", allRecordings, upcoming, saved)
            };


        }


        return function () {
            return new RecordingsFilterSort();
        };


    }]);

angular.module("videotron.illico.pvr-grid").factory("RecordingsList", function () {


    function RecordingsList(type) {
        this.type = type;
        this.list = [];

        this.addRecording = function(recording){
            this.list.push(recording);
        };

        this.reset = function(){
            this.list = [];
        };
    }


    return function (type) {
        return new RecordingsList(type);

    };


});

angular.module("videotron.illico.pvr-grid").factory("SeriesGroupGridItemProvider",
    ["GridItem", "Value", "$translate", "Sprite", "SpritePool", "RECORDING_STATE",
        function (GridItem, Value, $translate, Sprite, SpritePool, RECORDING_STATE) {


            function SeriesGroupSpriteFactory_web() {


                this.create = function () {
                    var sprite = new Sprite();
                    var rootElement = sprite.element;


                    var recordingContent = document.createElement("div");
                    recordingContent.className = "row-content";
                    rootElement.appendChild(recordingContent);

                    // LEFT COL
                    var leftCol = document.createElement("div");
                    leftCol.className = "column left";
                    recordingContent.appendChild(leftCol);

                    var checkBox = document.createElement("div");
                    checkBox.className = "select-button";
                    leftCol.appendChild(checkBox);

                    var deleteIcon = document.createElement("div");
                    deleteIcon.className = "delete-icon";
                    leftCol.appendChild(deleteIcon);

                    var thumb = document.createElement("div");
                    thumb.className = "thumbnail";
                    leftCol.appendChild(thumb);

                    var thumbImage = document.createElement("img");
                    thumb.appendChild(thumbImage);

                    var thumbIconsContainer = document.createElement("div");
                    thumbIconsContainer.className = "icons-container";
                    thumb.appendChild(thumbIconsContainer);

                    var thumbIcons1 = document.createElement("i");
                    thumbIconsContainer.appendChild(thumbIcons1);

                    var thumbIcons2 = document.createElement("i");
                    thumbIconsContainer.appendChild(thumbIcons2);

                    var thumbIcons3 = document.createElement("i");
                    thumbIconsContainer.appendChild(thumbIcons3);

                    // CENTER COL
                    var centerCol = document.createElement("ul");
                    centerCol.className = "column center";
                    recordingContent.appendChild(centerCol);

                    var titleOuter = document.createElement("li");
                    titleOuter.className = "title";
                    centerCol.appendChild(titleOuter);

                    var title = document.createElement("span");
                    titleOuter.appendChild(title);

                    var viewingStatusIcon = document.createElement("i");
                    titleOuter.appendChild(viewingStatusIcon);

                    var showButtonLabel = document.createElement("li");
                    showButtonLabel.className = "show-hide-records-button show";
                    centerCol.appendChild(showButtonLabel);

                    var hideButtonLabel = document.createElement("li");
                    hideButtonLabel.className = "show-hide-records-button hide";
                    centerCol.appendChild(hideButtonLabel);

                    var warning = document.createElement("li");
                    warning.className = "warning";
                    centerCol.appendChild(warning);

                    // RIGHT COL
                    var rightCol = document.createElement("div");
                    rightCol.className = "column right";
                    recordingContent.appendChild(rightCol);

                    var channel = document.createElement("div");
                    channel.className = "channel";
                    rightCol.appendChild(channel);

                    var innerChannel = document.createElement("div");
                    channel.appendChild(innerChannel);

                    var channelLogo = document.createElement("img");
                    innerChannel.appendChild(channelLogo);

                    var channelPosition = document.createElement("p");
                    channel.appendChild(channelPosition);

                    var channelPositionInner = document.createElement("span");
                    channelPosition.appendChild(channelPositionInner);

                    sprite.thumb = thumbImage;
                    sprite.thumbIcons1 = thumbIcons1;
                    sprite.thumbIcons2 = thumbIcons2;
                    sprite.thumbIcons3 = thumbIcons3;
                    sprite.title = title;
                    sprite.viewingStatusIcon = viewingStatusIcon;
                    sprite.showButtonLabel = showButtonLabel;
                    sprite.hideButtonLabel = hideButtonLabel;
                    sprite.warning = warning;
                    sprite.positions = channelPositionInner;
                    sprite.logo = channelLogo;

                    return sprite;
                };
            }

            function SeriesGroupSpriteFactory_tablet() {

                this.create = function () {
                    var sprite = new Sprite();
                    var rootElement = sprite.element;

                    var recordingWrapper = document.createElement("div");
                    recordingWrapper.className = "row-wrapper";
                    rootElement.appendChild(recordingWrapper);

                    // CHECK BOX
                    var checkBox = document.createElement("div");
                    checkBox.className = "select-button";
                    recordingWrapper.appendChild(checkBox);

                    var recordingContent = document.createElement("div");
                    recordingContent.className = "row-content";
                    recordingWrapper.appendChild(recordingContent);

                    // LEFT COL
                    var leftCol = document.createElement("div");
                    leftCol.className = "column left";
                    recordingContent.appendChild(leftCol);

                    var thumb = document.createElement("div");
                    thumb.className = "thumbnail";
                    leftCol.appendChild(thumb);

                    var thumbImage = document.createElement("img");
                    thumb.appendChild(thumbImage);

                    var thumbIconsContainer = document.createElement("div");
                    thumbIconsContainer.className = "icons-container";
                    thumb.appendChild(thumbIconsContainer);

                    var recordingInProgressIcon = document.createElement("i");
                    thumbIconsContainer.appendChild(recordingInProgressIcon);

                    // CENTER COL
                    var centerCol = document.createElement("ul");
                    centerCol.className = "column center";
                    recordingContent.appendChild(centerCol);

                    var titleOuter = document.createElement("li");
                    titleOuter.className = "title";
                    centerCol.appendChild(titleOuter);

                    var viewingStatusIcon = document.createElement("i");
                    titleOuter.appendChild(viewingStatusIcon);

                    var title = document.createElement("span");
                    titleOuter.appendChild(title);

                    // RIGHT COL
                    var rightCol = document.createElement("div");
                    rightCol.className = "column right";
                    recordingContent.appendChild(rightCol);

                    var toggleEpisodesButton = document.createElement("div");
                    toggleEpisodesButton.className = "show-hide-records-button";
                    rightCol.appendChild(toggleEpisodesButton);

                    var hideButtonLabel = document.createElement("div");
                    hideButtonLabel.className = "show-hide-records-button hide";
                    rightCol.appendChild(hideButtonLabel);


                    sprite.thumb = thumbImage;
                    sprite.title = title;
                    sprite.viewingStatusIcon = viewingStatusIcon;
                    sprite.recordingInProgressIcon = recordingInProgressIcon;
                    sprite.toggleEpisodesButton = toggleEpisodesButton;

                    return sprite;
                };
            }

            function SeriesGroupSpriteFactory_mobile() {


                this.create = function () {
                    var sprite = new Sprite();
                    var rootElement = sprite.element;

                    var recordingWrapper = document.createElement("div");
                    recordingWrapper.className = "row-wrapper";
                    rootElement.appendChild(recordingWrapper);

                    // CHECK BOX
                    var checkBox = document.createElement("div");
                    checkBox.className = "select-button";
                    recordingWrapper.appendChild(checkBox);

                    var recordingContent = document.createElement("div");
                    recordingContent.className = "row-content";
                    recordingWrapper.appendChild(recordingContent);

                    // LEFT COL
                    var leftCol = document.createElement("div");
                    leftCol.className = "column left";
                    recordingContent.appendChild(leftCol);

                    var thumb = document.createElement("div");
                    thumb.className = "thumbnail";
                    leftCol.appendChild(thumb);

                    var thumbImage = document.createElement("img");
                    thumb.appendChild(thumbImage);

                    var thumbIconsContainer = document.createElement("div");
                    thumbIconsContainer.className = "icons-container";
                    thumb.appendChild(thumbIconsContainer);

                    var recordingInProgressIcon = document.createElement("i");
                    thumbIconsContainer.appendChild(recordingInProgressIcon);

                    // CENTER COL
                    var centerCol = document.createElement("ul");
                    centerCol.className = "column center";
                    recordingContent.appendChild(centerCol);

                    var titleOuter = document.createElement("li");
                    titleOuter.className = "title";
                    centerCol.appendChild(titleOuter);

                    var viewingStatusIcon = document.createElement("i");
                    titleOuter.appendChild(viewingStatusIcon);

                    var title = document.createElement("span");
                    titleOuter.appendChild(title);

                    var toggleEpisodesButton = document.createElement("li");
                    toggleEpisodesButton.className = "show-hide-records-button";
                    centerCol.appendChild(toggleEpisodesButton);

                    var warning = document.createElement("li");
                    warning.className = "warning";
                    centerCol.appendChild(warning);

                    // RIGHT COL
                    var rightCol = document.createElement("div");
                    rightCol.className = "column right";
                    recordingContent.appendChild(rightCol);


                    sprite.thumb = thumbImage;
                    sprite.title = title;
                    sprite.viewingStatusIcon = viewingStatusIcon;
                    sprite.recordingInProgressIcon = recordingInProgressIcon;
                    sprite.toggleEpisodesButton = toggleEpisodesButton;
                    sprite.warning = warning;

                    return sprite;
                };
            }

            // heavily inspired by fallbackSrc directive,
            // but since gridItems aren't parsed by Angular for performance reasons,
            // vanilla implementation here
            function replaceSrcWithFallbackSrc() {
                // first make sure we haven't already switched the src
                // this avoids endless calls if fallback image returns a 404
                if(this.dataset.fallbackSrc && this.src !== this.dataset.fallbackSrc){
                    //console.error("use fallback image - series", this.src);
                    this.src = this.dataset.fallbackSrc;
                }
            }

            function RecordingRenderer(className, recordingRowStyle) {

                this.render = function (sprite, recording) {
                    var isGroupOpenClass = (recording.isGroupOpen) ? " showEpisodes" : "";
                    var isSelectedClass = (recording.selectedForDeletion) ? " selected" : "";
                    if(sprite.thumb){
                        sprite.thumb.src = recording.image;
                        sprite.thumb.dataset.fallbackSrc = recording.fallbackSrc;
                        sprite.thumb.onerror = replaceSrcWithFallbackSrc
                    }

                    sprite.viewingStatusIcon.className = recording.extractViewedStatusIcon;

                    switch(recordingRowStyle){
                        case "tablet":
                        case "mobile":
                            sprite.title.textContent = recording.seriesTitle;
                            sprite.recordingInProgressIcon.className = recording.status.hasRecordingInProgress ? "icon recordingInProgress" : "";
                            sprite.toggleEpisodesButton.textContent = recording.episodesCount + " " + $translate.instant("Episodes recorded");
                            break;
                        case "web":
                        default:
                            sprite.title.textContent = recording.seriesTitle + " (" + recording.episodesCount + ")";
                            sprite.showButtonLabel.textContent = $translate.instant("See list of episodes");
                            sprite.hideButtonLabel.textContent = $translate.instant("Hide list of episodes");
                            //sprite.thumbIcons1.className = recording.status.hasError ? "icon alert" : "";
                            sprite.thumbIcons2.className = recording.status.hasRecordingInProgress ? "icon group-rec" : "icon group";
                            sprite.warning.textContent = (recording.status.hasError) ? $translate.instant("At least one recording failed") : "";
                            //sprite.thumbIcons3.className = "icon group";
                            if(sprite.positions){
                                sprite.positions.className = (typeof recording.definition === "string") ? recording.definition.toLowerCase() : "";
                                sprite.positions.textContent = recording.channelPosition;
                            }
                            if(sprite.logo){
                                sprite.logo.src = recording.channelLogo;
                            }
                            break;
                    }

                    sprite.setClass(className + isGroupOpenClass + isSelectedClass);
                };
            }

            function SeriesGroupGridItemProvider(gridItemType, zIndex, GridItem, container, RECORDING_ROW_STYLE) {

                function rendererWithCustomClasses(className, recordingRowStyle){
                    return  new RecordingRenderer(className, recordingRowStyle)
                }

                var gridItemsByRecordingGroupId = {};
                var GROUP_CLASSES= "recording seriesGroup";
                var channelGroupRenderer = rendererWithCustomClasses(GROUP_CLASSES, RECORDING_ROW_STYLE);

                var SpriteFactory;
                switch(RECORDING_ROW_STYLE){
                    case "web": SpriteFactory = SeriesGroupSpriteFactory_web; break;
                    case "tablet": SpriteFactory = SeriesGroupSpriteFactory_tablet; break;
                    case "mobile": SpriteFactory = SeriesGroupSpriteFactory_mobile; break;
                }

                var channelGroupSpritePool = new SpritePool(container, 2, new SpriteFactory());


                this.setGroups = function (channelGroups) {
                    var i = channelGroups.length;
                    while (i--) {
                        var channelGroup = channelGroups[i];
                        var gridItem = new GridItem(gridItemType, 0, 0, 0, 0, channelGroup, channelGroupRenderer);
                        gridItem.zIndex = zIndex;
                        gridItem.spritePool = channelGroupSpritePool;
                        gridItemsByRecordingGroupId[channelGroup.id] = gridItem;
                    }
                };

                this.findGridItems = function (rows, startX, endX, result) {
                    var i = rows.length;
                    while (i--) {
                        var row = rows[i];
                        var gridItem = gridItemsByRecordingGroupId[row.id];
                        if (gridItem) {
                            gridItem.viewportX = 0;
                            gridItem.viewportY = row.viewportStartY;
                            gridItem.width = endX - startX;
                            gridItem.height = row.height;
                            result.push(gridItem);
                        }
                    }
                };



                this.findGridItemById = function (id) {
                    return gridItemsByRecordingGroupId[id]
                };

                this.toggleShowEpisodes = function (seriesGroup, isVisible) {

                    seriesGroup.isGroupOpen = isVisible;

                    var gridItem = gridItemsByRecordingGroupId[seriesGroup.id];

                    if(gridItem.sprite){
                        gridItem.renderer.render(gridItem.sprite, seriesGroup);
                    }

                };

                this.resetSelectedSeriesGroupsGridItems = function () {

                    for(var i in gridItemsByRecordingGroupId){
                        var gridItem = gridItemsByRecordingGroupId[i];
                        if (gridItem && gridItem.data && gridItem.data.selectedForDeletion) {
                            gridItem.data.selectedForDeletion = false;
                            if(gridItem.sprite){
                                gridItem.renderer.render(gridItem.sprite, gridItem.data)
                            }
                        }
                    }

                };

            }
            return function (gridItemType, zIndex, container, RECORDING_ROW_STYLE) {
                return new SeriesGroupGridItemProvider(gridItemType, zIndex, GridItem, container, RECORDING_ROW_STYLE);
            };


        }]);

angular.module("videotron.illico.pvr-grid").factory("SortingGroupTitleGridItemProvider",
    ["GridItem", "Sprite", "SpritePool", "RECORDINGS_SORT", "$translate", function (GridItem, Sprite, SpritePool, RECORDINGS_SORT, $translate) {

        var sortBy;

        // TODO - remove RECORDING_ROW_STYLE or create new factory/renderer

        function SortingGroupDelimiterSpriteFactory() {
            this.create = function () {
                var sprite = new Sprite();
                var rootElement = sprite.element;
                var content = document.createElement("h2");
                content.className = "group-separator";
                rootElement.appendChild(content);

                var title = document.createElement("span");
                content.appendChild(title);

                var editTerminal = document.createElement("span");
                editTerminal.className = "edit-terminal-name";
                content.appendChild(editTerminal);

                sprite.content = title;
                sprite.editTerminal = editTerminal;
                return sprite;
            };

        }

        function SortingGroupDelimiterRenderer(isTerminal) {
            this.render = function (sprite, sortingGroupDelimiter) {
                sprite.content.textContent = sortingGroupDelimiter.id;
                if(isTerminal && sprite.editTerminal){
                    sprite.editTerminal.textContent = $translate.instant("edit terminal name");
                }else{
                    sprite.editTerminal.textContent = "";
                }
            };
        }


        function SortingGroupTitleGridItemProvider(gridItemType, offsetX, zIndex, container, RECORDING_ROW_STYLE) {

            var gridItemsBySortingGroupDeleimiterId = {};
            var renderer = new SortingGroupDelimiterRenderer(false);
            var rendererForTerminal = new SortingGroupDelimiterRenderer(true);

            var sortingGroupDelimiterSpritePool = new SpritePool(container, 2, new SortingGroupDelimiterSpriteFactory());

            this.setSortingGroupDelimiters = function (sortingGroupDelimiters) {

                for (var i = 0, count = sortingGroupDelimiters.length; i < count; i++) {
                    var sortingGroupDelimiter = sortingGroupDelimiters[i];
                    var gridItem;
                    if(sortBy === RECORDINGS_SORT.TERMINAL){
                        gridItem = new GridItem(gridItemType, 0, 0, 0, 0, sortingGroupDelimiter, rendererForTerminal);
                    }else{
                        gridItem = new GridItem(gridItemType, 0, 0, 0, 0, sortingGroupDelimiter, renderer);
                    }
                    gridItem.zIndex = zIndex;
                    gridItem.spritePool = sortingGroupDelimiterSpritePool;
                    gridItemsBySortingGroupDeleimiterId[sortingGroupDelimiter.id] = gridItem;
                }

            };

            this.setSortBy = function (value) {
                sortBy = value;
            };

            this.findGridItems = function (rows, startX, endX, result) {
                var i = rows.length;
                while (i--) {
                    var row = rows[i];
                    var gridItem = gridItemsBySortingGroupDeleimiterId[row.id];
                    if (gridItem) {
                        gridItem.viewportX = 0;
                        gridItem.viewportY = row.viewportStartY;
                        gridItem.height = row.height;
                        gridItem.width = endX - startX + offsetX;
                        result.push(gridItem);
                    }
                }
            };
        }

        return function (gridItemType, offsetX, zIndex, container, RECORDING_ROW_STYLE) {
            return new SortingGroupTitleGridItemProvider(gridItemType, offsetX, zIndex, container, RECORDING_ROW_STYLE);
        };

    }]);

angular.module("videotron.illico.pvr-grid").filter("formatProgramDuration",
    ["Time", function (Time) {
        // TODO - replace with custom angular $locale date filter?
        return function (input) {
            var result = Time.minutesToHoursAndMinutes(Time.millisecondsToMinutes(input));
            var hours = (result.hours > 0) ? result.hours + " h " : "";
            //var minutes = ("0" + result.minutes).slice(-2); // 0 padded removed during TOC integration
            var minutes = result.minutes + " min";
            result = hours + minutes;
            return result;
        };
    }]);
angular.module("videotron.illico.pvr-grid").filter("formatStartOrEndTime", ["$filter", function ($filter) {
    var timeFilter = $filter("date");

    return function (milliseconds) {
        var date = new Date(milliseconds);
        var formattedTime;
        if (date.getMinutes() === 0) {
            // 13 h or 1 p.m.
            formattedTime = timeFilter(date, "vl_recording_start_end_time_no_minutes_format");
        } else {
            // 13 h 01 or 1:01 p.m.
            formattedTime = timeFilter(date, "vl_recording_start_end_time_format");
        }
        return formattedTime;
    };
}]);
// global set for analytics tracking and release notes automation
// use global object since other projects (IENP, PLWE) will also be adding their version to this global
var illicoAppVersions = illicoAppVersions || {};
// value replaced at build time with actual version info, see GruntFile for details
illicoAppVersions.IENP = 'IENP-2.9.8';

angular.module('app.epg.web').component('pageEpgA11y', {
    templateUrl: '/appEnp/templates/epg/epg.template.a11y.html',
    controller: 'pageEpgA11yCtrl',
    bindings: {
        importedConfig: '<',
        groupedChannelsToDisplay: '<'
    }
});
angular.module("app.epg.web").controller("pageEpgA11yCtrl",
    ["$scope", "InitParams", "AppConfig", "AppServicesInitializer", "SERVICES_BASE_PATH", "ChannelsDataLoader", "Channels", "Metadata", "MetadataLoader", "LoadingOverlay", "SrvInitializeMainFilter", "CHANNEL_MAIN_FILTERS",
                    "Time", "TimeSpan", "GridUnitConverter", "ChannelsFilter", "ProgramsDataLoader", "SrvLinearContentDetails", "LocalStorage", "EPGExtraFilters", "NativeActions", "SrvChannelFilters", "SrvFavoriteChannel",
        function ($scope, InitParams, AppConfig, AppServicesInitializer, SERVICES_BASE_PATH, ChannelsDataLoader, Channels, Metadata, MetadataLoader, LoadingOverlay, SrvInitializeMainFilter, CHANNEL_MAIN_FILTERS,
                  Time, TimeSpan, GridUnitConverter, ChannelsFilter, ProgramsDataLoader, SrvLinearContentDetails, LocalStorage, EPGExtraFilters, NativeActions, SrvChannelFilters, SrvFavoriteChannel) {

            var TOTAL_DAYS_IN_GRID = 14;
            var PIXELS_PER_MINUTE = 8; // should not need this
            var CURRENT_MAIN_FILTER_STORE_KEY = "main-filter";
            var CURRENT_PLATFORM = "web";
            var programsDataLoader = new ProgramsDataLoader(SERVICES_BASE_PATH);

            var channels = new Channels();
            var channelsFilter = new ChannelsFilter();
            var metadata = new Metadata();
            var metadataLoader = new MetadataLoader(SERVICES_BASE_PATH);

            var startTime;
            var endTime;
            var channelsDataLoader;

            var $ctrl = this;

            var screenWidth = $(document).width();
            //console.log("screenWidth", screenWidth);

            //subtracting 2% left-right margin and star-logo area for calc. 120 for 120min periods
            var pixelToTimeRatio = (screenWidth - (screenWidth*0.02) - 152) / 120;

            //15min from grid start
            $scope.currentTimeLinePos = (screenWidth*0.02) + 152 + (pixelToTimeRatio * 15);

            //console.info("pageEpgA11yCtrl", $ctrl.importedConfig);

            $ctrl.$onChanges = function (changes) {
                //console.log('changes', changes);
                //console.info("pageEpgA11yCtrl", $ctrl.importedConfig)
            };


            // expose to the page scope
            $ctrl.showMainToolbar = false;
            $ctrl.showNoResultsFilterError = false;
            $ctrl.selectedchannelFilter = '';
            $ctrl.channelFiltersList = SrvChannelFilters.getFilters();
            $ctrl.mainFilters = [CHANNEL_MAIN_FILTERS.ALL, CHANNEL_MAIN_FILTERS.FAVORITES, CHANNEL_MAIN_FILTERS.IN_PACKAGE];
            $ctrl.mainFilter = SrvInitializeMainFilter.getIndex($ctrl.mainFilters, CURRENT_MAIN_FILTER_STORE_KEY);
            $ctrl.extraFilters = [];
            $ctrl.groupedChannelsToDisplay = [];

            $ctrl.programLinkAction = function($event, programLinkObj){
                $event.preventDefault();
                //console.log(programLinkObj);
                NativeActions.link({link: programLinkObj});
            };

            $ctrl.toggleFavorite = function($event, channel){
                $event.preventDefault();

                // change on backend
                SrvFavoriteChannel.updateChannelFavoriteState(channel, channel.selection).then(function(){
                    var favChannels;
                    metadata.toggleChannelFavoriteState(channel, channel.selection);
                    favChannels = channels.sortChannelsByPosition(metadata.getFavoriteChannels());
                    channelsFilter.setFavoriteChannels(favChannels);

                    //Google Analytics tracking through Native Bridge
                    if (!channel.selection) {
                        NativeActions.trackEvent('Grille Horaire', 'Ajouter à mes sélections', channel.name);
                    } else {
                        NativeActions.trackEvent('Grille Horaire', 'Retirer de mes sélections', channel.name);
                    }

                    // change visual state
                    channel.selection = !channel.selection;
                }, function(){
                    // in case of error, do nothing
                });

            };


            // watchers
            // currentPlatformOnly should probably become a component instead
            $scope.$watch('$ctrl.currentPlatformOnly', function(value){
                var ga_state = value ? 'Sélectionner' : 'Désélectionner';
                
                if(typeof value !== 'boolean'){
                    return;
                }

                // expects JSON with a value that's a string not a boolean
                EPGExtraFilters.setPlatformFilter(JSON.stringify({currentPlatformOnly : value.toString()}), CURRENT_PLATFORM);
                $ctrl.extraFilters = EPGExtraFilters.getExtraFilters();

                //Google Analytics tracking through Native Bridge
                NativeActions.trackEvent('Grille Horaire', 'Chaînes web seulement', ga_state);
            });

            // selectedchannelFilter should probably become a component instead
            $scope.$watch('$ctrl.selectedchannelFilter', function(filter){
                // console.log("selectedchannelFilter", filter);
                if(typeof filter === 'undefined'){
                    return;
                }

                if(filter){
                    EPGExtraFilters.setGeneralFilters(filter);

                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Filtre: ' + filter.label);

                }else{
                    EPGExtraFilters.setGeneralFilters();

                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Retirer filtre');
                }
                $ctrl.extraFilters = EPGExtraFilters.getExtraFilters();
            });

            //console.log("$scope",$scope)
            $scope.$watch('$ctrl.mainFilter', function(value){
                //console.log("$watch mainFilter", value)
                LocalStorage.set(CURRENT_MAIN_FILTER_STORE_KEY, value);
                channelsFilter.setMainFilter(value);
                channelsChanged(channelsFilter.filter());
            });

            $scope.$watch('$ctrl.extraFilters', function (value) {
                //console.log("$watch extraFilters", value)
                channelsFilter.setExtraFilters(value);
                channelsChanged(channelsFilter.filter());
            });

            $scope.$watch('$ctrl.groupedChannelsToDisplay' ,function(value){
                //console.log("$watch groupedChannelsToDisplay",value);
            });


            // launch AppServicesInitializer and ChannelsDataLoader
            // get now to establish where to start
            // split next 14 days into viewable section/pages (8hours per page by example)
            // * check out ProgramsLoader.initialize
            // * need to determine how to cleanly handle first page, example :
            // ** it's currently 6:27AM, do we :
            // *** add 8 hours to this (breaking all further pages at 14:27, 22:27, 06:27?)
            // *** tweak page sizes to force clean 00:00, 08:00, 16:00 pages (mean the first page won't be the same size as the other pages)
            // * alternative solution being to force page size to viewport width (example 1000px wide = 100px for logo, 900px for programs, 300 minutes(5 hours) at 3px/minute)
            // * might end up a little strange sometimes to have a page from 11:27 to 15:14 for example
            // launch programsDataLoader with page info and channel filters as params
            // * see how complicated it would be to cache results to avoid useless back-end calls
            // var cache = {
            //     segment0: {
            //         channelId : [ProgramObj, ProgramObj, ProgramObj, ProgramObj]
            //     }
            // }
            // on pagination, launch programsDataLoader again
            // on filter, launch programsDataLoader again
            // add status messages on page updates (with aria role status)

            function channelsChanged(channelGroups) {
                if(!channelGroups){
                    return
                }

                $ctrl.groupedChannelsToDisplay = channelGroups;

                $scope.loadPrograms();

                //console.log('channelsChanged()');
                var noFavorites = false;
                var total = 0;

                channelGroups.forEach(function(group){
                    if (group && group.channels){
                        total += group.channels.length;
                    }
                });

                //console.log("channelsChanged -> total",total);

                // only if metaData has already been set to avoid flicker
                if (metadata.isSet()) {
                    // show error if no favorites, even if we have most watched channels
                    if (channelGroups && channelGroups.length > 1) {
                        for (var i = 0; i < channelGroups.length; i++) {
                            if (channelGroups[i].type === CHANNEL_MAIN_FILTER_GROUPS.FAVORITES && channelGroups[i].channels.length === 0) {
                                noFavorites = true;
                            }
                        }
                    }

                    // show error if no favorites or no channels in channelGroups
                    if (noFavorites || (total === 0 && channelGroups)) {
                        $ctrl.showNoResultsFilterError = true;
                        // since no programs found, programsLoader will never be called, so dismiss spinner and show toolbar now
                        $ctrl.showMainToolbar = true;
                        LoadingOverlay.hide();
                        //console.log('channelsChanged::hide');
                    } else {
                        $ctrl.showNoResultsFilterError = false;
                    }
                }
            }

            function loadMetadata() {
                return metadataLoader.load().then(function (value) {
                    //console.log('value: ', value);
                    var favChannels;
                    metadata.setMetadata(value);
                    favChannels = channels.sortChannelsByPosition(metadata.getFavoriteChannels());
                    channelsFilter.setFavoriteChannels(favChannels);
                    channelsChanged(channelsFilter.filter());
                });
            }

            $scope.gridPage = 0;

            function transformPrograms(programsList, pageStartTime, pageEndTime){
                programsList.forEach(function(program){

                    var PIXELS_PER_MINUTE = pixelToTimeRatio;
                    var programStartTime = new Date(program.startTime);
                    var programEndTime = new Date(program.endTime);

                    if(programStartTime < pageStartTime){
                        programStartTime = pageStartTime;
                    }

                    if(programEndTime > pageEndTime){
                        programEndTime = pageEndTime;

                    }

                    program.duration = Time.millisecondsToMinutes(programEndTime - programStartTime) * PIXELS_PER_MINUTE;

                });
                return programsList;
            }




            $scope.loadPrograms = function (direction){

                var channelsToLoad = [];

                var HOURS_PER_SCREEN = 3;

                var BASE_TIMESPAN = 6;

                if(direction === "forward"){
                    $scope.gridPage++;
                } else if(direction === "backward"){
                    $scope.gridPage--;
                }

                var timeTranslate = Time.hours(HOURS_PER_SCREEN) * $scope.gridPage;

                var pageStartTime = new Date(AppConfig.getNow() - (Time.hours(0.25)) + (Time.hours(HOURS_PER_SCREEN)) * $scope.gridPage);

                var pageEndTime = new Date(pageStartTime.getTime() + (Time.hours(BASE_TIMESPAN)));

                console.log("pageStartTime", pageStartTime);
                console.log("pageEndTime", pageEndTime);

                //console.log("$ctrl.groupedChannelsToDisplay", $ctrl.groupedChannelsToDisplay);
                $ctrl.groupedChannelsToDisplay.forEach(function(group){

                    group.channels.forEach(function(channel){
                        //console.info(channel.id, channel)
                        channelsToLoad.push(channel.id);
                    });

                    $scope.gridLoading = true;

                    programsDataLoader.load(ENP.customDateFromTs(startTime -900000 + timeTranslate), Time.hoursToMinutes(BASE_TIMESPAN), channelsToLoad).then(function (programsByChannel) {
                        if(programsByChannel.length){

                            var actualChannel;

                            var channelRange = programsByChannel.length;
                            //var channelRange = 50;

                            for(var i = 0; i < channelRange; i++){

                                actualChannel = channels.findChannelByID( programsByChannel[i].channelId);
                                //console.log("actualChannel", actualChannel);
                                actualChannel.programs = transformPrograms(programsByChannel[i].programs, pageStartTime, pageEndTime);
                            }

                            $scope.gridLoading = false;

                        }

                    }, function(err){
                        console.log(err)
                    });

                })

            }



            $scope.gridLeftPos = 0;

            $scope.refreshGrid = function(direction, offset){

                //loadPrograms(direction);

                var delta = (screenWidth - (screenWidth*0.02) - 304);

                if(direction === "forward") {
                    $scope.gridLeftPos = $scope.gridLeftPos - delta;
                }else{
                    $scope.gridLeftPos = $scope.gridLeftPos + delta;

                    if($scope.gridLeftPos > 0){
                        $scope.gridLeftPos = 0;
                    }
                }


                $(".programList").css({"-webkit-transform":"translate(" + $scope.gridLeftPos + "px, 0px)"});


            }


            var $doc = angular.element(document);

            function HandlerDown(e) {

                if (event.shiftKey && event.keyCode == 9) {
                    $scope.tabDirection = "backward";
                }else if (event.keyCode == 9) {
                    $scope.tabDirection = "forward";
                }

            }
            $doc.on("keydown", HandlerDown);


            $scope.focused = function(item, e) {

                var elem = document.activeElement,
                    viewportOffset = elem.getBoundingClientRect(),
                    elemRightBorderPos = viewportOffset.left + elem.offsetWidth,
                    thresholdPos = (screenWidth - (screenWidth*0.01) - 10);

                var delta = viewportOffset.left -162;

                function translateGrid() {
                    $(".programList").css({"-webkit-transform":"translate(" + $scope.gridLeftPos + "px, 0px)"});
                }

                if($scope.tabDirection === "forward" && elemRightBorderPos > thresholdPos) {

                    $scope.gridLeftPos = $scope.gridLeftPos - delta;
                    translateGrid();


                }else if($scope.tabDirection === "backward" && (viewportOffset.left < 150 + (screenWidth*0.01))){
                    $scope.gridLeftPos = $scope.gridLeftPos - delta;
                    translateGrid();
                }


            };

            //DATE TIME SELECTION

            function applyDate() {

                for(var i=0; i < 14; i++){
                    $scope.availableDays.push($scope.tomorrow.setDate($scope.tomorrow.getDate() + 1));
                }

                $scope.availableDays[0] = "Aujourd'hui";
                $scope.availableDays[1] = "Demain";

                $scope.nextHour = new Date();

                $scope.hoursOfDay = [];

                var timestamp;
                var hour;

                console.log("$scope.selectedDay", $scope.selectedDay);

            }


            $scope.currentDate = new Date();
            $scope.tomorrow = new Date();
            $scope.selectedDay = 0;
            $scope.selectedTime = 1;
            $scope.availableDays = [ $scope.currentDate ];



            applyDate();

            $scope.changePageStartTime = function(){
                console.log("selectedTime", $scope.selectedTime);
                $scope.gridPage = $scope.selectedDay * 12 + ($scope.selectedTime / 2);
                applyDate();
                $scope.loadPrograms();
            }


            $scope.selectedChannel = "";

            $scope.jumpToChannel = function(){
                $("#star-" + $scope.selectedChannel).focus();
            }


            $ctrl.$onInit = function () {
                AppConfig.setFromParentConfig($ctrl.importedConfig);
                //console.log("AppConfig", $ctrl.importedConfig);
                startTime = AppConfig.getNow();
                endTime = startTime + Time.days(TOTAL_DAYS_IN_GRID);
                //var viewport = new Viewport();
                //var timeSpan = new TimeSpan($scope, startTime, endTime);
                //var gridUnitConverter = new GridUnitConverter(PIXELS_PER_MINUTE, viewport, timeSpan);
                channelsDataLoader = new ChannelsDataLoader(SERVICES_BASE_PATH, AppConfig.getLogoBasePath());

                //var programsLoader = new ProgramsLoader(SERVICES_BASE_PATH, viewport, gridUnitConverter);
                //console.log(SERVICES_BASE_PATH, AppConfig.getLogoBasePath(), startTime)

                //var currentDay = Time.extractMidnightDate(startTime);

                EPGExtraFilters.setPlatformFilter('{"currentPlatformOnly" : "' + InitParams.getCurrentPlatformOnly() + '"}', CURRENT_PLATFORM);
                $ctrl.extraFilters = EPGExtraFilters.getExtraFilters();

                channelsDataLoader.load().then(function (value) {
                    channels.setChannels(value);
                    channelsFilter.setChannels(channels);
                    loadMetadata();
                    channelsChanged(channelsFilter.filter());
                }, function(err){
                    //console.log("err", err);
                });

                LoadingOverlay.hide();
            }


        }
    ]);


angular.module("app.epg.web").controller("pageEpgA11yCtrl",
    ["$scope", "InitParams", "AppConfig", "AppServicesInitializer", "SERVICES_BASE_PATH", "ChannelsDataLoader", "Channels", "Metadata", "MetadataLoader", "LoadingOverlay", "SrvInitializeMainFilter", "CHANNEL_MAIN_FILTERS",
                    "Time", "TimeSpan", "GridUnitConverter", "ChannelsFilter", "ProgramsDataLoader", "SrvLinearContentDetails", "LocalStorage", "EPGExtraFilters", "NativeActions", "SrvChannelFilters", "SrvFavoriteChannel",
        function ($scope, InitParams, AppConfig, AppServicesInitializer, SERVICES_BASE_PATH, ChannelsDataLoader, Channels, Metadata, MetadataLoader, LoadingOverlay, SrvInitializeMainFilter, CHANNEL_MAIN_FILTERS,
                  Time, TimeSpan, GridUnitConverter, ChannelsFilter, ProgramsDataLoader, SrvLinearContentDetails, LocalStorage, EPGExtraFilters, NativeActions, SrvChannelFilters, SrvFavoriteChannel) {

            var TOTAL_DAYS_IN_GRID = 14;
            var PIXELS_PER_MINUTE = 8; // should not need this
            var CURRENT_MAIN_FILTER_STORE_KEY = "main-filter";
            var CURRENT_PLATFORM = "web";
            var programsDataLoader = new ProgramsDataLoader(SERVICES_BASE_PATH);

            var channels = new Channels();
            var channelsFilter = new ChannelsFilter();
            var metadata = new Metadata();
            var metadataLoader = new MetadataLoader(SERVICES_BASE_PATH);

            var startTime;
            var endTime;
            var channelsDataLoader;

            var $ctrl = this;

            var screenWidth = $(document).width();
            //console.log("screenWidth", screenWidth);

            //subtracting 2% left-right margin and star-logo area for calc. 120 for 120min periods
            var pixelToTimeRatio = (screenWidth - (screenWidth*0.02) - 152) / 180;

            //15min from grid start - offscreen for this release
            //$ctrl.currentTimeLinePos = (screenWidth*0.02) + 152 + (pixelToTimeRatio * 15);
            $ctrl.currentTimeLinePos = -10000;

            //console.info("pageEpgA11yCtrl", $ctrl.importedConfig);

            $ctrl.$onChanges = function (changes) {
                //console.log('changes', changes);
                //console.info("pageEpgA11yCtrl", $ctrl.importedConfig)
            };


            // expose to the page scope
            $ctrl.showMainToolbar = false;
            $ctrl.showNoResultsFilterError = false;
            $ctrl.selectedchannelFilter = '';
            $ctrl.channelFiltersList = SrvChannelFilters.getFilters();
            $ctrl.mainFilters = [CHANNEL_MAIN_FILTERS.ALL, CHANNEL_MAIN_FILTERS.FAVORITES, CHANNEL_MAIN_FILTERS.IN_PACKAGE];
            $ctrl.mainFilter = SrvInitializeMainFilter.getIndex($ctrl.mainFilters, CURRENT_MAIN_FILTER_STORE_KEY);
            $ctrl.extraFilters = [];
            $ctrl.groupedChannelsToDisplay = [];

            $ctrl.programLinkAction = function($event, programLinkObj){
                $event.preventDefault();

                // remember original focused item id even after a recording deletion
                $ctrl.modalOriginItemId = $event.currentTarget.id;

                //console.log("programLinkObj",programLinkObj);
                NativeActions.link({link: programLinkObj});
            };

            $ctrl.toggleFavorite = function($event, channel){
                $event.preventDefault();

                // change on backend
                SrvFavoriteChannel.updateChannelFavoriteState(channel, channel.selection).then(function(){
                    var favChannels;
                    metadata.toggleChannelFavoriteState(channel, channel.selection);
                    favChannels = channels.sortChannelsByPosition(metadata.getFavoriteChannels());
                    channelsFilter.setFavoriteChannels(favChannels);

                    //Google Analytics tracking through Native Bridge
                    if (!channel.selection) {
                        NativeActions.trackEvent('Grille Horaire', 'Ajouter à mes sélections', channel.name);
                    } else {
                        NativeActions.trackEvent('Grille Horaire', 'Retirer de mes sélections', channel.name);
                    }

                    // change visual state
                    channel.selection = !channel.selection;
                }, function(){
                    // in case of error, do nothing
                });

            };


            // watchers
            // currentPlatformOnly should probably become a component instead
            $scope.$watch('$ctrl.currentPlatformOnly', function(value){
                var ga_state = value ? 'Sélectionner' : 'Désélectionner';

                if(typeof value !== 'boolean'){
                    return;
                }

                // expects JSON with a value that's a string not a boolean
                EPGExtraFilters.setPlatformFilter(JSON.stringify({currentPlatformOnly : value.toString()}), CURRENT_PLATFORM);
                $ctrl.extraFilters = EPGExtraFilters.getExtraFilters();

                //Google Analytics tracking through Native Bridge
                NativeActions.trackEvent('Grille Horaire', 'Chaînes web seulement', ga_state);
            });

            // selectedchannelFilter should probably become a component instead
            $scope.$watch('$ctrl.selectedchannelFilter', function(filter){
                // console.log("selectedchannelFilter", filter);
                if(typeof filter === 'undefined'){
                    return;
                }
                LoadingOverlay.show();

                if(filter){
                    EPGExtraFilters.setGeneralFilters(filter);

                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Filtre: ' + filter.label);

                }else{
                    EPGExtraFilters.setGeneralFilters();

                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Retirer filtre');
                }
                $ctrl.extraFilters = EPGExtraFilters.getExtraFilters();
                LoadingOverlay.hide();
            });

            //console.log("$scope",$scope)
            $scope.$watch('$ctrl.mainFilter', function(value){
                //console.log("$watch mainFilter", value)
                LocalStorage.set(CURRENT_MAIN_FILTER_STORE_KEY, value);
                channelsFilter.setMainFilter(value);
                channelsChanged(channelsFilter.filter());
            });

            $scope.$watch('$ctrl.extraFilters', function (value) {
                //console.log("$watch extraFilters", value)
                channelsFilter.setExtraFilters(value);
                channelsChanged(channelsFilter.filter());
            });

            $scope.$watch('$ctrl.groupedChannelsToDisplay' ,function(value){
                //console.log("$watch groupedChannelsToDisplay",value);
            });

            // event occurs when recording added/modified/deleted inside ContentDetails modal
            NativeActions.onMetaDataUpdateRequest(function () {
                loadMetadata().then(updateMetaDataOnCurrentPrograms);
            });

            function handleLoaderErrors(errorResponse){
                // TODO handle different types of errors here
                console.error(errorResponse);
            }


            // launch AppServicesInitializer and ChannelsDataLoader
            // get now to establish where to start
            // split next 14 days into viewable section/pages (8hours per page by example)
            // * check out ProgramsLoader.initialize
            // * need to determine how to cleanly handle first page, example :
            // ** it's currently 6:27AM, do we :
            // *** add 8 hours to this (breaking all further pages at 14:27, 22:27, 06:27?)
            // *** tweak page sizes to force clean 00:00, 08:00, 16:00 pages (mean the first page won't be the same size as the other pages)
            // * alternative solution being to force page size to viewport width (example 1000px wide = 100px for logo, 900px for programs, 300 minutes(5 hours) at 3px/minute)
            // * might end up a little strange sometimes to have a page from 11:27 to 15:14 for example
            // launch programsDataLoader with page info and channel filters as params
            // * see how complicated it would be to cache results to avoid useless back-end calls
            // var cache = {
            //     segment0: {
            //         channelId : [ProgramObj, ProgramObj, ProgramObj, ProgramObj]
            //     }
            // }
            // on pagination, launch programsDataLoader again
            // on filter, launch programsDataLoader again
            // add status messages on page updates (with aria role status)

            function updateMetaDataOnCurrentPrograms(){
                $ctrl.groupedChannelsToDisplay.forEach(function(channelGroup){
                    channelGroup.channels.forEach(function(channel) {
                        channel.programs.forEach(function(program) {
                            program.isScheduledRecording = metadata.programIsRecording(program);
                        })
                    })
                });
            }

            function channelsChanged(channelGroups) {
                if(!channelGroups){
                    return
                }

                $ctrl.groupedChannelsToDisplay = channelGroups;

                $ctrl.loadPrograms();

                //console.log('channelsChanged()');
                var noFavorites = false;
                var total = 0;

                channelGroups.forEach(function(group){
                    if (group && group.channels){
                        total += group.channels.length;
                    }
                });

                //console.log("channelsChanged -> total",total);

                // only if metaData has already been set to avoid flicker
                if (metadata.isSet()) {
                    // show error if no favorites, even if we have most watched channels
                    if (channelGroups && channelGroups.length > 1) {
                        for (var i = 0; i < channelGroups.length; i++) {
                            if (channelGroups[i].type === CHANNEL_MAIN_FILTER_GROUPS.FAVORITES && channelGroups[i].channels.length === 0) {
                                noFavorites = true;
                            }
                        }
                    }

                    // show error if no favorites or no channels in channelGroups
                    if (noFavorites || (total === 0 && channelGroups)) {
                        $ctrl.showNoResultsFilterError = true;
                        // since no programs found, programsLoader will never be called, so dismiss spinner and show toolbar now
                        $ctrl.showMainToolbar = true;
                        LoadingOverlay.hide();
                        $ctrl.gridLoading = false;
                        //console.log('channelsChanged::hide');
                    } else {
                        $ctrl.showNoResultsFilterError = false;
                    }
                }
            }

            function loadMetadata() {
                return metadataLoader.load().then(function (value) {
                    //console.log('value: ', value);
                    var favChannels;
                    metadata.setMetadata(value);
                    favChannels = channels.sortChannelsByPosition(metadata.getFavoriteChannels());
                    channelsFilter.setFavoriteChannels(favChannels);
                    channelsChanged(channelsFilter.filter());
                }).catch(handleLoaderErrors);
            }

            function transformPrograms(programsList, pageStartTime, pageEndTime){
                programsList.forEach(function(program){

                    var PIXELS_PER_MINUTE = pixelToTimeRatio;
                    var programStartTime = new Date(program.startTime);
                    var programEndTime = new Date(program.endTime);

                    if(programStartTime < pageStartTime){
                        programStartTime = pageStartTime;
                    }

                    if(programEndTime > pageEndTime){
                        programEndTime = pageEndTime;

                    }

                    program.isScheduledRecording = metadata.programIsRecording(program);

                    program.duration = Time.millisecondsToMinutes(programEndTime - programStartTime) * PIXELS_PER_MINUTE;

                });

                return programsList;
            }


            $ctrl.lastFocusedProgram = "0-0";

            // CODE REVIEW : why expose on $scope? Does not seem to be used outside of this controller...
            // should be normal function instead
            $ctrl.loadPrograms = function (direction){

                $ctrl.gridLoading = true;

                var channelsToLoad = [];

                var HOURS_PER_SCREEN = 3;

                //console.log("$ctrl.selectedDay", $ctrl.selectedDay);

                if(direction === "forward"){
                    $ctrl.selectedTime = $ctrl.selectedTime + HOURS_PER_SCREEN;
                } else if(direction === "backward"){
                    $ctrl.selectedTime = $ctrl.selectedTime - HOURS_PER_SCREEN;
                }

                //reset at midnight
                if($ctrl.selectedTime > 23){
                    $ctrl.selectedTime = $ctrl.selectedTime - 24;
                    $ctrl.selectedDay = $ctrl.selectedDay + 1;
                }

                var timeDiff = ($ctrl.selectedDay * 24) + $ctrl.selectedTime - $ctrl.currentDate.getHours() - 1;

                console.log("timeDiff", timeDiff);

                $ctrl.pageStartTime = new Date(AppConfig.getNow() + Time.hours(timeDiff) - 900000);

                var pageEndTime = new Date($ctrl.pageStartTime.getTime() + (Time.hours(HOURS_PER_SCREEN)));

                // console.log("pageStartTime", $ctrl.pageStartTime);
                // console.log("pageEndTime", pageEndTime);

                //console.log("$ctrl.groupedChannelsToDisplay", $ctrl.groupedChannelsToDisplay);
                $ctrl.groupedChannelsToDisplay.forEach(function(group){

                    group.channels.forEach(function(channel){
                        //console.info(channel.id, channel)
                        channelsToLoad.push(channel.id);
                    });

                    programsDataLoader.load(ENP.customDateFromTs($ctrl.pageStartTime), Time.hoursToMinutes(HOURS_PER_SCREEN), channelsToLoad).then(function (programsByChannel) {
                        if(programsByChannel.length){

                            var actualChannel;

                            var channelRange = programsByChannel.length;
                            //var channelRange = 50;

                            for(var i = 0; i < channelRange; i++){
                                actualChannel = channels.findChannelByID( programsByChannel[i].channelId);
                                //console.log("actualChannel", actualChannel);
                                actualChannel.programs = transformPrograms(programsByChannel[i].programs, $ctrl.pageStartTime, pageEndTime);
                            }

                            $ctrl.gridLoading = false;

                            var lastProgramId = $ctrl.lastFocusedProgram;

                            //console.log("lastProgramId", lastProgramId);

                            lastProgramId = lastProgramId.split("-");

                            setTimeout(function(){
                                if(direction === "forward"){
                                    $("#" + lastProgramId[0] + "-0").focus();
                                    //console.log("#" + lastProgramId[0] + "-0 FOCUS");
                                }else if(direction === "backward"){

                                    //count the num of programs in row
                                    var numPrograms = programsByChannel[lastProgramId[0]].programs.length;

                                    $("#" + lastProgramId[0] + "-" + (numPrograms -1)).focus();
                                }

                                if($ctrl.modalOriginItemId){
                                    $('#' + $ctrl.modalOriginItemId).focus();

                                    // empty scope variable after usage
                                    $ctrl.modalOriginItemId = "";
                                }

                            }, 0);

                        }

                    }).catch(handleLoaderErrors);

                })

            }

            $ctrl.focused = function($event) {
                $ctrl.lastFocusedProgram = $($event.target).attr("id");
            };

            //DATE TIME SELECTION

            function applyDate() {

                for(var i=0; i < 14; i++){
                    $ctrl.availableDays.push($ctrl.tomorrow.setDate($ctrl.tomorrow.getDate() + 1));
                }

                $ctrl.availableDays[0] = "Aujourd'hui";
                $ctrl.availableDays[1] = "Demain";

                $ctrl.hoursOfDay = [];

                var hour = new Date().setHours(0,0,0,0);

                var i;

                for(i=0; i < 24; i++){
                    $ctrl.hoursOfDay.push(hour + (i * 3600000));
                }

                // console.log("$ctrl.selectedDay", $ctrl.selectedDay);
                // console.log("$ctrl.selectedTime", $ctrl.selectedTime);

            }


            $ctrl.currentDate = new Date();
            $ctrl.tomorrow = new Date();
            $ctrl.selectedDay = 0;
            $ctrl.selectedTime = $ctrl.currentDate.getHours() + 1;
            $ctrl.availableDays = [ $ctrl.currentDate ];

            applyDate();


            $ctrl.changePageStartTime = function(){
                console.log("selectedTime", $ctrl.selectedTime);
                applyDate();
                $ctrl.loadPrograms();
            }


            $ctrl.selectedChannel = "";

            $ctrl.jumpToChannel = function(){
                $("#star-" + $ctrl.selectedChannel).focus();
            }

            $ctrl.startedBeforeCurrentTime = function (programStartTime) {
                // console.log("programStartTime", new Date(programStartTime));
                // console.log("currentDate", $ctrl.currentDate);
                return (new Date(programStartTime) < $ctrl.currentDate) ? true : false;
            }


            $ctrl.$onInit = function () {
                AppConfig.setFromParentConfig($ctrl.importedConfig);
                //console.log("AppConfig", $ctrl.importedConfig);
                startTime = AppConfig.getNow();
                endTime = startTime + Time.days(TOTAL_DAYS_IN_GRID);
                //var viewport = new Viewport();
                //var timeSpan = new TimeSpan($scope, startTime, endTime);
                //var gridUnitConverter = new GridUnitConverter(PIXELS_PER_MINUTE, viewport, timeSpan);
                channelsDataLoader = new ChannelsDataLoader(SERVICES_BASE_PATH, AppConfig.getLogoBasePath());

                //var programsLoader = new ProgramsLoader(SERVICES_BASE_PATH, viewport, gridUnitConverter);
                //console.log(SERVICES_BASE_PATH, AppConfig.getLogoBasePath(), startTime)

                //var currentDay = Time.extractMidnightDate(startTime);

                EPGExtraFilters.setPlatformFilter('{"currentPlatformOnly" : "' + InitParams.getCurrentPlatformOnly() + '"}', CURRENT_PLATFORM);
                $ctrl.extraFilters = EPGExtraFilters.getExtraFilters();

                channelsDataLoader.load().then(function (value) {
                    channels.setChannels(value);
                    channelsFilter.setChannels(channels);
                    loadMetadata();
                    channelsChanged(channelsFilter.filter());
                }).catch(handleLoaderErrors);

                LoadingOverlay.hide();
            }


        }
    ]);


angular.module("app.epg.web").config(["AppConfigProvider", "SERVICES_BASE_PATH", "HttpInterceptorProvider", "$httpProvider", "LoadingOverlayProvider", "$provide", "$exceptionHandlerProvider",
    function (AppConfigProvider, SERVICES_BASE_PATH, HttpInterceptorProvider, $httpProvider, LoadingOverlayProvider,
              $provide, $exceptionHandlerProvider) {

        // all the page urls where the $exceptionHandler should handle the error, all others handled by the web exception handler
        var urlsOfPagesToHandleErrorsRegExp =  new RegExp(/tele-horaire|tv-guide|mes-enregistrements|my-recordings/);

        // all the urls where the HttpInterceptor should handle the HTTP error, all others handled by the web responseInterceptor
        var urlsOfServicesToInterceptRegExp =  new RegExp(/appEnp\/|recording\/|recordings|terminals\/recorders|content\/recorded\/|content\/linear\/|guide\//);

        $exceptionHandlerProvider.setErrorPageUrl("/error");
        $exceptionHandlerProvider.setAuthenticationErrorPageUrl("/authenticationError");
        $exceptionHandlerProvider.setPerceptionErrorPageUrl("/perceptionError");
        $exceptionHandlerProvider.setEmbeddedInWebsite(urlsOfPagesToHandleErrorsRegExp);

        // configure template path for web version only
        LoadingOverlayProvider.setTemplatePath("/appEnp/templates/common-web/loadingOverlay.web.template.html");
        LoadingOverlayProvider.setAppendNode("#site_content_wrapper");

        $provide.decorator("AppConfig", ["$delegate", "AppConfigDecorator", function ($delegate, AppConfigDecorator) {
            return AppConfigDecorator.decorate($delegate);
        }]);

        HttpInterceptorProvider.setMaintenanceUrl("/maintenance/maintenance-web.html");
        HttpInterceptorProvider.setEmbeddedInWebsite(urlsOfServicesToInterceptRegExp);
        $httpProvider.interceptors.push("HttpInterceptor");

        // always need credentials now that webgate server in place
        $httpProvider.defaults.withCredentials = true;

        AppConfigProvider.setServiceBasePath(SERVICES_BASE_PATH);
        AppConfigProvider.setThumbsImagePathName("thumbsImagePath");
        AppConfigProvider.setLargeThumbsImagePathName("largeThumbsImagePath");



    }]);


angular.module("app.epg.web").controller("CtrlEPG",
    ["$scope", "$rootScope", "$filter", "Clock", "Time", "$timeout", "GroupedProgramsTooltip", "LocalStorage",
        "CHANNEL_MAIN_FILTERS", "SERVICES_BASE_PATH", "SrvChannelFilters", "AppConfig", "NativeActions", "EPGExtraFilters", "SrvFavoriteChannel",
        "$translate", "InitParams", "SrvLinearContentDetails", "SrvInitializeMainFilter", "LoadingOverlay", "AppServicesInitializer", "$interval",
        function ($scope, $rootScope, $filter, Clock, Time, $timeout, GroupedProgramsTooltip, LocalStorage,
                  CHANNEL_MAIN_FILTERS, SERVICES_BASE_PATH, SrvChannelFilters, AppConfig, NativeActions, EPGExtraFilters,
                  SrvFavoriteChannel, $translate, InitParams, SrvLinearContentDetails, SrvInitializeMainFilter, LoadingOverlay, AppServicesInitializer, $interval) {
            //console.info('CtrlEPG');
            var UPDATE_METADATA_EVENT_NAME = "update_meta_data";
            var UPDATE_PROFILE_EVENT_NAME = "update_profile_data";
            var APP_WAKE_UP_EVENT_NAME = "app_wake_up";//mobile
            var CURRENT_MAIN_FILTER_STORE_KEY = "main-filter";
            var MINUTES_INTO_THE_PAST = 120; // should always be >= (CHANNELS_COLUMN_WIDTH / PIXELS_PER_MINUTE)
            var MINUTES_BETWEEN_NOW_LINE_AND_CHANNELS_EDGE = 30;
            var TOTAL_DAYS_IN_GRID = 14;
            var RESET_TIME = Time.minutes(60);
            var CHANNEL_FILTER_LABEL = $translate.instant("CHANNEL FILTER LABEL");
            var CURRENT_PLATFORM = "web";

            var intervalsTimeouts = [];
            var clock = new Clock(10000);
            var epgDataShare = {
                currentDay: null,
                startTime: null,
                timespan: null,
                now: null,
                servicesBasePath: SERVICES_BASE_PATH,
                logoBasePath: null,
                focusedRow: undefined,
                programOrChannelClick: null,
                channelStarClick: null,
                updateMetaDataEventName: UPDATE_METADATA_EVENT_NAME,
                updateProfileDataEventName: UPDATE_PROFILE_EVENT_NAME,
                appWakeUpEventName: APP_WAKE_UP_EVENT_NAME,//mobile
                scrollButtonListener: null,
                scrollPosition: null,
                showNoResultsFilterError: false,
                mainFilter: null,
                extraFilters: null,
                gridContainerParentId: '#tvguide'
            };

            $scope.epgDataShare = epgDataShare;

            $scope.dataConfigIsResolved = false;

            // Web channels only
            $scope.currentPlatformOnly = false;
            $scope.toggleCurrentPlatform = function(){
                // expects JSON with a value that's a string not a boolean
                NativeActions.fakeNativeBridgeIn('setPlatform', JSON.stringify({currentPlatformOnly : $scope.currentPlatformOnly.toString()}));

                if($scope.currentPlatformOnly){
                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Chaînes web seulement', 'Sélectionner');
                }else{
                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Chaînes web seulement', 'Désélectionner');
                }

            };

            // Channel filter pane
            function toggleFilterPane(){
                $scope.channelFiltersAreOpen = !$scope.channelFiltersAreOpen;

                if($scope.channelFiltersAreOpen){
                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Ouvrir paneau');
                }else{
                    //Google Analytics tracking through Native Bridge
                    NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Fermer paneau');

                }
            }
            function isFilterActive(){
//                console.log('isFilterActive()');
//                console.log('$scope.selectedChannelFilterLabel: ',$scope.selectedChannelFilterLabel);
//                console.log('CHANNEL_FILTER_LABEL: ',CHANNEL_FILTER_LABEL);
                return $scope.selectedChannelFilterLabel !== CHANNEL_FILTER_LABEL;
            }
            function removeFilters(){
//                console.log('removeFilters()');
                NativeActions.fakeNativeBridgeIn('setFilter',[]);
                $scope.selectedChannelFilterLabel = CHANNEL_FILTER_LABEL;

                //Google Analytics tracking through Native Bridge
                NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Retirer filtre');
            }
            function addFilter(criteria){
//                console.log('addFilter()');
//                console.log('criteria: ',criteria);
                NativeActions.fakeNativeBridgeIn('setFilter',[criteria]);
                $scope.selectedChannelFilterLabel = criteria.label;

                //Google Analytics tracking through Native Bridge
                NativeActions.trackEvent('Grille Horaire', 'Filtrer les chaines', 'Filtre: ' + criteria.label);
            }

            $scope.channelFiltersAreOpen = false;
            $scope.channelFiltersList = SrvChannelFilters.getFilters();
            $scope.selectedChannelFilterLabel = CHANNEL_FILTER_LABEL;
            $scope.toggleFilterPane = toggleFilterPane;
            $scope.removeFilters = removeFilters;
            $scope.isFilterActive = isFilterActive;

            $scope.toggleChannelsFilter = function(criteria){
//                console.log('toggleChannelsFilter()');
//                console.log('criteria: ',criteria);
//                console.log('$scope.selectedChannelFilterLabel: ',$scope.selectedChannelFilterLabel);
                if($scope.selectedChannelFilterLabel === criteria.label){
                    removeFilters();
                    toggleFilterPane();
                }else{
                    addFilter(criteria);

                    // wait a little before closing the menu
                    // this seems like a bad idea, removing for now
                    // intervalsTimeouts.push($timeout(toggleFilterPane, 500));
                }
            };


            // move the whole grid left a little so that "now" line is visible on screen
            function startTime(now){return now - Time.minutes(MINUTES_INTO_THE_PAST);};
            function displayedNowTime(now){return now - Time.minutes(MINUTES_BETWEEN_NOW_LINE_AND_CHANNELS_EDGE);};


            EPGExtraFilters.setPlatformFilter('{"currentPlatformOnly" : "' + InitParams.getCurrentPlatformOnly() + '"}', CURRENT_PLATFORM);

            epgDataShare.extraFilters = EPGExtraFilters.getExtraFilters();


            $scope.$on("group_click", function (event, data) {
                GroupedProgramsTooltip.show(data.element, data.programs, data.channel, function (program) {
                    NativeActions.link(program);
                });

                //the tooltip is mispositioned when page scrolled; just close the tooltip if scroll evt is detected
                $(document).bind('scroll',
                    function(evt) {
//                        console.log('evt: ',evt);
                        GroupedProgramsTooltip.hide();

                        //unregister listener
                        $(document).unbind('scroll');
                    }
                );
            });



            $scope.mainFilters = [CHANNEL_MAIN_FILTERS.ALL, CHANNEL_MAIN_FILTERS.FAVORITES, CHANNEL_MAIN_FILTERS.IN_PACKAGE];

            epgDataShare.mainFilter = SrvInitializeMainFilter.getIndex($scope.mainFilters, CURRENT_MAIN_FILTER_STORE_KEY);


            $scope.googleAnalyticsEvent = function (type, value) {

                //Google Analytics tracking through Native Bridge
                if(type == "select day"){
                    var dayDiff = Math.ceil((value.time - new Date())/(24*3600*1000)) * 10 /10;
                    if(dayDiff != "-0"){ //do not track on initial page load $watch
                    NativeActions.trackEvent('Grille Horaire', 'Sélectionner jour', 'Aujourd\'hui + ' + dayDiff + ' jours');
                    }
                }else if(type == "filter tab"){
                    NativeActions.trackEvent('Grille Horaire', 'Onglets', value);
                }
            };

            $scope.setFilterCurrent = function (filter) {
                //console.log('filter: ', filter);
                epgDataShare.mainFilter = filter;
            };


            NativeActions.onFilterChange(function (event, filter) {
//                console.log('CtrlEPG::onFilterChange()');
//                console.log('event: ',event);
//                console.log('filter: ',filter);
                // filter is actually an JSON of an array of filters
                if (typeof(filter) === "string") {
                    filter = JSON.parse(filter);
                }

                EPGExtraFilters.setGeneralFilters(filter);
                epgDataShare.extraFilters = EPGExtraFilters.getExtraFilters();

                // close tooltip since grid will change
                GroupedProgramsTooltip.hide();
            });

            NativeActions.onPlatformChange(function (event, filter) {
                EPGExtraFilters.setPlatformFilter(filter, CURRENT_PLATFORM);
                epgDataShare.extraFilters = EPGExtraFilters.getExtraFilters();

                // close tooltip since grid will change
                GroupedProgramsTooltip.hide();
            });


            NativeActions.onMetaDataUpdateRequest(function () {
                $scope.$broadcast(UPDATE_METADATA_EVENT_NAME);
            });


            NativeActions.onProfileDataUpdateRequest(function () {
                $scope.$broadcast(UPDATE_PROFILE_EVENT_NAME);
            });


            $scope.$watch("epgDataShare.mainFilter", function (value) {
                //console.log('$watch::epgDataShare.mainFilter');
                //console.log('value: ',value);
                LocalStorage.set(CURRENT_MAIN_FILTER_STORE_KEY, value);
            });


            epgDataShare.programOrChannelClick = function (programOrChannel) {
                NativeActions.link(programOrChannel);
            };

            epgDataShare.channelStarClick = function (channel, channelIsFavorite) {
                // NativeActions.addToFavorites(channelIsFavorite); // not used in web
                return SrvFavoriteChannel.updateChannelFavoriteState(channel, channelIsFavorite);
            };


            function epgInit() {
                //console.log('epgInit()');
                LoadingOverlay.show();
                //console.log('epgInit::show');

                AppServicesInitializer.initialize(['AppConfig'])
                    .then(function (response) {
                        //console.log('response: ', response);
                        var nowFromInit = AppConfig.getNow();
                        // make the last day in the grid end at midnight and not actually 14 days ahead
                        var startTimeDateObject = new Date(startTime(nowFromInit));
                        var ms_elapsed_today = Time.hours(startTimeDateObject.getHours()) + Time.minutes(startTimeDateObject.getMinutes());
                        var timeSpan = Time.days(TOTAL_DAYS_IN_GRID) - ms_elapsed_today;

                        clock.setReferenceTime(nowFromInit);
                        clock.addSecondCycleListener(function () {
                            epgDataShare.now = clock.getTime();
                        }, 20);
                        clock.start();

                        epgDataShare.now = clock.getTime();
                        epgDataShare.startTime = {
                            value: startTime(nowFromInit)
                        };
                        epgDataShare.displayedNowTime = {
                            value: displayedNowTime(nowFromInit)
                        };
                        epgDataShare.timespan = {
                            value: timeSpan
                        };
                        //day starts at midnight
                        epgDataShare.currentDay = {
                            time: Time.extractMidnightDate(nowFromInit)
                        };
                        epgDataShare.logoBasePath = AppConfig.getLogoBasePath();

                        if (AppConfig.showChannel()) {
                            epgDataShare.focusedRow = AppConfig.getChannelIdToShow();
                        }

                        $scope.dataConfigIsResolved = true;

                        clock.addExceptionHandler(resetApp);

                        intervalsTimeouts.push($interval(resetApp, RESET_TIME));

                        LoadingOverlay.hide();
                        //console.log('epgInit::hide');
                    });
            }

            function resetApp() {
                //console.log('resetApp()');
                LoadingOverlay.show();
                //console.log('resetApp::show');

                AppServicesInitializer.initialize(['AppConfig'])
                    .then(function (response) {
                        //console.log('response: ', response);
                        var nowFromInit = AppConfig.getNow();
                        // make the last day in the grid end at midnight and not actually 14 days ahead
                        var startTimeDateObject = new Date(startTime(nowFromInit));
                        var ms_elapsed_today = Time.hours(startTimeDateObject.getHours()) + Time.minutes(startTimeDateObject.getMinutes());
                        var timeSpan = Time.days(TOTAL_DAYS_IN_GRID) - ms_elapsed_today;

                        epgDataShare.startTime = {
                            value: startTime(nowFromInit)
                        };
                        epgDataShare.timespan = {
                            value: timeSpan
                        };

                        clock.stop();
                        clock.setReferenceTime(nowFromInit);
                        clock.start();

                        epgDataShare.now = clock.getTime();

                        LoadingOverlay.hide();
                        //console.log('resetApp::hide');
                    });
            }


            //destroy intervals/timeouts when scope gets destroyed
            $scope.$on('$destroy', function (evt) {
                //console.log('evt: ', evt);
                if (intervalsTimeouts.length > 0) {
                    for (var i = -1, j = intervalsTimeouts.length; ++i < j;) {
                        $interval.cancel(intervalsTimeouts[i]);
                        $timeout.cancel(intervalsTimeouts[i]);
                        intervalsTimeouts[i] = undefined;
                    }
                }

                intervalsTimeouts = [];
            });


            //INIT
            epgInit();
        }
    ]);


angular.module("app.epg.web").directive("epgScrollButtons", ["NativeActions", "$parse", "$translate", "$anchorScroll", function (NativeActions, $parse, $translate, $anchorScroll) {

    return {
        restrict: "A",
        template: "<div class='horizontal-scroll-button left'><div class='left'></div></div><div class='horizontal-scroll-button right'><div class='right'></div></div><div class='vertical-scroll-button' ng-class='showOnceScrolled'><div class='scroll-to-top'>{{scrollToTop}}</div></div>",
        scope: {
            scrollButtonListener: "=",
            scrollPosition: "=",
            showNoResultsFilterError: "=",
            mainFilter: "=",
            extraFilters: "="
        },
        link: function ($scope, $element, $attributes) {

            // percentage of the viewport to scroll on click
            var CLICK_SCROLL_DISTANCE = 0.4;
            var PARENT_ELEMENT = "body";

            $scope.scrollToTop = $translate.instant("scrollToTop");
            $scope.$watch("scrollPosition", function (value) {
                if (angular.isDefined(value) && value <= 100) {
                    $scope.showOnceScrolled = "show";
                } else {
                    $scope.showOnceScrolled = "";
                }
            });

            function isLeftArrow(keycode) {
                return keycode === 37;
            }

            function isRightArrow(keycode) {
                return keycode === 39;
            }

            function startScroll(scrollFromLeftToRight) {
                var data = {
                    scrollFromLeftToRight: scrollFromLeftToRight,
                    scrollDistance: CLICK_SCROLL_DISTANCE
                };

                $scope.scrollButtonListener(data);
            }

            function stopScroll() {
                $scope.scrollButtonListener(null);
            }

            function scrollToTop() {
                // by not setting an anchor, we'll scroll to top of page
                $anchorScroll();
            }


            function pointerStartEvent(event) {
                var isScrollToTop = $(event.target).hasClass("scroll-to-top");
                var scrollFromLeftToRight = $(event.target).hasClass("right");
                if (isScrollToTop) {
                    scrollToTop();
                } else {
                    startScroll(scrollFromLeftToRight);
                }

            }

            function pointerStopEvent() {
                stopScroll();
            }

            function keyboardStartEvent(event) {
                var keyCode = event.keyCode;
                if (isRightArrow(keyCode)) {
                    startScroll(true);
                } else if (isLeftArrow(keyCode)) {
                    startScroll(false);
                }
            }

            function keyboardStopEvent(event) {
                var keyCode = event.keyCode;
                if (isRightArrow(keyCode) || isLeftArrow(keyCode)) {
                    stopScroll();
                }
            }



            function handleFilterChange(){
                if($scope.showNoResultsFilterError){
                    $element.hide();
                }else{
                    $element.show();
                }
            }

            var watchNoResults = $scope.$watch("showNoResultsFilterError", handleFilterChange);
            var watchMainFilter = $scope.$watch("mainFilter", handleFilterChange);
            var watchExtraFilters = $scope.$watch("extraFilters", handleFilterChange);

            function destroy() {
                // unbind all listeners and watchers once this directive is destroyed
                $element.unbind("mousedown", pointerStartEvent);
                $(PARENT_ELEMENT).unbind("mouseup", pointerStopEvent);
                $(PARENT_ELEMENT).unbind("keydown", keyboardStartEvent);
                $(PARENT_ELEMENT).unbind("keyup", keyboardStopEvent);
                watchNoResults();
                watchMainFilter();
                watchExtraFilters();
                $element.unbind("$destroy", destroy);
            }

            $element.bind("mousedown", pointerStartEvent);
            $(PARENT_ELEMENT).bind("mouseup", pointerStopEvent);
            $(PARENT_ELEMENT).bind("keydown", keyboardStartEvent);
            $(PARENT_ELEMENT).bind("keyup", keyboardStopEvent);
            $element.bind("$destroy", destroy);


        }
    }


}]);
// TODO make common
angular.module("app.epg.web").directive("favoriteTutorial", function () {


    return {
        restrict: "A",
        require: "^filterCombinationError",
        link: function (scope, element, attributes, filterCombinationErrorController) {

            scope.close = function () {
                filterCombinationErrorController.close();
            };

        }
    };

});
// TODO make common
angular.module("app.epg.web").directive("filterCombinationError", ["CHANNEL_MAIN_FILTERS", "$translate", function (CHANNEL_MAIN_FILTERS, $translate) {

    return {
        restrict: "A",
        templateUrl: "/appEnp/templates/epg/directives/filter-combination-error.template.html",
        replace: true,
        scope: {
            showNoResultsFilterError: "=",
            mainFilter: "=",
            extraFilters: "="
        },
        controller: ["$scope", function ($scope) {

            this.close = function () {
                $scope.showNoResultsFilterError = false;
            };

        }],
        link: function (scope, element, attributes) {
            scope.contentUrl = null;

            function handleStateChange() {
                if (scope.showNoResultsFilterError) {
                    if (scope.mainFilter === CHANNEL_MAIN_FILTERS.FAVORITES && scope.extraFilters.length === 0) {
                        scope.contentUrl = "/appEnp/templates/epg/directives/favorites-tutorial.template.html";
                    } else {
                        scope.contentUrl = "/appEnp/templates/epg/directives/base-filter-combination-error.template.html";
                    }
                } else {
                    scope.contentUrl = null;
                }

                var filters = [];

                filters.push($translate.instant(scope.mainFilter.label));
                for (var i = 0, count = scope.extraFilters.length; i < count; i++) {
                    filters.push(scope.extraFilters[i].name);
                }
                scope.filters = filters;
            }


            scope.$watch("showNoResultsFilterError", handleStateChange);
            scope.$watch("mainFilter", handleStateChange);
            scope.$watch("extraFilters", handleStateChange);

        }
    };


}]);
// TODO make common
angular.module("app.epg.web").directive("selectDay", ["Time", "Day", "UID", function (Time, Day, UID) {

    return {

        restrict: "A",
        scope: {
            startDay: "=",
            endDay: "=",
            selectedDay: "=",
            now: "="
        },
        templateUrl: "/appEnp/templates/epg/directives/select-day_web.template.html",
        replace: true,
        link: function (scope, element, attributes) {
            var removeStartDayWatcher;
            var removeEndDayWatcher;

            scope.templateId = UID.get("template-");

            scope.days = [];

            function updateAvailableDays() {
                var startDay = Time.extractMidnightDate(scope.startDay);
                var endDay = Time.extractMidnightDate(scope.endDay);
                if (startDay > endDay){
                    throw new Error("Illegal arguments error");
                }
                var days = [];
                var t = startDay;
                do {
                    days.push(new Day(t));
                    t = Time.nextDay(t);
                } while (t < endDay);
                scope.days = days;
            }


            function updateSelectedDay() {
                var selectedDay = scope.selectedDay;
                var startDay = scope.startDay;
                var endDay = scope.endDay;
                if (selectedDay && (selectedDay.time < startDay || selectedDay.time > endDay)) {
                    scope.selectedDay = scope.days[0];
                }
            }

            removeStartDayWatcher = scope.$watch("startDay", function (value) {
                updateAvailableDays();
                updateSelectedDay();
            });

            removeEndDayWatcher = scope.$watch("endDay", function (value) {
                updateAvailableDays();
                updateSelectedDay();
            });

            function destroy() {
                element.unbind("$destroy", destroy);
                removeEndDayWatcher();
                removeStartDayWatcher();
            }

            element.bind("$destroy", destroy);


        }

    };

}]);
angular.module("app.epg.web").directive("selectMainFilter", ["$translate", "Time", "Day", "UID", function ($translate, Time, Day, UID) {

    return {

        restrict: "A",
        scope: {
            mainFilters: "=",
            mainFilter: "="
        },
        templateUrl: "/appEnp/templates/epg/directives/select-main-filter.template.html",
        replace: true,
        link: function (scope, element, attributes) {

            scope.$watch("mainFilter", function (value) {
                scope.selectedMainFilterLabel = $translate.instant(scope.mainFilter.label);
            });

        }

    };

}]);
// TODO make common
angular.module("app.epg.web").filter("formatDay", ["$filter", "Time", "$translate", "$sce", function ($filter, Time, $translate, $sce) {
    var dateFilter = $filter("date");

    var dateFormat = "vl_date_format";

    return function (inputDay, now) {
        var inputDayDayCount = Time.millisecondsToNumberOfDays(inputDay.time);
        var nowDayCount = Time.millisecondsToNumberOfDays(Time.extractMidnightDate(now)); // day starts at midnight
        var inputDate = new Date(inputDay.time);
        var result;
        if (inputDayDayCount === nowDayCount) {
            result = $translate.instant("Today") + "<span> (" + dateFilter(inputDate, dateFormat) + ")</span>";
        } else if (inputDayDayCount - 1 === nowDayCount) {
            result = $translate.instant("Tomorrow") + "<span>  (" + dateFilter(inputDate, dateFormat) + ")</span>";
        } else {
            result = dateFilter(inputDate, dateFormat);
        }
        return $sce.trustAsHtml(result);
    };
}]);
angular.module("app.epg.web").config(["NativeBridgeProvider", function (NativeBridgeProvider) {

    NativeBridgeProvider.setBridgeINExpression("enpWebBridgeIn");
    NativeBridgeProvider.setBridgeOUTExpression("enpWebBridgeOut");

}]);
angular.module("app.epg.web").config(["$routeProvider", function ($routeProvider) {
    // EPG routing handled in IllicoWebClient

    $routeProvider
        .when("/error", {
            templateUrl: "/appEnp/templates/common/error.template.html",
            controller: "CtrlError"
        })
        .when("/authenticationError", {
            templateUrl: "/appEnp/templates/common/error.authentication.template.html",
            controller: "CtrlAuthenticationError"
        })
        .when("/perceptionError", {
            templateUrl: "/appEnp/templates/common/error.perception.template.html",
            controller: "CtrlPerceptionError"
        });
}]);
angular.module("app.epg.web").run(["$document", function ($document) {
    //prevent page scroll on IPAD
//    $document[0].ontouchmove = function (event) {
//        event.preventDefault();
//    };
}]);

// TODO make common
angular.module("app.epg.web").service("AppConfigDecorator", ["$q", "$location", function ($q, $location) {


    function addShowChannelExtraConfig(data) {
        var url = $location.$$absUrl;
        var result = /channelId=([^&#]*)/g.exec(url);
        if (result) {
            data.channelId = result[1];
        } else {
            data.channelId = null;
        }
    }

    function addExtraConfig(data) {
        var extraConfig = {};
        if (data.extra) {
            throw new Error("'extra' key is already defined in the config");
        } else {
            data.extra = extraConfig;
        }
        addShowChannelExtraConfig(extraConfig);
        return data;
    }

    function illegalOverriding() {
        throw new Error("Illegal overriding");
    }


    this.decorate = function (appConfig) {
        var initialize = appConfig.initialize;

        appConfig.initialize = function () {
            return initialize.call(appConfig).then(function (data) {
                return addExtraConfig(data);
            }, function (error) {
                $q.reject(error);
            });
        };

        appConfig.showChannel = appConfig.showChannel ? illegalOverriding() : function () {
            var data = appConfig.get();
            return data && data.extra && data.extra.channelId;
        };

        appConfig.getChannelIdToShow = appConfig.getChannelIdToShow ? illegalOverriding() : function () {
            var data = appConfig.get();
            return data && data.extra ? data.extra.channelId : null;
        };

        return appConfig;
    };

}]);
// TODO make common
angular.module("app.epg.web").service("EPGExtraFilters", [ "$translate", function ($translate) {
    var platformFilter = [];//web channels
    var generalFilters = [];//HD, Francophones, Anglophones,...
    var extraFilters = [];

    function updateExtraFilters() {
        extraFilters = [].concat(platformFilter).concat(generalFilters);
    }

    function createFilterFunction(filter) {
        var result;
        switch (true) {
            case filter.key === "genre":
                result = function (channel) {
                    // genre value is an integer but filter value is a string
                    return channel[filter.key] === parseInt(filter.value);
                };
                break;
            case filter.key === "freePreview":
                result = function (channel) {
                    return channel[filter.key] === true;
                };
                break;
            case filter.key === "isHd":
                result = function (channel) {
                    return channel.isHd || false;
                };
                break;
            case filter.key === "isUhd":
                result = function (channel) {
                    return channel.isUhd || false;
                };
                break;
            case filter.hasOwnProperty("currentPlatformOnly"):
                // purposely testing truthy here
                if (filter.currentPlatformOnly == true) {
                    result = function (channel) {
                        return channel.hasLinearFeed;
                    };
                } else {
                    result = null;
                }
                break;
            default :
                // currently lang filter uses default
                result = function (channel) {
                    return channel[filter.key] === filter.value;
                };
        }
        return result;
    }

    function createFiltersFunctions(filters) {
        var result = [];
        var filtersIsDefined = angular.isDefined(filters);
        if (filtersIsDefined && !angular.isArray(filters)) {
            filters = [filters];
        } else if (!filtersIsDefined) {
            filters = [];
        }
        for (var i = 0, count = filters.length; i < count; i++) {
            var filter = filters[0];
            var func = createFilterFunction(filter);
            if (func) {
                result.push({func: func, name: filter.label});
            }
        }
        return result;
    }

    this.setGeneralFilters = function (filters) {
        generalFilters = createFiltersFunctions(filters);
        updateExtraFilters();
    };

    this.setPlatformFilter = function (filter, platform) {
        if(typeof(filter) === "string"){
            filter = JSON.parse(filter);
        }
        // force boolean from string boolean
        filter.currentPlatformOnly = (filter.currentPlatformOnly == "true");
        filter.label = $translate.instant(platform + "Only");
        platformFilter = createFiltersFunctions(filter);
        updateExtraFilters();
    };

    this.getExtraFilters = function () {
        return extraFilters;
    };

    // todo should be added to others
    this.resetFilters = function() {
        platformFilter = [];
        generalFilters = [];
        updateExtraFilters();
    };
}]);
// TODO make common
angular.module("app.epg.web").service("GroupedProgramsTooltip",
    ["Tooltip", "$filter", function (Tooltip, $filter) {

        var PROGRAM_INDEX_ATTRIBUTE_NAME = "program-index";

        function createContent(programs, channel) {

            var dateFilter = $filter("date");

            var result = [];
            var programCount = programs.length;
            result.push("<div class=\"grouped-programs-tooltip\"><div class=\"qtip-titlebar channel-name\">",
                channel.name,
                "</div><ul>");
            for (var i = 0; i < programCount; i++) {
                var program = programs[i];
                var startTime = dateFilter(ENP.tsFromCustomDate(program.startTime), "shortTime");
                var selection = program.extra.selection ? "<span class=\"selection\"></span>" : "";
                var recording = program.extra.recording ? "<span class=\"recording\"></span>" : "";
                var adult = program.ratingIcon === "ADULT" ? "<span class=\"adult\"></span>" : "";

                var extra = "<span class=\"extra\">" + selection + recording + adult + "</span>";

                result.push("<li ",
                    PROGRAM_INDEX_ATTRIBUTE_NAME,
                    "='",
                    i,
                    "'><span class='inner-wrapper'><span class=\"start-time\">",
                    startTime,
                    "</span> <span class=\"title\">",
                    program.title,
                    "</span>", extra, "</span></li>");

            }
            result.push("</ul></div>");
            return result.join("");
        }


        this.show = function (target, programs, channel, programClickCallback) {
            var content = createContent(programs, channel);
            var contentElement = angular.element(content);
           function contentElementClick(event) {
                var targetElement = angular.element(event.target).closest("li");
                var programIndex = parseInt(targetElement.attr(PROGRAM_INDEX_ATTRIBUTE_NAME));
                if (!isNaN(programIndex)) {
                    var program = programs[programIndex];
                    programClickCallback.call(null, program);
                    Tooltip.hide();
                }
            }
            contentElement.on("click", contentElementClick);
            Tooltip.show(target, contentElement, "click", function () {
                contentElement.off("click", contentElementClick);
            });
        };


        this.hide = function () {
            Tooltip.hide();
        };


    }]);
angular.module("app.pvr.web").controller("pagePvrA11yCtrl",
    ["$scope", "$rootScope", "$filter", "$q", "Clock", "Time", "LocalStorage", "DeleteRecordingModal", "DeleteRecordingsModal", "SrvLinearContentDetails", "RecordingsDataLoader", "Recordings", "SrvTerminals", "SERVICES_BASE_PATH", "AppConfig", "NativeActions", "RECORDINGS_CATEGORIES", "RECORDING_STATE", "RECORDINGS_SORT", "$document", "RecordingsFilterSort", "LoadingOverlay", "$translate", "AppServicesInitializer",
        function ($scope, $rootScope, $filter, $q, Clock, Time, LocalStorage, DeleteRecordingModal, DeleteRecordingsModal, SrvLinearContentDetails, RecordingsDataLoader, Recordings, SrvTerminals, SERVICES_BASE_PATH, AppConfig, NativeActions, RECORDINGS_CATEGORIES, RECORDING_STATE, RECORDINGS_SORT, $document, RecordingsFilterSort, LoadingOverlay, $translate, AppServicesInitializer) {
            //console.info('CtrlPVR');
            var RECORDS_FILTER_COOKIE_STORE_KEY = "recordings-sorted-by";

            var recordingsDataLoader;
            var recordingsFilterSort = new RecordingsFilterSort();
            var recordings = new Recordings();



            var $ctrl = this;

            $ctrl.recordingsCategory = null;
            $ctrl.recordingsSortedBy = null;
            $ctrl.recordingsSortableBy = null;//not implemented in all platforms
            $ctrl.showRecordingsSelection = false;
            $ctrl.selectedRecordings = [];
            $ctrl.programOrChannelClick = angular.noop;
            $ctrl.recordingLongPress = angular.noop;//not implemented in all platforms
            $ctrl.deleteRecord = angular.noop;
            $ctrl.recordingsReturnNoResult = false;
            $ctrl.editTerminalName = angular.noop;
            $ctrl.gridContainerParentId = '#tvguide';
            $ctrl.showMainToolbar = false;


            $ctrl.dataConfigAndTerminalsAreResolved = false;
            $ctrl.groupedSortedRecordingsList = [];





            $rootScope.googleAnalyticsEvent = function (type, value) {
                //Google Analytics tracking through Native Bridge
                if(type === "select filter"){
                    NativeActions.trackEvent('Page "mes enregistrements"', 'Sélectionner filtre', $translate.instant(value));
                }else if(type === "filter tab"){
                    NativeActions.trackEvent('Page "mes enregistrements"', 'Onglets', value);
                }
            };

            // Recordings sorting
            function initializeRecordSorting(defaultValue) {
                var storedId = LocalStorage.get(RECORDS_FILTER_COOKIE_STORE_KEY);
                var result = defaultValue;
                angular.forEach(RECORDINGS_SORT, function (filter) {
                    if (filter.id === storedId) {
                        result = filter;
                    }
                });

                return result;
            }

            $ctrl.deleteSingleRecording = function($event, recording){
                $event.stopPropagation();
                DeleteRecordingModal.confirmDeleteRecording(recording, function(){
                    loadRecordings(false);
                }, function(){
                    loadRecordings(false);
                 }).catch(function(){
                    loadRecordings(false);
                });
            };

            $ctrl.deleteMultipleRecordings = function($event, recordings){
                var recordingIds = [];

                $event.stopPropagation();
                recordings.forEach(function(recording){
                   if(recording && recording.recordingId){
                       recordingIds.push(recording.recordingId);
                   }
                });
                DeleteRecordingsModal.confirmDeleteRecordings(recordingIds, null, function(){
                    $ctrl.showRecordingsSelection = false;
                    loadRecordings(false);
                }, function(){
                    loadRecordings(false);
                 }).catch(function(){
                    loadRecordings(false);
                });
            };

            $ctrl.programOrChannelClick = function (programOrChannel) {
                // ignore click on logo by filtering out provider link
                if(programOrChannel.objectType !== "CHANNEL"){
                    NativeActions.link(programOrChannel);
                }
            };
            $ctrl.recordingAction = function($event, recordingObj){
                $event.stopPropagation();
                //console.log(recordingObj);
                NativeActions.link(recordingObj);
            };
            $ctrl.seriesAction = function($event, seriesObj){
                $event.preventDefault();
                //console.log("toggle episodes", seriesObj);
                //NativeActions.link(seriesObj);
            };

            $ctrl.rowAction = function($event, recording) {
                if(!recording.hasOwnProperty("isGroup")){
                    $ctrl.recordingAction($event, recording);
                }else{
                    if(recording.show !== true){
                        recording.show = true;
                    }else{
                        recording.show = false;
                    }
                }
            }

            $scope.$watch('$ctrl.recordingsSortedBy', function (sortBy) {
                recordingsFilterSort.setSortBy(sortBy);
                recordingsChanged(recordingsFilterSort.getGroupedRecordings());
                if(sortBy && sortBy.id){
                    LocalStorage.set(RECORDS_FILTER_COOKIE_STORE_KEY, sortBy.id);
                }
            });

            $scope.$watch('$ctrl.recordingsCategory', function (category) {
                recordingsFilterSort.setCategory(category);
                recordingsChanged(recordingsFilterSort.getGroupedRecordings());
            });


            // TODO still used?
            $ctrl.openEpg = function () {
            };

            function recordingsChanged(groupedSortedRecordingsList) {
                //console.log("recordingsChanged(groupedSortedRecordingsList)", groupedSortedRecordingsList)
                $ctrl.showMainToolbar = true;
                // TODO series currently not grouped since currently done by gridRenderer
                $ctrl.groupedSortedRecordingsList = groupedSortedRecordingsList;

                // handle display for empty recording list
                $ctrl.recordingsReturnNoResult = groupedSortedRecordingsList && groupedSortedRecordingsList.length === 0;

                setTimeout(function(){
                    if($ctrl.focusedElemIdHistory[0]){
                        //console.log("$ctrl.previousFocusedElemId[0]", $ctrl.focusedElemIdHistory[0]);
                        $("#" + $ctrl.focusedElemIdHistory[0]).focus();
                    }
                },0);

            }

            function loadRecordings(force) {
                //console.log('loadRecordings('+force+')');
                var forceReload = (force === true);

                LoadingOverlay.show();
                //console.log('loadRecordings::show');

                return recordingsDataLoader.load(forceReload).then(function (value) {
                    recordings.setRecordings(value);
                    //recordingGridItemProvider.setRecordings(recordings);
                    recordingsFilterSort.setRecordings(recordings);

                    console.log("recordings", recordings.getSavedRecordings().list.length);


                    // currently only used in tabdroid, so we test before assigning instead of adding attrs to all platforms
                    //if(angular.isDefined($ctrl.recordedRecordCount) && angular.isDefined($ctrl.upcomingRecordCount)){
                        $ctrl.recordedRecordCount = recordings.getSavedRecordings().list.length;
                        $ctrl.upcomingRecordCount = recordings.getUpcomingRecordings().list.length;
                        //console.log('$ctrl.recordedRecordCount', $ctrl.recordedRecordCount);
                        //console.log('$ctrl.upcomingRecordCount', $ctrl.upcomingRecordCount);
                    //}



                    //console.warn("recordingsFilterSort.getGroupedRecordings(recordingGridItemProvider)", recordingsFilterSort.getGroupedRecordings(recordingGridItemProvider))
                    recordingsChanged(recordingsFilterSort.getGroupedRecordings());

                    LoadingOverlay.hide();

                    $ctrl.loading = false;
                    //console.log('loadRecordings::hide');
                });
            }

            $ctrl.focusedElemIdHistory = [];

            $ctrl.addElemIdToHistory = function (id) {
                $ctrl.focusedElemIdHistory.push(id);

                if($ctrl.focusedElemIdHistory.length > 2){
                    $ctrl.focusedElemIdHistory.shift();
                }

                //console.log("$ctrl.previousFocusedElemId", $ctrl.focusedElemIdHistory);
            }


            //INIT
            $ctrl.$onInit = function () {
                //console.log('pvrInit()');

                $ctrl.loading = true;
                LoadingOverlay.show();
                AppConfig.setFromParentConfig($ctrl.importedConfig);

                // set data from /init
                recordingsDataLoader = new RecordingsDataLoader(SERVICES_BASE_PATH, AppConfig.getLogoBasePath(), AppConfig.getThumbsBasePath());


                AppServicesInitializer.initialize(['SrvTerminals'])
                    .then(function (responses) {
                        //console.log('responses: ', responses);


                        $ctrl.userHasPVR = SrvTerminals.hasTerminals();
                        $ctrl.reloadData = loadRecordings;
                        $ctrl.recordingsSortedBy = initializeRecordSorting(RECORDINGS_SORT.DATE);
                        $ctrl.recordingsCategory = RECORDINGS_CATEGORIES.RECORDED;
                        $ctrl.dataConfigAndTerminalsAreResolved = true;




                        loadRecordings();

                        LoadingOverlay.hide();
                    });
            };
        }
    ]);
angular.module('app.pvr.web').component('pagePvrA11y', {
    templateUrl: '/appEnp/templates/pvr/pvr.template.a11y.html',
    controller: 'pagePvrA11yCtrl',
    bindings: {
       importedConfig : '<'
    }
});
angular.module("app.pvr.web").config(["NativeBridgeProvider", "AppConfigProvider", "DeleteRecordingModalProvider", "DeleteRecordingsModalProvider", "RecordingsDeletionErrorProvider",
    "SERVICES_BASE_PATH", "$httpProvider", "HttpInterceptorProvider", "LoadingOverlayProvider",  "$exceptionHandlerProvider",
    function (NativeBridgeProvider, AppConfigProvider, DeleteRecordingModalProvider, DeleteRecordingsModalProvider, RecordingsDeletionErrorProvider,
              SERVICES_BASE_PATH, $httpProvider, HttpInterceptorProvider, LoadingOverlayProvider,  $exceptionHandlerProvider) {

        // TODO - can config be combined between EPG and PVR?

        // TODO - move to global app config? repeated 4 times now, more repetition forseeable
        $exceptionHandlerProvider.setErrorPageUrl("/error");
        $exceptionHandlerProvider.setAuthenticationErrorPageUrl("/authenticationError");
        $exceptionHandlerProvider.setPerceptionErrorPageUrl("/perceptionError");



        // configure template path for web version only
        LoadingOverlayProvider.setTemplatePath("/appEnp/templates/common-web/loadingOverlay.web.template.html");
        LoadingOverlayProvider.setAppendNode("#site_content_wrapper");

        HttpInterceptorProvider.setMaintenanceUrl("/maintenance/maintenance-web.html");

        $httpProvider.interceptors.push("HttpInterceptor");

        // always need credentials now that webgate server in place
        $httpProvider.defaults.withCredentials = true;

        AppConfigProvider.setServiceBasePath(SERVICES_BASE_PATH);
        AppConfigProvider.setThumbsImagePathName("thumbsImagePath");
        AppConfigProvider.setLargeThumbsImagePathName("largeThumbsImagePath");

        NativeBridgeProvider.setBridgeINExpression("enpWebBridgeIn");
        NativeBridgeProvider.setBridgeOUTExpression("enpWebBridgeOut")

        // todo remove?
        $.extend($.event.special.swipe, {
            scrollSupressionThreshold: 50, // More than this horizontal displacement, and we will suppress scrolling.
            durationThreshold: 250, // More time than this, and it isn't a swipe.
            horizontalDistanceThreshold: 50  // Swipe horizontal displacement must be more than this.
        });


        DeleteRecordingModalProvider.setModalConfirmDeleteTemplate("/appEnp/templates/content-details/modal-confirm-record-deletion.template.html");
        DeleteRecordingModalProvider.setModalConfirmDeleteRecordingInProgressTemplate("/appEnp/templates/content-details/modal-confirm-recording-in-progress-deletion.template.html");
        DeleteRecordingsModalProvider.setModalConfirmDeleteMultipleTemplate("/appEnp/templates/content-details/modal-confirm-multiple-record-deletion.template.html");
        RecordingsDeletionErrorProvider.setModalRecordingsDeletionErrorTemplate("/appEnp/templates/content-details/modal-recordings-deleteion-error.template.html");

    }]);


angular.module("app.pvr.web").controller("CtrlPVR",
    ["$scope", "$rootScope", "$filter", "$q", "Clock", "Time", "LocalStorage", "DeleteRecordingModal", "DeleteRecordingsModal", "SrvLinearContentDetails", "RecordingsDataLoader", "SrvTerminals", "SERVICES_BASE_PATH", "AppConfig", "NativeActions", "RECORDINGS_CATEGORIES", "RECORDING_STATE", "RECORDINGS_SORT", "$document", "RecordingsFilterSort", "LoadingOverlay", "$translate", "AppServicesInitializer",
        function ($scope, $rootScope, $filter, $q, Clock, Time, LocalStorage, DeleteRecordingModal, DeleteRecordingsModal, SrvLinearContentDetails, RecordingsDataLoader, SrvTerminals, SERVICES_BASE_PATH, AppConfig, NativeActions, RECORDINGS_CATEGORIES, RECORDING_STATE, RECORDINGS_SORT, $document, RecordingsFilterSort, LoadingOverlay, $translate, AppServicesInitializer) {
            //console.info('CtrlPVR');
            var RECORDS_FILTER_COOKIE_STORE_KEY = "recordings-sorted-by";
            var UPDATE_RECORDING_DATA_EVENT_NAME = "update_recording_data";
            var APP_WAKE_UP_EVENT_NAME = "app_wake_up";

            var help_path;
            //shared data object between controllers
            var pvrDataShare = {
                recordingsCategory: null,
                recordingsSortedBy: null,
                recordingsSortableBy: null,//not implemented in all platforms
                showRecordingsSelection: false,
                selectedRecordings: [],
                servicesBasePath: SERVICES_BASE_PATH,
                logoBasePath: null,
                thumbsBasePath: null,
                programOrChannelClick: angular.noop,
                recordingLongPress: angular.noop,//not implemented in all platforms
                deleteRecord: angular.noop,
                recordingsReturnNoResult: false,
                userHasLegacyTerminals: false,
                editTerminalName: angular.noop,
                updateRecordingDataEventName: UPDATE_RECORDING_DATA_EVENT_NAME,
                appWakeUpEventName: APP_WAKE_UP_EVENT_NAME,
                gridContainerParentId: '#tvguide',
                showMainToolbar: false
            };


            $scope.pvrDataShare = pvrDataShare;

            $scope.dataConfigAndTerminalsAreResolved = false;


            // forceRefresh is true only when the refresh button is click here
            function updateData(forceRefresh) {
                var force = (forceRefresh === true);
                $scope.$broadcast(UPDATE_RECORDING_DATA_EVENT_NAME, force);
            }


            NativeActions.onUpdateData(function () {
                $scope.$broadcast(UPDATE_RECORDING_DATA_EVENT_NAME, false);
            });

            NativeActions.onAppWakeUp(function () {
                $scope.$broadcast(APP_WAKE_UP_EVENT_NAME);
            });


            $rootScope.googleAnalyticsEvent = function (type, value) {
                //Google Analytics tracking through Native Bridge
                if(type === "select filter"){
                    NativeActions.trackEvent('Page "mes enregistrements"', 'Sélectionner filtre', $translate.instant(value));
                }else if(type === "filter tab"){
                    NativeActions.trackEvent('Page "mes enregistrements"', 'Onglets', value);
                }
            };

            // Recordings sorting
            function initializeRecordSorting(defaultValue) {
                var storedId = LocalStorage.get(RECORDS_FILTER_COOKIE_STORE_KEY);
                var result = defaultValue;
                angular.forEach(RECORDINGS_SORT, function (filter) {
                    if (filter.id === storedId) {
                        result = filter;
                    }
                });

                return result;
            }

            function recordingsSortedByChange(value) {
                if(value && value.id){
                    LocalStorage.set(RECORDS_FILTER_COOKIE_STORE_KEY, value.id);
                }
            }

            function updateRecordsList(doNotScrollToTop) {
                //console.log('updateRecordsList()');
                //pvr.groupedRecords = RecordingsFilterSort.getSortedRecordingsByCategory(pvr.recordingsCategory, pvr.recordingsSortedBy);
                // always sroll unlees we recieve a true value here
                if (!doNotScrollToTop || typeof doNotScrollToTop !== "boolean") {
                    $document.scrollTop(0);
                }
            }


            pvrDataShare.deleteRecord = function(recording){
                DeleteRecordingModal.confirmDeleteRecording(recording, function(){
                    updateData(false);
                }, function(){
                    updateData(false);
                 }).catch(function(){
                    updateData(false);
                });
            };

            pvrDataShare.deleteRecords = function(recordingIds){
                DeleteRecordingsModal.confirmDeleteRecordings(recordingIds, null, function(){
                    pvrDataShare.showRecordingsSelection = false;
                    updateData(false);
                }, function(){
                    updateData(false);
                 }).catch(function(){
                    updateData(false);
                });
            };

            pvrDataShare.programOrChannelClick = function (programOrChannel) {
                // ignore click on logo by filtering out provider link
                if(programOrChannel.objectType !== "CHANNEL"){
                    NativeActions.link(programOrChannel);
                }
            };

            pvrDataShare.editTerminalName = function () {
                NativeActions.editTerminalName();
            };

            $scope.$watch("pvrDataShare.recordingsSortedBy", recordingsSortedByChange);
            $scope.$watch("pvrDataShare.recordingsCategory", updateRecordsList);

            $scope.programManuelRecording = function () {
                NativeActions.manualRecording();
            };

            $scope.openEpg = function () {
                NativeActions.openEpg();
            };

            $scope.helpMissingTerminal = function () {
                NativeActions.helpMissingTerminal(help_path);
            };


            function pvrInit() {
                //console.log('pvrInit()');
                LoadingOverlay.show();

                AppServicesInitializer.initialize(['AppConfig', 'SrvTerminals'])
                    .then(function (responses) {
                        //console.log('responses: ', responses);
                        help_path = AppConfig.getHelpPath();

                        pvrDataShare.logoBasePath = AppConfig.getLogoBasePath();
                        pvrDataShare.thumbsBasePath = AppConfig.getThumbsBasePath();

                        $scope.userHasPVR = SrvTerminals.hasTerminals();
                        pvrDataShare.userHasLegacyTerminals = SrvTerminals.hasLegacyTerminals();

                        $scope.reloadData = updateData;

                        pvrDataShare.recordingsSortedBy = initializeRecordSorting(RECORDINGS_SORT.DATE);

                        pvrDataShare.recordingsCategory = RECORDINGS_CATEGORIES.RECORDED;

                        $scope.dataConfigAndTerminalsAreResolved = true;

                        LoadingOverlay.hide();
                    });
            }


            //INIT
            pvrInit();
        }
    ]);
angular.module("app.pvr.web").directive("noRecordings", ["$translate", "RECORDINGS_CATEGORIES", function ($translate, RECORDINGS_CATEGORIES) {

    return {
        restrict: "A",
        templateUrl: "/appEnp/templates/pvr/directives/no-recordings.template.html",
        replace: true,
        scope: {
            recordingsReturnNoResult: "=",
            userHasLegacyTerminals: "=",
            recordingsCategory: "="
        },
        controller: ["$scope", function ($scope) {

            $scope.goToEpg = function () {
                $scope.$parent.openEpg();
            };
            $scope.goToHelp = function () {
                $scope.$parent.helpMissingTerminal();
            };
            $scope.programManuelRecordingClick = function () {
                $scope.$parent.programManuelRecording();
            };

        }],
        link: function (scope, element, attributes) {

            function handleStateChange() {
                scope.isRecorded = scope.recordingsCategory === RECORDINGS_CATEGORIES.RECORDED;
            }


            scope.$watch("recordingsReturnNoResult", handleStateChange);
            scope.$watch("recordingsCategory", handleStateChange);

        }
    };


}]);

angular.module("app.pvr.web").directive("selectRecordFilter",["UID", function (UID) {

    return {
        restrict: "A",
        templateUrl: "/appEnp/templates/pvr/directives/select-record-filter_web.template.html",
        replace: true,
        scope: {
            filters: "=",
            recordingsSortedBy: "="
        },
        link: function (scope) {
            scope.templateId = UID.get("template-");
            //console.log("scope.recordingsSortedBy", scope.recordingsSortedBy)
        }


    };


}]);
angular.module("app.pvr.web").directive("toolBar", function () {
    return {
        restrict: "E",
        templateUrl: "/appEnp/templates/pvr/directives/tool-bar_web.template.html",
        replace: true,
        scope: {
            recordingsSortedBy: "=",
            recordingsCategory: "=",
            deleteRecordsFlag: "=",
            deleteRecordsAction: "&",
            deleteCount: "=",
            reloadAction: "&",
            showMainToolbar: "="
        },
        controller: ["$scope", "RECORDINGS_SORT", "RECORDINGS_CATEGORIES",
            function ($scope, RECORDINGS_SORT, RECORDINGS_CATEGORIES) {
                $scope.RECORDINGS_CATEGORIES = RECORDINGS_CATEGORIES;

                $scope.recordingsSortableBy = [
                    RECORDINGS_SORT.DATE,
                    RECORDINGS_SORT.TERMINAL,
                    RECORDINGS_SORT.ALPHABETICAL
                ];

                $scope.deleteButtonClick = function () {
                    if ($scope.deleteRecordsFlag) {
                        $scope.deleteRecordsAction();
                    } else {
                        $scope.deleteRecordsFlag = true;
                    }
                };

                $scope.cancelRecordsDelete = function () {
                    $scope.deleteRecordsFlag = false;
                };

                $scope.showMainToolbar = true;
            }]
    };
});

angular.module("app.pvr.web").directive("toolBarA11y", function () {
    return {
        restrict: "E",
        templateUrl: "/appEnp/templates/pvr/directives/tool-bar_web.template.a11y.html",
        replace: true,
        scope: {
            recordingsSortedBy: "=",
            recordingsCategory: "=",
            deleteRecordsFlag: "=",
            deleteRecordsAction: "&",
            deleteCount: "=",
            reloadAction: "&",
            showMainToolbar: "="
        },
        controller: ["$scope", "RECORDINGS_SORT", "RECORDINGS_CATEGORIES",
            function ($scope, RECORDINGS_SORT, RECORDINGS_CATEGORIES) {
                $scope.RECORDINGS_CATEGORIES = RECORDINGS_CATEGORIES;

                $scope.recordingsSortableBy = [
                    RECORDINGS_SORT.DATE,
                    RECORDINGS_SORT.TERMINAL,
                    RECORDINGS_SORT.ALPHABETICAL
                ];

                $scope.deleteButtonClick = function () {
                    if ($scope.deleteRecordsFlag) {
                        $scope.deleteRecordsAction();
                    } else {
                        $scope.deleteRecordsFlag = true;
                    }
                };

                $scope.cancelRecordsDelete = function () {
                    $scope.deleteRecordsFlag = false;
                };

                $scope.showMainToolbar = true;
            }]
    };
});

angular.module("app.pvr.web").config(["$routeProvider", function ($routeProvider) {
    // PVR routing handled in IllicoWebClient

    $routeProvider
        .when("/error", {
            templateUrl: "/appEnp/templates/common/error.template.html",
            controller: "CtrlError"
        })
        .when("/authenticationError", {
            templateUrl: "/appEnp/templates/common/error.authentication.template.html",
            controller: "CtrlAuthenticationError"
        })
        .when("/perceptionError", {
            templateUrl: "/appEnp/templates/common/error.perception.template.html",
            controller: "CtrlPerceptionError"
        });
}]);

//# sourceMappingURL=epg-pvr-web.min.js.map